
var gridDiv = document.querySelector('#myGrid');
var gridInvExportInfo = null;
var columnInvExportInfo = [];

function onBtExport(gridOptions, format) {
    var columns_to_export=[];
    var col_state=gridOptions.columnApi.getColumnState();
    for(var i in col_state){
        if(col_state[i].hide==false)
            columns_to_export.push(col_state[i].colId)
    }

    var params = {
        skipHeader: false,
        columnGroups: true,
        skipFooters: false,
        skipGroups: false,
        skipPinnedTop: false,
        skipPinnedBottom: false,
        allColumns: false,
        columnKeys: columns_to_export,
        onlySelected: false,
        suppressQuotes: false,
        fileName: "smart-report." + format,
    };

    params.processCellCallback = function (params) {
        console.log(params);
        /*var day = 0;
        if(params.column.colId === "dow" && params.node.data.time_period >= "00:00:00" && params.node.data.time_period < "03:00:00" ){
            //console.log(params.value);
            if(parseInt(params.value) - 2 <= 0)
                day = parseInt(params.value) + 5;
            else
                day  = parseInt(params.value) - 2;
        }
        if(params.column.colId === "dow"){
            if(day === 0)
                day = parseInt(params.value) - 1;
            if(day === 1) return "Monday";
            if(day === 2) return "Tuesday";
            if(day === 3) return "Wednesday";
            if(day === 4) return "Thursday";
            if(day === 5) return "Friday";
            if(day === 6) return "Saturday";
            if(day === 7) return "Sunday";
        }
        if(((params.column.colId.indexOf("cume") !== -1 && params.column.colDef.headerName!== 'XCume(00)') || params.column.colId.indexOf("share") !== -1 || params.column.colId.indexOf("turnover") !== -1 || params.column.colId.indexOf("rating") !== -1 || params.column.colId.indexOf("impressions") !== -1) && params.column.colId.indexOf("program") === -1 ){
            if(params.value === 'NaN' || isNaN(params.value) || params.value === null || params.value === 'null')
                return 0.0;
            var vv = Number(Math.round((params.value) +'e1')+'e-1');
            if(isNaN(vv))
                return 0.0;
            return vv;
        }
        if((params.column.colId.indexOf("hundreds") !== -1) && params.column.colId.indexOf("program") === -1 ){
            if(params.value === 'NaN' || isNaN(params.value) || params.value === null || params.value === 'null')
                return 0;
            var vv = Number(Math.round((params.value) +'e0')+'e-0');
            if(isNaN(vv))
                return 0;
            return vv;
        }
        if(params.column.colId === "time_period" && params.value !== "" && params.value !== null){
            return moment(params.value, "HH:mm:ss").format("h:mm:ss A");
        }
        if(params.column.colId.indexOf("tsl") !== -1){
            return sformat(params.value * 60);
        }
        if(params.node.field === "day_part"){
            //console.log("inside");
            if(params.value !== null && params.value !== 'null' && params.value !== '') {
                if (params.value.length === 15) {
                    console.log("inside1");
                    var days = params.value.substring(0, 7);
                    var start = params.value.substring(7, 11);
                    var end = params.value.substring(11, 15);
                    if(moment(start, "HHmm").isValid() && moment(end, "HHmm").isValid()) {
                        start = moment(start, "HHmm").format("h:mm A");
                        end = moment(end, "HHmm").format("h:mm A");
                        return days + " (" + start + " - " + end + ")";
                    }
                }
            }
        }*/
        //console.log(params);
        return params.value;
        /*console.log(params);
        if (params.value && params.value.toUpperCase) {
            return params.value.toUpperCase();
        } else {
            return params.value;
        }*/
    };
    if (format === 'csv') {
        params.customHeader = [];
        params.customFooter = [];
    }else {
        params.customHeader = [
            [],
            [
                {data: {type: 'String', value: 'Report'}},
                {data: {type: 'String', value: "Smart Report"}}
            ],
            /*[
                {data:{type:'String', value:'Survey'}},
                {data:{type:'String', value:  header_books_print_export}}
            ],
            [
                {data:{type:'String', value:'Geography'}},
                {data:{type:'String', value: head[4]}}
            ],
            [
                {data:{type:'String', value:'Created'}},
                {data:{type:'String', value: head[3]}}
            ],*/
        ];

        params.customFooter = [
            [],
            /*[
                {data:{type:'String', value:'Disclaimer'}}

            ],
            [
                {data:{type:'String', value: "The above estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nLabeled estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nData &copy; Nielsen Media Research and estimates are copyrighted and subject to all qualifications and limitations stated in the Nielsen report."}}
            ],
            [
                {data:{type:'String', value: (market_type === "PPM") ? "PPM estimates are derived from the PPM technology and methodology and are subject to the qualifications and limitations stated in that Report. \n" +
                            " PPM ratings are based on audience estimates and are the opinion of Nielsen and should not be relied on for precise accuracy or precise representativeness of a demographic or radio market.\n" : ""}}

            ],*/
            []
        ];
    }

    if (format === 'csv') {
        console.log("-------------csv-----------------");
        gridOptions.api.exportDataAsCsv(params);
    } else {
        console.log("-------------excel-----------------");
        var content = gridOptions.api.getDataAsExcel(params);
        var workbook = XLSX.read(content, {type: 'binary'});
        var xlsxContent = XLSX.writeFile(workbook, 'smart-export.xlsx', {bookType: 'xlsx', type: 'base64'});
        //gridOptions.api.exportDataAsExcel(params);
    }
}

function exportGrid(format) {
    onBtExport(gridInvExportInfo, format);
}

function asd(format, obj){
    if(format === 'csv'){
        console.log("csvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
        console.log(gridInvExportInfo);
        exportGrid('csv');
    }else{
        console.log("excellllllllllllllllllll");
        console.log(gridInvExportInfo);
        exportGrid('xls');
    }
}

function onBtExportInDetail(gridOptions, format) {

    var params = {
        skipHeader: false,
        columnGroups: (format == "csv") ? false : true,
        skipFooters: false,
        skipGroups: false,
        skipPinnedTop: false,
        skipPinnedBottom: false,
        allColumns: false,
        onlySelected: false,
        suppressQuotes: false,
        fileName: "smart-report." + format,

    };

    params.processHeaderCallback = function(header){
        console.log("header line");
        console.log(header);
        var header_text = header.column.getColDef().headerName.replace('<br>', '');
        console.log('header.column.getColDef().headerName', header.column.getColDef().headerName);
        return header_text;
    };

    // var order_level= ['ordered_ads', 'ordered_gross_cost', 'ordered_net_cost', 'ordered_impressions', 'ordered_gross_cpp', 'ordered_net_cpp', 'ordered_grp','ordered_gross_cpm', 'ordered_net_cpm', 'av_grp_impressions']
    // var array_data =  [ 'advertiser', 'campaign', 'vendor', 'owner', 'order_type', 'brand', 'product', 'estimate_number','job_number', 'campaign_number', 'campstart', 'campend', 'wv_number' ];
    // var array_invoiced= ['ads','impressions_invoiced', 'rate_per_spot','rate_per_spot_net', 'spend_difference_gross', 'spend_difference_net'];
    // var line_level= [ 'daypart', 'length', 'programming', 'network', 'station_format', 'cable_zone', 'rev_number' ];
    // var inv_spot_level= [ 'time_of_day', 'type_spot_length', 'run_date', 'day_of_week', 'ads', 'rate_per_spot','rate_per_spot_net', 'invoice_number', 'comercial_id', 'impressions_invoiced'];


   // params.processCellCallback = function (params) {
        // console.log(params);
        // if(typeof params.node.rowPinned !== 'undefined') {
        //     if (params.node.rowPinned == 'top') {
        //         if (params.value === 'undefined' || params.value === null || params.value === 'null')
        //             return '';
        //         else if (params.value === 'NaN')
        //             return 0.0;
        //         else if (params.value === '$NaN')
        //             return '$0.00';
        //         else
        //             return params.value;
        //     }
        // }
        //  else{
        //      if(params.node.level === 0) {
        //          console.log('level   ' +params.node.level, params.column.colId)
        //          if (array_data.indexOf(params.column.colId) !== -1 || order_level.indexOf(params.column.colId) !== -1 || array_invoiced.indexOf(params.column.colId) !== -1 || params.node.field === 'order_number')
        //              return params.value;
        //      }
        //      else if(params.node.level === 1){
        //          if (order_level.indexOf(params.column.colId) !== -1 || array_invoiced.indexOf(params.column.colId) !== -1 || params.node.field === 'broadcast_month')
        //              return params.value;
        //      }
        //      else if(params.node.level === 2){
        //           if (order_level.indexOf(params.column.colId) !== -1 || array_invoiced.indexOf(params.column.colId) !== -1 || line_level.indexOf(params.column.colId) !== -1  || params.node.field === 'order_line')
        //              return params.value;
        //      }
        //      else{
        //          if (inv_spot_level.indexOf(params.column.colId) !== -1  )
        //              return params.value;
        //      }
        //  }
    //     return params.value
    //
    // };
    if (format === 'csv') {
        params.customHeader = [];
        params.customFooter = [];
    }else {
        params.customHeader = [
            [],
            [
                {data: {type: 'String', value: 'Report'}},
                {data: {type: 'String', value: "Smart Report"}}
            ],
            /*[
                {data:{type:'String', value:'Survey'}},
                {data:{type:'String', value:  header_books_print_export}}
            ],
            [
                {data:{type:'String', value:'Geography'}},
                {data:{type:'String', value: head[4]}}
            ],
            [
                {data:{type:'String', value:'Created'}},
                {data:{type:'String', value: head[3]}}
            ],*/
        ];

        params.customFooter = [
            [],
            /*[
                {data:{type:'String', value:'Disclaimer'}}

            ],
            [
                {data:{type:'String', value: "The above estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nLabeled estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nData &copy; Nielsen Media Research and estimates are copyrighted and subject to all qualifications and limitations stated in the Nielsen report."}}
            ],
            [
                {data:{type:'String', value: (market_type === "PPM") ? "PPM estimates are derived from the PPM technology and methodology and are subject to the qualifications and limitations stated in that Report. \n" +
                            " PPM ratings are based on audience estimates and are the opinion of Nielsen and should not be relied on for precise accuracy or precise representativeness of a demographic or radio market.\n" : ""}}

            ],*/
            []
        ];
    }

    if (format === 'csv') {
        console.log("-------------csv-----------------");
        gridOptions.api.exportDataAsCsv(params);
    } else {
        console.log("-------------excel-----------------");
        gridOptions.api.exportDataAsExcel(params);
        // var content = gridOptions.api.getDataAsExcel(params);
        // var workbook = XLSX.read(content, {type: 'binary'});
        // var xlsxContent = XLSX.writeFile(workbook, 'smart-export.xlsx', {bookType: 'xlsx', type: 'base64'});
        //gridOptions.api.exportDataAsExcel(params);
    }
}

function exportGridInDetail(format) {
    onBtExportInDetail(gridInvExportInfo, format);
}

function asdInvDetail(format, obj){
    if(format === 'csv'){
        exportGridInDetail('csv');
    }else{
        exportGridInDetail('xls');
    }
}
$('#row_data_details').on('click', function(){
    var columns_to_add = {};
    columns_to_add['order_number'] = 'Order Number';
    columns_to_add['broadcast_month'] = 'Month';
    columns_to_add['order_line'] = 'Order Line';
    var all_columns = collect(gridInvExportInfo.columnDefs).groupBy('field').all();
    var html = '<table style="width: 100%;" class="table-bordered table-striped table-condensed"><tr style="">';
    html += '<td><b>Order Number</b></td><td><b>Month</b></td><td><b>Order Line</b></td>';
    for(var ind in gridInvExportInfo.columnApi.getColumnState()){
       var value =  gridInvExportInfo.columnApi.getColumnState()[ind];
       if(typeof columns_to_add[value.colId] === 'undefined' && value.hide === false && typeof all_columns[value.colId] !== 'undefined'){
           var h = all_columns[value.colId][0].headerName;
           html += '<td><b>'+ h.replace('<br>', '') +'</b></td>';
           columns_to_add[value.colId] = h;
       }
   }

   html += '</tr>';
    gridInvExportInfo.api.forEachNodeAfterFilterAndSort(function (node) {
       if(node.level === 3){
           html += '<tr>';
           for(var ind in columns_to_add){
               console.log('node_node_', node)
               html += '<td style="border: 1px solid #D3D3D3">'+ node.data[ind] +'</td>';
           }
           html += '</tr>';
       }
    });
    html += '</table>';

    var a = document.createElement('a');
    var data_type = 'data:application/vnd.ms-excel';
    a.href = data_type + ', ' + encodeURIComponent(html);
    a.download =  'smart-report.xls';
    a.click();
    if(typeof e !== 'undefined')
        e.preventDefault();
});

$(document).ready(function(){

    if($(".inv_detail_report_header").length > 0) {
        init_progress_loader(2, 'Loading Report. Please wait ...');
        //Chart Detail Tabs
        var campaigns_chart = [];
        var vendors_chart = [];
        var months_chart = [];
        $('.custom_chart_market_detail').on('click', function () {
            var tab_selected = $(this).attr('data-tab');
            $('#tab_selected_graph').val(tab_selected);
            // $('.chart_market_span_text').html(tab_selected);
            //chart options
            var html_type = ' <option value=""></option>' +
                '                                            <option value="pie">Pie</option>' +
                '                                            <option value="line">Line</option>' +
                '                                            <option value="column">Column (Vertical)</option>' +
                '                                            <option value="bar">Column (Horizontal)</option>';

            $('#chart_type_details').select2({
                minimumResultsForSearch: 5,
                placeholder: 'Select one....',

            });
            $('#chart_type_details').html(html_type);

            $('#chart_breakout_details').select2({
                minimumResultsForSearch: 5
            });
            $('#chart_data_type_details').select2({
                minimumResultsForSearch: 5
            });

            var html = '';
            for (var ind in campaigns_chart)
                html += '<option>' + campaigns_chart[ind] + '</option>';
            $('#chart_markets_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_books'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_books'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_markets_details').html(html).multiSelect('refresh');

            var html = '';
            for (var ind in vendors_chart)
                html += '<option>' + vendors_chart[ind] + '</option>';
            $('#chart_stations_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_stations'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_stations'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_stations_details').html(html).multiSelect('refresh');

            var html = '';
            months_chart.sort();
            for (var ind in months_chart)
                html += '<option value="'+ months_chart[ind] +'">' + moment(months_chart[ind]).format('MMMM, YYYY') + '</option>';
            $('#chart_month_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type_details option:selected').val() === 'pie') {
                        form_curr_dayparts = this.$element.val();
                        if (this.$element.val().length > 1) {
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 1 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }
                        if (form_curr_dayparts.length < 2)
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                        else
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');

                    }
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type option:selected').val() == 'pie') {
                        form_curr_dayparts = this.$element.val();
                        this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                    }
                }
            });
            $('#chart_month_details').html(html).multiSelect('refresh');

            $('#graphsOptionsModalDetail').modal('show');

            //Select all
            $('#sel_all_chart_books').on('click', function (e) {
                $('#chart_markets_details').multiSelect('select_all');
            });
            $('#sel_all_chart_stations').on('click', function (e) {
                $('#chart_stations_details').multiSelect('select_all');
            });
            $('#sel_all_chart_dayparts').on('click', function (e) {
                $('#chart_month_details').multiSelect('select_all');
            });
            //Deselect all
            $('#desel_all_chart_books').on('click', function (e) {
                $('#chart_markets_details').multiSelect('deselect_all');
            });
            $('#desel_all_chart_stations').on('click', function (e) {
                $('#chart_stations_details').multiSelect('deselect_all');
            });
            $('#desel_all_chart_dayparts').on('click', function (e) {
                $('#chart_month_details').multiSelect('deselect_all');
            });
        });
        $('#chart_type_details').on('change', function(){
            if($(this).val() === 'pie'){
                $('.div_only_one_daypart_details').show();
                $('#chart_month_details').multiSelect('deselect_all');
            }
            else {
                $('.div_only_one_daypart_details').hide();
            }
        });
        $('#submit_charts_options_details').on('click', function(){
            if($('#chart_type_details option:selected').val() == ''){
                swal({
                        title: "Warning",
                        text: "Select Chart Type first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_stations_details').val().length == 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Station...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_month_details').val().length == 0) {
                if ($('#chart_type_details option:selected').val() === 'pie')
                    text = 'Select a Month first...';
                else
                    text = 'Select at least one Month...';
                swal({
                        title: "Warning",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_markets_details').val().length === 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Campaign first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else {
                show_overlay_loader('#graphsOptionsModalDetial .modal-content');
                $('#modalTTChart').html('Detail Report Chart');
                var vendor_charts = $('#chart_stations_details').val();
                var month_chart = $('#chart_month_details').val();
                var camp_charts = $('#chart_markets_details').val();
                var data_type = $('#chart_data_type_details option:selected').val();
                var data_type_text = $('#chart_data_type_details option:selected').html();
                var simbol = (data_type === 'ads' || data_type === 'ordered_ads' ) ? '' : '$';
                var to_fixed = 0;
               if(data_type === 'ads' || data_type === 'ordered_ads')
                    to_fixed = 0;
                else
                    to_fixed = 2;

                var results = [];
                var array_month_ordered = [];
                var rev_array = [];
                gridInvExportInfo.api.forEachNode(function (node) {
                    if (node.level === 0) {
                        $.each(node.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                $.each(value.childrenAfterGroup, function (index, value) {
                                    var mm = value.data.broadcast_month.replace(',', ' 01,');
                                    console.log('mmmmm ', mm);
                                    if (vendor_charts.indexOf(value.data.vendor) !== -1 && month_chart.indexOf(moment(mm).format('YYYY/MM/DD')) !== -1 && camp_charts.indexOf(value.data.campaign) !== -1) {
                                       var rev = value.data.rev_number.split('#');
                                        var order = value.data.order_number +' Rev_'+  rev[1].trim();
                                        if (typeof results[order] === 'undefined')
                                            results[order] = [];
                                        var time = moment(mm).format('YYYY/MM/DD')
                                        if (typeof results[order][time] === 'undefined')
                                            results[order][time] = [];

                                        if (typeof results[order][time][value.data.order_line] === 'undefined') {
                                            results[order][time][value.data.order_line] = [];
                                            results[order][time][value.data.order_line]['value'] = 0;
                                        }
                                        var amount = 0;
                                        if (data_type === 'ads' || data_type === 'ordered_ads')
                                            amount = !isNaN(parseInt(value.data[data_type])) ? parseInt(value.data[data_type]) : 0;
                                        else {
                                            var amount = value.data[data_type];
                                            amount = amount.replace('$', '');
                                            amount = amount.replace(/,/g, '');
                                            amount = !isNaN(parseFloat(amount)) ? parseFloat(amount).toFixed(2) : 0.00;
                                        }
                                        results[order][time][value.data.order_line]['value'] += amount;
                                        if(array_month_ordered.indexOf(time) === -1)
                                            array_month_ordered.push(time);

                                    }
                                });
                            });
                        });
                    }
                });
                array_month_ordered.sort();
                console.log('charts_final_results results', results);
                var charts_final_results = {};
                for (var order in results) {
                    for (var ind in array_month_ordered) {
                        var time_period = array_month_ordered[ind];
                        if (typeof charts_final_results[order] === 'undefined')
                            charts_final_results[order] = [];
                        if (typeof charts_final_results[order][time_period] === 'undefined') {
                            charts_final_results[order][time_period] = [];
                            charts_final_results[order][time_period]['total'] = 0;
                            charts_final_results[order][time_period]['stations'] = [];
                        }
                        for (var line in results[order][time_period]) {
                            if (typeof charts_final_results[order][time_period]['stations'][line] === 'undefined')
                                charts_final_results[order][time_period]['stations'][line] = 0;
                            if (typeof results[order][time_period][line] !== 'undefined') {
                                charts_final_results[order][time_period]['total'] += parseFloat(results[order][time_period][line]['value']);
                                charts_final_results[order][time_period]['stations'][line] += parseFloat(results[order][time_period][line]['value']);
                            }
                        }
                    }
                }

                console.log('charts_final_results ', charts_final_results);
                console.log('array_month_ordered ', array_month_ordered);
                var html = '';
                //content tabs
                html += '<div class="tab-content gr" style="width: 100%">';
                html += '<div class="row"> <div class="col-md-12">' +
                    '                                <div id="container_market_chart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                    '                            </div></div>';
                html += '</div>';
                $('.container-graphs-div').html(html);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                if ($('#chart_type_details option:selected').val() == 'column' || $('#chart_type_details option:selected').val() == 'bar') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data.push({
                                name: moment(time_period).format('MMM YYYY'),
                                y: market_value,
                                drilldown: moment(time_period).format('MMM YYYY') + '_' + cont,
                            });

                            data2.push({
                                name: market,
                                id: moment(time_period).format('MMM YYYY') + '_' + cont,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var orientation_type = $('#chart_type_details option:selected').val() === 'column' ? 'columns' : 'rows';
                    var defaultTitle = 'Click the '+ orientation_type +' to view ' + $('#chart_data_type_details option:selected').html() + ' by lines.'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text:  data_type_text + ' Details Chart',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_data_type option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol + '{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        drilldown: {
                            series: data2
                        }

                    });
                }
                if ($('#chart_type_details option:selected').val() == 'line') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data.push({
                                name: moment(time_period).format('MMM YYYY'),
                                y: market_value,
                                drilldown: moment(time_period).format('MMM YYYY') + '_' + cont,
                            });

                            data2.push({
                                name: market,
                                id: moment(time_period).format('MMM YYYY') + '_' + cont,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }
                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details option:selected').html() + ' by  lines'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            // type: $('#chart_type option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: data_type_text + ' Details Chart',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_type_details option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        drilldown: {
                            series: data2
                        }
                        //drilldown : data2,

                    });
                }
                if ($('#chart_type_details option:selected').val() == 'pie') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data2.push({
                                name: market,
                                id: market,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            y: market_value,
                            drilldown: market,
                        });
                        cont++;
                    }
                    console.log('series series', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details option:selected').html() + ' by lines'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text:  data_type_text + ' Details Chart ('+ moment($('#chart_month_details').val()[0]).format('MMMM,  YYYY') + ')',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true,
                                },
                                showInLegend: true,

                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: [{
                            name:  'Or. Rev ' + $('#chart_data_type_details option:selected').html() ,
                            colorByPoint: true,
                            data: series
                        }],
                        drilldown: {
                            series: data2
                        }
                        //drilldown : data2,

                    });
                }

                $('#GraphsModal').modal('show');
                hide_overlay_loader('#graphsOptionsModalDetail .modal-content');

            }

            hide_overlay_loader('#graphsOptionsModal .modal-content');

        });


        $('.export_totals_to').on('click', function () {
            $('#format_x').val($(this).attr('data'));
            $('#totalsToExport').modal('show');
        });
        $('#submit_export_totals').on('click', function () {
            var selectedItems = [];
            $('.all_more_options_totals input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });

            if($('#format_x_grid').val() == 'campaign')
                onBtExportBreakTo(gridInvExportInfo, $('#format_x').val(), selectedItems);
            else
                onBtExportBreakTo(gridInvExportInfo, $('#format_x').val(), selectedItems);
        });

        function onBtExportBreakTo(gridOptions, format, selectedItems) {
            console.log('selectedItems ', selectedItems);
            var params = {
                skipHeader: false,
                columnGroups: (format == "csv") ? false : true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "smart-report." + format,

            };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Detail Report"}}
                    ],
                ];

                params.customFooter = [
                    [],
                    []
                ];
            }
            console.log("selectedItems before", selectedItems);
            params.shouldRowBeSkipped = function(row){
                console.log('row_row_row ', row.node.field);
                console.log('row_row_row ', row);
                if(typeof row.node.key === 'undefined' )
                    return true;
                if(row.node.field === 'order_line' )
                    return true;
                if(selectedItems.indexOf('order') === -1 && row.node.field === 'order_number')
                    return true;
                if(selectedItems.indexOf('month') === -1 && row.node.field === 'broadcast_month')
                    return true;

            };
            params.processHeaderCallback = function(header){
                var header_text = header.column.getColDef().headerName;
                header_text = header_text.toString().split('<br>');
                var html = '';
                for(var i in header_text)
                    html += header_text[i]+' ';
                return html
            };
            params.processCellCallback = function (params) {
                console.log('params_params_ ', params.column.colId , params);
                if(params.column.colId === 'cost' || params.column.colId === 'net_cost'){
                    var param_val = params.value.replace('$', '');
                    param_val = param_val.replace(/,/g, '') ;

                    if(isNaN(parseFloat(param_val)))
                        param_val = 0;
                    param_val = parseFloat(param_val).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    return param_val;
                }
                else if(params.column.colId === "broadcast_month")
                    return moment(params.value).format('MMMM, YYYY');
                else if(params.column.colId === "ag-Grid-AutoColumn")
                    return params.value
                else
                    return params.node.aggData[params.column.colId];

            };

            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridOptions.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                var content = gridOptions.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'smart-report.xlsx', {bookType: 'xlsx', type: 'base64'});
            }
        }

        var totals = {
            'rate_per_spot': 0,
            'rate_per_spot_net': 0,
            'ads': 0,
        };
        var totals_by_order = [];
        var rowdata = [];
        console.log('details ^^^', details);
        for(var i in details){
            var lines = details[i];
            if(campaigns_chart.indexOf(lines['camp_name']) === -1)
                campaigns_chart.push(lines['camp_name'])
            if(vendors_chart.indexOf(lines['vendor_name']) === -1)
                vendors_chart.push(lines['vendor_name'])

            var imp = 0;
           if(details[i]['media_type'] === 'Digital' || details[i]['media_type'] === 'Podcast Programmatic')
                  imp=  (isNaN(parseFloat(details[i]['impressions']))) ? 0 : parseFloat(Number(Math.round((details[i]['impressions']) + 'e1') + 'e-1'))  /1000;
           else if(details[i]['media_type'] == 'Radio')
                imp = (isNaN(parseFloat(details[i]['impressions']))) ? 0 : parseFloat(Number(Math.round((details[i]['impressions']) + 'e1') + 'e-1')) /10;
           else
               imp =  (isNaN(parseFloat(details[i]['impressions']))) ? 0 : parseFloat(Number(Math.round((details[i]['impressions']) + 'e1') + 'e-1'));

           var av_grp_impressions = (!isNaN(parseFloat(details[i]['rating'] * details[i]['ordered_spots'])) && imp > 0) ? ( parseFloat(details[i]['rating'] * details[i]['ordered_spots'])) / imp : 0;

           var mi = 0;
            for(var x in lines['months']){
                if(months_chart.indexOf(x) === -1)
                    months_chart.push(x);

                var months = lines['months'][x]['invoice_spots'];
                var ord_spots = lines['months'][x]['order_spot'];
                var clicks = typeof lines['months'][x]['order_clicks'] !== 'undefined' ? parseInt(lines['months'][x]['order_clicks']) : 0;
                var hiatus = lines['months'][x]['hiatus'];
                var taxes = typeof lines['months'][x]['taxes'] !== 'undefined' && !isNaN(parseFloat(lines['months'][x]['taxes'])) ? lines['months'][x]['taxes'] : 0;

                var mult = 1;
                if(details[i]['media_type'] === 'OOH' || details[i]['media_type'] === 'Other' || details[i]['media_type'] === 'Digital' || details[i]['media_type'] === 'OTT JamLoop' || details[i]['media_type'] === 'Podcast Programmatic') {
                    if (typeof lines['months'][x]['order_days'] !== 'undefined')
                        mult = details[i]['total_days'] > 0 ? lines['months'][x]['order_days'] / details[i]['total_days'] : 1;
                    else if (typeof lines['months'][x]['order_spot_only_one_day'] !== 'undefined')
                        mult = 1;
                    else
                        mult = 0;
                }
                var cost_order = 0;
                var client_cost = 0;
                if(details[i]['media_type'] === 'Print' || details[i]['media_type'] === 'Mail' )
                    cost_order = (isNaN(details[i]['cost']) || isNaN(ord_spots)) ? 0 : details[i]['cost'] * ord_spots;
                else if(details[i]['media_type'] === 'Television' || details[i]['media_type'] === 'Radio' || details[i]['media_type'] === 'Podcast Attached') {
                    cost_order = (isNaN(lines['months'][x]['order_cost'])) ? 0 : lines['months'][x]['order_cost'];
                    client_cost = (isNaN(lines['months'][x]['client_cost'])) ? 0 : lines['months'][x]['client_cost'] ;
                }
                else if(details[i]['media_type'] === 'OOH' || details[i]['media_type'] === 'Other' || details[i]['media_type'] === 'OTT JamLoop') {
                     cost_order = (isNaN(details[i]['cost']) || isNaN(details[i]['ad_count'])) ? 0 : details[i]['cost'] * details[i]['ad_count'];
                    if(cost_order === 0) {
                        console.log('inside_cost_order', x, details[i]['cost'], ord_spots)
                         cost_order = (isNaN(details[i]['cost'])) ? 0 : details[i]['cost'] * ord_spots;
                    }
                }else
                     cost_order = (isNaN(parseFloat(details[i]['cost']))) ? 0 : details[i]['cost'] ;

                if(details[i]['media_type'] !== 'Television' && details[i]['media_type'] !== 'Radio' || details[i]['media_type'] !== 'Podcast Attached')
                    client_cost = parseFloat(((parseFloat(cost_order) * parseFloat(mult)) * parseFloat(details[i]['client_cost_com'])) /100);

                var grp = parseFloat(Number(Math.round((details[i]['rating']) + 'e1') + 'e-1') * ord_spots);
                grp = isNaN(parseFloat(grp)) ? 0 : grp;

                var cpp = (grp > 0 && !isNaN(parseFloat(cost_order))) ? cost_order / grp : 0;

                var gri = imp * ord_spots;
                gri = isNaN(parseFloat(gri)) ? 0 : gri;
                var cost_per_click = (clicks > 0 && !isNaN(parseFloat(cost_order))) ? (parseFloat(cost_order) * mult) / clicks : 0;

                if(months.length > 0){
                    for(var z in months) {
                        var month= months[z];
                        var cost_invoice = (isNaN(month['inv_cost'])) ? 0 : month['inv_cost'];
                        var spend_different = (parseFloat(cost_order) * mult) - parseFloat(cost_invoice);
                        console.log('details[i]_ details[i]',  details[i]);
                        console.log('month_month_month_month_ ',  month);

                        if(details[i]['media_type'] !== 'Digital' && details[i]['media_type'] !== 'OOH' && details[i]['media_type'] !== 'Podcast Programmatic')
                            var com = details[i]['agency_commission'];
                       else if(details[i]['media_type'] === 'OOH')
                            var com = (typeof ooh_comisions_invoices[details[i]['rev_id']] !== 'undefined') ? ooh_comisions_invoices[details[i]['rev_id']]['commission'] : 0;
                        else if(details[i]['media_type'] === 'Podcast Programmatic')
                            var com = (typeof podcast_comisions_invoices[details[i]['rev_id']] !== 'undefined') ? podcast_comisions_invoices[details[i]['rev_id']]['commission'] : 0;
                       else
                           var com = (typeof digital_comisions_invoices[details[i]['rev_id']] !== 'undefined') ? digital_comisions_invoices[details[i]['rev_id']]['commission'] : 0;

                        var approved_grp = 0;
                        var approved_gri = 0;
                        if(details[i]['media_type'] === 'Television' || details[i]['media_type'] === 'Radio' || details[i]['media_type'] === 'Podcast Attached') {
                            approved_grp = !isNaN(parseFloat(details[i]['rating'])) && !isNaN(parseInt(month['inv_ads'])) ? parseFloat(Number(Math.round((details[i]['rating']) + 'e1') + 'e-1') * month['inv_ads']) : 0;
                            approved_gri = !isNaN(parseFloat(details[i]['impressions'])) && !isNaN(parseInt(month['inv_ads'])) ? parseFloat(Number(Math.round((details[i]['impressions']) + 'e1') + 'e-1') * month['inv_ads']) : 0;
                        }
                        var order_type = details[i]['media_type'] === 'Podcast Attached' || details[i]['media_type'] === 'Podcast Programmatic' ? 'Podcast' : details[i]['media_type'];

                        rowdata.push({
                            'rev_id': details[i]['rev_id'],
                            'product': details[i]['product_name'],
                            'advertiser': details[i]['advertiser_name'],
                            'campaign': details[i]['camp_name'],
                            'estimate_number': details[i]['estimate_number'],
                            'job_number': details[i]['job_number'],
                            'campaign_number': details[i]['campaign_number'],
                            'campstart': moment(details[i]['campstart']).format('YYYY/MM/DD'),
                            'campend': moment(details[i]['campend']).format('YYYY/MM/DD'),
                            'accounting': details[i]['accounting'],
                            'accounting_date': details[i]['accounting_date'],
                            'vendor': details[i]['vendor_name'],
                            'vendor_pubid': details[i]['vendor_pubid'],
                            'vendor_code': details[i]['vendor_code'],
                            'ad_date': typeof details[i]['ad_date'] !== 'undefined' && details[i]['ad_date'] !== null ? details[i]['ad_date'] : '',
                            'size': typeof details[i]['size'] !== 'undefined' && details[i]['size'] !== null ? details[i]['size'] : '',
                            'issue_vol': typeof details[i]['issue_vol'] !== 'undefined' && details[i]['issue_vol'] !== null ? details[i]['issue_vol'] : '',
                            'comments': typeof details[i]['comments'] !== 'undefined' && details[i]['comments'] !== null ? details[i]['comments'] : '',
                            'market': details[i]['market'],
                            'wv_number': details[i]['wv_number'],
                            'order_number': details[i]['order_number'],
                            'rev_number': 'Revision #'+details[i]['rev_number'],
                            'invoice_number': month['invoice_number'],
                            'ads': month['inv_ads'],
                            'taxes': taxes,
                            'impressions_invoiced':  typeof month['impressions_invoiced'] !== 'undefined' ? parseInt(month['impressions_invoiced']) : 0,
                            'rate_per_spot': parseFloat(month['inv_cost']).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'rate_per_spot_net': parseFloat((month['inv_cost'] - (month['inv_cost'] * (com / 100)))).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'time_of_day': month['inv_time_aired'],
                            'type_spot_length': ':'+ month['inv_length_aired'],
                            'run_date': (moment(month['inv_date_aired']).format('MM/DD/YYYY') == 'Invalid date') ? '' : moment(month['inv_date_aired']).format('MM/DD/YYYY'),
                            'day_of_week': month['inv_day_aired'],
                            'broadcast_month': moment(x).format('MMMM, YYYY')+ hiatus,
                            'inv_sent_accounting': month['inv_sent_accounting'],
                            'order_type': order_type,
                            'order_line':'Or. Line ' +  details[i]['line_number'],
                            'daypart': (details[i]['daypart'] == null) ? '' : details[i]['daypart'],
                            'programming': (details[i]['program'] == null) ? '' : details[i]['program'],
                            'owner': (details[i]['owner'] == null) ? '' : details[i]['owner'],
                            'tag': '',
                            'av_grp_impressions': parseFloat(av_grp_impressions).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }),
                            'network': (details[i]['network'] == null) ? '' : details[i]['network'].toUpperCase(),
                            'station_format': (details[i]['station_format'] == null) ? '' : details[i]['station_format'],
                            'cable_zone': (details[i]['cable_zone'] == null) ? '' : details[i]['cable_zone'],
                            'ordered_ads': ord_spots,
                            'ordered_grp': parseFloat(details[i]['rating'] * ord_spots).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }),
                            'approved_grp': parseFloat(approved_grp).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }),
                            'approved_gri': parseFloat(approved_gri).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }),
                            'length': ':'+details[i]['length'],
                            'ordered_impressions': parseFloat(gri).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }),
                            'ordered_gross_cost': (parseFloat(cost_order) * mult).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'client_cost': parseFloat(client_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'ordered_net_cost': (parseFloat(((cost_order) - ((cost_order) * (details[i]['agency_commission'] / 100)))) * mult).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'ordered_gross_cpp': parseFloat(cpp).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'ordered_net_cpp': parseFloat(((cpp) - ((cpp) * (details[i]['agency_commission'] / 100)))).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'ordered_gross_cpm': parseFloat((gri > 0) ? cost_order / gri : 0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'ordered_net_cpm': parseFloat((gri > 0) ? ((cost_order / gri) - ((cost_order / gri) * (details[i]['agency_commission'] / 100))) : 0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'spend_difference_gross': parseFloat(spend_different).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'spend_difference_net': parseFloat((spend_different > 0) ? ((spend_different) - ((spend_different) * (details[i]['agency_commission'] / 100))) : 0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                            'comercial_id': month['inv_commercial_id'],
                            'tag': month['tag'],
                            'order_line_id':  details[i]['order_line_id']+'_'+ moment(x).format('x'),
                            'ordered_clicks':  clicks,
                            'cost_per_click': parseFloat(cost_per_click).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }),
                        });
                        totals['rate_per_spot'] += parseFloat(month['inv_cost']);

                        if(details[i]['media_type'] !== 'Digital' && details[i]['media_type'] !== 'OOH')
                           totals['rate_per_spot_net'] += parseFloat(month['inv_cost'] - (month['inv_cost'] * (details[i]['agency_commission'] / 100)));
                        else if(details[i]['media_type'] === 'OOH') {
                            var com = (typeof ooh_comisions_invoices[details[i]['rev_id']] !== 'undefined') ? ooh_comisions_invoices[details[i]['rev_id']]['commission'] : 0;
                            totals['rate_per_spot_net'] += parseFloat(month['inv_cost'] - (month['inv_cost'] * (com / 100)));
                        }else {
                            var com = (typeof digital_comisions_invoices[details[i]['rev_id']] !== 'undefined') ? digital_comisions_invoices[details[i]['rev_id']]['commission'] : 0;
                            totals['rate_per_spot_net'] += parseFloat(month['inv_cost'] - (month['inv_cost'] * (com / 100)));
                        }
                        totals['ads']++;
                    }
                }
                else{
                    var spend_different= parseFloat(cost_order) * mult;
                    var hiatus= lines['months'][x]['hiatus'];
                    rowdata.push({
                        'rev_id': details[i]['rev_id'], 'rev_id': details[i]['rev_id'],
                        'brand':  details[i]['brand_name'],
                        'product': details[i]['product_name'],
                        'advertiser': details[i]['advertiser_name'],
                        'campaign': details[i]['camp_name'],
                        'estimate_number': details[i]['estimate_number'],
                        'job_number': details[i]['job_number'],
                        'campaign_number': details[i]['campaign_number'],
                        'campstart': moment(details[i]['campstart']).format('YYYY/MM/DD'),
                        'campend': moment(details[i]['campend']).format('YYYY/MM/DD'),
                        'accounting': details[i]['accounting'],
                        'accounting_date': details[i]['accounting_date'],
                        'wv_number': details[i]['wv_number'],
                        'vendor': details[i]['vendor_name'],
                        'vendor_pubid': details[i]['vendor_pubid'],
                        'vendor_code': details[i]['vendor_code'],
                        'market': details[i]['market'],
                        'order_number': details[i]['order_number'],
                        'rev_number': 'Revison #'+ details[i]['rev_number'],
                        'invoice_number': '-',
                        'ads':  0,
                        'impressions_invoiced' : 0,
                        'rate_per_spot':    parseFloat( 0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'rate_per_spot_net': parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'time_of_day': '',
                        'type_spot_length': '',
                        'run_date': '',
                        'day_of_week': '',
                        'ad_date': typeof details[i]['ad_date'] !== 'undefined' && details[i]['ad_date'] !== null ? details[i]['ad_date'] : '',
                        'size': typeof details[i]['size'] !== 'undefined' && details[i]['size'] !== null ? details[i]['size'] : '',
                        'issue_vol': typeof details[i]['issue_vol'] !== 'undefined' && details[i]['issue_vol'] !== null ? details[i]['issue_vol'] : '',
                        'comments': typeof details[i]['comments'] !== 'undefined' && details[i]['comments'] !== null ? details[i]['comments'] : '',
                        'inv_sent_accounting': '',
                        'broadcast_month': moment(x).format('MMMM, YYYY') + hiatus,
                        'order_type': details[i]['media_type'],
                        'order_line': 'Or. Line '+details[i]['line_number'],
                        'daypart': (details[i]['daypart']== null) ? '' : details[i]['daypart'],
                        'programming': (details[i]['program']== null) ? '' : details[i]['program'],
                        'owner': (details[i]['owner']== null) ? '' : details[i]['owner'],
                        'tag': '',
                        'av_grp_impressions': parseFloat(av_grp_impressions ).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }),
                        'network': (details[i]['network']== null) ? '' : details[i]['network'].toUpperCase(),
                        'station_format': (details[i]['station_format']== null) ? '' : details[i]['station_format'],
                        'cable_zone': (details[i]['cable_zone']== null) ? '' : details[i]['cable_zone'],
                        'ordered_ads': ord_spots,
                        'ordered_grp' : parseFloat(details[i]['rating'] * ord_spots).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'approved_grp': parseFloat(0).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'approved_gri': parseFloat(0).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'length': details[i]['length'],
                        'ordered_impressions' : parseFloat(gri).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }),
                        'ordered_gross_cost':    (parseFloat( cost_order ) * mult).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'client_cost': parseFloat(client_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'ordered_net_cost':    (parseFloat( ((cost_order )- ((cost_order)* (details[i]['agency_commission'] / 100))) ) * mult).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'ordered_gross_cpp': parseFloat(cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'ordered_net_cpp': parseFloat(((cpp) - ((cpp) * (details[i]['agency_commission'] / 100)))).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'ordered_gross_cpm': parseFloat((gri > 0) ? cost_order / gri : 0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'ordered_net_cpm': parseFloat((gri > 0) ? ((cost_order / gri) - ((cost_order / gri) * (details[i]['agency_commission'] / 100))) : 0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'spend_difference_gross' : parseFloat( spend_different).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'spend_difference_net' : parseFloat( (spend_different > 0) ? ((spend_different )- ((spend_different)* (details[i]['agency_commission'] / 100))) : 0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'comercial_id': '',
                        'order_line_id':  details[i]['order_line_id']+'_'+ moment(x).format('x'),
                        'ordered_clicks':  clicks,
                        'cost_per_click': parseFloat(cost_per_click).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                    });
                }
                mi++;
            }
        }
        console.log('rowdata_rowdata_rowdata_', rowdata)

        var totalInvDetailUpd = function(g){
            var result = {
                'rate_per_spot': 0,
                'rate_per_spot_net': 0,
                'ads': 0,
                'spend_difference_gross': 0,
                'spend_difference_net': 0,
                'ordered_gross_cost': 0,
                'ordered_net_cost': 0,
                'client_cost': 0,
                'ordered_gross_cpp': 0,
                'ordered_net_cpp': 0,
                'ordered_gross_cpm': 0,
                'ordered_net_cpm': 0,
                'ordered_ads': 0,
                'ordered_impressions': 0,
                'ordered_grp': 0,
                'av_grp_impressions': 0,
                'approved_gri': 0,
                'approved_grp': 0,
                'ordered_clicks': 0,
                'cost_per_click': 0,
            };
            var gri = 0;
            var added_lines = [];
            var added_taxes = [];

            g.api.forEachNodeAfterFilterAndSort(function(node){
                 if(node.level === 3) {
                     console.log('totalInvDetailUpd_', node.data)
                     //order totals
                     if(added_lines.indexOf(node.data['order_line_id']) == -1){
                         result['ordered_ads'] += parseFloat( node.data['ordered_ads']);
                         result['ordered_clicks'] += parseFloat( node.data['ordered_clicks']);
                         result['ordered_impressions'] += parseFloat( node.data['ordered_impressions'].replace(/,/g, ''));
                         result['ordered_grp'] += parseFloat( node.data['ordered_grp'].replace(/,/g, ''));
                         result['av_grp_impressions'] += parseFloat( node.data['av_grp_impressions'].replace(/,/g, ''));
                         //gri += parseFloat( node.data['ordered_impressions'].replace(/,/g, '') * node.data['ordered_ads']);
                         gri += parseFloat( node.data['ordered_impressions'].replace(/,/g, '') );

                         var or_gross =  node.data['ordered_gross_cost'].replace('$', '');
                         or_gross =  or_gross.replace(/,/g, '') ;
                         result['ordered_gross_cost'] += parseFloat(or_gross);

                         var or_gross =  node.data['ordered_net_cost'].replace('$', '');
                         or_gross=  or_gross.replace(/,/g, '') ;
                         result['ordered_net_cost'] += parseFloat(or_gross);

                         var client_cost =  node.data['client_cost'].replace('$', '');
                         client_cost =  client_cost.replace(/,/g, '') ;
                         result['client_cost'] += parseFloat(client_cost);

                         added_lines.push(node.data['order_line_id']);
                     }
                     result['ads'] += parseFloat(node.data['ads']);
                     result['approved_gri'] += parseFloat( node.data['approved_gri'].replace(/,/g, ''));
                     result['approved_grp'] += parseFloat( node.data['approved_grp'].replace(/,/g, ''));

                     var or_gross=  node.data['rate_per_spot'].replace('$', '');
                     or_gross=  or_gross.replace(/,/g, '') ;
                     result['rate_per_spot'] += parseFloat(or_gross);

                     var or_gross=  node.data['rate_per_spot_net'].replace('$', '');
                     or_gross=  or_gross.replace(/,/g, '') ;
                     result['rate_per_spot_net'] += parseFloat(or_gross);

                     if(typeof node.data.taxes !== 'undefined' && typeof added_taxes[node.data.invoice_number] === 'undefined'){
                         added_taxes[node.data.invoice_number] = 1;
                         result['rate_per_spot_net'] += parseFloat(node.data.taxes);
                     }
                 }

            });

            result['spend_difference_gross'] = parseFloat( parseFloat(result['ordered_gross_cost']) - parseFloat(result['rate_per_spot'])).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });

            result['spend_difference_net'] = parseFloat( parseFloat(result['ordered_net_cost']) - parseFloat(result['rate_per_spot_net'])).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });


            if(gri > 0){
                result['ordered_gross_cpm'] = parseFloat( result['ordered_gross_cost'] / gri ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                result['ordered_net_cpm'] = parseFloat( result['ordered_net_cost'] / gri ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            }
            else{
                result['ordered_gross_cpm'] = parseFloat( 0 ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                result['ordered_net_cpm'] = parseFloat( 0 ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            }

            if( result['ordered_grp'] > 0){
                result['ordered_gross_cpp'] = parseFloat( result['ordered_gross_cost'] / result['ordered_grp'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                result['ordered_net_cpp'] = parseFloat( result['ordered_net_cost'] / result['ordered_grp'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            }
            else{
                result['ordered_gross_cpp'] = parseFloat( 0 ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                result['ordered_net_cpp'] = parseFloat( 0 ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            }

            result['cost_per_click'] = result['ordered_clicks'] > 0 ?  result['ordered_gross_cost'] / result['ordered_clicks'] : 0;
            result['cost_per_click'] = parseFloat(result['cost_per_click']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });

            result['ordered_gross_cost'] = parseFloat( result['ordered_gross_cost']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            result['ordered_net_cost'] = parseFloat( result['ordered_net_cost']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            result['client_cost'] = parseFloat(result['client_cost']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            result['rate_per_spot'] = parseFloat( result['rate_per_spot']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            result['rate_per_spot_net'] = parseFloat( result['rate_per_spot_net']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            result['ordered_impressions']= parseFloat( result['ordered_impressions']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            result['ordered_grp']= parseFloat( result['ordered_grp']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            result['approved_gri']= parseFloat( result['approved_gri']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            result['approved_grp']= parseFloat( result['approved_grp']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });

            result['av_grp_impressions']= parseFloat( result['av_grp_impressions']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });

            g.api.setPinnedTopRowData(
                [ result ]
            );
            close_progress_loader();
        };
        function BlankFormatRenderer() {
        }

        BlankFormatRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            if ((params.node.rowPinned == 'top') ) {
                if (typeof params.value === 'undefined')
                    this.eGui.innerHTML = '';
                else
                    this.eGui.innerHTML = params.value;
            }
            else {
                if (params.column.colDef.field == 'market' || params.column.colDef.field == 'campaign' || params.column.colDef.field == 'advertiser' || params.column.colDef.field == 'product' || params.column.colDef.field == 'brand' ||
                    params.column.colDef.field == 'campstart' || params.column.colDef.field == 'campend' || params.column.colDef.field == 'wv_number' || params.column.colDef.field == 'vendor' || params.column.colDef.field == 'vendor_code' || params.column.colDef.field == 'vendor_pubid' ||
                    params.column.colDef.field == 'order_type' || params.column.colDef.field == 'owner' || params.column.colDef.field == 'estimate_number' || params.column.colDef.field == 'job_number' ||
                    params.column.colDef.field == 'campaign_number' ||  params.column.colDef.field == 'accounting' ||  params.column.colDef.field == 'accounting_date') {
                    if (params.node.level == 0)
                        this.eGui.innerHTML = params.value;
                    else
                        this.eGui.innerHTML = '';
                } else if (params.column.colDef.field == 'network' || params.column.colDef.field == 'rev_number' || params.column.colDef.field == 'time_of_day' || params.column.colDef.field == 'type_spot_length' ||
                    params.column.colDef.field == 'run_date' || params.column.colDef.field == 'day_of_week' || params.column.colDef.field == 'daypart' || params.column.colDef.field == 'programming' ||
                    params.column.colDef.field == 'station_format' || params.column.colDef.field == 'cable_zone' || params.column.colDef.field == 'length' ||
                    params.column.colDef.field == 'size'  || params.column.colDef.field == 'issue_vol' || params.column.colDef.field == 'comments' || params.column.colDef.field == "ad_date") {
                    if (params.node.level == 2)
                        this.eGui.innerHTML = params.value;
                    else
                        this.eGui.innerHTML = '';
                } else if (params.column.colDef.field === 'client_cost' || params.column.colDef.field == 'ordered_ads' || params.column.colDef.field == 'ordered_grp' || params.column.colDef.field == 'ordered_grp' || params.column.colDef.field == 'ordered_impressions' || params.column.colDef.field == 'av_grp_impressions' ||
                    params.column.colDef.field == 'ordered_gross_cost' || params.column.colDef.field == 'ordered_net_cost' || params.column.colDef.field == 'ordered_gross_cpp' || params.column.colDef.field == 'ordered_net_cpp' ||
                    params.column.colDef.field == 'ordered_gross_cpm' || params.column.colDef.field == 'ordered_net_cpm' || params.column.colDef.field == 'spend_difference_gross' || params.column.colDef.field == 'spend_difference_net' ||
                    params.column.colDef.field == 'ordered_clicks' ||  params.column.colDef.field == 'cost_per_click') {
                    if (params.node.level == 0 || params.node.level == 1 || params.node.level == 2)
                        this.eGui.innerHTML = params.value;
                    else
                        this.eGui.innerHTML = '';
                }
            }
        };
        BlankFormatRenderer.prototype.getGui = function () {
            return this.eGui;
        };
        columnInvExportInfo = [
            {
                headerName: "Order. No",
                field: 'order_number',
                width: 130,
                cellStyle: {'text-align': "right"},
                //  hide: (custom_details.indexOf("Order. No") !== -1) ? false : true,
                rowGroupIndex: 0,
                hide: true,
               // pinned:'left',
                suppressMovable: true,
                cellRenderer: function(params) {
                    var html = '';
                    if (typeof params.value !== 'undefined' &&  params.value.indexOf('-') !== -1)
                        html = "  <span style='color:#B7432C; text-align: left'>" +  params.value + "</span> ";
                    else
                        html = "  <span style='text-align: left'>" + params.value + "</span> ";
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    this.eGui = tempDiv.firstElementChild;
                    return this.eGui;
                },
            },
            {
                headerName: "Order Rev. No",
                field: 'rev_number',
                width: 130,
                cellStyle: {'text-align': "right"},
                pinned: 'left',
                cellRenderer: BlankFormatRenderer,
                // rowGroupIndex: 1,
                // hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Order Line",
                field: 'order_line',
                width: 130,
                cellStyle: {'text-align': "right"},
                // hide: (custom_details.indexOf("Order Line") !== -1) ? false : true
                rowGroupIndex: 2,
                hide: true,
               // pinned:'left',
                suppressMovable: true,
                pinned: 'left'
            },
            {
                headerName: "Month",
                field: 'broadcast_month',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
               // pinned:'left',
                suppressMovable: true,
            },
            {
                headerName: "order line id",
                field: 'order_line_id',
                width: 120,
                cellStyle: {'text-align': "right"},
                hide: true,
            },
            {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Advertiser") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            }, {
                headerName: "Campaign",
                field: 'campaign',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign") !== -1) ? false : true,
               cellRenderer: BlankFormatRenderer,
            }, {
                headerName: "Market",
                field: 'market',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Market") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Brand",
                field: 'brand',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Brand") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            }, {
                headerName: "Product",
                field: 'product',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Product") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Camp. Start",
                field: 'campstart',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign Start Date") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            }, {
                headerName: "Camp. End",
                field: 'campend',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign End Date") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Camp. No.",
                field: 'campaign_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Camp. No.") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Accounting",
                field: 'accounting',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Accounting Order No.") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            }, {
                headerName: "Order Transfer Date",
                field: 'accounting_date',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Order Transfer Date") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Work. Version No.",
                field: 'wv_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Version Number") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
           {
                headerName: "Est. No.",
                field: 'estimate_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Estimate No.") !== -1) ? false : true,
               cellRenderer: BlankFormatRenderer,
            }, {
                headerName: "Job No.",
                field: 'job_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Job No.") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },

           {
                headerName: "Vendor",
                field: 'vendor',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Vendor") !== -1) ? false : true,
               cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Vendor ID",
                field: 'vendor_code',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Vendor ID") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Vendor Pub/ID",
                field: 'vendor_pubid',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Vendor Pub/ID") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Owner",
                field: 'owner',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Owner") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Media Type",
                field: 'order_type',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Media Type") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },

            // {
            //     headerName: "Order Line",
            //     field: 'order_line',
            //     width: 100,
            //     cellStyle: {'text-align': "right"},
            //     hide: (custom_details.indexOf("Order Line") !== -1) ? false : true
            // },

            {
                headerName: "Daypart",
                field: 'daypart',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Daypart") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,

            },
            {
                headerName: "Length",
                field: 'length',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Length") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Network",
                field: 'network',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Network") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Programming",
                field: 'programming',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Programming") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Station Format",
                field: 'station_format',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Station Format") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Cable Zone",
                field: 'cable_zone',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Cable Zone") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ad Date",
                field: 'ad_date',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Ad Date") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Size",
                field: 'size',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Size") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Issue/Vol",
                field: 'issue_vol',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Issue/Vol") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Comments",
                field: 'comments',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Comments") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },

            {
                headerName: "Ordered <br> Ads",
                field: 'ordered_ads',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Ads") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> GRPs",
                field: 'ordered_grp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered GRPs") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> GRIs",
                field: 'ordered_impressions',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered GRIs") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Gross Cost",
                field: 'ordered_gross_cost',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Gross Cost") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Net Cost",
                field: 'ordered_net_cost',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Net Cost") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Client Cost",
                field: 'client_cost',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Client Cost") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Gross CPP",
                field: 'ordered_gross_cpp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Gross CPP") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Net CPP",
                field: 'ordered_net_cpp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Net CPP") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Gross CPM",
                field: 'ordered_gross_cpm',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Gross CPM") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Net CPM",
                field: 'ordered_net_cpm',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Net CPM") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered <br> Clicks",
                field: 'ordered_clicks',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Clicks") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Ordered Cost <br> per Click",
                field: 'cost_per_click',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ordered Cost per Click") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Inv. Number",
                field: 'invoice_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Invoice No.") !== -1) ? false : true
            }, {
                headerName: "Inv. Transfer Date",
                field: 'inv_sent_accounting',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Invoice Transfer Date") !== -1) ? false : true
            },
            {
                headerName: "Commercial ID",
                field: 'comercial_id',
                width: 130,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Commercial ID") !== -1) ? false : true
            },
            {
                headerName: "Tag",
                field: 'tag',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Tag") !== -1) ? false : true
            },
            {
                headerName: "Approved <br> Ads",
                field: 'ads',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Approved Ads") !== -1) ? false : true,
               // aggFunc: 'sum',
            },
            {
                headerName: "Approved <br> Impressions",
                field: 'impressions_invoiced',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Approved Impressions") !== -1) ? false : true,
                headerTooltip: 'The Invoice Impressions is applicable to Digital media only.',
               // aggFunc: 'sum',
            },
            {
                headerName: "Approved <br> Gross Cost",
                field: 'rate_per_spot',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Approved Gross Cost") !== -1) ? false : true,
               // aggFunc: avgAggFunction,
            },
            {
                headerName: "Approved <br> Net Cost",
                field: 'rate_per_spot_net',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Approved Net Cost") !== -1) ? false : true
            },
            {
                headerName: "Approved <br> GRPs",
                field: 'approved_grp',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Approved GRPs") !== -1) ? false : true
            },
            {
                headerName: "Approved <br> GRIs",
                field: 'approved_gri',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Approved GRIs") !== -1) ? false : true
            },

            {
                headerName: "Time Aired",
                field: 'time_of_day',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Time Aired") !== -1) ? false : true
            }, {
                headerName: "Length Aired",
                field: 'type_spot_length',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Length Aired") !== -1) ? false : true
            }, {
                headerName: "Date Aired",
                field: 'run_date',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Date Aired") !== -1) ? false : true
            }, {
                headerName: "Day Aired",
                field: 'day_of_week',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Day Aired") !== -1) ? false : true
            },
            {
                headerName: "Spend  <br> Difference Gross",
                field: 'spend_difference_gross',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Spend Difference Gross") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Spend <br> Difference Net",
                field: 'spend_difference_net',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Spend Difference Net") !== -1) ? false : true,
                cellRenderer: BlankFormatRenderer,
            },

        ];
        var html = '';
        var html_1 = '';
        var est_arra = ['Ordered Client Cost','Ordered  Ads','Ordered  GRPs', 'Ordered  Impressions','Ordered  Gross Cost', 'Ordered  Net Cost',
            'Ordered  Gross CPP',' Ordered   Net CPP', 'Ordered  Gross CPM', 'Ordered  Net CPM', 'Avg. GRPs/Impressions', 'Invoiced  Ads', 'Invoice Impressions' ,'Invoiced  Gross Cost', 'Date Aired', 'Invoiced  Net Cost', 'Time Aired', 'Length Aired', 'Day Aired',
            'Spend   Difference Gross','Spend  Difference Net', 'GRPs', 'Ads', 'GRIs', 'Impressions', 'Gross Cost', 'Net Cost', 'Gross CPP', 'Gross CPP', 'Net CPP', 'Gross CPM', 'Net CPM', 'Approved GRPs', 'Approved GRIs'];
         columnInvExportInfo.sort(function(a, b) {
            return a.headerName.replace('<br>', '') == b.headerName.replace('<br>', '') ? 0 : a.headerName.replace('<br>', '') < b.headerName.replace('<br>', '') ? -1 : 1
        })

        for(var ind in columnInvExportInfo){

            if(columnInvExportInfo[ind].field !== 'order_number' && columnInvExportInfo[ind].field !== 'order_line_id' && columnInvExportInfo[ind].field !== 'broadcast_month' && columnInvExportInfo[ind].field !== 'order_line' ) {
                var hidden = (columnInvExportInfo[ind].hide) ? ["hidden-column", "background-color: rgb(204, 204, 204);"] : ["", ""]
                if(est_arra.indexOf(columnInvExportInfo[ind].headerName.replace('<br>', '')) !== -1){
                    html_1 += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px;">' +
                        '<a class="dropdown-item ' + hidden[0] + '" data-hidden="' + columnInvExportInfo[ind].field + '" style="' + hidden[1] + '">   ' + columnInvExportInfo[ind].headerName.replace('<br>', '') + '</a></li>';
                }
                else{
                    html += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px; ">' +
                        '<a   class="dropdown-item ' + hidden[0] + '" data-hidden="' + columnInvExportInfo[ind].field + '" style="' + hidden[1] + '">   ' + columnInvExportInfo[ind].headerName.replace('<br>', '') + '</a></li>';
                }
            }
        }
        var html_list = ' <li class="dropdown-header" style=" color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>DISPLAY OPTIONS</strong></li>';
        html_list += html;
        html_list += ' <li class="dropdown-header" style="color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>METRIC OPTIONS</strong></li>';
        html_list += html_1;

         $("#inv-detail-hiden-columns").html(html_list);

        $('.smart-rpt-analysis-hide-column a').bind('click', function (e) {
            var attr = $(this).attr('data-hidden');
            if ($(this).hasClass('hidden-column') ) {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            } else {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        var InvoceDetailAggFunction = function (nodes){
            var result = {};
            var added_taxes = [];
            var added_taxes_t = [];
            if (nodes[0] != undefined) {
                if (nodes[0].level === 2){
                    var array_invoiced= ['ads', 'impressions_invoiced', 'rate_per_spot','rate_per_spot_net', 'spend_difference_gross', 'spend_difference_net', 'approved_grp', 'approved_gri'];
                    var array_ordered= [
                        'ordered_ads', 'ordered_gross_cost', 'ordered_net_cost', 'ordered_impressions', 'ordered_gross_cpp', 'ordered_net_cpp', 'ordered_grp','ordered_gross_cpm', 'ordered_net_cpm',
                        'av_grp_impressions', 'client_cost', 'ordered_clicks', 'cost_per_click'
                    ];
                    //order
                    result['ordered_ads']=0;
                    result['ordered_clicks']=0;
                    result['cost_per_click']=0;
                    result['ordered_gross_cost']=0;
                    result['ordered_net_cost']=0;
                    result['ordered_impressions']=0;
                    result['ordered_gross_cpp']=0;
                    result['ordered_net_cpp']=0;
                    result['ordered_gross_cpm']=0;
                    result['ordered_net_cpm']=0;
                    result['ordered_grp']=0;
                    result['av_grp_impressions']=0;
                    result['client_cost']=0;

                    //invoice
                    result['ads']=0;
                    result['rate_per_spot']=0;
                    result['rate_per_spot_net']=0;
                    result['spend_difference_gross']=0;
                    result['spend_difference_net']=0;
                    result['impressions_invoiced']=0;
                    result['approved_gri']=0;
                    result['approved_grp']=0;
                    var gri = 0;
                    var media = '';
                    var rev_id = 0;
                    var month = '';
                    var invoices_added = [];
                    var invoices_added_text = '';
                    var invoices_sent_added = [];
                    var invoices_sent_text = '';

                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterFilter, function (index, value) {
                            if(index == 0) {
                             //   gri +=  value['data']['ordered_impressions'].replace(/,/g, '') * value['data']['ordered_ads'];
                                gri +=  value['data']['ordered_impressions'].replace(/,/g, '') ;
                                vbl = value['data']['ordered_ads'];
                                mm = value['data']['order_type'];
                                media = value['data']['order_type'];
                                rev_id = value['data']['rev_id'];
                                month = value['data']['broadcast_month'];
                                console.log('detail_report inside the node', value);

                                if(value['data']['invoice_number'] !== '-' && value['data']['invoice_number'] !== '' && value['data']['invoice_number'] !== null && invoices_added.indexOf(value['data']['invoice_number']) === -1) {
                                   if(invoices_added.length === 0)
                                       invoices_added_text += value['data']['invoice_number'];
                                   else
                                       invoices_added_text += ' ,'+ value['data']['invoice_number'];
                                    invoices_added.push(value['data']['invoice_number']);
                                }
                                if(value['data']['inv_sent_accounting'] !== '' && value['data']['inv_sent_accounting'] !== '' && value['data']['inv_sent_accounting'] !== null && invoices_sent_added.indexOf(value['data']['inv_sent_accounting']) === -1) {
                                    if(invoices_sent_text.length === 0)
                                        invoices_sent_text += value['data']['inv_sent_accounting'];
                                    else
                                        invoices_sent_text += '/ '+ value['data']['inv_sent_accounting'];
                                    invoices_sent_added.push(value['data']['inv_sent_accounting']);
                                }
                                if(typeof value['data']['taxes'] !== 'undefined' && typeof added_taxes[value['data']['invoice_number']] === 'undefined'){
                                    added_taxes[value['data']['invoice_number']] = 1;
                                    result['rate_per_spot_net'] += parseFloat(value['data']['taxes']);
                                }

                                for(var xx in result){
                                    if(array_ordered.indexOf(xx) !== -1) {
                                        if(typeof value['data'][xx] !== 'undefined') {
                                            if (xx === 'ordered_ads' || xx === 'ordered_clicks')
                                                result[xx] += value['data'][xx];
                                            else  {
                                                if(mm !== 'Digital') {
                                                    var sum = value['data'][xx].replace('$', '');
                                                    sum = sum.replace(/,/g, '');
                                                    result[xx] += parseFloat(sum)
                                                }
                                                else{
                                                    var sum = value['data'][xx].replace('$', '');
                                                    sum = sum.replace(/,/g, '');
                                                    if(vbl > 0 || mm === 'Digital')
                                                        result[xx] += (parseFloat(sum) );
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            $.each(value['data'], function (index, value) {
                                if(index =='order_type')
                                    media = value;
                               if (index in result) {
                                   if (typeof value !== 'undefined') {
                                       if(array_invoiced.indexOf(index) !== -1) {
                                           if (isNaN(value)) {
                                               var sum = value.replace('$', '');
                                               sum = sum.replace(/,/g, '');
                                               result[index] += parseFloat(sum)
                                           } else
                                               result[index] += parseFloat(value);
                                      }
                                   }
                               }
                            });
                        });
                    });
                    if(media === 'Digital'){
                        if(typeof digital_comisions_invoices[rev_id] !== 'undefined'){
                            result['rate_per_spot_net'] = result['rate_per_spot'] - ((result['rate_per_spot'] * digital_comisions_invoices[rev_id]['commission']) / 100);
                        }
                    }
                    if(media === 'OOH'){
                        if(typeof ooh_comisions_invoices[rev_id] !== 'undefined'){
                            result['rate_per_spot_net'] = result['rate_per_spot'] - ((result['rate_per_spot'] * ooh_comisions_invoices[rev_id]['commission']) / 100);
                        }
                    }


                    if(media === 'OOH' || media === 'Other' || media === 'Digital') {
                        if (typeof motnhly_cost_breakout[rev_id] !== 'undefined' && typeof motnhly_cost_breakout[rev_id][month] !== 'undefined')
                            result['ordered_gross_cost'] = motnhly_cost_breakout[rev_id][month];
                    }
                    result['invoice_number'] = invoices_added_text;
                    result['inv_sent_accounting'] = invoices_sent_text;

                    result['spend_difference_gross'] = parseFloat( parseFloat(result['ordered_gross_cost']) - parseFloat(result['rate_per_spot'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['spend_difference_net'] = parseFloat( parseFloat(result['ordered_net_cost']) - parseFloat(result['rate_per_spot_net'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    if( result['ordered_grp'] > 0){
                        result['ordered_gross_cpp'] = parseFloat( result['ordered_gross_cost'] / result['ordered_grp'] ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpp'] = parseFloat( result['ordered_net_cost'] / result['ordered_grp'] ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    else{
                        result['ordered_gross_cpp'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpp'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    if(gri > 0){
                        result['ordered_gross_cpm'] = parseFloat( result['ordered_gross_cost'] / gri ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpm'] = parseFloat( result['ordered_net_cost'] / gri ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    else{
                        result['ordered_gross_cpm'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpm'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    var cost_per_click = result['ordered_clicks'] > 0 ? result['ordered_gross_cost'] / result['ordered_clicks'] : 0
                    result['cost_per_click'] = parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    result['ordered_gross_cost'] = parseFloat( result['ordered_gross_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['client_cost'] = parseFloat( result['client_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['ordered_net_cost'] = parseFloat( result['ordered_net_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['rate_per_spot'] = parseFloat( result['rate_per_spot']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['rate_per_spot_net'] = parseFloat( result['rate_per_spot_net']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['ordered_grp']= parseFloat( result['ordered_grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['approved_grp']= parseFloat( result['approved_grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['approved_gri']= parseFloat( result['approved_gri']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['ordered_impressions']= parseFloat( result['ordered_impressions']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['impressions_invoiced']= parseInt( result['impressions_invoiced']);
                    console.log('result_node_level_2 ', result);


                }
                else if (nodes[0].level === 1){
                    var array_ordered = ['client_cost', 'ordered_ads', 'ordered_gross_cost', 'ordered_net_cost', 'ordered_impressions', 'ordered_gross_cpp', 'ordered_net_cpp', 'ordered_grp','ordered_gross_cpm', 'ordered_net_cpm', 'av_grp_impressions']
                    var array_data =  [ 'advertiser', 'campaign', 'market', 'vendor', 'vendor_pubid', 'vendor_code', 'owner', 'order_type', 'brand', 'product', 'estimate_number','job_number', 'campaign_number', 'campstart', 'campend', 'wv_number', 'accounting', 'accounting_date' ];
                    var array_invoiced = ['ads', 'impressions_invoiced','rate_per_spot','rate_per_spot_net', 'spend_difference_gross', 'spend_difference_net', 'approved_gri', 'approved_grp', 'ordered_clicks', 'cost_per_click'];

                    //order
                    result['ordered_ads']=0;
                    result['ordered_clicks']=0;
                    result['ordered_gross_cost']=0;
                    result['ordered_net_cost']=0;
                    result['ordered_impressions']=0;
                    result['ordered_gross_cpp']=0;
                    result['ordered_net_cpp']=0;
                    result['ordered_gross_cpm']=0;
                    result['ordered_net_cpm']=0;
                    result['ordered_grp']=0;
                    result['av_grp_impressions']=0;
                    result['client_cost']=0;


                    //oreder data
                    result['advertiser']='';
                    result['campaign']='';
                    result['market']='';
                    result['vendor']='';
                    result['vendor_pubid']='';
                    result['vendor_code']='';
                    result['owner']='';
                    result['order_type']='';
                    result['brand']='';
                    result['product']='';
                    result['estimate_number']='';
                    result['job_number']='';
                    result['campaign_number']='';
                    result['campstart']='';
                    result['campend']='';
                    result['wv_number']='';
                    result['accounting']='';
                    result['accounting_date']='';

                    //invoice
                    result['ads']=0;
                    result['rate_per_spot']=0;
                    result['rate_per_spot_net']=0;
                    result['spend_difference_gross']=0;
                    result['spend_difference_net']=0;
                    result['impressions_invoiced']=0;
                    result['approved_gri']=0;
                    result['approved_grp']=0;
                    var gri=0;
                    var added_taxes = [];


                    $.each(nodes, function (index, value) {
                       // nodes[index].expanded = true;
                        $.each(value.childrenAfterFilter, function (index, value) {
                            $.each(value.childrenAfterFilter, function (index, value) {
                                if(index == 0) {
                                   // gri +=  value['data']['ordered_impressions'].replace(/,/g, '') * value['data']['ordered_ads'];
                                    gri +=  value['data']['ordered_impressions'].replace(/,/g, '') ;
                                    vbl= value['data']['ordered_ads'];
                                    mm= value['data']['order_type'];
                                    for(var xx in result){
                                        if(array_ordered.indexOf(xx) !== -1) {
                                            if(typeof value['data'][xx] !== 'undefined') {
                                                if (xx == 'ordered_ads' || xx === 'ordered_clicks')
                                                    result[xx] += value['data'][xx];
                                                else  {
                                                    if(mm !== 'Digital') {
                                                        var sum = value['data'][xx].replace('$', '');
                                                        sum = sum.replace(/,/g, '');
                                                        result[xx] += parseFloat(sum)
                                                    }
                                                    else{
                                                        var sum = value['data'][xx].replace('$', '');
                                                        sum = sum.replace(/,/g, '');
                                                        if(vbl > 0 || mm === 'Digital')
                                                            result[xx] += (parseFloat(sum) );
                                                    }
                                                }
                                            }
                                        }
                                        else if(array_data.indexOf(xx) !== -1)
                                            result[xx] = value['data'][xx];
                                    }

                                    if(typeof value['data']['taxes'] !== 'undefined' && typeof added_taxes_t[value['data']['invoice_number']] === 'undefined'){
                                        added_taxes_t[value['data']['invoice_number']] = 1;
                                        result['rate_per_spot_net'] += parseFloat(value['data']['taxes']);
                                    }
                                }
                                $.each(value['data'], function (index, value) {
                                    if (index in result) {
                                        if (typeof value !== 'undefined') {
                                            if(array_invoiced.indexOf(index) !== -1 ){
                                                if(isNaN(value)) {
                                                    var sum = value.replace('$', '');
                                                    sum = sum.replace(/,/g, '');
                                                    if(isNaN(result[index])) {
                                                        var sumx = result[index].replace('$', '');
                                                        sumx = sumx.replace(/,/g, '');
                                                    }
                                                    else
                                                        sumx=  result[index];
                                                    result[index] = parseFloat(sumx) + parseFloat(sum);
                                                }
                                                else
                                                    result[index]+= parseFloat(value);

                                            }
                                        }
                                    }
                                });

                            });
                      });
                    });

                    result['spend_difference_gross'] = parseFloat( parseFloat(result['ordered_gross_cost']) - parseFloat(result['rate_per_spot'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['spend_difference_net'] = parseFloat( parseFloat(result['ordered_net_cost']) - parseFloat(result['rate_per_spot_net'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    if( result['ordered_grp'] > 0){
                        result['ordered_gross_cpp'] = parseFloat( result['ordered_gross_cost'] / result['ordered_grp'] ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpp'] = parseFloat( result['ordered_net_cost'] / result['ordered_grp'] ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    else{
                        result['ordered_gross_cpp'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpp'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    if(gri > 0){
                        result['ordered_gross_cpm'] = parseFloat( result['ordered_gross_cost'] / gri ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpm'] = parseFloat( result['ordered_net_cost'] / gri ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    else{
                        result['ordered_gross_cpm'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['ordered_net_cpm'] = parseFloat( 0 ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    var cost_per_click = result['ordered_clicks'] > 0 ? result['ordered_gross_cost'] / result['ordered_clicks'] : 0
                    result['cost_per_click'] = parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    result['rate_per_spot_net'] = parseFloat( result['rate_per_spot_net']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });


                   result['ordered_gross_cost'] = parseFloat( result['ordered_gross_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                   result['client_cost'] = parseFloat( result['client_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['ordered_net_cost'] = parseFloat( result['ordered_net_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['rate_per_spot'] = parseFloat( result['rate_per_spot']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['ordered_impressions']= parseFloat( result['ordered_impressions']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['ordered_grp']= parseFloat( result['ordered_grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['approved_gri']= parseFloat( result['approved_gri']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['approved_grp']= parseFloat( result['approved_grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });

                    result['av_grp_impressions']= parseFloat( result['av_grp_impressions']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['impressions_invoiced'] = parseInt( result['impressions_invoiced']);

                    console.log('result_node_level_1 ', result);

               }
                else if(nodes[0].level === 3) {
                    var array_ordered= [
                        'client_cost', 'ordered_ads', 'ordered_gross_cost', 'ordered_net_cost', 'ordered_impressions', 'ordered_gross_cpp', 'ordered_net_cpp', 'ordered_grp','ordered_gross_cpm', 'ordered_net_cpm', 'av_grp_impressions',
                        'daypart', 'length', 'programming', 'network', 'station_format', 'cable_zone', 'rev_number', 'accounting','accounting_date', 'ad_date', 'size', 'issue_vol','comments', 'ordered_clicks', 'cost_per_click'
                    ];
                    var array_invoiced= ['ads', 'impressions_invoiced','rate_per_spot','rate_per_spot_net', 'spend_difference_gross', 'spend_difference_net', 'approved_gri', 'approved_grp'];

                    result['ordered_ads']=0;
                    result['ordered_clicks']=0;
                    result['ordered_gross_cost']= 0;
                    result['ordered_net_cost']=0;
                    result['ordered_impressions']=0;
                    result['ordered_gross_cpp']=0;
                    result['ordered_net_cpp']=0;
                    result['ordered_gross_cpm']=0;
                    result['ordered_net_cpm']=0;
                    result['ordered_grp']=0;
                    result['av_grp_impressions']=0;
                    result['client_cost']=0;
                    result['cost_per_click']=0;


                    //line datas
                    result['daypart']='';
                    result['length']='';
                    result['programming']='';
                    result['network']='';
                    result['station_format']='';
                    result['cable_zone']='';
                    result['ad_date']='';
                    result['size']='';
                    result['issue_vol']='';
                    result['comments']='';
                    result['rev_number']='';
                    result['accounting']='';
                    result['accounting_date']='';

                    result['ads']=0;
                    result['rate_per_spot']=0;
                    result['rate_per_spot_net']=0;
                    result['spend_difference_gross']=0;
                    result['spend_difference_net']=0;
                    result['impressions_invoiced']=0;
                    result['approved_gri']=0;
                    result['approved_grp']=0;

                    $.each(nodes, function (index, value) {
                        if(index == 0) {
                           for(var xx in result){
                               if(array_ordered.indexOf(xx) !== -1) {
                                   if(typeof value['data'][xx] !== 'undefined')
                                       result[xx] = value['data'][xx];
                               }
                           }

                        }
                         $.each(value['data'], function (index, value) {
                               if (index in result) {
                                   if (typeof value !== 'undefined') {
                                       if(array_invoiced.indexOf(index) !== -1) {
                                           if (index == 'ads' || index == 'impressions_invoiced')
                                               result[index] += value;
                                           else  {
                                               var sum = value.replace('$', '');
                                               sum = sum.replace(/,/g, '');
                                               result[index] += parseFloat(sum)
                                           }
                                       }
                                   }
                               }
                          });
                    });
                    if(isNaN(result['ordered_gross_cost'])) {
                        var or_gross = result['ordered_gross_cost'].replace('$', '');
                        or_gross = or_gross.replace(/,/g, '');
                    }
                    else
                        or_gross = result['ordered_gross_cost'];

                    if(isNaN(result['ordered_net_cost'])) {
                        var or_net = result['ordered_net_cost'].replace('$', '');
                        or_net = or_net.replace(/,/g, '');
                    }
                    else
                        or_net = result['ordered_net_cost'];

                    result['spend_difference_gross'] = parseFloat( parseFloat(or_gross) - parseFloat(result['rate_per_spot'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    result['spend_difference_net'] = parseFloat( parseFloat(or_net) - parseFloat(result['rate_per_spot_net'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    result['rate_per_spot'] = parseFloat( result['rate_per_spot']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['rate_per_spot_net'] = parseFloat( result['rate_per_spot_net']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['impressions_invoiced']=  parseInt( result['impressions_invoiced'])
                    result['ordered_impressions']= parseFloat( result['ordered_impressions']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['ordered_grp']= parseFloat( result['ordered_grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['approved_gri']= parseFloat( result['approved_gri']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['approved_grp']= parseFloat( result['approved_grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                }

               return result;
            }
            else
                return false;


        };
         gridInvExportInfo = {
            columnDefs: columnInvExportInfo,
             autoGroupColumnDef: {
                 headerName: 'Orders',//custom header name for group
                 pinned: 'left',//force pinned left. Does not work in columnDef
                 suppressMovable: false,
                 suppressFilter: false,
                 cellRendererParams: {
                     suppressCount: true,//remove number in Group Column
                     suppressMovable: false,
                     suppressFilter: false,
                 }
             },
             defaultColDef: {
                 width: 150,
                 suppressToolPanel: true
             },
             //pinnedTopRowData:  totalInvDetailUpd (this),
             enableColResize: true,
             //suppressMenuColumnPanel: true,
             suppressTouch: true,
             headerHeight: 35,
             suppressDragLeaveHidesColumns: true,
             enableCellChangeFlash: true,
             rowHeight: 20,
             suppressRowHoverClass: true,
             toolPanelSuppressValues: true,defaultToolPanel: '',
             suppressParentsInRowNodes: true,
             toolPanelSuppressValues: true,
             toolPanelSuppressRowGroups: true,
             groupUseEntireRow: false,
             groupDefaultExpanded: 0,
             marryChildren: true,
             suppressAggFuncInHeader: true,
             enableFilter: true,
             enableSorting: true,
             animateRows: true,
             groupRowAggNodes: function (nodes) {
                 return InvoceDetailAggFunction(nodes);
             },
             onGridReady: function (e) {
                 totalInvDetailUpd (this)
             },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            getContextMenuItems: getContextMenuInvoiceOrder,
            onFilterChanged: function (e) {
                totalInvDetailUpd(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters').show();
                else
                    $('#reset_filters').hide();
            },
        };

        $('#myGridInvDetail').html('');
        gridInvExportInfo.rowData = rowdata;
        var gridDet = document.querySelector('#myGridInvDetail');
        var grid = new agGrid.Grid(gridDet, gridInvExportInfo);

        $('#reset_filters').on('click', function () {
            $.each(gridInvExportInfo.api.getFilterModel(), function (index, value) {
                gridInvExportInfo.api.destroyFilter(index);
            });
        });
    }
    else if($(".inv_status_report_header").length > 0) {
        show_loader();
        console.log(resultss);
        var advertisers = collect(advertiserss);
        console.log("advertisers");
        console.log(advertisers);
        var campaigns = collect(campaignss);
        console.log("campaigns");
        console.log(campaigns);
        var products = collect(productss);
        console.log("products");
        console.log(products);
        var brands = collect(brandss);
        console.log("brands");
        console.log(brands);
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        columnInvExportInfo = [
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 150,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                suppressMovable: true,
                hide: true,
            },{
                headerName: "Vendor",
                field: 'vendor',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                suppressMovable: true,
                hide: true,
            }, {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 150,
                cellStyle: {'text-align': "right"},
                pinned: 'right',
                hide: (custom_details.indexOf("Advertiser") !== -1) ? false : true
            },
            {
                headerName: "Order. No",
                field: 'reference_number',
                width: 250,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Order. No") !== -1) ? false : true,
                pinned: 'right',
                cellRenderer: function(params) {
                    var html = '';
                    if (typeof params.value !== 'undefined' &&  params.value.indexOf('-') !== -1)
                        html = "  <span style='color:#B7432C; text-align: left'>" +  params.value + "</span> ";
                    else if (typeof params.value !== 'undefined')
                        html = "  <span style='text-align: left'>" + params.value + "</span> ";
                    else
                        html = "  <span style='text-align: left'></span> ";
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    this.eGui = tempDiv.firstElementChild;
                    return this.eGui;
                },
            },
            {
                headerName: "Rev. No",
                field: 'revision_number',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: true,
                pinned: 'right',
            },
            {
                headerName: "Est. No.",
                field: 'estimate_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Estimate No.") !== -1) ? false : true,
                pinned: 'right',
            }, {
                headerName: "Job No.",
                field: 'job_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Job No.") !== -1) ? false : true,
                pinned: 'right',
            }, {
                headerName: "Camp. No.",
                field: 'campaign_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Camp. No.") !== -1) ? false : true,
                pinned: 'right',
            }, {
                headerName: "Camp. Start",
                field: 'campstart',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign Start Date") !== -1) ? false : true,
                pinned: 'right',
            }, {
                headerName: "Camp. End",
                field: 'campend',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign End Date") !== -1) ? false : true,
                pinned: 'right',
            }, {
                headerName: "Market",
                field: 'market',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Market") !== -1) ? false : true,
                pinned: 'right',
            },  {
                headerName: "Brand",
                field: 'brand',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Brand") !== -1) ? false : true,
                pinned: 'right',
            }, {
                headerName: "Product",
                field: 'product',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Product") !== -1) ? false : true,
                pinned: 'right',
            },
        ];
        console.log('months_complete ', months_complete);
        for(var x in months_complete){
            columnInvExportInfo.push({
                headerName: moment(months_complete[x]).format('MMMM/YYYY'),
                field:  moment(months_complete[x]).format('MMMM/YYYY'),
                width: 120,
                cellStyle: {'text-align': "right"},
                cellClassRules: {
                    'matched-class': function (params) {
                        console.log('params ', params)
                        if (typeof params.value !== 'undefined' && params.node.rowPinned != 'top') {
                            if ( params.value === 'Matched')
                                return true;
                        }
                    },
                    'partially-matched-class': function (params) {
                        if (params.value !== 'undefined' && params.node.rowPinned != 'top') {
                            console.log( params.value);
                            if ( params.value === 'Partially Matched')
                                return true;
                        }
                    },
                    'not-in-class': function (params) {
                        if (params.value !== 'undefined' && params.node.rowPinned != 'top') {
                            if ( params.value === 'Not In')
                                return true;
                        }
                    },
                    'entered-class': function (params) {
                        if (params.value !== 'undefined' && params.node.rowPinned != 'top') {
                            if ( params.value === 'Entered')
                                return true;
                        }
                    },

                },
            });
        }
        var html = '';
        var html_1 = '';
        var est_arra = ['Ordered  Ads','Ordered  GRPs', 'Ordered  Impressions','Ordered  Gross Cost', 'Ordered  Net Cost',
            'Ordered  Gross CPP',' Ordered   Net CPP', 'Ordered  Gross CPM', 'Ordered  Net CPM', 'Avg. GRPs/Impressions', 'Invoiced  Ads', 'Invoiced  Gross Cost', 'Date Aired', 'Invoiced  Net Cost', 'Time Aired', 'Length Aired', 'Day Aired',
            'Spend   Difference Gross','Spend  Difference Net', 'GRPs', 'Ads', 'GRIs', 'Impressions', 'Gross Cost', 'Net Cost', 'Gross CPP', 'Gross CPP', 'Net CPP', 'Gross CPM', 'Net CPM'];
        columnInvExportInfo.sort(function(a, b) {
            return a.headerName.replace('<br>', '') == b.headerName.replace('<br>', '') ? 0 : a.headerName.replace('<br>', '') < b.headerName.replace('<br>', '') ? -1 : 1
        })

        for(var ind in columnInvExportInfo){
            if( columnInvExportInfo[ind].headerName !== 'Campaign' && columnInvExportInfo[ind].headerName !== 'Vendor') {
                var hidden = (columnInvExportInfo[ind].hide) ? ["hidden-column", "background-color: rgb(204, 204, 204);"] : ["", ""]
                if (est_arra.indexOf(columnInvExportInfo[ind].headerName.replace('<br>', '')) !== -1)
                    html_1 += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="dropdown-item ' + hidden[0] + '" data-hidden="' + columnInvExportInfo[ind].field + '" style="' + hidden[1] + '">' + columnInvExportInfo[ind].headerName + '</a></li>';
                else
                    html += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="dropdown-item ' + hidden[0] + '" data-hidden="' + columnInvExportInfo[ind].field + '" style="' + hidden[1] + '">' + columnInvExportInfo[ind].headerName + '</a></li>';
            }
        }
        var html_list = ' <li class="dropdown-header" style=" color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>DISPLAY OPTIONS</strong></li>';
        html_list += html;
        html_list += ' <li class="dropdown-header" style="color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>METRIC OPTIONS</strong></li>';
        html_list += html_1;
        $("#inv-status-hiden-columns").html(html_list);
        $('.smart-rpt-analysis-hide-column a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-hidden');
            if ($(this).hasClass('hidden-column') ) {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            } else {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        gridInvExportInfo = {
            columnDefs: columnInvExportInfo,
            autoGroupColumnDef: {
                headerName: 'Campaign',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            toolPanelSuppressValues: true,
            defaultToolPanel: '',
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 30,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            getContextMenuItems: getContextMenuInvoiceOrder,
            onFilterChanged: function (e) {
               //totalTVUpdateDataMatrix(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters').show();
                else
                    $('#reset_filters').hide();
            },
        };

        $('#myGridInvStatus').html('');
        gridInvExportInfo.rowData = [];
        console.log('resultss.data at the end ', results);
        gridInvExportInfo.rowData = resultss;
        var gridDet = document.querySelector('#myGridInvStatus');
        var grid = new agGrid.Grid(gridDet, gridInvExportInfo);

        gridInvExportInfo.api.forEachNode(function(node) {
            node.setExpanded(true);
        });

        $('#reset_filters').on('click', function () {
            $.each(gridInvExportInfo.api.getFilterModel(), function (index, value) {
                gridInvExportInfo.api.destroyFilter(index);
            });
        });

        console.log("radio and tv");
        console.log(rowdata);

        hide_loader();

    }
    else if($(".matrix_report_header").length > 0) {
        init_progress_loader(2, 'Loading Report. Please wait ...');
        for(var x in alldata)
            alldata[x]['startdate'] = flight_dates[alldata[x]['flight_date_id']]["date"].split(" ")[0]

        alldata = collect(alldata);
        var results = [];
        var totals = {};
        for(var h in week_dates) {
            totals['impressions_' + week_dates[h]] = 0;
            totals['ads_' + week_dates[h]] = 0;
            totals['cost_' + week_dates[h]] = 0;
            totals['net_cost_' + week_dates[h]] = 0;
            totals['grp_' + week_dates[h]] = 0;
            totals['gri_' + week_dates[h]] = 0;
            totals['cpp_' + week_dates[h]] = 0;
            totals['net_cpp_' + week_dates[h]] = 0;
            totals['cpm_' + week_dates[h]] = 0;
            totals['net_cpm_' + week_dates[h]] = 0;
        }

        var advts = alldata.groupBy("advname").all();
        for (var aname in advts) {
            var camps = collect(advts[aname]).groupBy("campname").all();
            for (var cname in camps) {
                var mkets = collect(camps[cname]).groupBy("market").all();
                for (var maname in mkets) {
                    var vndrs = collect(mkets[maname]).groupBy("vndrid").all();
                    for (var vid in vndrs) {
                        var aux2 = collect(vndrs[vid]).groupBy("mtype").all();
                        for (var mname in aux2) {
                            var dp = mname;
                            if (mname.indexOf("Television") !== -1 || mname.indexOf("Radio") !== -1) {
                                var this_week_on_hold = [];
                                var mx = (mname.indexOf("Television") !== -1) ? 'tv' : 'radio';
                                if(typeof week_on_hold[aux2[dp][0]['wv_id']] !== 'undefined' && typeof week_on_hold[aux2[dp][0]['wv_id']][aux2[dp][0]['market_id']] !== 'undefined' && typeof week_on_hold[aux2[dp][0]['wv_id']][aux2[dp][0]['market_id']][mx] !== 'undefined')
                                    this_week_on_hold = week_on_hold[aux2[dp][0]['wv_id']][aux2[dp][0]['market_id']][mx];
                                var aux3 = collect(aux2[dp]);
                                var m_name_string = '';
                                if (aux2[dp][0]['market_type'] == '')
                                    m_name_string = 'Custom - ' + maname;
                                else if (aux2[dp][0]['market_type'] == 'dma' || aux2[dp][0]['market_type'] == 'msa')
                                    m_name_string = aux2[dp][0]['market_type'].toUpperCase() + ' - ' + maname;
                                else
                                    m_name_string = 'National - ' + maname;
                                var media = aux2[dp][0]['mtype'].split("Line")[1];
                                if(media === 'OTT')
                                    media = "OTT JamLoop";

                                var res = {
                                    'brand': aux2[dp][0]['brand'],
                                    'comission': aux2[dp][0]['agency_commission'],
                                    'product': aux2[dp][0]['product'],
                                    'advertiser': aname,
                                    'campaign': cname,
                                    'estimate_number': aux2[dp][0]['estimate_number'],
                                    'job_number': aux2[dp][0]['job_number'],
                                    'campaign_number': aux2[dp][0]['campaign_number'],
                                    'campstart': aux2[dp][0]['campstart'].split("-")[1] + "/" + aux2[dp][0]['campstart'].split("-")[0],
                                    'campend': aux2[dp][0]['campend'].split("-")[1] + "/" + aux2[dp][0]['campend'].split("-")[0],
                                    'wv_number': aux2[dp][0]['wv_number'],
                                    // 'demo': aux2[dp][0]['demo_people'].toUpperCase() + " " + aux2[dp][0]['demoname'],
                                    'market': m_name_string,
                                    'media': media,
                                    'daypart': (dp_first !== null && dp_first !== "null" && dp_first !== "undefined") ? dp_first : "",
                                    'cable_zone': (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? "" : aux2[dp][0]['zone'],
                                    'vendor': aux2[dp][0]['vndr_name'],
                                    'owner': aux2[dp][0]['owner'],
                                };


                                for (var h in week_dates) {
                                    res['impressions_' + week_dates[h]] = 0;
                                    res['ads_' + week_dates[h]] = 0;
                                    res['cost_' + week_dates[h]] = 0;
                                    res['net_cost_' + week_dates[h]] = 0;
                                    res['grp_' + week_dates[h]] = 0;
                                    res['gri_' + week_dates[h]] = 0;
                                    res['cpp_' + week_dates[h]] = 0;
                                    res['net_cpp_' + week_dates[h]] = 0;
                                    res['cpm_' + week_dates[h]] = 0;
                                    res['net_cpm_' + week_dates[h]] = 0;
                                }
                                var total_line_cost = 0;
                                var aux4 = aux3.groupBy("startdate").all();
                                for (var j in aux4) {
                                    if (week_dates.indexOf(j) !== -1) {
                                        var aux5 = collect(aux4[j]);
                                        console.log('aux5 ', aux5)

                                        var ads = aux5.sum("spots");
                                        var ads = aux5.sum(function (row) {
                                            return this_week_on_hold.indexOf(row.flight_date_id) === -1 ? row.spots : 0;
                                        });

                                        if (ads > 0) {
                                            var imp = aux5.sum("impressions");
                                            totals['impressions_' + j] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(imp / 10) : parseFloat(imp);
                                            totals['ads_' + j] += parseInt(ads);
                                            var cost = aux5.sum(function (row) {
                                                if (aux2[dp][0]['vndr_name'] == "KGTV 10.1")
                                                    console.log('history cost ', row)
                                                if (typeof row.tiered_rate === 'undefined' || row.tiered_rate === 0)
                                                    return (row.spots > 0 && row.cost > 0) ? row.cost * row.spots : 0;
                                                else if (row.tiered_rate === 1 || (row.tiered_rate_value !== null && row.tiered_rate_value !== '' && !isNaN(parseFloat(row.tiered_rate_value))))
                                                    return !isNaN(parseFloat(row.spots)) ? row.tiered_rate_value * row.spots : 0;
                                                else
                                                    return 0;
                                            });
                                            total_line_cost += parseFloat(cost);

                                            totals['cost_' + j] += parseFloat(cost);
                                            totals['net_cost_' + j] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux2[dp][0]['agency_commission']) / 100)) + 'e1') + 'e-1'));
                                            var grp = aux5.sum(function (row) {
                                                if(this_week_on_hold.indexOf(row.flight_date_id) === -1)
                                                  return ((row.rating !== '') && (row.spots !== '') && (row.rating !== null) && (row.spots !== null)) ? parseFloat(Number(Math.round((row.rating) + 'e1') + 'e-1') * row.spots) : 0;
                                                else
                                                    return 0;
                                            });
                                            totals['grp_' + j] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(grp) : parseFloat(grp);
                                            var gri = aux5.sum(function (row) {
                                                if(this_week_on_hold.indexOf(row.flight_date_id) === -1)
                                                    return ((row.impressions !== '') && (row.spots !== '') && (row.impressions !== null) && (row.spots !== null)) ? parseFloat(Number(Math.round((row.impressions) + 'e1') + 'e-1') * row.spots) : 0;
                                                 else
                                                     return 0;
                                            });
                                            totals['gri_' + j] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(gri / 10) : parseFloat(gri);

                                            res['impressions_' + j] = Number(Math.round((imp) + 'e1') + 'e-1');
                                            res['ads_' + j] = ads;
                                            res['cost_' + j] = Number(Math.round((cost) + 'e1') + 'e-1');
                                            res['net_cost_' + j] = Number(Math.round((cost - (cost * parseFloat(aux2[dp][0]['agency_commission']) / 100)) + 'e1') + 'e-1');
                                            res['grp_' + j] = Number(Math.round((grp) + 'e1') + 'e-1');
                                            res['gri_' + j] = Number(Math.round((gri) + 'e1') + 'e-1');
                                            res['cpp_' + j] = (grp > 0) ? Number(Math.round((cost / grp) + 'e1') + 'e-1') : 0;
                                            res['net_cpp_' + j] = (grp > 0) ? Number(Math.round(((cost / grp) - ((cost / grp) * (parseFloat(aux2[dp][0]['agency_commission']) / 100))) + 'e1') + 'e-1') : 0;
                                            res['cpm_' + j] = (gri > 0) ? Number(Math.round((cost / gri) + 'e1') + 'e-1') : 0;
                                            res['net_cpm_' + j] = (gri > 0) ? Number(Math.round(((cost / gri) - ((cost / gri) * (parseFloat(aux2[dp][0]['agency_commission']) / 100))) + 'e1') + 'e-1') : 0;

                                        }
                                    }
                                }
                                console.log('res res before', res);
                                res['ads_totals'] = 0;
                                res['cost_totals'] = 0;
                                res['net_cost'] = 0;
                                res['grp_totals'] = 0;
                                res['gri_totals'] = 0;
                                res['cpp_totals'] = 0;
                                res['net_cpp_totals'] = 0;
                                res['cpm_totals'] = 0;
                                res['net_cpm_totals'] = 0;
                                for (var xxd in aux2[dp]) {
                                    if (this_week_on_hold.indexOf(aux2[dp][xxd].flight_date_id) === -1) {
                                        res['ads_totals'] += aux2[dp][xxd].spots;
                                        res['grp_totals'] += !isNaN(parseFloat(aux2[dp][xxd].rating)) && !isNaN(parseFloat(aux2[dp][xxd].spots)) ? parseFloat(Number(Math.round((aux2[dp][xxd].rating) + 'e1') + 'e-1') * aux2[dp][xxd].spots) : 0;

                                        if (aux2[dp][0]['mtype'].split("Line")[1] === "Radio")
                                            res['gri_totals'] += !isNaN(parseFloat(aux2[dp][xxd].impressions)) && !isNaN(parseFloat(aux2[dp][xxd].spots)) ? parseFloat(Number(Math.round((aux2[dp][xxd].impressions) + 'e1') + 'e-1') * aux2[dp][xxd].spots) / 10 : 0;
                                        else if (aux2[dp][0]['mtype'].split("Line")[1] === "Digital")
                                            res['gri_totals'] += !isNaN(parseFloat(aux2[dp][xxd].impressions)) && !isNaN(parseFloat(aux2[dp][xxd].spots)) ? parseFloat(Number(Math.round((aux2[dp][xxd].impressions) + 'e1') + 'e-1') * aux2[dp][xxd].spots) / 1000 : 0;
                                        else
                                            res['gri_totals'] += !isNaN(parseFloat(aux2[dp][xxd].impressions)) && !isNaN(parseFloat(aux2[dp][xxd].spots)) ? parseFloat(Number(Math.round((aux2[dp][xxd].impressions) + 'e1') + 'e-1') * aux2[dp][xxd].spots) : 0;
                                    }

                                }
                                res['cost_totals'] = !isNaN(parseFloat(total_line_cost)) ? total_line_cost : 0;
                                var com = aux2[dp][0]['agency_commission'];
                                res['net_cost'] = res['cost_totals'] - (res['cost_totals'] * parseFloat(com) / 100);

                                res['cpm_totals'] = (res['gri_totals'] > 0) ? parseFloat(res['cost_totals']) / parseFloat(res['gri_totals']) : 0;

                                res['cpp_totals'] = (res['grp_totals'] > 0) ? parseFloat(res['cost_totals']) / parseFloat(res['grp_totals']) : 0;

                                res['net_cpp_totals'] = (res['grp_totals'] > 0) ? (res['cost_totals'] / res['grp_totals']) - ((res['cost_totals'] / res['grp_totals']) * (parseFloat(com) / 100)) : 0;
                                res['net_cpm_totals'] = (res['gri_totals'] > 0) ? (res['cost_totals'] / res['gri_totals']) - ((res['cost_totals'] / res['gri_totals']) * (parseFloat(com) / 100)) : 0;
                                results.push(res);
                                //         }
                                //     }
                                // }
                            }
                        }
                    }
                }
            }
        }

        for(var h in week_dates) {
            var commission = (totals['cost_'+week_dates[h]] > 0) ? (1 - (totals['net_cost_'+week_dates[h]] / totals['cost_'+week_dates[h]])) : 0;
            totals['cpp_'+week_dates[h]] = (totals['grp_'+week_dates[h]] > 0) ? Number(Math.round((totals['cost_'+week_dates[h]] / totals['grp_'+week_dates[h]]) + 'e1') + 'e-1') : 0;
            totals['net_cpp_'+week_dates[h]] = (totals['grp_'+week_dates[h]] > 0) ? Number(Math.round(((totals['cost_'+week_dates[h]] / totals['grp_'+week_dates[h]]) - ((totals['cost_'+week_dates[h]] / totals['grp_'+week_dates[h]]) * (parseFloat(commission)))) + 'e1') + 'e-1') : 0;
            totals['cpm_'+week_dates[h]] = (totals['gri_'+week_dates[h]] > 0) ? Number(Math.round((totals['cost_'+week_dates[h]] / totals['gri_'+week_dates[h]]) + 'e1') + 'e-1') : 0;
            totals['net_cpm_'+week_dates[h]] = (totals['gri_'+week_dates[h]] > 0) ? Number(Math.round(((totals['cost_'+week_dates[h]] / totals['gri_'+week_dates[h]]) - ((totals['cost_'+week_dates[h]] / totals['gri_'+week_dates[h]]) * (parseFloat(commission)))) + 'e1') + 'e-1') : 0;
        }


        function totalTVUpdateDataMatrix(g) {
            var totals = {};
            for (var h in week_dates) {
                totals['impressions_' + week_dates[h]] = 0;
                totals['ads_' + week_dates[h]] = 0;
                totals['cost_' + week_dates[h]] = 0;
                totals['net_cost_' + week_dates[h]] = 0;
                totals['grp_' + week_dates[h]] = 0;
                totals['gri_' + week_dates[h]] = 0;
                totals['cpp_' + week_dates[h]] = 0;
                totals['net_cpp_' + week_dates[h]] = 0;
                totals['cpm_' + week_dates[h]] = 0;
                totals['net_cpm_' + week_dates[h]] = 0;
            }
            totals['ads_totals'] = 0;
            totals['cost_totals'] = 0;
            totals['net_cost'] = 0;
            totals['grp_totals'] = 0;
            totals['gri_totals'] = 0;
            totals['cpm_totals'] = 0;
            totals['cpp_totals'] = 0;
            totals['net_cpp_totals'] = 0;
            totals['net_cpm_totals'] = 0;

            g.api.forEachNodeAfterFilterAndSort(function (node) {
                for (var h in week_dates) {
                    if (!isNaN(parseFloat(node.data['impressions_' + week_dates[h]])))
                        totals['impressions_' + week_dates[h]] += (node.data.media === "Radio") ? parseFloat(node.data['impressions_' + week_dates[h]] / 10) : parseFloat(node.data['impressions_' + week_dates[h]]);

                    totals['ads_' + week_dates[h]] += !isNaN(parseFloat(node.data['ads_' + week_dates[h]])) ? parseInt(node.data['ads_' + week_dates[h]]) : 0;
                    totals['cost_' + week_dates[h]] += !isNaN(parseFloat(node.data['cost_' + week_dates[h]])) ? parseInt(node.data['cost_' + week_dates[h]]) : 0;
                    totals['net_cost_' + week_dates[h]] += !isNaN(parseFloat(node.data['net_cost_' + week_dates[h]])) ? parseInt(node.data['net_cost_' + week_dates[h]]) : 0;

                    if (!isNaN(parseFloat(node.data['grp_' + week_dates[h]])))
                        totals['grp_' + week_dates[h]] += (node.data.media === "Radio") ? parseFloat(node.data['grp_' + week_dates[h]]) : parseFloat(node.data['grp_' + week_dates[h]]);
                    if (!isNaN(parseFloat(node.data['gri_' + week_dates[h]]))) {
                        totals['gri_' + week_dates[h]] += (node.data.media === "Radio") ? parseFloat(node.data['gri_' + week_dates[h]]) : parseFloat(node.data['gri_' + week_dates[h]]);
                    }
                }
                totals['ads_totals'] += !isNaN(parseInt(node.data.ads_totals)) ? parseInt(node.data.ads_totals) : 0;
                totals['cost_totals'] += !isNaN(parseFloat(node.data.cost_totals)) ? parseFloat(node.data.cost_totals) : 0;
                totals['net_cost'] += parseFloat(node.data.net_cost);
                totals['grp_totals'] += parseFloat(node.data.grp_totals);

                totals['gri_totals'] += parseFloat(node.data.gri_totals);
            });

            var commission = (totals['net_cost'] > 0 && totals['cost_totals'] > 0) ? (1 - (totals['net_cost'] / totals['cost_totals'])) : 0;

            totals['cpm_totals'] = (totals['gri_totals'] > 0) ? totals['cost_totals'] / totals['gri_totals'] : 0;
            totals['cpp_totals'] = (totals['grp_totals'] > 0) ? totals['cost_totals'] / totals['grp_totals'] : 0;
            totals['net_cpp_totals'] = (totals['cpp_totals']) * (1 - (commission / 100));
            // totals['net_cpm_totals'] =  (totals['cpm_totals']) * (1 - (commission / 100));
            totals['net_cpm_totals'] = (totals['cost_totals'] > 0 && totals['gri_totals'] > 0) ? (totals['cost_totals'] / totals['gri_totals']) - ((totals['cost_totals'] / totals['gri_totals']) * (parseFloat(commission))) : 0;
            totals['net_cpp_totals'] = (totals['cost_totals'] > 0 && totals['grp_totals'] > 0) ? (totals['cost_totals'] / totals['grp_totals']) - ((totals['cost_totals'] / totals['grp_totals']) * (parseFloat(commission))) : 0;


            for (var h in week_dates) {
                var commission = (totals['net_cost_' + week_dates[h]] > 0 && totals['cost_' + week_dates[h]] > 0) ? (1 - (totals['net_cost_' + week_dates[h]] / totals['cost_' + week_dates[h]])) : 0;
                totals['cpp_' + week_dates[h]] = (totals['cost_' + week_dates[h]] > 0 && totals['grp_' + week_dates[h]] > 0) ? (totals['cost_' + week_dates[h]] / totals['grp_' + week_dates[h]]) : 0;
                totals['net_cpp_' + week_dates[h]] = (totals['cost_' + week_dates[h]] > 0 && totals['grp_' + week_dates[h]] > 0) ? ((totals['cost_' + week_dates[h]] / totals['grp_' + week_dates[h]]) - ((totals['cost_' + week_dates[h]] / totals['grp_' + week_dates[h]]) * (parseFloat(commission)))) : 0;
                totals['cpm_' + week_dates[h]] = (totals['cost_' + week_dates[h]] > 0 && totals['gri_' + week_dates[h]] > 0) ? (totals['cost_' + week_dates[h]] / totals['gri_' + week_dates[h]]) : 0;
                totals['net_cpm_' + week_dates[h]] = (totals['cost_' + week_dates[h]] > 0 && totals['gri_' + week_dates[h]] > 0) ? ((totals['cost_' + week_dates[h]] / totals['gri_' + week_dates[h]]) - ((totals['cost_' + week_dates[h]] / totals['gri_' + week_dates[h]]) * (parseFloat(commission)))) : 0;
            }


            // for (var ind in totals) {
            //     if (ind !== "ads") {
            //         if(ind.indexOf("gri") !== -1 || ind.indexOf("grp") !== -1 )
            //            totals[ind] = Number(Math.round((totals[ind]) + 'e1') + 'e-1');
            //     }
            // }
            console.log('final totals', totals)

            g.api.setPinnedTopRowData(
                [totals]
            );
        }

        columnInvExportInfo = [

            {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Advertiser") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Campaign",
                field: 'campaign',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Est. No.",
                field: 'estimate_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Estimate No.") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Job No.",
                field: 'job_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Job No.") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Camp. No.",
                field: 'campaign_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Camp. No") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Camp. Start",
                field: 'campstart',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign Start Date") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Camp. End",
                field: 'campend',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign End Date") !== -1) ? false : true,
                pinned: 'left',
            },{
                headerName: "Comission",
                field: 'comission',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
                pinned: 'left',
            },
            {
                headerName: "Brand",
                field: 'brand',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Brand") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Product",
                field: 'product',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Product") !== -1) ? false : true,
                pinned: 'left',
            },
          {
                headerName: "Market",
                field: 'market',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Market") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Media",
                field: 'media',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Media Type") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Vendor",
                field: 'vendor',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Vendor") !== -1) ? false : true,
                pinned: 'left',
            }, {
                headerName: "Owner",
                field: 'owner',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Owner") !== -1) ? false : true,
                pinned: 'left',
            },
        ];
        var ws_global_column_definitions = {
            headerName: 'Week ',
            headerTooltip: 'Week ',
            groupId: 'week_',
            children: [],
            headerClass: 'group-header',
        };
        var html2 = '';
        for(var x in week_dates){
            var month_y = $.extend({}, ws_global_column_definitions);
            month_y.group_id = week_dates[x],
            month_y.headerName = 'Week:  ' + moment(week_dates[x]).format('MM/DD/YYYY'),
            month_y.headerTooltip = 'Week:  ' +  moment(week_dates[x]).format('MM/DD/YYYY'),

            html2 += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="weekcolumn dropdown-item" data-hidden="'+ week_dates[x] +'">'+ moment(week_dates[x]).format('MM/DD/YYYY') +'</a></li>';

            month_y.children = [
                {
                    headerName: "Ads",
                    field: 'ads_' + week_dates[x],
                    headerTooltip: 'Ads Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 80,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Ads") !== -1) ? false : true,
                    cellRenderer: IntFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    },
                },
                {
                    headerName: "Gross Cost",
                    field: 'cost_' + week_dates[x],
                    headerTooltip: 'Gross Cost Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 120,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Gross Cost") !== -1) ? false : true,
                    cellRenderer: CurrencyFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    }

                },
                {
                    headerName: "Net Cost",
                    field: 'net_cost_' + week_dates[x],
                    headerTooltip: 'Net Cost Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 120,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Net Cost") !== -1) ? false : true,
                    cellRenderer: CurrencyFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                            return false;
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    }
                },
                {
                    headerName: "GRP",
                    field: 'grp_' + week_dates[x],
                    headerTooltip: 'GRP Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("GRPs") !== -1) ? false : true,
                    cellRenderer: FloatFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                            return false;
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    }
                },
                {
                    headerName: "GRI",
                    field: 'gri_' + week_dates[x],
                    width: 100,
                    headerTooltip: 'GRI Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("GRIs") !== -1) ? false : true,
                    cellRenderer: FloatFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                            return false;
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    }
                },
                {
                    headerName: "CPP",
                    field: 'cpp_' + week_dates[x],
                    headerTooltip: 'CPP Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Gross CPP") !== -1) ? false : true,
                    cellRenderer: CurrencyFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                            return false;
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    }
                },
                {
                    headerName: "NET CPP",
                    field: 'net_cpp_' + week_dates[x],
                    headerTooltip: 'Net CPP Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Net CPP") !== -1) ? false : true,
                    cellRenderer: CurrencyFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;

                            }
                            return false;
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                            return false;
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    }
                },
                {
                    headerName: "CPM",
                    field: 'cpm_' + week_dates[x],
                    headerTooltip: 'CPM  Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Gross CPM") !== -1) ? false : true,
                    cellRenderer: CurrencyFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                            return false;
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },

                    }
                },
                {
                    headerName: "NET CPM",
                    field: 'net_cpm_' + week_dates[x],
                    headerTooltip: 'Net CPM Week: ' + moment(week_dates[x]).format('MM/DD/YYYY'),
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Net CPM") !== -1) ? false : true,
                    cellRenderer: CurrencyFormatRendererMatrix,
                    cellClassRules: {
                        'ooh-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OOH' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'other-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Other' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                            return false;
                        },
                        'print-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Print' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'mail-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Mail' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'digital-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'Digital' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                        'ott-week-change': function (params) {
                            if (params.node.rowPinned != 'top') {
                                if (params.data.media === 'OTT JamLoop' && params.data[params.colDef.field] !== null)
                                    return true;
                            }
                        },
                    }
                }];

            console.log('month_y ', month_y);
            columnInvExportInfo.push(month_y);
        }

        var month_y = $.extend({}, ws_global_column_definitions);
        month_y.group_id = week_dates[x];
        month_y.headerName = 'Totals';
        month_y.headerTooltip = 'Totals';
        month_y.pinned = 'right';
        month_y.children = [
                {
                    headerName: "Ads",
                    field: 'ads_totals',
                    width: 80,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Ads") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: IntFormatRendererMatrix,
                },
                {
                    headerName: "Gross Cost",
                    field: 'cost_totals',
                    width: 120,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Gross Cost") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: CurrencyFormatRendererMatrix,
                }, {
                    headerName: "Net Cost",
                    field: 'net_cost',
                    width: 120,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Net Cost") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: CurrencyFormatRendererMatrix,
                },{
                    headerName: "GRP",
                    field: 'grp_totals',
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("GRPs") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: FloatFormatRendererMatrix,
                },{
                    headerName: "GRI",
                    field: 'gri_totals',
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("GRIs") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: FloatFormatRendererMatrix,
                },{
                    headerName: "CPP",
                    field: 'cpp_totals',
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Gross CPP") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: CurrencyFormatRendererMatrix,
                },{
                    headerName: "NET CPP",
                    field: 'net_cpp_totals',
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Net CPP") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: CurrencyFormatRendererMatrix,
                },{
                    headerName: "CPM",
                    field: 'cpm_totals',
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Gross CPM") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: CurrencyFormatRendererMatrix,
                },{
                    headerName: "NET CPM",
                    field: 'net_cpm_totals',
                    width: 100,
                    cellStyle: {'text-align': "right"},
                    hide: (estimate_options.indexOf("Net CPM") !== -1) ? false : true,
                    pinned: 'right',
                    cellRenderer: CurrencyFormatRendererMatrix,
                }];
        columnInvExportInfo.push(month_y);

        html2 += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="weekcolumn dropdown-item" data-hidden="totals">Totals</a></li>';

        $("#week-matrix-hiden-columns").html(html2);

        var html = '';
        for(var ind in columnInvExportInfo) {
            if (typeof columnInvExportInfo[ind].groupId === 'undefined') {
                var hidden = (columnInvExportInfo[ind].hide) ? ["hidden-column", "background-color: rgb(204, 204, 204);"] : ["", ""];
                html += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px">' +
                    '<a class="dropdown-item stringscolumn' + hidden[0] + '" data-hidden="' + columnInvExportInfo[ind].field + '" style="' + hidden[1] + '">' + columnInvExportInfo[ind].headerName + '</a></li>';
            }
        }
        $("#matrix-hiden-columns").html(html);

       $('#params-matrix-hiden-columns a').each( function(){
           if(estimate_options.indexOf($(this).html()) === -1){
               $(this).addClass('hidden-column');
               $(this).css('background-color', '#CCCCCC');
           }
           else{
               $(this).removeClass('hidden-column');
               $(this).css('background-color', 'white');
           }
       });

        $('.smart-rpt-analysis-hide-column a').bind('click', function (e) {
            if($(this).hasClass("weekcolumn")){
                var attr = $(this).attr('data-hidden');
                if ($(this).hasClass('hidden-column')) {
                    var hidden_val = [];
                    $('.paramcolumns').each(function () {
                        if(!$(this).hasClass('hidden-column'))
                            hidden_val.push($(this).attr('data-hidden')+'_'+attr);
                    });

                    gridInvExportInfo.columnApi.setColumnsVisible(hidden_val, true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }else{
                    var columns = [];
                    for(var ind in columnInvExportInfo){
                        if (typeof columnInvExportInfo[ind].groupId !== 'undefined') {
                            for (var group in columnInvExportInfo[ind]['children']) {
                                if (columnInvExportInfo[ind]['children'][group].field.indexOf(attr) !== -1)
                                    columns.push(columnInvExportInfo[ind]['children'][group].field);
                            }
                        }
                    }
                    gridInvExportInfo.columnApi.setColumnsVisible(columns, false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                }
            }else if($(this).hasClass("paramcolumns")){
                var attr = $(this).attr('data-hidden');
                if ($(this).hasClass('hidden-column')) {
                    var hidden_val = [];
                    $('.weekcolumn').each(function () {
                        if(!$(this).hasClass('hidden-column'))
                            hidden_val.push(attr +'_'+ $(this).attr('data-hidden'));
                    });
                    gridInvExportInfo.columnApi.setColumnsVisible(hidden_val, true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }else{
                    var columns = [];
                    for(var ind in columnInvExportInfo){
                        if (typeof columnInvExportInfo[ind].groupId !== 'undefined') {
                            for(var group in columnInvExportInfo[ind]['children']) {
                                if (columnInvExportInfo[ind]['children'][group].field.indexOf(attr) !== -1)
                                    columns.push(columnInvExportInfo[ind]['children'][group].field);
                            }
                        }
                    }
                    gridInvExportInfo.columnApi.setColumnsVisible(columns, false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
            }else {
                var attr = $(this).attr('data-hidden');
                if ($(this).hasClass('hidden-column')) {
                    gridInvExportInfo.columnApi.setColumnsVisible([attr], true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                } else {
                    gridInvExportInfo.columnApi.setColumnsVisible([attr], false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
            }
            e.stopPropagation();
        });
        gridInvExportInfo = {
            columnDefs: columnInvExportInfo,
            enableFilter: true,
            enableSorting: true,
          //  pinnedTopRowData: [totals],
            headerHeight: 25,
            rowSelection: 'single',
            rowHeight: 22,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowClickSelection: true,
            animateRows: true,
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onGridReady: function(){
                totalTVUpdateDataMatrix(this);
            },
          //  getContextMenuItems: getContextMenuInvoiceOrder,
            onFilterChanged: function (e) {
                totalTVUpdateDataMatrix(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters').show();
                else
                    $('#reset_filters').hide();
            },
        };
         var final_totals = [...results, ...non_broadcast];
         console.log('final totlas ', final_totals)
        $('#myGridMatrix').html('');
        gridInvExportInfo.rowData = final_totals;
        var gridDet = document.querySelector('#myGridMatrix');
        var grid = new agGrid.Grid(gridDet, gridInvExportInfo);
        gridInvExportInfo.api.setPinnedTopRowData(
            [totals]
        );

        $('#reset_filters').on('click', function () {
            $.each(gridInvExportInfo.api.getFilterModel(), function (index, value) {
                gridInvExportInfo.api.destroyFilter(index);
            });
        });
        function CurrencyFormatRendererMatrix() {
        }

        CurrencyFormatRendererMatrix.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            $(this.eGui).css('text-align', 'right');
            if (params.node.rowPinned !== 'bottom') {
                if (typeof params.value !== 'undefined') {
                    if (isNaN(parseFloat(params.value)))
                        params.value = 0;

                    params.value = parseFloat(params.value).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    this.eGui.innerHTML = params.value;
                } else
                    this.eGui.innerHTML = '$0.0';
            } else
                this.eGui.innerHTML ='$0.0';
        };

        CurrencyFormatRendererMatrix.prototype.getGui = function () {
            return this.eGui;
        };
        function FloatFormatRendererMatrix() {
        }

        FloatFormatRendererMatrix.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            $(this.eGui).css('text-align', 'right');
            if (params.node.rowPinned !== 'bottom') {
                if (typeof params.value !== 'undefined') {
                    if (isNaN(parseFloat(params.value)))
                        params.value = 0;

                    params.value = parseFloat(params.value).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    this.eGui.innerHTML = params.value;
                } else
                    this.eGui.innerHTML = '0.0';
            } else
                this.eGui.innerHTML ='0.0';
        };

        FloatFormatRendererMatrix.prototype.getGui = function () {
            return this.eGui;
        };
        function IntFormatRendererMatrix() {
        }

        IntFormatRendererMatrix.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            $(this.eGui).css('text-align', 'right');
            if (params.node.rowPinned !== 'bottom') {
                if (typeof params.value !== 'undefined') {
                    if (isNaN(parseInt(params.value)))
                        params.value = 0;

                    params.value = parseInt(params.value).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });
                    this.eGui.innerHTML = params.value;
                } else
                    this.eGui.innerHTML = 0;
            } else
                this.eGui.innerHTML = 0;
        };

        IntFormatRendererMatrix.prototype.getGui = function () {
            return this.eGui;
        };

        close_progress_loader();
        $('.export_button').on('click', function(){
            show_loader();
            var format = $(this).attr('data-ac');
            var html_table = '<table class="table table-bordered table-striped table-condensed" >';
            var html_table = '</table>';
            var html_header = '';

            var html_body = '';
            var vis_columns = [];
            var vis_metrics = [];
            var vis_weeks = [];
            var colspan = 0 ;
            var vis_columns_html = [];
            var vis_metrics_html = [];

            $('.stringscolumn').each(function () {
                if(!$(this).hasClass('hidden-column')) {
                    vis_columns.push($(this).attr('data-hidden'));
                    vis_columns_html.push($(this).html());
                }
            });
            colspan += parseInt(vis_columns.length);

            $('.paramcolumns').each(function () {
                if(!$(this).hasClass('hidden-column')) {
                    vis_metrics.push($(this).attr('data-hidden'));
                    vis_metrics_html.push($(this).html());
                }
            });
            $('.weekcolumn').each(function () {
                if(!$(this).hasClass('hidden-column'))
                    vis_weeks.push($(this).attr('data-hidden'));
            });

            colspan += parseInt(vis_metrics.length) * parseInt(vis_weeks.length);

            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>GENERATED BY GALEFORCEMEDIA </b></td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>SMART  REPORT:  Calendar/CrossMatrix </b></td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>DATE RANGE: </b> '+ report_fd_header +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>AGENCY: </b> '+ agency_name +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>CLIENT: </b> '+ advertisers_name +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>MEDIA TYPE: </b> '+ media_type_string +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"></td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"></td></tr></table>';

            html_body += '<table style="width: 100%;"><tr style="background: black;  color: white">';
            if(vis_columns.length > 0)
                html_body += '<th colspan="'+ vis_columns.length +'"></th>';

            for(var ind in vis_weeks){
                if(vis_weeks[ind] != 'totals') {
                    var week = moment(vis_weeks[ind]).format('MM/DD/YYYY')
                    html_body += '<th  style="background: #373737; color: white" colspan="' + vis_metrics.length + '">Week: ' + week + '</th>';
                }
                else
                    html_body += '<th  style="background: #373737; color: white" colspan="' + vis_metrics.length + '"> Totals</th>';
            }

            html_body += '</tr><tr>';
            for(var ind in vis_columns_html)
                html_body += '<td style="background: black; color: white">&nbsp;&nbsp;&nbsp;&nbsp;'+ vis_columns_html[ind]+ '&nbsp;&nbsp;&nbsp;&nbsp;</td>';

            for(var index in vis_weeks) {
                for (var ind in vis_metrics_html)
                    html_body += '<td style="background: black; color: white">&nbsp;&nbsp;&nbsp;&nbsp;' + vis_metrics_html[ind] + '&nbsp;&nbsp;&nbsp;&nbsp;</td>';
            }
            html_body += '</tr>';
            html_body += '<tr>';
            var node = gridInvExportInfo.api.pinnedRowModel.pinnedTopRows[0];

            for(var ind in vis_columns)
                html_body += '<td style="color: black; text-align: left; background-color: #f15925"> </td>';

            for(var index in vis_weeks){
                var week = vis_weeks[index];
                for(var ind in vis_metrics){
                    var col = vis_metrics[ind];
                    console.log('col ', col);
                    console.log('week ', week);
                    var value = 0;
                    if(col.indexOf('ads') !== -1){
                        if(isNaN(parseInt(node.data[col+'_'+week])))
                            value = 0;
                        else
                            value = node.data[col+'_'+week];
                    }
                    else if(col.indexOf('gri') !== -1 || col.indexOf('grp') !== -1){
                        if(isNaN(parseFloat(node.data[col+'_'+week])))
                            value = 0;
                        else
                            value = node.data[col+'_'+week];
                        value =  parseFloat(value).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    else if(col.indexOf('cost') !== -1 || col.indexOf('cpm') !== -1 || col.indexOf('cpp') !== -1){
                        if(col === 'net_cost' && week === 'totals')
                            value = node.data['net_cost'];
                        else if(isNaN(parseFloat(node.data[col+'_'+week])))
                            value = 0;
                        else
                            value = node.data[col+'_'+week];
                        value =  parseFloat(value).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 1,
                        });
                    }
                    html_body += '<td style="color: black;text-align: center;background-color: #f15925">' + value + '</td>';
                }
            }
            html_body += '</tr>';
            html_body += '</tr>';

            gridInvExportInfo.api.forEachNodeAfterFilterAndSort(function(node){
                html_body += '<tr>';
                console.log('node ', node);
                for(var ind in vis_columns) {
                    var col = vis_columns[ind];
                    html_body += '<td style="color: black; text-align: left;">' +node.data[col] + '</td>';
                }
                for(var index in vis_weeks){
                    var week = vis_weeks[index];
                    for(var ind in vis_metrics){
                        var color = 'white';
                        if(node.data.media === 'OOH')
                            color= '#C7F5F4';
                        else if(node.data.media === 'Other')
                            color= '#EFCEF7';
                        else if(node.data.media === 'Print')
                            color= '#DBF1D2';
                        else if(node.data.media === 'Mail')
                            color= '#E3DFF3';
                        else if(node.data.media === 'Digital')
                            color= '#FFCCCC';

                        var col = vis_metrics[ind];
                        var value = '';
                        if(col.indexOf('ads') !== -1){
                            if(isNaN(parseFloat(node.data[col+'_'+week])))
                                value = 0;
                            else
                                value = node.data[col+'_'+week];
                            if(node.data[col+'_'+week] === null || week == 'totals')
                                color = 'white';
                        }
                        else if(col.indexOf('gri') !== -1 || col.indexOf('grp') !== -1){
                            if(isNaN(parseFloat(node.data[col+'_'+week])))
                                value = 0;
                            else
                                value = node.data[col+'_'+week];

                            value =  parseFloat(value).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            });

                            if(node.data[col+'_'+week] === null || week == 'totals')
                                color = 'white';
                        }
                        else if(col.indexOf('cost') !== -1 || col.indexOf('cpm') !== -1 || col.indexOf('cpp') !== -1){
                            if(col === 'net_cost' && week === 'totals')
                                value = node.data['net_cost'];
                            else if(isNaN(parseFloat(node.data[col+'_'+week])))
                                value = 0;
                            else
                                value = node.data[col+'_'+week];
                            value =  parseFloat(value).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 1,
                            });

                            if(node.data[col+'_'+week] === null || week == 'totals')
                                color = 'white';
                        }
                        html_body += '<td style="color: black;text-align: center;background-color: '+ color +'">' +value + '</td>';
                    }
                }
                html_body += '</tr>';
            });

            html_body += '</table>';

            var html = html_table + html_header + html_body;

            if(format=='xls'){
                var a = document.createElement('a');
                var data_type = 'data:application/vnd.ms-excel';
                a.href = data_type + ', ' + encodeURIComponent(html);
                a.download = 'smart-report.xls';
                //triggering the function
                a.click();
            }
            else{
                var url='data:application/csv,charset=utf-8,' + encodeURIComponent(html);
                location.href=url;
                return false;
            }

            hide_loader();
        })

    }
    else if($(".sum_report_header").length > 0) {
        show_loader();
        var campaigns_chart = [];
        var markets_chart = [];
        var media_type_chart = [];
        var vendors_chart = [];
        var months_chart = [];

        //Chart Totals Tab
        $('.custom_chart_market').on('click', function () {
            //chart options
            var html_type = ' <option value=""></option>' +
                '                                            <option value="pie">Pie</option>' +
                // '                                            <option value="line">Line</option>' +
                '                                            <option value="column">Column (Vertical)</option>' +
                '                                            <option value="bar">Column (Horizontal)</option>';

            $('#chart_type').select2({
                minimumResultsForSearch: 5,
                placeholder: 'Select one....',

            });
            $('#chart_type').html(html_type);

            $('#chart_breakout').select2({
                minimumResultsForSearch: 5
            });
            $('#chart_breakout').val('campaign');

            $('#chart_data_type').select2({
                minimumResultsForSearch: 5
            });
            $('.chart_type_label_total_tab_text').html('Select Campaign(s)');

            var html = '';
            for(var ind in campaigns_chart)
                html += '<option> '+ ind +' </option>';

            $('#chart_total_params').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_totals'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_totals'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                // afterSelect: function (values) {
                //     this.qs1.cache();
                //     if ($('#chart_type option:selected').val() === 'pie') {
                //         form_curr_dayparts = this.$element.val();
                //         if (this.$element.val().length > 1) {
                //             this.$element.multiSelect('deselect', values);
                //             form_curr_dayparts = this.$element.val();
                //
                //             swal({
                //                     title: "Warning",
                //                     text: "The max number is 1 ...",
                //                     type: "warning",
                //                     showCancelButton: true,
                //                     confirmButtonClass: "btn-danger",
                //                     confirmButtonText: "OK",
                //                     cancelButtonText: "Close",
                //                     closeOnConfirm: true,
                //                     closeOnCancel: true
                //                 },
                //                 function (isConfirm) {
                //
                //                 });
                //         }
                //         if (form_curr_dayparts.length < 2)
                //             this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                //         else
                //             this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');
                //
                //     }
                // },
                // afterDeselect: function (values) {
                //     this.qs1.cache();
                //     if ($('#chart_type option:selected').val() == 'pie') {
                //         form_curr_dayparts = this.$element.val();
                //         this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                //     }
                // }
            });
            $('#chart_total_params').html(html).multiSelect('refresh');

            $('#graphsOptionsModal').modal('show');

            //Select all
            $('#sel_all_chart_totals').on('click', function (e) {
                $('#chart_total_params').multiSelect('select_all');
            });
            //Deselect all
            $('#desel_all_chart_totals').on('click', function (e) {
                $('#chart_total_params').multiSelect('deselect_all');
            });

        });
        $('#chart_breakout').on('change', function(){
            var array = '';
            var type = $('#chart_breakout option:selected').html();
            if($('#chart_breakout option:selected').val() === 'campaign')
                array = campaigns_chart;
            else if($('#chart_breakout option:selected').val() === 'market')
                array = markets_chart;
            else if($('#chart_breakout option:selected').val() === 'media_type')
                array = media_type_chart;
            else
                array = vendors_chart;

            var html = '';
            for(var ind in array)
                html += '<option> '+ ind +' </option>';
            $('#chart_total_params').html(html).multiSelect('refresh');
            $('.chart_type_label_total_tab_text').html('Select '+ type +'(s):')
            //Select all
            $('#sel_all_chart_totals').on('click', function (e) {
                $('#chart_total_params').multiSelect('select_all');
            });
            //Deselect all
            $('#desel_all_chart_totals').on('click', function (e) {
                $('#chart_total_params').multiSelect('deselect_all');
            });
        });
        $('#submit_charts_options_totals').on('click', function(){
            var type_selected = $('#chart_breakout option:selected').val();
            var text = '';
            if($('#chart_type option:selected').val() === '')
                text = 'Select a Chart Type first...';
            else if($('#chart_data_type option:selected').val() === '')
                text = 'Select a Data Type first...';
            else if($('#chart_total_params').val().length === 0)
                text = 'Select a '+ $('#chart_breakout option:selected').html() +' first...';

            if(text !== '') {
                swal({
                        title: "Warning",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else {
                show_overlay_loader('#graphsOptionsModal .modal-content');
                $('#modalTTChart').html('Summary Report Chart (Totals)');
                var data_type = $('#chart_data_type option:selected').val();
                var tab_selected = $('#chart_data_type option:selected').html();
                var break_type_html = $('#chart_breakout option:selected').html();
                var simbol = (data_type === 'ads' || data_type === 'gri' || data_type === 'grp') ? '' : '$';
                var to_fixed = 0;
                if(data_type === 'gri' || data_type === 'grp')
                    to_fixed = 1;
                else if(data_type === 'ads')
                    to_fixed = 0;
                else
                    to_fixed = 2;

                var array = '';
                if($('#chart_breakout option:selected').val() === 'campaign')
                    array = campaigns_chart;
                else if($('#chart_breakout option:selected').val() === 'market')
                    array = markets_chart;
                else if($('#chart_breakout option:selected').val() === 'media_type')
                    array = media_type_chart;
                else
                    array = vendors_chart;

                var include = $('#chart_total_params').val();

                html = '';
                html += '<div class="tab-content gr" style="width: 100%">';
                html += '<div class="row"> <div class="col-md-12">' +
                    '                                <div id="container_market_chart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                    '                            </div></div>';
                html += '</div>';

                $('.container-graphs-div').html(html);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                    var series = [];
                    console.log('include ', include);
                    for(var ind in include){
                        var breakout_type = include[ind];
                        if(typeof array[breakout_type] !== 'undefined') {
                            var data = [];
                            var value = 0;
                            if (typeof array[breakout_type][data_type] !== 'undefined')
                                value = !isNaN(parseFloat(array[breakout_type][data_type])) ? parseFloat(array[breakout_type][data_type]) : 0;
                            else {
                                if (data_type === 'cpm')
                                    value = (array[breakout_type].grp > 0) ? array[breakout_type].cost / array[breakout_type].grp : 0;
                                else
                                    value = (array[breakout_type].gri > 0) ? array[breakout_type].cost / array[breakout_type].gri : 0;
                            }
                            data.push({
                                name: breakout_type,
                                y: value,
                            });

                            series.push({
                                name: breakout_type,
                                data: data,
                            });
                        }
                    }

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var orientation_type = $('#chart_type option:selected').val() === 'column' ? 'columns' : 'rows';
                    var defaultTitle = 'Click the '+ orientation_type +' to view ' + $('#chart_data_type option:selected').html() + ' by vendors.'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: break_type_html + ' ' + tab_selected + '  Chart',
                        },
                        subtitle: {
                            text: '',
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_data_type option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol + '{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        // drilldown: {
                        //     series: data2
                        // }

                    });
                }
                if ($('#chart_type option:selected').val() == 'pie') {
                    var series = [];
                    for(var ind in include){
                        var breakout_type = include[ind];
                        if(typeof array[breakout_type] !== 'undefined') {
                            var data = [];
                            var value = 0;
                            if (typeof array[breakout_type][data_type] !== 'undefined')
                                value = !isNaN(parseFloat(array[breakout_type][data_type])) ? parseFloat(array[breakout_type][data_type]) : 0;
                            else {
                                if (data_type === 'cpm')
                                    value = (array[breakout_type].grp > 0) ? array[breakout_type].cost / array[breakout_type].grp : 0;
                                else
                                    value = (array[breakout_type].gri > 0) ? array[breakout_type].cost / array[breakout_type].gri : 0;
                            }
                            series.push({
                                name: breakout_type,
                                y: value,
                            });
                        }
                    }
                    console.log('series ', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type option:selected').html() + ' by  stations'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: break_type_html + ' ' + tab_selected + '  Chart',
                        },
                        subtitle: {
                            text: '',
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true,
                                },
                                showInLegend: true,

                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: [{
                            name:  $('#chart_data_type option:selected').html() ,
                            colorByPoint: true,
                            data: series
                        }],
                        // drilldown: {
                        //     series: data2
                        // }
                        //drilldown : data2,

                    });
                }
                $('#GraphsModal').modal('show');
                hide_overlay_loader('#graphsOptionsModal .modal-content');


            }

        });

        //Chart Detail Tabs
        $('.custom_chart_market_detail').on('click', function () {
            var tab_selected = $(this).attr('data-tab');
            $('#tab_selected_graph').val(tab_selected);
           // $('.chart_market_span_text').html(tab_selected);
            //chart options
            var html_type = ' <option value=""></option>' +
                '                                            <option value="pie">Pie</option>' +
                '                                            <option value="line">Line</option>' +
                '                                            <option value="column">Column (Vertical)</option>' +
                '                                            <option value="bar">Column (Horizontal)</option>';

            $('#chart_type_details').select2({
                minimumResultsForSearch: 5,
                placeholder: 'Select one....',

            });
            $('#chart_type_details').html(html_type);

            $('#chart_breakout_details').select2({
                minimumResultsForSearch: 5
            });
            $('#chart_data_type_details').select2({
                minimumResultsForSearch: 5
            });

            var html = '';
            for (var ind in campaigns_chart)
                   html += '<option>' + ind + '</option>';
            $('#chart_markets_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_books'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_books'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_markets_details').html(html).multiSelect('refresh');

            var html = '';
            for (var ind in vendors_chart)
                html += '<option>' + ind + '</option>';
            $('#chart_stations_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_stations'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_stations'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_stations_details').html(html).multiSelect('refresh');

            var html = '';
            months_chart.sort();
            for (var ind in months_chart)
                html += '<option value="'+ months_chart[ind] +'">' + moment(months_chart[ind]).format('MMMM, YYYY') + '</option>';
            $('#chart_month_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type_details option:selected').val() === 'pie') {
                        form_curr_dayparts = this.$element.val();
                        if (this.$element.val().length > 1) {
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 1 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }
                        if (form_curr_dayparts.length < 2)
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                        else
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');

                    }
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type option:selected').val() == 'pie') {
                        form_curr_dayparts = this.$element.val();
                        this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                    }
                }
            });
            $('#chart_month_details').html(html).multiSelect('refresh');

            $('#graphsOptionsModalDetail').modal('show');

            //Select all
            $('#sel_all_chart_books').on('click', function (e) {
                $('#chart_markets_details').multiSelect('select_all');
            });
            $('#sel_all_chart_stations').on('click', function (e) {
                $('#chart_stations_details').multiSelect('select_all');
            });
            $('#sel_all_chart_dayparts').on('click', function (e) {
                $('#chart_month_details').multiSelect('select_all');
            });
            //Deselect all
            $('#desel_all_chart_books').on('click', function (e) {
                $('#chart_markets_details').multiSelect('deselect_all');
            });
            $('#desel_all_chart_stations').on('click', function (e) {
                $('#chart_stations_details').multiSelect('deselect_all');
            });
            $('#desel_all_chart_dayparts').on('click', function (e) {
                $('#chart_month_details').multiSelect('deselect_all');
            });
        });
        $('#chart_type_details').on('change', function(){
            if($(this).val() === 'pie'){
                $('.div_only_one_daypart_details').show();
                $('#chart_month_details').multiSelect('deselect_all');
            }
            else {
                $('.div_only_one_daypart_details').hide();
            }
        });
        $('#submit_charts_options_details').on('click', function(){
            if($('#chart_type_details option:selected').val() == ''){
                swal({
                        title: "Warning",
                        text: "Select Chart Type first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_stations_details').val().length == 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Station...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_month_details').val().length == 0) {
                if ($('#chart_type_details option:selected').val() === 'pie')
                    text = 'Select a Month first...';
                else
                    text = 'Select at least one Month...';
                swal({
                        title: "Warning",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_markets_details').val().length === 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Campaign first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else {
                show_overlay_loader('#graphsOptionsModalDetial .modal-content');
                $('#modalTTChart').html('Summary Report Chart (Details)');
                var vendor_charts = $('#chart_stations_details').val();
                var month_chart = $('#chart_month_details').val();
                var camp_charts = $('#chart_markets_details').val();
                var data_type = $('#chart_data_type_details option:selected').val();
                var data_type_text = $('#chart_data_type_details option:selected').html();
                var simbol = (data_type === 'ads' || data_type === 'gri' || data_type === 'grp') ? '' : '$';
                var to_fixed = 0;
                if(data_type === 'gri' || data_type === 'grp')
                    to_fixed = 1;
                else if(data_type === 'ads')
                    to_fixed = 0;
                else
                    to_fixed = 2;
                var results = [];

                var array_month_ordered = [];
                gridCampBreakout.api.forEachNode(function (node) {
                    console.log('node_node_node_', node);
                    if (node.level === 0) {
                        $.each(node.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                $.each(value.childrenAfterGroup, function (index, value) {
                                    if (vendor_charts.indexOf(value.data.vendor) !== -1 && month_chart.indexOf(value.data.broadcast_month) !== -1 && camp_charts.indexOf(value.data.campaign) !== -1) {
                                        if (typeof results[value.data.campaign] === 'undefined')
                                            results[value.data.campaign] = [];
                                        if (typeof results[value.data.campaign][value.data.vendor] === 'undefined')
                                            results[value.data.campaign][value.data.vendor] = [];
                                            var time = value.data.broadcast_month;
                                            if (typeof results[value.data.campaign][value.data.vendor][time] === 'undefined') {
                                                results[value.data.campaign][value.data.vendor][time] = [];
                                                results[value.data.campaign][value.data.vendor][time]['value'] = 0;
                                            }
                                            var amount = 0;
                                            if (data_type === 'ads')
                                                amount = !isNaN(parseInt(value.data[data_type])) ? parseInt(value.data[data_type]) : 0;
                                            else {
                                                var amount = value.data[data_type];
                                                amount = amount.replace('$', '');
                                                amount = amount.replace(/,/g, '');
                                                amount = !isNaN(parseFloat(amount)) ? parseFloat(amount).toFixed(2) : 0.00;
                                            }
                                            results[value.data.campaign][value.data.vendor][time]['value'] += amount;
                                        if(array_month_ordered.indexOf(time) === -1)
                                            array_month_ordered.push(time);

                                    }
                                });
                            });
                        });
                    }
                });
                array_month_ordered.sort();
                console.log('charts_final_results results', results);
                var charts_final_results = {};
                for (var market in results) {
                    for (var vendor in results[market]) {
                        for(var ind in array_month_ordered) {
                            var time_period = array_month_ordered[ind];
                            if (typeof charts_final_results[market] === 'undefined')
                                charts_final_results[market] = [];
                            if (typeof charts_final_results[market][time_period] === 'undefined') {
                                charts_final_results[market][time_period] = [];
                                charts_final_results[market][time_period]['total'] = 0;
                                charts_final_results[market][time_period]['stations'] = [];
                            }
                            if (typeof charts_final_results[market][time_period]['stations'][vendor] === 'undefined')
                                charts_final_results[market][time_period]['stations'][vendor] = 0;

                            if(typeof  results[market][vendor][time_period] !== 'undefined') {
                                charts_final_results[market][time_period]['total'] += parseFloat(results[market][vendor][time_period]['value']);
                                charts_final_results[market][time_period]['stations'][vendor] += parseFloat(results[market][vendor][time_period]['value']);
                            }
                        }
                    }
                }

                console.log('charts_final_results ', charts_final_results);
                console.log('array_month_ordered ', array_month_ordered);
                var html = '';
                //content tabs
                html += '<div class="tab-content gr" style="width: 100%">';
                html += '<div class="row"> <div class="col-md-12">' +
                    '                                <div id="container_market_chart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                    '                            </div></div>';
                html += '</div>';
                $('.container-graphs-div').html(html);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                if ($('#chart_type_details option:selected').val() == 'column' || $('#chart_type_details option:selected').val() == 'bar') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data.push({
                                name: moment(time_period).format('MMM YYYY'),
                                y: market_value,
                                drilldown: moment(time_period).format('MMM YYYY') + '_' + cont,
                            });

                            data2.push({
                                name: market,
                                id: moment(time_period).format('MMM YYYY') + '_' + cont,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var orientation_type = $('#chart_type_details option:selected').val() === 'column' ? 'columns' : 'rows';
                    var defaultTitle = 'Click the '+ orientation_type +' to view ' + $('#chart_data_type_details option:selected').html() + ' by vendors.'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Campaign ' + data_type_text + ' Details Chart',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_data_type option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol + '{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        drilldown: {
                            series: data2
                        }

                    });
                }
                if ($('#chart_type_details option:selected').val() == 'line') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data.push({
                                name: moment(time_period).format('MMM YYYY'),
                                y: market_value,
                                drilldown: moment(time_period).format('MMM YYYY') + '_' + cont,
                            });

                            data2.push({
                                name: market,
                                id: moment(time_period).format('MMM YYYY') + '_' + cont,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }

                    console.log('series cleint acti', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details option:selected').html() + ' by  stations'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            // type: $('#chart_type option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Campaign ' + data_type_text + ' Details Chart',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_type_details option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        drilldown: {
                            series: data2
                        }
                        //drilldown : data2,

                    });
                }
                if ($('#chart_type_details option:selected').val() == 'pie') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data2.push({
                                name: market,
                                id: market,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            y: market_value,
                            drilldown: market,
                        });
                        cont++;
                    }
                    console.log('series series', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details option:selected').html() + ' by  stations'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Campaign ' + data_type_text + ' Details Chart ('+ moment($('#chart_month_details').val()[0]).format('MMMM,  YYYY') + ')',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true,
                                },
                                showInLegend: true,

                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: [{
                            name:  'Campaign ' + $('#chart_data_type_details option:selected').html() ,
                            colorByPoint: true,
                            data: series
                        }],
                        drilldown: {
                            series: data2
                        }
                        //drilldown : data2,

                    });
                }

                $('#GraphsModal').modal('show');
                hide_overlay_loader('#graphsOptionsModalDetail .modal-content');

            }

            hide_overlay_loader('#graphsOptionsModal .modal-content');

        });


        alldata = collect(alldata);
        var results = [];
        var totals = {
            'impressions': 0,
            'cost': 0,
            'net_cost': 0,
            'client_cost': 0,
            'grp': 0,
            'gri': 0,
            'cpp': 0,
            'net_cpp': 0,
            'cpm': 0,
            'net_cpm': 0,
            'ads': 0,
            'clicks' : 0,
            'cost_per_click' : 0,
        };
        var alldmos = collect(alldemos);
        var campaigns_totals=[];
        var market_totals=[];
        var media_totals=[];
        var vendor_totals=[];
        var advts = alldata.groupBy("advname").all();
        console.log('advts_advts_advts ', advts)
        for (var aname in advts) {
            var camps = collect(advts[aname]).whereIn('work_line_id', work_lines_allowed).groupBy("campname").all();
            for (var cname in camps) {
                var versions = collect(camps[cname]).groupBy("wv_number").all();
                for (var ver_number in versions) {
                    var mkets = collect(versions[ver_number]).groupBy("market").all();
                    console.log('markets .....', mkets);
                    for (var maname in mkets) {
                        var mtype = maname;
                        var vndrs = collect(mkets[maname]).groupBy("vndrid").all();
                        console.log('vndrs_vndrs_vndrs mkets[maname]', mkets[maname]);
                        console.log('vndrs_vndrs_vndrs vndrs', vndrs);
                        for (var vid in vndrs) {
                            var aux1 = collect(vndrs[vid]).groupBy("mtype").all();
                            for (var mname in aux1) {
                                var curr_demos = alldmos.where("campaign_id", +aux1[mname][0]['campid']).all();
                                var indmos = [];
                                for (var k in curr_demos)
                                    indmos.push(curr_demos[k].demo_type.toUpperCase() + " " + curr_demos[k].demo_name);
                                if (mname.indexOf("Television") !== -1 || mname.indexOf("Radio") !== -1) {
                                    var aux2_dp = collect(aux1[mname]).groupBy("daypart").all();
                                    for (var dp_first in aux2_dp) {
                                        console.log("BEFORE GROUP: ", aux2_dp[dp_first])
                                        var aux2 = collect(aux2_dp[dp_first]).groupBy("zone").all();
                                        console.log("AFTER GROUP: ", aux2)
                                        for (var dp in aux2) {
                                            if (aux2[dp].length > 0) {
                                                var aux3 = collect(aux2[dp]);
                                                var ads = parseInt(aux3.sum("spots"));
                                                ads = (isNaN(ads)) ? 0 : ads
                                                if (ads > 0) {
                                                    var imp = aux3.sum("impressions");
                                                    totals['impressions'] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(imp / 10) : parseFloat(imp);
                                                    totals['ads'] += parseInt(ads);
                                                    var cost = aux3.sum(function (row) {
                                                        return (row.gross_cost > 0 && row.gross_cost > 0) ? row.gross_cost : 0;
                                                    });
                                                    var client_cost =  aux3.sum(function (row) {
                                                        return (row.client_cost > 0 ) ? row.client_cost : 0;
                                                    });
                                                    totals['cost'] += parseFloat(cost);
                                                    totals['client_cost'] += parseFloat(client_cost);
                                                    totals['cost'] += parseFloat(cost);
                                                    totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux2[dp][0]['agency_commission']) / 100)) + 'e1') + 'e-1'));
                                                    var grp = aux3.sum(function (row) {
                                                        return ((row.rating !== '') && (row.spots !== '') && (row.rating !== null) && (row.spots !== null)) ? parseFloat(Number(Math.round((row.rating) + 'e1') + 'e-1') * row.spots) : 0;
                                                    });
                                                    totals['grp'] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(grp / 10) : parseFloat(grp);
                                                    var gri = aux3.sum(function (row) {
                                                        return ((row.impressions !== '') && (row.spots !== '') && (row.impressions !== null) && (row.spots !== null)) ?
                                                            parseFloat(Number(Math.round((row.impressions) + 'e1') + 'e-1') * row.spots) : 0;
                                                    });
                                                    totals['gri'] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(gri / 10) : parseFloat(gri);
                                                    results.push({
                                                        'commission': parseFloat(aux2[dp][0]['agency_commission']),
                                                        'brand': aux2[dp][0]['brand'],
                                                        'product': aux2[dp][0]['prod'],
                                                        'advertiser': aname,
                                                        'campaign': cname,
                                                        'estimate_number': aux1[mname][0]['estimate_number'],
                                                        'job_number': aux1[mname][0]['job_number'],
                                                        'campaign_number': aux1[mname][0]['campaign_number'],
                                                        'campstart': moment(aux1[mname][0]['campstart']).format('MM/DD/YYYY'),
                                                        'campend': moment(aux1[mname][0]['campend']).format('MM/DD/YYYY'),
                                                        'wv_number': aux2[dp][0]['wv_number'],
                                                        'demo': aux2[dp][0]['demo_people'].toUpperCase() + " " + aux2[dp][0]['demoname'],
                                                        'market': mtype,
                                                        'media': aux2[dp][0]['mtype'].split("Line")[1],
                                                        'daypart': (dp_first !== null && dp_first !== "null" && dp_first !== "undefined") ? dp_first : "",
                                                        'cable_zone': (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? "" : aux2[dp][0]['zone'],
                                                        'vendor': aux2[dp][0]['vndr_name'],
                                                        'owner': aux1[mname][0]['owner'],
                                                        'impressions': Number(Math.round((imp) + 'e1') + 'e-1'),
                                                        'ads': ads,
                                                        'clicks': 0,
                                                        'cost_per_click': 0,
                                                        'client_cost':  parseFloat(client_cost).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'cost': parseFloat(cost).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'net_cost': parseFloat((cost - (cost * parseFloat(aux2[dp][0]['agency_commission']) / 100))).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'grp': parseFloat(grp).toLocaleString("en-US", {
                                                            style: "decimal",
                                                            minimumFractionDigits: 1,
                                                            maximumFractionDigits: 1,
                                                        }),
                                                        'gri': parseFloat((aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(gri / 10) : parseFloat(gri)).toLocaleString("en-US", {
                                                            style: "decimal",
                                                            minimumFractionDigits: 1,
                                                            maximumFractionDigits: 1,
                                                        }),
                                                        'cpp': (grp > 0) ? parseFloat(cost / grp).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'net_cpp': (grp > 0) ? parseFloat(((cost / grp) - ((cost / grp) * (parseFloat(aux2[dp][0]['agency_commission']) / 100)))).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'cpm': (gri > 0) ? parseFloat(cost / gri).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'net_cpm': (gri > 0) ? parseFloat(((cost / gri) - ((cost / gri) * (parseFloat(aux2[dp][0]['agency_commission']) / 100)))).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                                else if(mname.indexOf("Podcast") !== -1 ) {
                                    var aux2_dp = collect(aux1[mname]).groupBy("daypart").all();
                                    console.log('Podcast_Podcast aux2_dp', aux2_dp)
                                    for (var dp_first in aux2_dp) {
                                        var aux2 = collect(aux2_dp[dp_first]).groupBy("ad_type").all();
                                        for (var dp in aux2) {
                                            console.log('Podcast_Podcast aux2[dp]', aux2[dp])
                                            if (aux2[dp].length > 0) {
                                                var ads = 0;
                                                var grp = 0;
                                                var gri = 0;
                                                var cost = 0;
                                                if (aux2[dp][0]['ad_type'] === 'attached') {
                                                    var aux3 = collect(aux2[dp]).where('ad_type', 'attached');
                                                    ads = parseInt(aux3.sum("spots"));
                                                    //ads = (isNaN(parseInt(ads))) ? 0 : ads;
                                                    console.log('Podcast_Podcast asds attached', ads)
                                                    var imp = aux3.sum("impressions");
                                                    totals['impressions'] +=  parseFloat(imp);
                                                    totals['ads'] += parseInt(ads);
                                                    var cost = aux3.sum(function (row) {
                                                        return (row.gross_cost > 0 && row.gross_cost > 0) ? row.gross_cost : 0;
                                                    });
                                                    var client_cost = aux3.sum(function (row) {
                                                        return (row.client_cost > 0) ? row.client_cost : 0;
                                                    });
                                                    totals['cost'] += parseFloat(cost);
                                                    totals['client_cost'] += parseFloat(client_cost);
                                                    totals['cost'] += parseFloat(cost);
                                                    totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux2[dp][0]['agency_commission']) / 100)) + 'e1') + 'e-1'));
                                                    var grp = aux3.sum(function (row) {
                                                        return ((row.rating !== '') && (row.spots !== '') && (row.rating !== null) && (row.spots !== null)) ? parseFloat(Number(Math.round((row.rating) + 'e1') + 'e-1') * row.spots) : 0;
                                                    });
                                                    totals['grp'] +=  parseFloat(grp);
                                                     gri = aux3.sum(function (row) {
                                                        return ((row.impressions !== '') && (row.spots !== '') && (row.impressions !== null) && (row.spots !== null)) ?
                                                            parseFloat(Number(Math.round((row.impressions) + 'e1') + 'e-1') * row.spots) : 0;
                                                    });
                                                    totals['gri'] += parseFloat(gri);
                                                    var com = parseFloat(aux2[dp][0]['agency_commission']);
                                                    imp = Number(Math.round((imp) + 'e1') + 'e-1');
                                                } else {
                                                    var aux3 = collect(aux2[dp]).where('ad_type', 'programmatic');
                                                    ads = parseInt(aux3.sum("ad_count"));
                                                    ads = (isNaN(parseInt(ads))) ? 0 : ads;
                                                    var imp = aux3.sum("impressions");
                                                    totals['impressions'] += parseFloat(imp / 1000);
                                                    totals['ads'] += parseInt(ads);
                                                    var cost = aux3.sum("total_cost");
                                                    totals['cost'] += parseFloat(cost);
                                                    totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux1[mname][0]['agency_commission'], 2) / 100)) + 'e1') + 'e-1'));
                                                    gri = aux3.sum(function (row) {
                                                        return ((row.impressions !== '') && (row.ad_count !== '') && (row.impressions !== null) && (row.ad_count !== null)) ?
                                                            parseFloat(Number(Math.round((row.impressions / 1000) + 'e3') + 'e-3') * row.ad_count) : 0;
                                                    });
                                                    var client_cost = aux3.sum(function (row) {
                                                        var c  = !isNaN(parseFloat(row.total_cost)) ? parseFloat(row.total_cost) : 0;
                                                        return !isNaN(parseFloat(row.client_cost_com)) ? (parseFloat(c) * parseFloat(row.client_cost_com) ) /100 : 0;
                                                    });
                                                    totals['client_cost'] += parseFloat(client_cost);
                                                    totals['gri'] += parseFloat(gri);
                                                    imp =  Number(Math.round((imp / 1000) + 'e1') + 'e-1');
                                                }

                                                console.log('Podcast_Podcast asds', ads)

                                                if (ads > 0)
                                                    results.push({
                                                        'commission': parseFloat(aux2[dp][0]['agency_commission']),
                                                        'brand': aux2[dp][0]['brand'],
                                                        'product': aux2[dp][0]['prod'],
                                                        'advertiser': aname,
                                                        'campaign': cname,
                                                        'estimate_number': aux1[mname][0]['estimate_number'],
                                                        'job_number': aux1[mname][0]['job_number'],
                                                        'campaign_number': aux1[mname][0]['campaign_number'],
                                                        'campstart': moment(aux1[mname][0]['campstart']).format('MM/DD/YYYY'),
                                                        'campend': moment(aux1[mname][0]['campend']).format('MM/DD/YYYY'),
                                                        'wv_number': aux2[dp][0]['wv_number'],
                                                        'demo': '',
                                                        'market': mtype,
                                                        'media': 'Podcast',
                                                        'daypart': (dp_first !== null && dp_first !== "null" && dp_first !== "undefined") ? dp_first : "",
                                                        'cable_zone': '',
                                                        'vendor': aux2[dp][0]['vndr_name'],
                                                        'owner': aux1[mname][0]['owner'],
                                                        'impressions': imp,
                                                        'ads': ads,
                                                        'clicks': 0,
                                                        'cost_per_click': 0,
                                                        'client_cost': parseFloat(client_cost).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'cost': parseFloat(cost).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'net_cost': parseFloat((cost - (cost * parseFloat(aux2[dp][0]['agency_commission']) / 100))).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'grp': parseFloat(grp).toLocaleString("en-US", {
                                                            style: "decimal",
                                                            minimumFractionDigits: 1,
                                                            maximumFractionDigits: 1,
                                                        }),
                                                        'gri': parseFloat(parseFloat(gri)).toLocaleString("en-US", {
                                                            style: "decimal",
                                                            minimumFractionDigits: 1,
                                                            maximumFractionDigits: 1,
                                                        }),
                                                        'cpp': (grp > 0) ? parseFloat(cost / grp).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'net_cpp': (grp > 0) ? parseFloat(((cost / grp) - ((cost / grp) * (parseFloat(aux2[dp][0]['agency_commission']) / 100)))).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'cpm': (gri > 0) ? parseFloat(cost / gri).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                        'net_cpm': (gri > 0) ? parseFloat(((cost / gri) - ((cost / gri) * (parseFloat(aux2[dp][0]['agency_commission']) / 100)))).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }) : parseFloat(0).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "USD",
                                                            minimumFractionDigits: 2
                                                        }),
                                                    });
                                            }
                                        }
                                    }
                                }
                                else {
                                    if (aux1[mname].length > 0) {
                                        var aux3 = collect(aux1[mname]);
                                        if (mname.indexOf("Digital") !== -1 ) {
                                            console.log('aux3_aux3_aux3_aux3_', aux3);
                                            console.log('aux3_aux3_aux3_aux3_ work_lines_allowed', work_lines_allowed);
                                            console.log('aux3_aux3_aux3_aux3_ test', aux3['work_line_id'] , work_lines_allowed.indexOf(aux1[mname][0]['work_line_id']) !== -1);
                                            var ads = parseInt(aux3.sum("ad_count"));
                                            ads = (isNaN(parseInt(ads))) ? 0 : parseInt(ads);
                                            var clicks = parseInt(aux3.sum("clicks"));
                                            clicks = (isNaN(parseInt(clicks))) ? 0 : parseInt(clicks);
                                            if (ads > 0/* && work_lines_allowed.indexOf(aux1[mname][0]['work_line_id']) !== -1*/) {
                                                var imp = aux3.sum("impressions");
                                                totals['impressions'] += parseFloat(imp / 1000);
                                                totals['ads'] += parseInt(ads);
                                                totals['clicks'] += parseInt(clicks);
                                                var cost = aux3.sum("total_cost");
                                                totals['cost'] += parseFloat(cost);
                                                totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux1[mname][0]['agency_commission'], 2) / 100)) + 'e1') + 'e-1'));
                                                var gri = aux3.sum(function (row) {
                                                    return ((row.impressions !== '') && (row.ad_count !== '') && (row.impressions !== null) && (row.ad_count !== null)) ? parseFloat(Number(Math.round((row.impressions / 1000) + 'e3') + 'e-3') * row.ad_count) : 0;
                                                });
                                                var client_cost = aux3.sum(function (row) {
                                                    var c  = !isNaN(parseFloat(row.total_cost)) ? parseFloat(row.total_cost) : 0;
                                                    return !isNaN(parseFloat(row.client_cost_com)) ? (parseFloat(c) * parseFloat(row.client_cost_com) ) /100 : 0;
                                                });
                                                totals['client_cost'] += parseFloat(client_cost);
                                                totals['gri'] += parseFloat(gri);
                                                var cost_per_click = clicks > 0 ? parseFloat(cost) / parseInt(clicks) : 0;
                                                totals['cost_per_click'] += parseInt(cost_per_click);
                                                console.log('cost_per_click_cost_per_click_ ', cost, ' --- ', ' --- ', clicks,  '---- ', cost_per_click)

                                                results.push({
                                                    'commission': parseFloat(aux1[mname][0]['agency_commission']),
                                                    'brand': aux1[mname][0]['brand'],
                                                    'product': aux1[mname][0]['prod'],
                                                    'advertiser': aname,
                                                    'campaign': cname,
                                                    'estimate_number': aux1[mname][0]['estimate_number'],
                                                    'job_number': aux1[mname][0]['job_number'],
                                                    'campaign_number': aux1[mname][0]['campaign_number'],
                                                    'campstart': moment(aux1[mname][0]['campstart']).format('MM/DD/YYYY'),
                                                    'campend': moment(aux1[mname][0]['campend']).format('MM/DD/YYYY'),
                                                    'wv_number': aux1[mname][0]['wv_number'],
                                                    'demo': '',
                                                    'market': mtype,
                                                    'media': aux1[mname][0]['mtype'].split("Line")[1],
                                                    'daypart': "",
                                                    'vendor': aux1[mname][0]['vndr_name'],
                                                    'owner': aux1[mname][0]['owner'],
                                                    'impressions': Number(Math.round((imp / 1000) + 'e1') + 'e-1'),
                                                    'ads': ads,
                                                    'clicks': clicks,
                                                    'client_cost': parseFloat(client_cost).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'cost_per_click': parseFloat(cost_per_click).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'cost': parseFloat(cost).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cost': parseFloat((cost - (cost * parseFloat(aux1[mname][0]['agency_commission'], 2) / 100))).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'gri': parseFloat(0).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),
                                                    'gri': parseFloat(gri).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),
                                                    'cpp': parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cpp': parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'cpm': (gri > 0) ? parseFloat(cost / gri).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }) : parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cpm': (gri > 0) ? parseFloat(((cost / gri) - ((cost / gri) * (parseFloat(aux1[mname][0]['agency_commission']) / 100)))).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }) : parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                });
                                            }
                                        }
                                        else {
                                            var ads = parseInt(aux3.sum("ad_count"));
                                            ads = (isNaN(ads)) ? 0 : ads
                                            if (ads > 0) {
                                                var imp = aux3.sum("impressions");
                                                totals['impressions'] += parseFloat(imp);
                                                console.log('aux3 ', aux3);
                                                var cost = aux3.sum(function (row) {
                                                    return ((row.cost !== '') && (row.ad_count !== '') && (row.cost !== null) && (row.ad_count !== null)) ? parseFloat(row.cost) * row.ad_count : 0;
                                                });
                                                var client_cost = aux3.sum(function (row) {
                                                    var c  = ((row.cost !== '') && (row.ad_count !== '') && (row.cost !== null) && (row.ad_count !== null)) ? parseFloat(row.cost) * row.ad_count : 0;
                                                    console.log('client_cost_client_cost_', c, row);
                                                    return !isNaN(parseFloat(row.client_cost_com)) ? (parseFloat(c) * parseFloat(row.client_cost_com) ) /100 : 0;
                                                });

                                                var comiss = mname.indexOf("OOH") === -1 ? parseFloat(aux1[mname][0]['agency_commission']) : parseFloat(aux1[mname][0]['digital_commission']);
                                                totals['cost'] += parseFloat(cost);
                                                totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux1[mname][0]['agency_commission']) / 100)) + 'e1') + 'e-1'));
                                                var gri = aux3.sum(function (row) {
                                                    return ((row.impressions !== '') && (row.ad_count !== '') && (row.impressions !== null) && (row.ad_count !== null)) ? parseFloat(Number(Math.round((row.impressions) + 'e1') + 'e-1') * row.ad_count) : 0;
                                                });
                                                totals['gri'] += parseFloat(gri);
                                                totals['client_cost'] += parseFloat(client_cost);
                                                results.push({
                                                    'commission': comiss,
                                                    'brand': aux1[mname][0]['brand'],
                                                    'product': aux1[mname][0]['prod'],
                                                    'advertiser': aname,
                                                    'campaign': cname,
                                                    'estimate_number': aux1[mname][0]['estimate_number'],
                                                    'job_number': aux1[mname][0]['job_number'],
                                                    'campaign_number': aux1[mname][0]['campaign_number'],
                                                    'campstart': moment(aux1[mname][0]['campstart']).format('MM/DD/YYYY'),
                                                    'campend': moment(aux1[mname][0]['campend']).format('MM/DD/YYYY'),
                                                    'wv_number': aux1[mname][0]['wv_number'],
                                                    'demo': '',
                                                    'market': mtype,
                                                    'media': aux1[mname][0]['mtype'].split("Line")[1],
                                                    'daypart': "",
                                                    'vendor': aux1[mname][0]['vndr_name'],
                                                    'owner': aux1[mname][0]['owner'],
                                                    'impressions': Number(Math.round((imp) + 'e1') + 'e-1'),
                                                    'ads': ads,
                                                    'clicks': 0,
                                                    'cost_per_click': 0,
                                                    'cost': parseFloat(cost).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'client_cost': parseFloat(client_cost).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cost': parseFloat((cost - (cost * parseFloat(comiss) / 100))).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'grp': parseFloat(0).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),
                                                    'gri': parseFloat(gri).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),
                                                    'cpp': parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cpp': parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'cpm': (gri > 0) ? parseFloat(cost / gri).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }) : parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cpm': (gri > 0) ? parseFloat(((cost / gri) - ((cost / gri) * (parseFloat(comiss) / 100)))).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }) : parseFloat(0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                });
                                            }
                                        }
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }
        console.log('podcast_podcast_ totals', totals)

        var commission = (totals['cost'] > 0) ? (1 - (totals['net_cost'] / totals['cost'])) : 0;

        function totalTVUpdateData(g){
            var totals = {
                'impressions': 0,
                'cost': 0,
                'net_cost': 0,
                'client_cost': 0,
                'grp': 0,
                'gri': 0,
                'cpp': 0,
                'net_cpp': 0,
                'cpm': 0,
                'net_cpm': 0,
                'ads': 0,
                'clicks': 0,
                'cost_per_click': 0,
            };
            campaigns_totals=[];
            market_totals=[];
            media_totals= [];
            vendor_totals = [];
            array_camp = [];
            array_markets = [];
            array_vendors = [];
            array_media = [];
            g.api.forEachNodeAfterFilterAndSort(function(node){
                console.log('totalTVUpdateData_totalTVUpdateData_ ', node.data);
                totals['impressions'] += (node.data.media === "Radio") ? parseFloat(node.data.impressions / 10) : parseFloat(node.data.impressions);
                totals['ads'] += (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads);
                totals['clicks'] += (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks);

                 var cost= node.data.cost.replace('$', '');
                 cost= cost.replace(/,/g, '')
                 totals['cost'] += parseFloat(cost);

                var net_cost= node.data.net_cost.replace('$', '');
                net_cost= net_cost.replace(/,/g, '')
                totals['net_cost'] += parseFloat(net_cost);

                var client_cost = node.data.client_cost.replace('$', '');
                client_cost = client_cost.replace(/,/g, '')
                totals['client_cost'] += parseFloat(client_cost);

                if(typeof node.data.grp !== 'undefined')
                    totals['grp'] +=  parseFloat(node.data.grp.replace(/,/g, '') );
                if(typeof node.data.gri !== 'undefined')
                   totals['gri'] +=  parseFloat(node.data.gri.replace(/,/g, '') );

                if (typeof campaigns_totals[node.data.campaign] === 'undefined') {
                     array_camp.push(node.data.campaign);
                     campaigns_totals[node.data.campaign] = [];
                     campaigns_totals[node.data.campaign] = {
                         ads: (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads),
                         clicks: (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks),
                         cost: parseFloat(cost),
                         net_cost: parseFloat(net_cost),
                         client_cost: parseFloat(client_cost),
                         gri:  parseFloat(node.data.gri.replace(/,/g, '')),
                         grp: (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1)  ?   parseFloat(node.data.grp.replace(/,/g, '')) : 0,
                         comissions: parseFloat(node.data.commission),
                     };
                 }
                 else{
                     campaigns_totals[node.data.campaign]['ads']+= (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads);
                     campaigns_totals[node.data.campaign]['clicks']+= (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks);
                     campaigns_totals[node.data.campaign]['cost']+= parseFloat(cost);
                     campaigns_totals[node.data.campaign]['net_cost']+= parseFloat(net_cost);
                     campaigns_totals[node.data.campaign]['client_cost']+= parseFloat(client_cost);
                     campaigns_totals[node.data.campaign]['gri']+= parseFloat(node.data.gri.replace(/,/g, ''));
                     campaigns_totals[node.data.campaign]['grp']+=  (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1) ?  parseFloat(node.data.grp.replace(/,/g, '')) : 0;
                 }

                if (typeof market_totals[node.data.market] === 'undefined') {
                    array_markets.push(node.data.market);
                    market_totals[node.data.market] = [];
                    market_totals[node.data.market] = {
                        ads: (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads),
                        clicks: (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks),
                        cost: parseFloat(cost),
                        net_cost: parseFloat(net_cost),
                        client_cost: parseFloat(client_cost),
                        gri:  parseFloat(node.data.gri.replace(/,/g, '')),
                        grp: (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1) ?   parseFloat(node.data.grp.replace(/,/g, '')) : 0,
                        comissions: parseFloat(node.data.commission),
                    };
                }
                else{
                    market_totals[node.data.market]['ads']+= (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads);
                    market_totals[node.data.market]['clicks']+= (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks);
                    market_totals[node.data.market]['cost']+= parseFloat(cost);
                    market_totals[node.data.market]['net_cost']+= parseFloat(net_cost);
                    market_totals[node.data.market]['client_cost']+= parseFloat(client_cost);
                    market_totals[node.data.market]['gri']+= parseFloat(node.data.gri.replace(/,/g, ''));
                    market_totals[node.data.market]['grp']+=  (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1) ?  parseFloat(node.data.grp.replace(/,/g, '')) : 0;
                }
                if (typeof media_totals[node.data.media] === 'undefined') {
                    array_media.push(node.data.media);
                    media_totals[node.data.media] = [];
                    media_totals[node.data.media] = {
                        ads: (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads),
                        clicks: (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks),
                        cost: parseFloat(cost),
                        net_cost: parseFloat(net_cost),
                        client_cost: parseFloat(client_cost),
                        gri:  parseFloat(node.data.gri.replace(/,/g, '')),
                        grp: (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1) ?   parseFloat(node.data.grp.replace(/,/g, '')) : 0,
                        comissions: parseFloat(node.data.commission),
                    };
                }
                else{
                    media_totals[node.data.media]['ads']+= (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads);
                    media_totals[node.data.media]['clicks'] += (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks);
                    media_totals[node.data.media]['cost']+= parseFloat(cost);
                    media_totals[node.data.media]['net_cost']+= parseFloat(net_cost);
                    media_totals[node.data.media]['client_cost']+= parseFloat(client_cost);
                    media_totals[node.data.media]['gri']+=  parseFloat(node.data.gri.replace(/,/g, ''));
                    media_totals[node.data.media]['grp']+=  (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1) ?  parseFloat(node.data.grp.replace(/,/g, '')) : 0;
                }
                if (typeof vendor_totals[node.data.vendor] === 'undefined') {
                    array_vendors.push(node.data.vendor);
                    vendor_totals[node.data.vendor] = [];
                    vendor_totals[node.data.vendor] = {
                        ads: (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads),
                        clicks: (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks),
                        cost: parseFloat(cost),
                        net_cost: parseFloat(net_cost),
                        client_cost: parseFloat(client_cost),
                        gri: parseFloat(node.data.gri.replace(/,/g, '')),
                        grp: (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1) ?   parseFloat(node.data.grp.replace(/,/g, '')) : 0,
                        comissions: parseFloat(node.data.commission),
                    };
                }
                else{
                    vendor_totals[node.data.vendor]['ads']+= (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads);
                    vendor_totals[node.data.vendor]['clicks'] += (isNaN(parseInt(node.data.clicks))) ? 0 : parseInt(node.data.clicks);
                    vendor_totals[node.data.vendor]['cost']+= parseFloat(cost);
                    vendor_totals[node.data.vendor]['net_cost']+= parseFloat(net_cost);
                    vendor_totals[node.data.vendor]['client_cost']+= parseFloat(client_cost);
                    vendor_totals[node.data.vendor]['gri']+=  parseFloat(node.data.gri.replace(/,/g, ''));
                    vendor_totals[node.data.vendor]['grp']+=  (node.data.media.indexOf("Television") !== -1 || node.data.media.indexOf("Radio") !== -1 || node.data.media.indexOf("Podcast") !== -1) ?  parseFloat(node.data.grp) : 0;
                }
            });
            console.log('campaigns_totals filter ', campaigns_totals);
            fill_summary_totals(campaigns_totals, market_totals, media_totals, vendor_totals, array_camp, array_markets, array_media, array_vendors);

            var commission = (totals['cost'] > 0) ? (1 - (totals['net_cost'] / totals['cost'])) : 0.00;
            totals['cpp'] = (totals['grp'] > 0) ? Number(Math.round((totals['cost'] / totals['grp']) + 'e2') + 'e-2') : 0.00;
            totals['net_cpp'] = (totals['grp'] > 0) ? Number(Math.round(((totals['cost'] / totals['grp']) - ((totals['cost'] / totals['grp']) * (parseFloat(commission)))) + 'e2') + 'e-2') : 0.00;
            totals['cpm'] = (totals['gri'] > 0) ? Number(Math.round((totals['cost'] / totals['gri']) + 'e1') + 'e-1') : 0;
            totals['net_cpm'] = (totals['gri'] > 0) ? Number(Math.round(((totals['cost'] / totals['gri']) - ((totals['cost'] / totals['gri']) * (parseFloat(commission)))) + 'e2') + 'e-2') : 0.00;
            totals['cost_per_click'] = (totals['clicks'] > 0) ? Number(Math.round((totals['cost'] / totals['clicks']) + 'e2') + 'e-2') : 0;

            totals['cost'] = parseFloat( totals['cost']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            totals['net_cost'] = parseFloat( totals['net_cost']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            totals['client_cost'] = parseFloat( totals['client_cost']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            totals['cpp'] = parseFloat( totals['cpp']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            totals['net_cpp'] = parseFloat( totals['net_cpp']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            totals['cpm'] = parseFloat( totals['cpm']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            totals['net_cpm'] = parseFloat( totals['net_cpm']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            totals['impressions']= parseFloat( totals['impressions']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            totals['grp']= parseFloat( totals['grp']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            totals['gri']= parseFloat( totals['gri']).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            totals['cost_per_click'] = parseFloat(totals['cost_per_click']).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            console.log('totals ****** finall', totals);
            g.api.setPinnedTopRowData([totals]);
        }
        console.log("DATA FROM OPTIONS: ", custom_details, estimate_options)
        columnInvExportInfo = [
           // 'commission': parseFloat(aux1[mname][0]['media_commission']),
            {
                headerName: "Commission",
                field: 'commission',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
            },
            {
                headerName: "Brand",
                field: 'brand',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Brand") !== -1) ? false : true
            }, {
                headerName: "Product",
                field: 'product',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Product") !== -1) ? false : true
            },
            {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Advertiser") !== -1) ? false : true
            }, {
                headerName: "Campaign",
                field: 'campaign',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign") !== -1) ? false : true
            }, {
                headerName: "Est. No.",
                field: 'estimate_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Estimate No.") !== -1) ? false : true
            }, {
                headerName: "Job No.",
                field: 'job_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Job No.") !== -1) ? false : true
            }, {
                headerName: "Camp. No.",
                field: 'campaign_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Camp. No.") !== -1) ? false : true
            }, {
                headerName: "Camp. Start",
                field: 'campstart',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign Start Date") !== -1) ? false : true
            }, {
                headerName: "Camp. End",
                field: 'campend',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign End Date") !== -1) ? false : true
            },{
                headerName: "Version Number",
                field: 'wv_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Version Number") !== -1) ? false : true
            }, {
                headerName: "Demo",
                field: 'demo',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Demo") !== -1) ? false : true
            }, {
                headerName: "Market",
                field: 'market',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Market") !== -1) ? false : true
            }, {
                headerName: "Media",
                field: 'media',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Media Type") !== -1) ? false : true
            }, {
                headerName: "Daypart",
                field: 'daypart',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Daypart") !== -1) ? false : true
            },{
                headerName: "Zone",
                field: 'cable_zone',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Cable Zone") !== -1) ? false : true
            }, {
                headerName: "Vendor",
                field: 'vendor',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Vendor") !== -1) ? false : true
            }, {
                headerName: "Owner",
                field: 'owner',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Owner") !== -1) ? false : true
            }, {
                headerName: "Impressions",
                field: 'impressions',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Impressions") !== -1) ? false : true
            }, {
                headerName: "Ads",
                field: 'ads',
                width: 50,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Ads") !== -1) ? false : true
            }, {
                headerName: "Gross Cost",
                field: 'cost',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Gross Cost") !== -1) ? false : true
            }, {
                headerName: "Net Cost",
                field: 'net_cost',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Net Cost") !== -1) ? false : true
            },
            {
                headerName: "Client Cost",
                field: 'client_cost',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Net Cost") !== -1) ? false : true
            }, {
                headerName: "GRP",
                field: 'grp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("GRPs") !== -1) ? false : true
            }, {
                headerName: "GRI",
                field: 'gri',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("GRIs") !== -1) ? false : true
            }, {
                headerName: "CPP",
                field: 'cpp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Gross CPP") !== -1) ? false : true
            }, {
                headerName: "NET CPP",
                field: 'net_cpp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Net CPP") !== -1) ? false : true
            }, {
                headerName: "CPM",
                field: 'cpm',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Gross CPM") !== -1) ? false : true
            }, {
                headerName: "NET CPM",
                field: 'net_cpm',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Net CPM") !== -1) ? false : true
            },
            {
                headerName: "Clicks",
                field: 'clicks',
                width: 50,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Clicks") !== -1) ? false : true
            }, {
                headerName: "Cost per Click",
                field: 'cost_per_click',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Cost per Click") !== -1) ? false : true
            },

        ];

        columnCampBreakout = [
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Month",
                field: 'broadcast_month',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRenderer,
            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 130,
                cellStyle: {'text-align': "right"},
                // hide: (custom_details.indexOf("Order Line") !== -1) ? false : true
                rowGroupIndex: 2,
                hide: true,
                // pinned:'left',
                suppressMovable: true,
                pinned: 'left'
            },
           {
               headerName: "Media type",
               field: 'media_type',
               width: 120,
               cellStyle: {'text-align': "center"},
               hide: true,
           },
           {
               headerName: "camp_id",
               field: 'camp_id',
               width: 120,
               cellStyle: {'text-align': "center"},
               hide: true,
           },
           {
               headerName: "Vendor id",
               field: 'vendor_id',
               width: 120,
               cellStyle: {'text-align': "center"},
               hide: true,
           },
           {
               headerName: "Line id",
               field: 'line_id',
               width: 120,
               cellStyle: {'text-align': "center"},
               hide: true,
           },
           {
               headerName: "Comission",
               field: 'comission',
               width: 120,
               cellStyle: {'text-align': "center"},
               hide: true,
           },
           {
               headerName: "impressions",
               field: 'impressions',
               width: 120,
               cellStyle: {'text-align': "center"},
               hide: true,
           },
           {
               headerName: "rating",
               field: 'rating',
               width: 120,
               cellStyle: {'text-align': "center"},
               hide: true,
           },
            {
                headerName: "Ads",
                field: 'ads',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Gross Cost",
                field: 'cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: CurrencyFormatRenderer,
            },
            {
                headerName: "Net Cost",
                field: 'net_cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: CurrencyFormatRenderer,
            },
            {
                headerName: "Client Cost",
                field: 'client_cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: CurrencyFormatRenderer,
            },
            {
                headerName: "GRP",
                field: 'grp',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "GRI",
                field: 'gri',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "CPP",
                field: 'cpp',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Net CPP",
                field: 'net_cpp',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "CPM",
                field: 'cpm',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Net CPM",
                field: 'net_cpm',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Clicks",
                field: 'clicks',
                width: 120,
                cellStyle: {'text-align': "center"},
            }, {
                headerName: "Cost per Click",
                field: 'cost_per_click',
                width: 140,
                cellStyle: {'text-align': "center"},
            },

        ];
        function CurrencyFormatRenderer() {
        }

        CurrencyFormatRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('div');

            $(this.eGui).css('text-align', 'right');

            if (params.node.rowPinned !== 'bottom') {
                if (typeof params.value !== 'undefined') {
                    var param_val = params.value.replace('$', '');
                    param_val = param_val.replace(/,/g, '') ;

                    if (isNaN(parseFloat(param_val))) {
                        console.log("NAN: " + parseFloat(param_val));
                        this.eGui.innerHTML = '$0.00';
                    } else {
                        param_val = parseFloat(param_val).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        this.eGui.innerHTML = param_val;
                    }
                } else {
                    this.eGui.innerHTML = '$0.00';
                }
            } else {
                this.eGui.innerHTML = '';
            }
        };

        CurrencyFormatRenderer.prototype.getGui = function () {
            return this.eGui;
        };
        columnCampBreakoutMonth = [
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Month",
                field: 'broadcast_month',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRenderer,
            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 130,
                cellStyle: {'text-align': "right"},
                // hide: (custom_details.indexOf("Order Line") !== -1) ? false : true
                rowGroupIndex: 1,
                hide: true,
                // pinned:'left',
                suppressMovable: true,
                pinned: 'left'
            },
            {
                headerName: "Media type",
                field: 'media_type',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "camp_id",
                field: 'camp_id',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "Vendor id",
                field: 'vendor_id',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "Line id",
                field: 'line_id',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "Comission",
                field: 'comission',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "impressions",
                field: 'impressions',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "rating",
                field: 'rating',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "Ads",
                field: 'ads',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Gross Cost",
                field: 'cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: CurrencyFormatRenderer,
            },
            {
                headerName: "Net Cost",
                field: 'net_cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: CurrencyFormatRenderer,
            },
            {
                headerName: "Client Cost",
                field: 'client_cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: CurrencyFormatRenderer,
            },
            {
                headerName: "GRP",
                field: 'grp',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "GRI",
                field: 'gri',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "CPP",
                field: 'cpp',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Net CPP",
                field: 'net_cpp',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "CPM",
                field: 'cpm',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Net CPM",
                field: 'net_cpm',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Clicks",
                field: 'clicks',
                width: 120,
                cellStyle: {'text-align': "center"},
            }, {
                headerName: "Cost per Click",
                field: 'cost_per_click',
                width: 140,
                cellStyle: {'text-align': "center"},
            },

        ];

        function MonthFormatRenderer() {
        }
        MonthFormatRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('span');
            if (typeof params.value !== 'undefined') {
                if (params.node.rowPinned !== 'bottom') {
                    console.log(' params.value ',  params.value );
                    if (typeof params.value !== 'undefined' && params.value !== null && params.value !== '' && params.value !== -1) {
                        console.log(' params.value ', moment(params.value).format('MMMM, YYYY'));
                        this.eGui.innerHTML = moment(params.value).format('MMMM, YYYY');
                    } else {
                        this.eGui.innerHTML = '';
                    }
                } else {
                    this.eGui.innerHTML = '';
                }
            } else {
                this.eGui.innerHTML = '';
            }
        };
        MonthFormatRenderer.prototype.getGui = function () {
            return this.eGui;
        };
        gridCampBreakout = {
            columnDefs: columnCampBreakout,
            autoGroupColumnDef: {
                headerName: 'Campaigns',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return CampBreakAggFunction(nodes);
            },
            onGridReady: function (e) {
               // totalInvDetailUpd (this)
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                // totalInvDetailUpd(this);
                // if (this.api.isAnyFilterPresent())
                //     $('#reset_filters').show();
                // else
                //     $('#reset_filters').hide();
            },
        };
        gridCampBreakoutMonth = {
            columnDefs: columnCampBreakoutMonth,
            autoGroupColumnDef: {
                headerName: 'Months',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return CampBreakAggFunction(nodes);
            },
            onGridReady: function (e) {
                // totalInvDetailUpd (this)
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                // totalInvDetailUpd(this);
                // if (this.api.isAnyFilterPresent())
                //     $('#reset_filters').show();
                // else
                //     $('#reset_filters').hide();
            },
        };
        var CampBreakAggFunction = function (nodes) {
            console.log('nodes ***********', nodes);
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 2) {
                    //invoice
                    result['ads'] = 0;
                    result['clicks'] = 0;
                    result['cost'] = 0;
                    result['net_cost'] = 0;
                    result['client_cost'] = 0;

                    var gri = 0;
                    var grp = 0;

                    $.each(nodes, function (index, value) {
                        console.log('value ----', value);
                        $.each(value.childrenAfterGroup, function (index, value) {
                            console.log('level 2 values', value);
                            gri += parseFloat(value['data']['impressions']) * parseInt(value['data']['ads']);
                            grp += parseFloat(value['data']['rating']) * parseInt(value['data']['ads']);
                            vbl = value['data']['ads'];
                            mm = value['data']['media_type'];
                            $.each(value['data'], function (index, value) {
                                if (index in result) {
                                    console.log(index);
                                    if (typeof value !== 'undefined') {
                                        if (isNaN(value)) {
                                            if (mm !== 'Digital' && mm !== 'podcast_programmatic') {
                                                var sum = value.replace('$', '');
                                                sum = sum.replace(/,/g, '') ;
                                                result[index] += parseFloat(sum)
                                            } else {
                                                var sum = value.replace('$', '');
                                                sum = sum.replace(/,/g, '') ;
                                              //  if (vbl > 0)
                                                    result[index] += (parseFloat(sum));
                                            }
                                        } else
                                            result[index] += parseFloat(value);

                                    }
                                }
                            });
                        });
                    });

                    result['grp'] = parseFloat(grp);
                    gri = Number(Math.round(((gri)) + 'e1') + 'e-1');
                    result['gri'] = gri;
                    console.log('podcast_level_2 ', result);
                    console.log('podcast_level_2', '   net_cost', result['net_cost'] , '  gri  ', gri , '  nect_cpm ',result['net_cost'] / gri);
                    if (result['grp'] > 0) {
                        result['cpp'] = parseFloat(result['cost'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpp'] = parseFloat(result['net_cost'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    var cost_per_click = result['clicks'] > 0 ? result['cost'] / result['clicks'] : 0;
                    result['cost_per_click'] = parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    if (gri > 0) {
                        result['cpm'] = parseFloat(result['cost'] / gri).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpm'] = parseFloat(result['net_cost'] / gri).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    result['grp'] = parseFloat(result['grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['gri'] = parseFloat(result['gri']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['cost'] = parseFloat(parseFloat(result['cost'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['client_cost'] = parseFloat(parseFloat(result['client_cost'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['net_cost'] = parseFloat(parseFloat(result['net_cost'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    console.log('level 2 resul', result);

                }
                else if (nodes[0].level === 1) {
                    result['ads'] = 0;
                    result['clicks'] = 0;
                    result['cost'] = 0;
                    result['net_cost'] = 0;
                    result['client_cost'] = 0;
                    var gri = 0;
                    var grp = 0;

                    $.each(nodes, function (index, value) {
                        // nodes[index].expanded = true;
                        $.each(value.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                gri += parseFloat(value['data']['impressions']) * parseInt(value['data']['ads']);
                                grp += parseFloat(value['data']['rating']) * parseInt(value['data']['ads']);
                                vbl = value['data']['ads'];
                                mm = value['data']['media_type'];
                                $.each(value['data'], function (index, value) {
                                    if (index in result) {
                                        if (typeof value !== 'undefined') {
                                            if (index == 'ads'|| index == 'clicks')
                                                result[index] += value;
                                            else {
                                                if (mm !== 'Digital' && mm !== 'podcast_programmatic') {
                                                    var sum = value.replace('$', '');
                                                    sum = sum.replace(/,/g, '') ;
                                                    result[index] += parseFloat(sum)
                                                } else {
                                                    var sum = value.replace('$', '');
                                                    sum = sum.replace(/,/g, '') ;
                                                   // if (vbl > 0)
                                                        result[index] += (parseFloat(sum));
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    });

                    console.log('result_level 1', result);
                    result['grp'] = parseFloat(grp);
                    gri = Number(Math.round(((gri)) + 'e1') + 'e-1');
                    result['gri'] = gri;
                    console.log('podcast_level_1', result);
                    console.log('podcast_level_1', '   net_cost', result['net_cost'] , '  gri  ', gri , '  nect_cpm ',result['net_cost'] / gri);
                    if (result['grp'] > 0) {
                        result['cpp'] = parseFloat(result['cost'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpp'] = parseFloat(result['net_cost'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    if (gri > 0) {
                        result['cpm'] = parseFloat(result['cost'] / gri).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpm'] = parseFloat(result['net_cost'] / gri).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    var cost_per_click = result['clicks'] > 0 ? result['cost'] / result['clicks'] : 0;
                    result['cost_per_click'] = parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    result['grp'] = parseFloat(result['grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['gri'] = parseFloat(result['gri']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['cost'] = parseFloat(parseFloat(result['cost'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['net_cost'] = parseFloat(parseFloat(result['net_cost'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['client_cost'] = parseFloat(parseFloat(result['client_cost'])).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                }
                else if (nodes[0].level === 3) {
                    result['ads'] = 0;
                    result['clicks'] = 0;
                    result['cost'] = 0;
                    result['net_cost'] = 0;
                    result['client_cost'] = 0;
                    var grp = 0;
                    var gri = 0;
                    console.log('nodes_nodes_nodes ', nodes);
                    $.each(nodes, function (index, value) {
                        console.log('value[data]', value['data']);
                        mm = value['data']['media_type'];
                        gri += parseFloat(value['data']['impressions']) * parseInt(value['data']['ads']);
                        grp += parseFloat(value['data']['rating']) * parseInt(value['data']['ads']);
                        vbl = value['data']['ads'];

                        $.each(value['data'], function (index, value) {
                            if (index in result) {
                                if (typeof value !== 'undefined') {
                                    if (index == 'ads' || index == 'clicks')
                                        result[index] += value;
                                    else {
                                        // var sum = value.replace('$', '');
                                        // sum = sum.replace(/,/g, '') ;
                                        // result[index] += parseFloat(sum)
                                        if (mm !== 'Digital' && mm !== 'podcast_programmatic') {
                                            var sum = value.replace('$', '');
                                            sum = sum.replace(/,/g, '') ;
                                            result[index] += parseFloat(sum)
                                        } else {
                                            var sum = value.replace('$', '');
                                            sum = sum.replace(/,/g, '') ;
                                           // if (vbl > 0)
                                                result[index] += (parseFloat(sum));
                                        }
                                    }

                                }
                            }
                        });
                    });

                    result['grp'] = parseFloat(grp);
                    gri = Number(Math.round(((gri)) + 'e1') + 'e-1');
                    result['gri'] = gri;
                    console.log('podcast_level_3 ', result);
                    console.log('podcast_level_3', '   net_cost', result['net_cost'] , '  gri  ', gri , '  nect_cpm ', result['net_cost'] / gri);
                    if (result['grp'] > 0) {
                        result['cpp'] = parseFloat(result['cost'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpp'] = parseFloat(result['net_cost'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    else {
                        result['cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    if (gri > 0) {
                        result['cpm'] = parseFloat(result['cost'] / gri).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpm'] = parseFloat(result['net_cost'] / gri).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['net_cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    var cost_per_click = result['clicks'] > 0 ? result['cost'] / result['clicks'] : 0;
                    result['cost_per_click'] = parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['grp'] = parseFloat(result['grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['gri'] = parseFloat(result['gri']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['cost'] = parseFloat(result['cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['net_cost'] = parseFloat(result['net_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    result['client_cost'] = parseFloat(result['client_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    console.log('level 3 results ', result);
                }
                return result;
            } else
                return false;
        };
        var camp_break = campaign_breakout_summary;
        var rowData = [];
        for(var i in camp_break) {
            var res = camp_break[i];
            console.log('months: ', res['months']);
            var mi = 0;
            for(var month in res['months']) {
                if(months_chart.indexOf(moment(month).format('YYYY/MM/01')) === -1)
                    months_chart.push(moment(month).format('YYYY/MM/01'));
                var agency_commission = parseFloat(res.agency_commission);
                var spots = res['months'][month];
                var clicks = typeof res['months_clicks'] !== 'undefined' && typeof res['months_clicks'][month] !== 'undefined' ? parseInt(res['months_clicks'][month]) : 0;
                var ind = 1;
                if(res.media_type === 'ooh' || res.media_type === 'other' || res.media_type === 'digital' || res.media_type === 'Digital' || res.media_type === 'ott' || res.media_type === 'OTT JamLoop' || res.media_type === 'podcast_programmatic')
                    ind = res.total_days > 0 ? res.months_days[mi]/res.total_days : 1;

                if(res.media_type  && res.media_type !== 'tv' &&  res.media_type !== 'radio' && res.media_type !== 'podcast_attached') {
                    if (res.media_type === 'ooh' || res.media_type === 'other' || res.media_type === 'ott' || res.media_type === 'OTT JamLoop' || res.media_type === 'OHH')
                        var gross_cost = res.ad_count * res.gross_cpa;
                     else if (res.media_type === 'digital' || res.media_type === 'Digital' || res.media_type === 'podcast_programmatic')
                        var gross_cost = res.gross_cpa;
                    else
                        var gross_cost = spots * res.gross_cpa;

                }else if(res.media_type === 'tv' ||  res.media_type === 'radio' || res.media_type === 'podcast_attached')
                    var gross_cost = res['months_cost'][month];

                var client_cost = res['months_client_cost'][month];
                var cost_per_click = clicks > 0 ? (parseFloat(gross_cost) * ind) / parseInt(clicks) : 0;

                var grp = (!isNaN(res.rating)) ? parseFloat(Number(Math.round((res.rating) + 'e1') + 'e-1') * spots) : 0;
                var gri = parseFloat(Number(Math.round((res.impressions) + 'e1') + 'e-1') * spots);
                var cpp = (!isNaN(parseFloat(grp)) && parseFloat(grp) > 0) ? parseFloat(gross_cost) / parseFloat(grp) : 0;
                if (res.media_type != 'radio')
                    var cpm = (!isNaN(parseFloat(gri)) && parseFloat(gri) > 0) ? parseFloat(gross_cost) / parseFloat(gri) : 0;
                else
                    var cpm = (!isNaN(parseFloat(gri)) && parseFloat(gri / 10) > 0) ? parseFloat(gross_cost) / (parseFloat(gri) / 10) : 0;

                if(res.media_type == 'radio')
                   var imp = (!isNaN(res.impressions)) ? Number(Math.round((res.impressions /10 ) + 'e1') + 'e-1') : 0;
                else if(res.media_type == 'Digital' || res.media_type === 'podcast_programmatic') {
                    var imp = (!isNaN(res.impressions)) ? parseFloat(res.impressions / 1000)  : 0;
                    gri = parseFloat(Number(Math.round((res.impressions /1000) + 'e1') + 'e-1') * spots);
                }
                else
                   var imp = (!isNaN(res.impressions)) ? Number(Math.round((res.impressions  ) + 'e1') + 'e-1') : 0;

                console.log('month_days: ', (typeof res.months_days !== 'undefined' ? res.months_days : 'undefined'));
                console.log('total_days: ', (typeof res.total_days !== 'undefined' ? res.total_days : 'undefined'));
                if( spots  > 0 || ((res.media_type === 'ooh' || res.media_type === 'other' || res.media_type === 'digital' || res.media_type === 'Digital' ||
                    res.media_type === 'OOH' || res.media_type === 'Other' || res.media_type === 'ott' || res.media_type === 'OTT JamLoop' || res.media_type === 'podcast_programmatic') &&
                    typeof res.months_days !== 'undefined' && typeof res.months_days[mi] !== 'undefined')) {
                    rowData.push({
                        'campaign': res.campaign_name,
                        'camp_id': res.camp_id,
                        'vendor': res.vendor_name,
                        'vendor_id': res.vendor_id,
                        'line_id': res.line_id,
                        'comission': agency_commission,
                        'rating': (!isNaN(res.rating)) ? Number(Math.round((res.rating) + 'e1') + 'e-1') : 0,
                        'impressions': imp,
                        'media_type': res.media_type,
                        'broadcast_month': moment(month).format('YYYY/MM/01'),
                        'ads': spots,
                        'clicks': clicks,
                        'cost':'$' + gross_cost * ind,
                        'client_cost':'$' + client_cost ,
                        // 'cost': parseFloat(gross_cost).toLocaleString("en-US", {
                        //     style: "currency",
                        //     currency: "USD",
                        //     minimumFractionDigits: 2
                        // }),
                        'net_cost' : '$'+ (gross_cost - gross_cost * (agency_commission / 100)) * ind,
                        // 'net_cost': parseFloat((gross_cost - gross_cost * (agency_commission / 100))).toLocaleString("en-US", {
                        //     style: "currency",
                        //     currency: "USD",
                        //   //  minimumFractionDigits: 2
                        // }),
                        'gri': parseFloat(gri * ind).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'grp': parseFloat(grp).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'cpp': parseFloat(cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'net_cpp': parseFloat(cpp - (cpp * (agency_commission / 100))).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'cpm': parseFloat(cpm).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'net_cpm': parseFloat((cpm - (cpm * (agency_commission / 100)))).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'cost_per_click': parseFloat(cost_per_click).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                    });
                }
                mi++;
            }
        }
        console.log('months_chart ', months_chart);

        var orderBy = [ 'campaign', 'broadcast_month', 'vendor'];
        var sorted = multisort(rowData, orderBy)
        gridCampBreakout.rowData = sorted;

        var orderBy = [  'broadcast_month', 'vendor', 'campaign'];
        var sorted_two = multisort(rowData, orderBy)
        gridCampBreakoutMonth.rowData = sorted_two;

        $('#myGridBreakout').html('');
        var gridCampBreakoutX = document.querySelector('#myGridBreakout');
        var grid = new agGrid.Grid(gridCampBreakoutX, gridCampBreakout);
        $('#myGridBreakoutMonth').html('');
        var gridCampBreakoutMonthX = document.querySelector('#myGridBreakoutMonth');
        var grid = new agGrid.Grid(gridCampBreakoutMonthX, gridCampBreakoutMonth);

        $('.export_camp_deta').on('click', function () {
            exportGridBreak($(this).attr('data'), gridCampBreakout);
        });
        $('.export_month_deta').on('click', function () {
            exportGridBreak($(this).attr('data'), gridCampBreakoutMonth);
        });
        function exportGridBreak(format, grid) {
            onBtExportBreak(grid, format);
        }
        $('.export_camp_deta_to').on('click', function () {
            $('#format_x_grid').val('campaign');
            $('#format_x_camp').val($(this).attr('data'));
            $('#style_x_camp').val($(this).attr('data-style'));
            $('#totalsToExportCampDetails').modal('show');
        });
        $('#submit_export_totals_camp').on('click', function () {
            var selectedItems = [];
            $('.all_more_options_totals_camp input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });

            if($('#format_x_grid').val() == 'campaign')
                onBtExportBreakTo(gridCampBreakout, $('#format_x_camp').val(), selectedItems);
            else
                onBtExportBreakTo(gridCampBreakoutMonth, $('#format_x_camp').val(), selectedItems);
        });
        $('.export_month_deta_to').on('click', function () {
          //  exportGridBreakTo($(this).attr('data'), gridCampBreakoutMonth);
            $('#format_x_camp').val($(this).attr('data'));
            $('#format_x_grid').val('month');
            $('#style_x_camp').val($(this).attr('data-style'));
            $('#totalsToExportCampDetails').modal('show');
        });
        function exportGridBreakTo(format, grid) {
            onBtExportBreakTo(grid, format);
        }
        function onBtExportBreakTo(gridOptions, format, selectedItems) {
            console.log('selectedItems ', selectedItems);
            var params = {
                skipHeader: false,
                columnGroups: (format == "csv") ? false : true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "smart-report." + format,

            };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Summary Report"}}
                    ],
                    /*[
                        {data:{type:'String', value:'Survey'}},
                        {data:{type:'String', value:  header_books_print_export}}
                    ],
                    [
                        {data:{type:'String', value:'Geography'}},
                        {data:{type:'String', value: head[4]}}
                    ],
                    [
                        {data:{type:'String', value:'Created'}},
                        {data:{type:'String', value: head[3]}}
                    ],*/
                ];

                params.customFooter = [
                    [],
                    /*[
                        {data:{type:'String', value:'Disclaimer'}}

                    ],
                    [
                        {data:{type:'String', value: "The above estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nLabeled estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nData &copy; Nielsen Media Research and estimates are copyrighted and subject to all qualifications and limitations stated in the Nielsen report."}}
                    ],
                    [
                        {data:{type:'String', value: (market_type === "PPM") ? "PPM estimates are derived from the PPM technology and methodology and are subject to the qualifications and limitations stated in that Report. \n" +
                                    " PPM ratings are based on audience estimates and are the opinion of Nielsen and should not be relied on for precise accuracy or precise representativeness of a demographic or radio market.\n" : ""}}

                    ],*/
                    []
                ];
            }
            console.log("selectedItems before", selectedItems);
            params.shouldRowBeSkipped = function(row){
                // console.log("row ", row);
                // console.log("selectedItems ", selectedItems);
                if(typeof row.node.key === 'undefined' )
                    return true
                if(selectedItems.indexOf('campaign') === -1 && row.node.field === 'campaign')
                    return true;
                if(selectedItems.indexOf('vendor') === -1 && row.node.field === 'vendor')
                    return true;
                if(selectedItems.indexOf('order') === -1 && row.node.field === 'order_number')
                    return true;
                if(selectedItems.indexOf('month') === -1 && row.node.field === 'broadcast_month')
                    return true;

            };
            params.processCellCallback = function (params) {
                if(params.value.toString().split('/').length === 3 && moment(params.value).isValid())
                   return moment(params.value).format('MMMM, YYYY');
                if(params.column.colId === 'cost' || params.column.colId === 'net_cost' || params.column.colId === 'client_cost'){
                  var param_val = params.value.replace('$', '');
                  param_val = param_val.replace(/,/g, '') ;

                  if(isNaN(parseFloat(param_val)))
                      param_val = 0;
                  param_val = parseFloat(param_val).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 2
                  });
                  return param_val;
              }
              else if(params.column.colId === "broadcast_month")
                 return moment(params.value).format('MMMM, YYYY');
               else
                  return  params.value;


            };
            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridOptions.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                var content = gridOptions.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'smart-report.xlsx', {bookType: 'xlsx', type: 'base64'});
            }
        }

        function onBtExportBreak(gridOptions, format) {
            var params = {
                skipHeader: false,
                columnGroups: (format == "csv") ? false : true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "smart-report." + format,

            };

            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Smart Report"}}
                    ],
                    /*[
                        {data:{type:'String', value:'Survey'}},
                        {data:{type:'String', value:  header_books_print_export}}
                    ],
                    [
                        {data:{type:'String', value:'Geography'}},
                        {data:{type:'String', value: head[4]}}
                    ],
                    [
                        {data:{type:'String', value:'Created'}},
                        {data:{type:'String', value: head[3]}}
                    ],*/
                ];

                params.customFooter = [
                    [],
                    /*[
                        {data:{type:'String', value:'Disclaimer'}}

                    ],
                    [
                        {data:{type:'String', value: "The above estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nLabeled estimates should be used with caution as they are derived from a sample that does not meet the Nielsen Company's minimum sample size requirements for reporting.\nData &copy; Nielsen Media Research and estimates are copyrighted and subject to all qualifications and limitations stated in the Nielsen report."}}
                    ],
                    [
                        {data:{type:'String', value: (market_type === "PPM") ? "PPM estimates are derived from the PPM technology and methodology and are subject to the qualifications and limitations stated in that Report. \n" +
                                    " PPM ratings are based on audience estimates and are the opinion of Nielsen and should not be relied on for precise accuracy or precise representativeness of a demographic or radio market.\n" : ""}}

                    ],*/
                    []
                ];
            }
            params.processCellCallback = function (params) {
                if(typeof params.value !== 'undefined' && params.value.toString().split('/').length === 3 && moment(params.value).isValid())
                    return moment(params.value).format('MMMM, YYYY');
                if (params.column.colId === 'cost' || params.column.colId === 'net_cost' || params.column.colId === 'client_cost' ) {
                    var param_val = params.value.replace('$', '');
                    param_val = param_val.replace(/,/g, '');

                    if (isNaN(parseFloat(param_val)))
                        param_val = 0;
                    param_val = parseFloat(param_val).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    return param_val;

                } else
                    return params.value;
            }

            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridOptions.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                // gridOptions.api.exportDataAsExcel({
                //     processRowGroupCallback: rowGroupCallback,
                // });
                console.log("-------------excel-----------------", params);
                var content = gridOptions.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'smart-report.xlsx', {bookType: 'xlsx', type: 'base64'});
                console.log(xlsxContent);
            }
        }
        function rowGroupCallback(params) {
            return params.node.key;
        }

        var html = '';
        var html_1= '';
        var est_arra = ['Ordered  Ads','Ordered  GRPs', 'Ordered  Impressions','Ordered  Gross Cost', 'Ordered  Net Cost',
            'Ordered  Gross CPP',' Ordered   Net CPP', 'Ordered  Gross CPM', 'Ordered  Net CPM', 'Avg. GRPs/Impressions', 'Invoiced  Ads', 'Invoiced  Gross Cost', 'Date Aired', 'Invoiced  Net Cost', 'Time Aired', 'Length Aired', 'Day Aired',
            'Spend   Difference Gross','Spend  Difference Net', 'GRPs', 'Ads', 'GRIs', 'Impressions', 'Gross Cost', 'Net Cost', 'Client Cost','Gross CPP', 'Gross CPP', 'Net CPP', 'Gross CPM', 'Net CPM'];
        columnInvExportInfo.sort(function(a, b) {
            return a.headerName.replace('<br>', '') == b.headerName.replace('<br>', '') ? 0 : a.headerName.replace('<br>', '') < b.headerName.replace('<br>', '') ? -1 : 1
        })
        for(var ind in columnInvExportInfo){
            var hidden = (columnInvExportInfo[ind].hide) ? ["hidden-column", "background-color: rgb(204, 204, 204);"] : ["",""]
            if(est_arra.indexOf(columnInvExportInfo[ind].headerName.replace('<br>', '')) !== -1)
                html_1 += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="dropdown-item ' + hidden[0] + '" data-hidden="'+ columnInvExportInfo[ind].field +'" style="' + hidden[1] + '">'+ columnInvExportInfo[ind].headerName +'</a></li>';
             else
                html += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="dropdown-item ' + hidden[0] + '" data-hidden="'+ columnInvExportInfo[ind].field +'" style="' + hidden[1] + '">'+ columnInvExportInfo[ind].headerName +'</a></li>';
        }
        var html_list = ' <li class="dropdown-header" style=" color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>DISPLAY OPTIONS</strong></li>';
        html_list += html;
        html_list += ' <li class="dropdown-header" style="color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>METRIC OPTIONS</strong></li>';
        html_list += html_1;
        $("#sum-hiden-columns").html(html_list);
        $('.smart-rpt-analysis-hide-column a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-hidden');
            if ($(this).hasClass('hidden-column') ) {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            } else {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });
        gridInvExportInfo = {
            columnDefs: columnInvExportInfo,
            defaultColDef: {
                suppressToolPanel: true
            },
            pinnedTopRowData: [{
                'impressions': 0,
                'cost': 0,
                'net_cost': 0,
                'client_cost': 0,
                'grp': 0,
                'gri': 0,
                'cpp': 0,
                'net_cpp': 0,
                'cpm': 0,
                'net_cpm': 0,
                'ads': 0,
                'clicks': 0,
                'cost_per_click': 0,
            }],
            rowSelection: 'single',
            suppressRowClickSelection: false,
            enableColResize: true,
            //suppressMenuColumnPanel: true,
            suppressTouch: true,
            headerHeight: 30,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 22,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            getContextMenuItems: getContextMenuInvoiceOrder,
            onGridReady: function(e){
                totalTVUpdateData(this);
            },
            onFilterChanged: function (e) {
                totalTVUpdateData(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters').show();
                else
                    $('#reset_filters').hide();
            },
        };
        $('#reset_filters').on('click', function () {
            $.each(gridInvExportInfo.api.getFilterModel(), function (index, value) {
                gridInvExportInfo.api.destroyFilter(index);
            });
        });

        $('#myGrid').html('');
        gridInvExportInfo.rowData = results;
        var gridDet = document.querySelector('#myGrid');
        var grid = new agGrid.Grid(gridDet, gridInvExportInfo);
        gridInvExportInfo.api.setPinnedTopRowData(
            [
                {
                    'impressions': '',
                    'cost': '$' + totals['cost'],
                    'net_cost': '$' + totals['net_cost'],
                    'client_cost': '$' + totals['client_cost'],
                    'grp': totals['grp'],
                    'gri': totals['gri'],
                    'cpp': '$' + totals['cpp'],
                    'net_cpp': '$' + totals['net_cpp'],
                    'cpm': '$' + totals['cpm'],
                    'net_cpm': '$' + totals['net_cpm'],
                    'ads': totals['ads'],
                }
            ]
        );

        console.log("radio and tv");
        console.log(results);

        function fill_summary_totals(camp_sum_totals, market_sum_totals, media_sum_totals, vendor_sum_totals, array_camp, array_markets, array_media, array_vendors){
            campaigns_chart = camp_sum_totals;
            markets_chart = market_sum_totals;
            media_type_chart = media_sum_totals;
            vendors_chart = vendor_sum_totals;
            console.log('^^^totals ^^^', camp_sum_totals);
            console.log('^^^totals ^^^', array_camp);
            array_camp.sort();
            var html='';
            html += '<div class="table-wrapper" style="margin-top: 1%;"><table id="camp_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr>' +
                    '<th> Campaign</th>' +
                    '<th> Ads</th>' +
                    '<th> Gross Cost</th>' +
                    '<th> Net Cost</th>' +
                    '<th> Client Cost</th>' +
                    '<th> GRP</th>' +
                    '<th> GRI</th>' +
                    '<th> CPP</th>' +
                    '<th> NET CPP</th>' +
                    '<th> CPM</th>' +
                    '<th> NET CPM</th>' +
                    '<th> Clicks</th>' +
                    '<th> Cost per Click</th>' +
                    '</tr></thead>';
            html += '<tbody>' ;
            for(var ind in array_camp){
                var camp = array_camp[ind];
                var comissions = camp_sum_totals[camp].comissions;
                var cpp = (camp_sum_totals[camp].grp > 0) ? camp_sum_totals[camp].cost/ camp_sum_totals[camp].grp : 0;
                var cpm = (camp_sum_totals[camp].gri > 0) ? camp_sum_totals[camp].cost/ camp_sum_totals[camp].gri : 0;
                var net_cpp = (camp_sum_totals[camp].grp > 0 ) ? (camp_sum_totals[camp].net_cost / camp_sum_totals[camp].grp): 0;
                var net_cpm = (camp_sum_totals[camp].gri > 0 ) ? (camp_sum_totals[camp].net_cost / camp_sum_totals[camp].gri) : 0;
                var cost_per_click = (camp_sum_totals[camp].clicks > 0) ? camp_sum_totals[camp].cost/ camp_sum_totals[camp].clicks : 0;
                html += '<tr>' +
                    '<td>'+ camp +'</td>' +
                    '<td>'+ camp_sum_totals[camp].ads +'</td>' +
                    '<td>'+ parseFloat(camp_sum_totals[camp].cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(camp_sum_totals[camp].net_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(camp_sum_totals[camp].client_cost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=   '<td>'+ parseFloat(camp_sum_totals[camp].grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }),+'</td>' ;
                html +=     '<td>'+ parseFloat(camp_sum_totals[camp].gri).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }),+'</td>' ;
                html +=   '<td>'+ parseFloat(cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(net_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(net_cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html += '<td>'+ camp_sum_totals[camp].clicks +'</td>' +
                    '<td>'+ parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=  '</tr>';
            }
            html += '</tbody></table></div>';

            //market
            html += '<div style="margin-top: 3%" class="table-wrapper"><table  id="market_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr>' +
                '<th> Market</th>' +
                '<th> Ads</th>' +
                '<th> Gross Cost</th>' +
                '<th> Net Cost</th>' +
                '<th> Client Cost</th>' +
                '<th> GRP</th>' +
                '<th> GRI</th>' +
                '<th> CPP</th>' +
                '<th> NET CPP</th>' +
                '<th> CPM</th>' +
                '<th> NET CPM</th>' +
                '<th> Clicks</th>' +
                '<th> Cost per Click</th>' +
                '</tr></thead>';
            html += '<tbody>' ;
            array_markets.sort();
            for(var ind in array_markets){
                var camp = array_markets[ind];
                var comissions = market_sum_totals[camp].comissions;
                var cpp = (market_sum_totals[camp].grp > 0) ? market_sum_totals[camp].cost/ market_sum_totals[camp].grp : 0;
                var cpm = (market_sum_totals[camp].gri > 0) ? market_sum_totals[camp].cost/ market_sum_totals[camp].gri : 0;
                var net_cpp = (market_sum_totals[camp].grp > 0 ) ? (market_sum_totals[camp].net_cost / market_sum_totals[camp].grp): 0;
                var net_cpm = (market_sum_totals[camp].gri > 0 ) ? (market_sum_totals[camp].net_cost / market_sum_totals[camp].gri) : 0;

                var cost_per_click = (market_sum_totals[camp].clicks > 0) ? market_sum_totals[camp].cost/ market_sum_totals[camp].clicks : 0;
                html += '<tr>' +
                    '<td>'+ camp +'</td>' +
                    '<td>'+ market_sum_totals[camp].ads +'</td>' +
                    '<td>'+ parseFloat(market_sum_totals[camp].cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(market_sum_totals[camp].net_cost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(market_sum_totals[camp].client_cost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=   '<td>'+ parseFloat(market_sum_totals[camp].grp).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),+'</td>' ;
                html +=     '<td>'+ parseFloat(market_sum_totals[camp].gri).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),+'</td>' ;
                html +=   '<td>'+ parseFloat(cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(net_cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(net_cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html += '<td>'+ market_sum_totals[camp].clicks +'</td>' +
                    '<td>'+ parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=  '</tr>';

            }
            html += '</tbody></table></div>';
            //media totals
            html += '<div style="margin-top: 3%" class="table-wrapper"><table  id="media_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr>' +
                '<th> Media</th>' +
                '<th> Ads</th>' +
                '<th> Gross Cost</th>' +
                '<th> Net Cost</th>' +
                '<th> Client Cost</th>' +
                '<th> GRP</th>' +
                '<th> GRI</th>' +
                '<th> CPP</th>' +
                '<th> NET CPP</th>' +
                '<th> CPM</th>' +
                '<th> NET CPM</th>' +
                '<th> Clicks</th>' +
                '<th> Cost per Click</th>' +
                '</tr></thead>';
            html += '<tbody>' ;
            array_media.sort();

            for(var ind in array_media){
                var camp = array_media[ind];
                var comissions = media_sum_totals[camp].comissions;
                var cpp = (media_sum_totals[camp].grp > 0) ? media_sum_totals[camp].cost/ media_sum_totals[camp].grp : 0;
                var cpm = (media_sum_totals[camp].gri > 0) ? media_sum_totals[camp].cost/ media_sum_totals[camp].gri : 0;
                var net_cpp = (media_sum_totals[camp].grp > 0 ) ? (media_sum_totals[camp].net_cost / media_sum_totals[camp].grp): 0;
                var net_cpm = (media_sum_totals[camp].gri > 0 ) ? (media_sum_totals[camp].net_cost / media_sum_totals[camp].gri) : 0;
                var mm = (camp == 'Television') ? 'Television/Cable' : camp;
                var cost_per_click = (media_sum_totals[camp].clicks > 0) ? media_sum_totals[camp].cost/ media_sum_totals[camp].clicks : 0;
                html += '<tr>' +
                    '<td>'+ mm +'</td>' +
                    '<td>'+ media_sum_totals[camp].ads +'</td>' +
                    '<td>'+ parseFloat(media_sum_totals[camp].cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(media_sum_totals[camp].net_cost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(media_sum_totals[camp].client_cost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=   '<td>'+ parseFloat(media_sum_totals[camp].grp).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),+'</td>' ;
                html +=     '<td>'+ parseFloat(media_sum_totals[camp].gri).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),+'</td>' ;
                html +=   '<td>'+ parseFloat(cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(net_cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(net_cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;

                html += '<td>'+ media_sum_totals[camp].clicks +'</td>' +
                    '<td>'+ parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=  '</tr>';
            }
            html += '</tbody></table></div>';
            //vendor totals
            html += '<div style="margin-top: 3%" class="table-wrapper"><table  id="vendor_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr>' +
                '<th> Vendor</th>' +
                '<th> Ads</th>' +
                '<th> Gross Cost</th>' +
                '<th> Net Cost</th>' +
                '<th> Client Cost</th>' +
                '<th> GRP</th>' +
                '<th> GRI</th>' +
                '<th> CPP</th>' +
                '<th> NET CPP</th>' +
                '<th> CPM</th>' +
                '<th> NET CPM</th>' +
                '<th> Clicks</th>' +
                '<th> Cost per Click</th>' +
                '</tr></thead>';
            html += '<tbody>' ;

            array_vendors.sort();
            for(var ind in array_vendors){
                var camp = array_vendors[ind];
                var comissions = vendor_sum_totals[camp].comissions;
                var cpp = (vendor_sum_totals[camp].grp > 0) ? vendor_sum_totals[camp].cost/ vendor_sum_totals[camp].grp : 0;
                var cpm = (vendor_sum_totals[camp].gri > 0) ? vendor_sum_totals[camp].cost/ vendor_sum_totals[camp].gri : 0;
                var net_cpp = (vendor_sum_totals[camp].grp > 0 ) ? (vendor_sum_totals[camp].net_cost / vendor_sum_totals[camp].grp): 0;
                var net_cpm = (vendor_sum_totals[camp].gri > 0 ) ? (vendor_sum_totals[camp].net_cost / vendor_sum_totals[camp].gri) : 0;
                var cost_per_click = (vendor_sum_totals[camp].clicks > 0) ? vendor_sum_totals[camp].cost/ vendor_sum_totals[camp].clicks : 0;
                html += '<tr>' +
                    '<td>'+ camp +'</td>' +
                    '<td>'+ vendor_sum_totals[camp].ads +'</td>' +
                    '<td>'+ parseFloat(vendor_sum_totals[camp].cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=    '<td>'+ parseFloat(vendor_sum_totals[camp].net_cost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(vendor_sum_totals[camp].client_cost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=   '<td>'+ parseFloat(vendor_sum_totals[camp].grp).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),+'</td>' ;
                html +=     '<td>'+ parseFloat(vendor_sum_totals[camp].gri).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),+'</td>' ;
                html +=   '<td>'+ parseFloat(cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(net_cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=    '<td>'+ parseFloat(cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html +=  '<td>'+ parseFloat(net_cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),+'</td>' ;
                html += '<td>'+ vendor_sum_totals[camp].clicks +'</td>' +
                    '<td>'+ parseFloat(cost_per_click).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),+'</td>' ;
                html +=  '</tr>';

            }
            html += '</tbody></table></div>';
            $('#totals_summary_tab').html(html);
        };

        $('.export_excel_totals').on('click', function () {
            $('#format_x').val('xls');
            $('#style_x').val($(this).attr('data-type'));
            $('#totalsToExport').modal('show');
        });
        $('#export_csv_totals').on('click', function () {
            $('#format_x').val('csv');
            $('#totalsToExport').modal('show');
        });
        $('#submit_export_totals').on('click', function () {
            show_overlay_loader($("#totalsToExport .modal-content"));
            type = $('#format_x').val();
            var html_table = '<table class="table table-bordered table-striped table-condensed" >';
            var html_table_end = '</table>';
            var html = '';

            var selectedItems = [];
            $('.all_more_options_totals  input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            console.log('selectedItems', selectedItems)
            if (selectedItems.indexOf('campaign') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>CAMPAIGN SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#camp_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            if (selectedItems.indexOf('market') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>MARKET SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#market_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            if (selectedItems.indexOf('media') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>MEDIA SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#media_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            if (selectedItems.indexOf('vendor') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>VENDOR SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#vendor_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            var dt = new Date();
            var day = dt.getDate();
            var month = dt.getMonth() + 1;
            var year = dt.getFullYear();
            var hour = dt.getHours();
            var mins = dt.getMinutes();
            var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
            if(type === 'xls') {
                if ($('#style_x').val() === 'style') {
                    var a = document.createElement('a');
                    var data_type = 'data:application/vnd.ms-excel';
                    a.href = data_type + ', ' + encodeURIComponent(html);
                    a.download = 'exported_' + postfix + '.xls';
                    a.click();
                } else {
                    var res = '<table><tr><td>'+ html +'</td></tr></table>';
                    console.log('res_res_res_ ', $(res));
                    var tbl = $(res)[0];
                    var wb = XLSX.utils.table_to_book(tbl, {sheet: "Sheet JS"});
                    console.log(wb);
                    wb['Sheets']['Sheet JS']['A1']['v'] = '';
                    hide_overlay_loader($("#totalsToExport .modal-content"));
                    $('#totalsToExport').modal('hide');
                    return XLSX.writeFile(wb, ('exported_' + postfix + '.xlsx'));
                    return false;
                }
            }
            else{
                var url='data:application/csv,charset=utf-8,' + encodeURIComponent(html);
                location.href=url;
                return false;
            }
            hide_overlay_loader($("#totalsToExport .modal-content"));
            $('#totalsToExport').modal('hide');
        });

        $('.export_camp_deta_row_data').on('click', function() {
            var grid = $(this).attr('data-grid') === 'campaign' ? gridCampBreakout : gridCampBreakoutMonth;
            var columns_to_add = {};
            if($(this).attr('data-grid') === 'campaign') {
                columns_to_add['campaign'] = 'Campaign';
                columns_to_add['broadcast_month'] = 'Month';
                columns_to_add['vendor'] = 'Vendor';
            } else{
                columns_to_add['broadcast_month'] = 'Month';
                columns_to_add['vendor'] = 'Vendor';
                columns_to_add['campaign'] = 'Campaign';
            }
            var all_columns = collect(grid.columnDefs).groupBy('field').all();
            var html = '<table style="width: 100%;" class="table-bordered table-striped table-condensed"><tr style="">';

            for(var ind in columns_to_add )
               html += '<td><b>'+ columns_to_add[ind] +'</b></td>';

            for(var ind in grid.columnApi.getColumnState()){
                var value =  grid.columnApi.getColumnState()[ind];
                if(typeof columns_to_add[value.colId] === 'undefined' && value.hide === false && typeof all_columns[value.colId] !== 'undefined'){
                    var h = all_columns[value.colId][0].headerName;
                    html += '<td><b>'+ h.replace('<br>', '') +'</b></td>';
                    columns_to_add[value.colId] = h;
                }
            }

            html += '</tr>';
            grid.api.forEachNodeAfterFilterAndSort(function (node) {
                if(node.level === 3){
                    html += '<tr>';
                    for(var ind in columns_to_add){
                        console.log('node_node_', node)
                        html += '<td style="border: 1px solid #D3D3D3">'+ node.data[ind] +'</td>';
                    }
                    html += '</tr>';
                }
            });
            html += '</table>';

            var a = document.createElement('a');
            var data_type = 'data:application/vnd.ms-excel';
            a.href = data_type + ', ' + encodeURIComponent(html);
            a.download =  'smart-report.xls';
            a.click();
            if(typeof e !== 'undefined')
                e.preventDefault();
        });

        hide_loader();
    }
    else if($(".camp_goal_report_header").length > 0) {
        show_loader();
        var tvs = collect(tv);
        var radios = collect(radio);
        var digitals = collect(digital);
        var prints = collect(printt);
        var mails = collect(mail);
        var others = collect(other);
        var oohs = collect(ooh);
        alldata = collect(alldata);
        var results = [];
        var totals = {
            'impressions': 0,
            'cost': 0,
            'net_cost': 0,
            'grp': 0,
            'gri': 0,
            'cpp': 0,
            'net_cpp': 0,
            'cpm': 0,
            'net_cpm': 0,
            'ads': 0,
            'goal_grp': 0,
            'goal_gri': 0,
            'goal_cost': 0,
        };
        var alldmos = collect(alldemos);
        var advts = alldata.groupBy("advname").all();
        for (var aname in advts) {
            var camps = collect(advts[aname]).groupBy("campname").all();
            for (var cname in camps) {
                var mkets = collect(camps[cname]).groupBy("market").all();
                console.log('mkets ********', mkets);
                for (var maname in mkets) {
                    var vndrs = collect(mkets[maname]).groupBy("daypart").all();
                    for (var vid in vndrs) {
                        var aux1 = collect(vndrs[vid]).groupBy("mtype").all();
                        for (var mname in aux1) {
                            var curr_demos = alldmos.where("campaign_id", +aux1[mname][0]['campid']).all();
                            var indmos = [];
                            for (var k in curr_demos)
                                indmos.push(curr_demos[k].demo_type.toUpperCase() + " " + curr_demos[k].demo_name);
                            // if (indmos.indexOf(aux1[mname][0]['demo_people'].toUpperCase() + " " + aux1[mname][0]['demoname']) !== -1) {
                            if (mname.indexOf("Television") !== -1 || mname.indexOf("Radio") !== -1) {
                                var aux2_dp = collect(aux1[mname]).groupBy("daypart").all();
                                for (var dp_first in aux2_dp) {
                                    console.log("BEFORE GROUP: ",aux2_dp[dp_first])
                                    var aux2 = collect(aux2_dp[dp_first]).groupBy("zone").all();
                                    console.log("AFTER GROUP: ",aux2)
                                    for (var dp in aux2) {
                                        if (aux2[dp].length > 0) {
                                            var aux3 = collect(aux2[dp]);
                                            var ads = parseInt(aux3.sum("spots"));
                                            var market_type = (aux2[dp][0]['market_type'] === 'dma') ? ('(DMA)') : ( (aux2[dp][0]['market_type'] === 'msa') ? ('(MSA)') :  'CUSTOM');
                                            ads = (isNaN(ads)) ? 0 : ads
                                            if (ads > 0) {
                                                var imp = aux3.sum("impressions");
                                                totals['impressions'] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(imp / 10) : parseFloat(imp);
                                                totals['ads'] += parseInt(ads);
                                                var cost = aux3.sum(function (row) {
                                                    return (row.spots > 0 && row.cost > 0) ? row.cost * row.spots : 0;
                                                });
                                                totals['cost'] += parseFloat(cost);
                                                totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux2[dp][0]['agency_commission']) / 100)) + 'e1') + 'e-1'));
                                                var grp = aux3.sum(function (row) {
                                                    return ((row.rating !== '') && (row.spots !== '') && (row.rating !== null) && (row.spots !== null)) ? parseFloat(Number(Math.round((row.rating) + 'e1') + 'e-1') * row.spots) : 0;
                                                });
                                                totals['grp'] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(grp / 10) : parseFloat(grp);
                                                var gri = aux3.sum(function (row) {
                                                    return ((row.impressions !== '') && (row.spots !== '') && (row.impressions !== null) && (row.spots !== null)) ? parseFloat(Number(Math.round((row.impressions) + 'e1') + 'e-1') * row.spots) : 0;
                                                });
                                                totals['gri'] += (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? parseFloat(gri / 10) : parseFloat(gri);
                                                var day_grp='0.0';
                                                var day_cost='0.00';
                                                if( mname.indexOf("Television") !== -1 && dp_first !== null && dp_first !== "null" && dp_first !== "undefined"){
                                                    if(typeof planner_tv[aux1[mname][0]['campid']] !== 'undefined'){
                                                        if(typeof planner_tv[aux1[mname][0]['campid']][aux1[mname][0]['market_id']] !== 'undefined'){
                                                            if(typeof planner_tv[aux1[mname][0]['campid']][aux1[mname][0]['market_id']][dp_first] !== 'undefined'){
                                                                day_grp=planner_tv[aux1[mname][0]['campid']][aux1[mname][0]['market_id']][dp_first]['grp'];
                                                                day_cost=planner_tv[aux1[mname][0]['campid']][aux1[mname][0]['market_id']][dp_first]['total'];
                                                            }
                                                        }
                                                    }
                                                }
                                                if( mname.indexOf("Radio") !== -1 && dp_first !== null && dp_first !== "null" && dp_first !== "undefined"){
                                                    if(typeof planner_radio[aux1[mname][0]['campid']] !== 'undefined'){
                                                        if(typeof planner_radio[aux1[mname][0]['campid']][aux1[mname][0]['market_id']] !== 'undefined'){
                                                            if(typeof planner_radio[aux1[mname][0]['campid']][aux1[mname][0]['market_id']][dp_first] !== 'undefined'){
                                                                day_grp = planner_radio[aux1[mname][0]['campid']][aux1[mname][0]['market_id']][dp_first]['grp'];
                                                                day_cost = planner_radio[aux1[mname][0]['campid']][aux1[mname][0]['market_id']][dp_first]['total'];
                                                            }
                                                        }
                                                    }
                                                }
                                                totals['goal_grp']+= Number(Math.round((day_grp) + 'e1') + 'e-1')
                                                totals['goal_cost']+= Number(Math.round((day_cost) + 'e1') + 'e-1')
                                                results.push({
                                                    'brand': aux2[dp][0]['brand'],
                                                    'product': aux2[dp][0]['product'],
                                                    'advertiser': aname,
                                                    'campaign': cname,
                                                    'estimate_number': aux1[mname][0]['estimate_number'],
                                                    'job_number': aux1[mname][0]['job_number'],
                                                    'campaign_number': aux1[mname][0]['campaign_number'],
                                                    'campstart': aux1[mname][0]['campstart'].split("-")[1] + "/" + aux1[mname][0]['campstart'].split("-")[0],
                                                    'campend': aux1[mname][0]['campend'].split("-")[1] + "/" + aux1[mname][0]['campend'].split("-")[0],
                                                   // 'wv_number': aux2[dp][0]['wv_number'],
                                                    'demo': aux2[dp][0]['demo_people'].toUpperCase() + " " + aux2[dp][0]['demoname'],
                                                    'market': maname +' '+market_type,
                                                    'media': aux2[dp][0]['mtype'].split("Line")[1],
                                                    'daypart': (dp_first !== null && dp_first !== "null" && dp_first !== "undefined") ? dp_first : "",
                                                  //  'cable_zone': (aux2[dp][0]['mtype'].split("Line")[1] === "Radio") ? "" : aux2[dp][0]['zone'],
                                                    'vendor': aux2[dp][0]['vndr_name'],
                                                    'owner': aux1[mname][0]['owner'],
                                                    'impressions': Number(Math.round((imp) + 'e1') + 'e-1'),
                                                    'ads': ads,
                                                    'cost': parseFloat( cost).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cost': parseFloat( (cost - (cost * parseFloat(aux1[mname][0]['agency_commission']) / 100))).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'grp': parseFloat(grp ).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),
                                                    'gri': parseFloat(gri ).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),
                                                    'cpp':  parseFloat( (grp > 0) ? cost / grp : 0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'net_cpp':  parseFloat( (grp > 0) ? (cost / gri) - ((cost / gri) * (parseFloat(aux2[dp][0]['agency_commission']) / 100)) : 0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),

                                                    'cpm':  parseFloat( (gri > 0) ? (cost / gri) : 0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),

                                                    'net_cpm':  parseFloat( (gri > 0) ? ((cost / gri) - ((cost / gri) * (parseFloat(aux1[mname][0]['agency_commission']) / 100))) : 0).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'goal_cost': parseFloat( day_cost ).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        minimumFractionDigits: 2
                                                    }),
                                                    'goal_gri':  parseFloat(0 ).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),
                                                    'goal_grp':  parseFloat(day_grp ).toLocaleString("en-US", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    }),

                                                });
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (aux1[mname].length > 0) {
                                    var aux3 = collect(aux1[mname]);
                                    if (mname.indexOf("Digital") !== -1) {
                                        var ads = parseInt(aux3.sum("ad_count"));
                                        ads = (isNaN(ads)) ? 0 : ads
                                        if (ads > 0) {
                                            var imp = aux3.sum("impressions");
                                            totals['impressions'] += parseFloat(imp / 1000);
                                            totals['ads'] += parseInt(ads);
                                            var cost = aux3.sum("total_cost");
                                            totals['cost'] += parseFloat(cost);
                                            totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux1[mname][0]['agency_commission']) / 100)) + 'e1') + 'e-1'));
                                            var gri = aux3.sum(function (row) {
                                                return ((row.impressions !== '') && (row.ad_count !== '') && (row.impressions !== null) && (row.ad_count !== null)) ? parseFloat(Number(Math.round((row.impressions / 1000) + 'e3') + 'e-3') * row.ad_count) : 0;
                                            });
                                            totals['gri'] += parseFloat(gri);

                                            if(typeof planner_digital[aux1[mname][0]['campid']] !== 'undefined'){
                                                if(typeof planner_digital[aux1[mname][0]['campid']][aux1[mname][0]['market_id']] !== 'undefined'){
                                                        day_grp = planner_digital[aux1[mname][0]['campid']][aux1[mname][0]['market_id']]['grp'];
                                                        day_cost = planner_digital[aux1[mname][0]['campid']][aux1[mname][0]['market_id']]['total'];
                                                }
                                            }
                                            totals['goal_gri'] +=day_grp;
                                            var market_type = (aux1[mname][0]['market_type'] === 'dma') ? ('(DMA)') : ( (aux1[mname][0]['market_type'] === 'msa') ? ('(MSA)') :  'CUSTOM');

                                            var media_next = aux1[mname][0]['mtype'].split("Line")[1];
                                            if(media_next === 'OTT')
                                                media_next = 'OTT JamLoop';
                                            results.push({
                                                'brand': aux1[mname][0]['brand'],
                                                'product': aux1[mname][0]['product'],
                                                'advertiser': aname,
                                                'campaign': cname,
                                                'estimate_number': aux1[mname][0]['estimate_number'],
                                                'job_number': aux1[mname][0]['job_number'],
                                                'campaign_number': aux1[mname][0]['campaign_number'],
                                                'campstart': aux1[mname][0]['campstart'].split("-")[1] + "/" + aux1[mname][0]['campstart'].split("-")[0],
                                                'campend': aux1[mname][0]['campend'].split("-")[1] + "/" + aux1[mname][0]['campend'].split("-")[0],
                                                'demo': aux1[mname][0]['demo_people'].toUpperCase() + " " + aux1[mname][0]['demoname'],
                                                'market': maname +' '+market_type,
                                                'media': media_next,
                                                'daypart': "",
                                                'vendor': aux1[mname][0]['vndr_name'],
                                                'owner': aux1[mname][0]['owner'],
                                                'impressions': Number(Math.round((imp / 1000) + 'e1') + 'e-1'),
                                                'ads': ads,
                                                'cost': parseFloat( cost).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'net_cost': parseFloat( (cost - (cost * parseFloat(aux1[mname][0]['agency_commission']) / 100))).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'grp': parseFloat(0 ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                                'gri': parseFloat(gri ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                                'cpp':  parseFloat( 0).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'net_cpp':  parseFloat( 0).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'cpm':  parseFloat( (gri > 0) ? (cost / gri) : 0 ).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                //'net_cpm': (gri > 0) ? '$' + Number(Math.round(((cost / gri) - ((cost / gri) * (parseFloat(aux1[mname][0]['agency_commission']) / 100))) + 'e2') + 'e-2') : '$' + 0.00,
                                                'net_cpm':  parseFloat( (gri > 0) ? (cost / gri) - ((cost / gri) * (parseFloat(aux1[mname][0]['agency_commission']) / 100)) : 0 ).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),

                                                'goal_cost': parseFloat( day_cost ).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'goal_gri':  parseFloat(day_grp ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                                'goal_grp':  parseFloat(0 ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                            });
                                        }
                                    } else {
                                        var ads = parseInt(aux3.sum("ad_count"));
                                        ads = (isNaN(ads)) ? 0 : ads
                                        if (ads > 0) {
                                            var imp = aux3.sum("impressions");
                                            totals['impressions'] += parseFloat(imp);
                                            var cost = aux3.sum("cost") * ads;
                                            totals['cost'] += parseFloat(cost);
                                            totals['net_cost'] += parseFloat(Number(Math.round((cost - (cost * parseFloat(aux1[mname][0]['agency_commission']) / 100)) + 'e1') + 'e-1'));
                                            var gri = aux3.sum(function (row) {
                                                return ((row.impressions !== '') && (row.ad_count !== '') && (row.impressions !== null) && (row.ad_count !== null)) ? parseFloat(Number(Math.round((row.impressions) + 'e1') + 'e-1') * row.ad_count) : 0;
                                            });
                                            totals['gri'] += parseFloat(gri);


                                            var media_next = aux1[mname][0]['mtype'].split("Line")[1];
                                            if(media_next === 'OTT')
                                                media_next = 'OTT JamLoop';

                                            if(mname.indexOf("Print") !== -1)
                                                var planner= planner_print;
                                            else if(mname.indexOf("OOH") !== -1)
                                                var planner= planner_ooh;
                                            else if(mname.indexOf("Mail") !== -1)
                                                var planner= planner_mail;
                                            else if(mname.indexOf("OTT") !== -1)
                                                var planner= planner_ott;
                                            else
                                                var planner= planner_other;


                                            if(typeof planner[aux1[mname][0]['campid']] !== 'undefined'){
                                                if(typeof planner[aux1[mname][0]['campid']][aux1[mname][0]['market_id']] !== 'undefined'){
                                                    day_grp = planner[aux1[mname][0]['campid']][aux1[mname][0]['market_id']]['grp'];
                                                    day_cost = planner[aux1[mname][0]['campid']][aux1[mname][0]['market_id']]['total'];
                                                }
                                            }


                                            totals['goal_gri'] +=day_grp;
                                            results.push({
                                                'brand': aux1[mname][0]['brand'],
                                                'product': aux1[mname][0]['product'],
                                                'advertiser': aname,
                                                'campaign': cname,
                                                'estimate_number': aux1[mname][0]['estimate_number'],
                                                'job_number': aux1[mname][0]['job_number'],
                                                'campaign_number': aux1[mname][0]['campaign_number'],
                                                'campstart': aux1[mname][0]['campstart'].split("-")[1] + "/" + aux1[mname][0]['campstart'].split("-")[0],
                                                'campend': aux1[mname][0]['campend'].split("-")[1] + "/" + aux1[mname][0]['campend'].split("-")[0],
                                                'demo': aux1[mname][0]['demo_people'].toUpperCase() + " " + aux1[mname][0]['demoname'],
                                                'market': maname,
                                                'media': media_next,
                                                'daypart': "",
                                                'vendor': aux1[mname][0]['vndr_name'],
                                                'owner': aux1[mname][0]['owner'],
                                                'impressions': Number(Math.round((imp) + 'e1') + 'e-1'),
                                                'ads': ads,
                                                'cost': parseFloat( cost).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'net_cost': parseFloat( (cost - (cost * parseFloat(aux1[mname][0]['agency_commission']) / 100))).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'grp': parseFloat(0 ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                                'gri': parseFloat(gri ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                                'cpp':  parseFloat( 0).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'net_cpp':  parseFloat( 0).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),

                                                'cpm':  parseFloat( (gri > 0) ? (cost / gri) : 0).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),

                                                'net_cpm':  parseFloat( (gri > 0) ? ((cost / gri) - ((cost / gri) * (parseFloat(aux1[mname][0]['agency_commission']) / 100))) : 0).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'goal_cost': parseFloat( day_cost ).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }),
                                                'goal_gri':  parseFloat(day_grp ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                                'goal_grp':  parseFloat(0 ).toLocaleString("en-US", {
                                                    style: "decimal",
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1,
                                                }),
                                            });
                                        }
                                    }
                                }
                            }
                            // }
                        }
                    }
                }
            }
        }
        var commission = (totals['cost'] > 0) ? (1 - (totals['net_cost'] / totals['cost'])) : 0;
        totals['cpp'] = (totals['grp'] > 0) ? Number(Math.round((totals['cost'] / totals['grp']) + 'e2') + 'e-2') : 0.00;
        totals['net_cpp'] = (totals['grp'] > 0) ? Number(Math.round(((totals['cost'] / totals['grp']) - ((totals['cost'] / totals['grp']) * (parseFloat(commission)))) + 'e2') + 'e-2') : 0.00;
        totals['cpm'] = (totals['gri'] > 0) ? Number(Math.round((totals['cost'] / totals['gri']) + 'e2') + 'e-2') : 0.00;
        totals['net_cpm'] = (totals['gri'] > 0) ? Number(Math.round(((totals['cost'] / totals['gri']) - ((totals['cost'] / totals['gri']) * (parseFloat(commission)))) + 'e2') + 'e-2') : 0.00;

        for (var ind in totals) {
            if (ind !== "ads") {
                totals[ind] = Number(Math.round((totals[ind]) + 'e1') + 'e-1');
                if(ind.indexOf("cpp") !== -1 || ind.indexOf("cpm") !== -1 || ind.indexOf("cost") !== -1)
                    totals[ind] = totals[ind];
            }
        }

        function totalTVUpdateData(g){
            var totals = {
                'impressions': 0,
                'cost': 0,
                'net_cost': 0,
                'grp': 0,
                'gri': 0,
                'cpp': 0,
                'net_cpp': 0,
                'cpm': 0,
                'net_cpm': 0,
                'ads': 0,
                'goal_cost':0,
                'goal_grp':0,
                'goal_gri':0,
            };
            g.api.forEachNodeAfterFilterAndSort(function(node){
                totals['impressions'] += (node.data.media === "Radio") ? parseFloat(node.data.impressions / 10) : parseFloat(node.data.impressions);
                totals['ads'] += (isNaN(parseInt(node.data.ads))) ? 0 : parseInt(node.data.ads);
                totals['cost'] += parseFloat(node.data.cost.split("$")[1]);
                totals['goal_cost'] += parseFloat(node.data.goal_cost.split("$")[1]);
                totals['goal_grp'] += parseFloat(node.data.goal_grp);
                totals['goal_gri'] += parseFloat(node.data.goal_gri);
                totals['net_cost'] += parseFloat(node.data.net_cost.split("$")[1]);
                totals['grp'] += (node.data.media === "Radio") ? parseFloat(node.data.grp / 10) : parseFloat(node.data.grp);
                totals['gri'] += (node.data.media === "Radio") ? parseFloat(node.data.gri / 10) : parseFloat(node.data.gri);
            });

            var commission = (totals['cost'] > 0) ? (1 - (totals['net_cost'] / totals['cost'])) : 0.00;
            totals['cpp'] = (totals['grp'] > 0) ? Number(Math.round((totals['cost'] / totals['grp']) + 'e2') + 'e-2') : 0.0;
            totals['net_cpp'] = (totals['grp'] > 0) ? Number(Math.round(((totals['cost'] / totals['grp']) - ((totals['cost'] / totals['grp']) * (parseFloat(commission)))) + 'e2') + 'e-2') : 0;
            totals['cpm'] = (totals['gri'] > 0) ? Number(Math.round((totals['cost'] / totals['gri']) + 'e2') + 'e-2') : 0.00;
            totals['net_cpm'] = (totals['gri'] > 0) ? Number(Math.round(((totals['cost'] / totals['gri']) - ((totals['cost'] / totals['gri']) * (parseFloat(commission)))) + 'e2') + 'e-2') : 0;

            for (var ind in totals) {
                if (ind !== "ads") {
                    totals[ind] = Number(Math.round((totals[ind]) + 'e1') + 'e-1');
                    if(ind.indexOf("cpp") !== -1 || ind.indexOf("cpm") !== -1 || ind.indexOf("cost") !== -1)
                        totals[ind] = totals[ind];
                }
            }

            console.log("totals");
            console.log(totals);
            g.api.setPinnedTopRowData(
                [
                    {
                        'impressions': parseFloat(totals['impressions'] ).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'cost': parseFloat( totals['cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'net_cost': parseFloat( totals['net_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'grp':parseFloat(totals['grp'] ).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'gri': parseFloat(totals['gri'] ).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'cpp': parseFloat( totals['cpp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'net_cpp':parseFloat( totals['net_cpp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'cpm':parseFloat( totals['cpm']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'net_cpm': parseFloat( totals['net_cpm']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                        'ads': totals['ads'],
                        'goal_grp': parseFloat(totals['goal_grp'] ).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'goal_gri': parseFloat(totals['goal_gri'] ).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }),
                        'goal_cost':parseFloat( totals['goal_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),
                    }
                ]
            );
        }
        console.log("DATA FROM OPTIONS: ", custom_details, estimate_options)
        columnInvExportInfo = [
            {
                headerName: "Brand",
                field: 'brand',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Brand") !== -1) ? false : true
            }, {
                headerName: "Product",
                field: 'product',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Product") !== -1) ? false : true
            },
            {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Advertiser") !== -1) ? false : true
            }, {
                headerName: "Campaign",
                field: 'campaign',
                width: 180,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign") !== -1) ? false : true
            }, {
                headerName: "Est. No.",
                field: 'estimate_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Estimate No.") !== -1) ? false : true
            }, {
                headerName: "Job No.",
                field: 'job_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Job No.") !== -1) ? false : true
            }, {
                headerName: "Camp. No.",
                field: 'campaign_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
               // hide: (custom_details.indexOf("Campaign End Date") !== -1) ? false : true
            }, {
                headerName: "Camp. Start",
                field: 'campstart',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign Start Date") !== -1) ? false : true
            }, {
                headerName: "Camp. End",
                field: 'campend',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign End Date") !== -1) ? false : true
            },/*{
                headerName: "Version Number",
                field: 'wv_number',
                width: 100,
                cellStyle: {'text-align': "right"}
            },*/ {
                headerName: "Demo",
                field: 'demo',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Demo") !== -1) ? false : true
            }, {
                headerName: "Market",
                field: 'market',
                width: 150,
                cellStyle: {'text-align': "right"},
             //   hide: (custom_details.indexOf("Market") !== -1) ? false : true
            }, {
                headerName: "Media",
                field: 'media',
                width: 100,
                cellStyle: {'text-align': "right"},
           //     hide: (custom_details.indexOf("Media Type") !== -1) ? false : true
            }, {
                headerName: "Daypart",
                field: 'daypart',
                width: 80,
                cellStyle: {'text-align': "right"},
              //  hide: (custom_details.indexOf("Daypart") !== -1) ? false : true
            },/*{
                headerName: "Zone",
                field: 'cable_zone',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Cable Zone") !== -1) ? false : true
            }, {
                headerName: "Vendor",
                field: 'vendor',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
            },*/ {
                headerName: "Owner",
                field: 'owner',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Owner") !== -1) ? false : true
            }, {
                headerName: "Impressions",
                field: 'impressions',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
            }, {
                headerName: "Ads",
                field: 'ads',
                width: 50,
                cellStyle: {'text-align': "right"},
                hide: true,
            }, {
                headerName: "Gross Cost",
                field: 'cost',
                width: 80,
                cellStyle: {'text-align': "right"},
              //  hide: (estimate_options.indexOf("Gross Cost") !== -1) ? false : true
            }, {
                headerName: "Net Cost",
                field: 'net_cost',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Net Cost") !== -1) ? false : true
            }, {
                headerName: "GRP",
                field: 'grp',
                width: 80,
                cellStyle: {'text-align': "right"},
              //  hide: (estimate_options.indexOf("GRPs") !== -1) ? false : true
            }, {
                headerName: "GRI",
                field: 'gri',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("GRIs") !== -1) ? false : true
            }, {
                headerName: "CPP",
                field: 'cpp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Gross CPP") !== -1) ? false : true
            }, {
                headerName: "NET CPP",
                field: 'net_cpp',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Net CPP") !== -1) ? false : true
            }, {
                headerName: "CPM",
                field: 'cpm',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Gross CPM") !== -1) ? false : true
            }, {
                headerName: "NET CPM",
                field: 'net_cpm',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (estimate_options.indexOf("Net CPM") !== -1) ? false : true
            },
            {
                headerName: "Goal Cost",
                field: 'goal_cost',
                width: 85,
                cellStyle: {'text-align': "right"},
               // hide: (estimate_options.indexOf("Net CPM") !== -1) ? false : true
            },
            {
                headerName: "Goal GRP",
                field: 'goal_grp',
                width: 80,
                cellStyle: {'text-align': "right"},
                // hide: (estimate_options.indexOf("Net CPM") !== -1) ? false : true
            },
            {
                headerName: "Goal GRI",
                field: 'goal_gri',
                width: 80,
                cellStyle: {'text-align': "right"},
                // hide: (estimate_options.indexOf("Net CPM") !== -1) ? false : true
            },

        ];
        var html = '';
        var html_1 = '';
        var est_arra = ['Ordered  Ads','Ordered  GRPs', 'Ordered  Impressions','Ordered  Gross Cost', 'Ordered  Net Cost',
            'Ordered  Gross CPP',' Ordered   Net CPP', 'Ordered  Gross CPM', 'Ordered  Net CPM', 'Avg. GRPs/Impressions', 'Invoiced  Ads', 'Invoiced  Gross Cost', 'Date Aired', 'Invoiced  Net Cost', 'Time Aired', 'Length Aired', 'Day Aired',
            'Spend   Difference Gross','Spend  Difference Net', 'GRPs', 'Ads', 'GRIs', 'Impressions', 'Gross Cost', 'Net Cost', 'Gross CPP', 'Gross CPP', 'Net CPP', 'Gross CPM', 'Net CPM', 'Goal Cost', 'Goal GRI', 'Goal GRP', 'GRI', 'GRP', 'CPM', 'CPP', 'NET CPM', 'NET CPP'];
        columnInvExportInfo.sort(function(a, b) {
            return a.headerName.replace('<br>', '') == b.headerName.replace('<br>', '') ? 0 : a.headerName.replace('<br>', '') < b.headerName.replace('<br>', '') ? -1 : 1
        })
        for(var ind in columnInvExportInfo){
            var hidden = (columnInvExportInfo[ind].hide) ? ["hidden-column", "background-color: rgb(204, 204, 204);"] : ["",""]
            if(est_arra.indexOf(columnInvExportInfo[ind].headerName.replace('<br>', '')) !== -1)
                html_1 += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="dropdown-item ' + hidden[0] + '" data-hidden="'+ columnInvExportInfo[ind].field +'" style="' + hidden[1] + '">'+ columnInvExportInfo[ind].headerName +'</a></li>';
            else
              html += '<li style="font-size: 12px; margin-bottom: -4px; margin-top: -4px"><a class="dropdown-item ' + hidden[0] + '" data-hidden="'+ columnInvExportInfo[ind].field +'" style="' + hidden[1] + '">'+ columnInvExportInfo[ind].headerName +'</a></li>';
        }
        var html_list = ' <li class="dropdown-header" style=" color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>DISPLAY OPTIONS</strong></li>';
        html_list += html;
        html_list += ' <li class="dropdown-header" style="color: #f47a51; font-size: 80%; margin-left: -5px; margin-bottom: 5px; margin-top: 5px;"><strong>METRIC OPTIONS</strong></li>';
        html_list += html_1;
        $("#sum-hiden-columns").html(html_list);
        $('.smart-rpt-analysis-hide-column a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-hidden');
            if ($(this).hasClass('hidden-column') ) {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            } else {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });
        gridInvExportInfo = {
            columnDefs: columnInvExportInfo,
            defaultColDef: {
                suppressToolPanel: true
            },
            pinnedTopRowData: [{
                'impressions': 0,
                'cost': 0,
                'net_cost': 0,
                'grp': 0,
                'gri': 0,
                'cpp': 0,
                'net_cpp': 0,
                'cpm': 0,
                'net_cpm': 0,
                'ads': 0,
                'goal_grp': 0,
                'goal_gri': 0,
                'goal_cost': 0,
            }],
            rowSelection: 'single',
            suppressRowClickSelection: false,
            enableColResize: true,
            //suppressMenuColumnPanel: true,
            suppressTouch: true,
            headerHeight: 30,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 22,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            getContextMenuItems: getContextMenuInvoiceOrder,
            onFilterChanged: function (e) {
                totalTVUpdateData(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters').show();
                else
                    $('#reset_filters').hide();
            },
        };
        $('#myGridGoal').html('');
        gridInvExportInfo.rowData = results;
        var gridDet = document.querySelector('#myGridGoal');
        var grid = new agGrid.Grid(gridDet, gridInvExportInfo);
        gridInvExportInfo.api.setPinnedTopRowData(
            [
                {
                    'impressions': parseFloat(totals['impressions'] ).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }),
                    'cost': parseFloat( totals['cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),
                    'net_cost': parseFloat( totals['net_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),
                    'grp':parseFloat(totals['grp'] ).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }),
                    'gri': parseFloat(totals['gri'] ).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }),
                    'cpp': parseFloat( totals['cpp']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),
                    'net_cpp':parseFloat( totals['net_cpp']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),
                    'cpm':parseFloat( totals['cpm']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),
                    'net_cpm': parseFloat( totals['net_cpm']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),
                    'ads': totals['ads'],
                    'goal_grp': parseFloat(totals['goal_grp'] ).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }),
                    'goal_gri': parseFloat(totals['goal_gri'] ).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }),
                    'goal_cost':parseFloat( totals['goal_cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }),
                }
            ]
        );
        $('#reset_filters').on('click', function () {
            $.each(gridInvExportInfo.api.getFilterModel(), function (index, value) {
                gridInvExportInfo.api.destroyFilter(index);
            });
        });

        console.log("radio and tv");
        console.log(results);

        hide_loader();
    }
    else if($(".client_activity_report_header").length > 0) {
        show_loader();
        $('.custom_chart_market').on('click', function () {
            var tab_selected = $(this).attr('data-tab');
            $('#tab_selected_graph').val(tab_selected);
            $('#market_label_text').html('Select ' + tab_selected + '(s)');
            $('.chart_market_span_text').html(tab_selected);
            //chart options
            var html_type = ' <option value=""></option>' +
                '                                            <option value="pie">Pie</option>' +
                '                                            <option value="line">Line</option>' +
                '                                            <option value="column">Column (Vertical)</option>' +
                '                                            <option value="bar">Column (Horizontal)</option>';

            $('#chart_type').select2({
                minimumResultsForSearch: 5,
                placeholder: 'Select one....',

            });
            $('#chart_type').html(html_type);

            $('#chart_breakout').select2({
                minimumResultsForSearch: 5
            });
            $('#chart_data_type').select2({
                minimumResultsForSearch: 5
            });
            var html = '';
            if (tab_selected === 'Market') {
                for (var ind in markets_name_array)
                    html += '<option>' + markets_name_array[ind] + '</option>';
            } else {
                for (var ind in advertisers_name_array)
                    html += '<option>' + advertisers_name_array[ind] + '</option>';
            }
            $('#chart_markets').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_books'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_books'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_markets').html(html).multiSelect('refresh');

            var html = '';
            for (var ind in vendors_added)
                html += '<option>' + vendors_added[ind] + '</option>';
            $('#chart_stations').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_stations'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_stations'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_stations').html(html).multiSelect('refresh');

            var html = '';
            for (var ind in columns_to_add) {
                if( columns_to_add[ind] !== 'total')
                html += '<option>' + columns_to_add[ind] + '</option>';
            }
            $('#chart_time_period').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type option:selected').val() === 'pie') {
                        form_curr_dayparts = this.$element.val();
                        if (this.$element.val().length > 1) {
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 1 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }
                        if (form_curr_dayparts.length < 2)
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                        else
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');

                    }
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type option:selected').val() == 'pie') {
                        form_curr_dayparts = this.$element.val();
                        this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                    }
                }
            });
            $('#chart_time_period').html(html).multiSelect('refresh');
            $('#graphsOptionsModal').modal('show');

            //Select all
            $('#sel_all_chart_books').on('click', function (e) {
                $('#chart_markets').multiSelect('select_all');
            });
            $('#sel_all_chart_stations').on('click', function (e) {
                $('#chart_stations').multiSelect('select_all');
            });
            $('#sel_all_chart_dayparts').on('click', function (e) {
                $('#chart_time_period').multiSelect('select_all');
            });
            //Deselect all
            $('#desel_all_chart_books').on('click', function (e) {
                $('#chart_markets').multiSelect('deselect_all');
            });
            $('#desel_all_chart_stations').on('click', function (e) {
                $('#chart_stations').multiSelect('deselect_all');
            });
            $('#desel_all_chart_dayparts').on('click', function (e) {
                $('#chart_time_period').multiSelect('deselect_all');
            });
        });

        $('#chart_type').on('change', function(){
            if($(this).val() === 'pie'){
                $('.div_only_one_daypart').show();
                $('#chart_time_period').multiSelect('deselect_all');
            }
            else {
                $('.div_only_one_daypart').hide();
            }
        });

        $('#submit_charts_options').on('click', function(){
            var tab_selected = $('#tab_selected_graph').val();
            if($('#chart_type option:selected').val() == ''){
                swal({
                        title: "Warning",
                        text: "Select Chart Type first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_stations').val().length == 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Station...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_time_period').val().length == 0) {
                if ($('#chart_type option:selected').val() === 'pie')
                    text = 'Select a Time Period first...';
                else
                    text = 'Select at least one Time Period...';
                swal({
                        title: "Warning",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_markets').val().length === 0){
                swal({
                        title: "Warning",
                        text: "Select at least one "+ tab_selected +" first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else {
                show_overlay_loader('#graphsOptionsModal .modal-content');
                var vendor_charts = $('#chart_stations').val();
                var time_period_charts = $('#chart_time_period').val();
                var markets_charts = $('#chart_markets').val();
                var data_type = $('#chart_data_type option:selected').val();
                var simbol = (data_type === 'ads') ? '' : '$';
                var to_fixed = (data_type === 'ads') ? 0 : 2;
                var results = [];
                var grid = (tab_selected === 'Market') ? gridCampBreakout : gridCampBreakoutAdvertiser;
                console.log('charts_final_results markets_charts', markets_charts);
                console.log('charts_final_results vendor_charts', vendor_charts);
                grid.api.forEachNode(function (node) {
                    console.log('node_node_node_', node);
                    if (node.level === 0) {
                        $.each(node.childrenAfterGroup, function (index, value) {
                            console.log('charts_final_results empty', results);
                            if (vendor_charts.indexOf(value.data.vendor) !== -1 && markets_charts.indexOf(value.data.market) !== -1) {
                                if (typeof results[value.data.market] === 'undefined')
                                    results[value.data.market] = [];
                                console.log('charts_final_results data.market', results);
                                if (typeof results[value.data.market][value.data.vendor] === 'undefined')
                                    results[value.data.market][value.data.vendor] = [];
                                for (var time_index in time_period_charts) {
                                    var time = time_period_charts[time_index];
                                    if (typeof results[value.data.market][value.data.vendor][time] === 'undefined') {
                                        results[value.data.market][value.data.vendor][time] = [];
                                        results[value.data.market][value.data.vendor][time]['length'] = 1;
                                        var amount = 0;
                                        if(data_type === 'ads')
                                            amount  = !isNaN(parseInt(value.data[data_type + '_' + time])) ? parseInt(value.data[data_type + '_' + time]) : 0;
                                        else{
                                            var amount = value.data[data_type + '_' + time];
                                            amount = amount.replace('$', '');
                                            amount = amount.replace(/,/g, '');
                                            amount = !isNaN(parseFloat(amount)) ? parseFloat(amount).toFixed(2) : 0.00;
                                        }
                                        results[value.data.market][value.data.vendor][time]['value'] = amount;
                                    }
                                }
                            }
                        });
                    }
                });
                console.log('charts_final_results results', results);
                var charts_final_results = {};
                for (var market in results) {
                    for (var vendor in results[market]) {
                        for (var time_period in results[market][vendor]) {
                            if (typeof charts_final_results[market] === 'undefined')
                                charts_final_results[market] = [];
                            if (typeof charts_final_results[market][time_period] === 'undefined') {
                                charts_final_results[market][time_period] = [];
                                charts_final_results[market][time_period]['total'] = 0;
                                charts_final_results[market][time_period]['stations'] = [];
                            }
                            if(typeof charts_final_results[market][time_period]['stations'][vendor] === 'undefined')
                                charts_final_results[market][time_period]['stations'][vendor] = 0;

                            charts_final_results[market][time_period]['total'] += parseFloat(results[market][vendor][time_period]['value']);
                            charts_final_results[market][time_period]['stations'][vendor] += parseFloat(results[market][vendor][time_period]['value']);
                        }
                    }
                }
                console.log('charts_final_results ', charts_final_results);
                var html = '';
                //content tabs
                html += '<div class="tab-content gr" style="width: 100%">';

                html += '<div class="row"> <div class="col-md-12">' +
                    '                                <div id="container_market_chart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                    '                            </div></div>';
                html += '</div>';

                $('.container-graphs-div').html(html);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                 if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                     var data2 = [];
                     var series = [];
                     var cont = 1;
                     for(var market in charts_final_results){
                         var data = [];
                         for(var time_period in charts_final_results[market]){
                             var array = [];
                             var market_value = charts_final_results[market][time_period]['total'];
                             for (var station in charts_final_results[market][time_period]['stations']){
                                 var station_metric = charts_final_results[market][time_period]['stations'][station];
                                 array.push([station, station_metric]);
                             }
                             data.push({
                                 name: time_period,
                                 y: market_value,
                                 drilldown: time_period + '_' + cont,
                             });

                             data2.push({
                                 name: market,
                                 id: time_period + '_' + cont,
                                 data: array,
                             });
                         }
                         series.push({
                             name: market,
                             data: data,
                         });
                         cont++;
                     }

                     Highcharts.theme = {
                         colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                     }
                     var orientation_type = $('#chart_type option:selected').val() === 'column' ? 'columns' : 'rows';
                     var defaultTitle = 'Click the '+ orientation_type +' to view ' + $('#chart_data_type option:selected').html() + ' by vendors.'

                     Highcharts.chart('container_market_chart', {
                         chart: {
                             type: $('#chart_type option:selected').val(),
                             events: {
                                 drilldown: function (e) {
                                     this.setSubtitle({text: e.point.name});
                                 },
                                 drillup: function (e) {
                                     this.setSubtitle({text: defaultTitle});
                                 },
                                 // load: function () {
                                 //     if (this.options.chart.forExport) {
                                 //         this.renderer.image('http://' + document.domain +'/images/gfd-logo-text-black.png', 80, 40, 143, 57).add();
                                 //     }
                                 // },
                                 // beforePrint: function(){
                                 //     x=this.renderer.image('http://' + document.domain +'/images/gfd-logo-text-black.png', 80, 40, 143, 57).add();
                                 //     this.print();
                                 // },
                                 // afterPrint: function(){
                                 //     x.element.remove();
                                 // }
                             },
                         },
                         title: {
                             text:  tab_selected + ' Details Chart',
                         },
                         subtitle: {
                             text: defaultTitle,
                         },
                         xAxis: {
                             type: 'category'
                         },
                         yAxis: {
                             title: {
                                 text: $('#chart_data_type option:selected').html(),
                             },
                             labels: {
                                 formatter: function() {
                                     return  simbol +''+ this.value ;
                                 }
                             },
                             min: 0,
                         },
                         credits: {
                             text: "Powered By Galeforcemedia",
                         },
                         plotOptions: {
                             column: {
                                 pointPadding: 0.2,
                                 borderWidth: 0
                             }
                         },
                         tooltip: {
                             valueDecimals: to_fixed,
                             headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                             pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol + '{point.y:.' +to_fixed+ 'f}</b> <br/>'
                         },
                         series: series,
                         drilldown: {
                             series: data2
                         }

                     });
                 }
                 if ($('#chart_type option:selected').val() == 'line') {
                     var data2 = [];
                     var series = [];
                     var cont = 1;
                     for(var market in charts_final_results){
                         var data = [];
                         for(var time_period in charts_final_results[market]){
                             var array = [];
                             var market_value = charts_final_results[market][time_period]['total'];
                             for (var station in charts_final_results[market][time_period]['stations']){
                                 var station_metric = charts_final_results[market][time_period]['stations'][station];
                                 array.push([station, station_metric]);
                             }
                             data.push({
                                 name: time_period,
                                 y: market_value,
                                 drilldown: time_period + '_' + cont,
                             });

                             data2.push({
                                 name: market,
                                 id: time_period + '_' + cont,
                                 data: array,
                             });
                         }
                         series.push({
                             name: market,
                             data: data,
                         });
                         cont++;
                     }

                     console.log('series cleint acti', series);

                     Highcharts.theme = {
                         colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                     }
                     var defaultTitle = 'Click the points to view ' + $('#chart_data_type option:selected').html() + ' by  stations'

                     Highcharts.chart('container_market_chart', {
                         chart: {
                             // type: $('#chart_type option:selected').val(),
                             events: {
                                 drilldown: function (e) {
                                     this.setSubtitle({text: e.point.name});
                                 },
                                 drillup: function (e) {
                                     this.setSubtitle({text: defaultTitle});
                                 },
                             },
                         },
                         title: {
                             text:  tab_selected + ' Details Chart',
                         },
                         subtitle: {
                             text: defaultTitle,
                         },
                         xAxis: {
                             type: 'category'
                         },
                         yAxis: {
                             title: {
                                 text: $('#chart_data_type option:selected').html(),
                             },
                             labels: {
                                 formatter: function() {
                                     return  simbol +''+ this.value ;
                                 }
                             },
                             min: 0,
                         },
                         credits: {
                             text: "Powered By Galeforcemedia",
                         },
                         plotOptions: {
                             column: {
                                 pointPadding: 0.2,
                                 borderWidth: 0
                             }
                         },
                         tooltip: {
                             valueDecimals: to_fixed,
                             headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                             pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                         },
                         series: series,
                         drilldown: {
                             series: data2
                         }
                         //drilldown : data2,

                     });
                 }
                 if ($('#chart_type option:selected').val() == 'pie') {
                     var data2 = [];
                     var series = [];
                     var cont = 1;
                     for(var market in charts_final_results){
                         var data = [];
                         for(var time_period in charts_final_results[market]){
                             var array = [];
                             var market_value = charts_final_results[market][time_period]['total'];
                             for (var station in charts_final_results[market][time_period]['stations']){
                                 var station_metric = charts_final_results[market][time_period]['stations'][station];
                                 array.push([station, station_metric]);
                             }
                             // data.push({
                             //     name: time_period,
                             //     y: market_value,
                             //     drilldown: time_period + '_' + cont,
                             // });

                             data2.push({
                                 name: market,
                                 id: market,
                                 data: array,
                             });
                         }
                         series.push({
                             name: market,
                             y: market_value,
                             drilldown: market,
                         });
                         cont++;
                     }
                     console.log('series series', series);

                     Highcharts.theme = {
                         colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                     }
                     var defaultTitle = 'Click the points to view ' + $('#chart_data_type option:selected').html() + ' by  stations'

                     Highcharts.chart('container_market_chart', {
                         chart: {
                             type: $('#chart_type option:selected').val(),
                             events: {
                                 drilldown: function (e) {
                                     this.setSubtitle({text: e.point.name});
                                 },
                                 drillup: function (e) {
                                     this.setSubtitle({text: defaultTitle});
                                 },
                             },
                         },
                         title: {
                             text:  tab_selected + ' Details Chart',
                         },
                         subtitle: {
                             text: defaultTitle,
                         },
                         // xAxis: {
                         //     type: 'category'
                         // },
                         // yAxis: {
                         //     title: {
                         //         text: $('#chart_data_type option:selected').html(),
                         //     },
                         //     labels: {
                         //         formatter: function() {
                         //             return  simbol +''+ this.value ;
                         //         }
                         //     },
                         //     min: 0,
                         // },
                         credits: {
                             text: "Powered By Galeforcemedia",
                         },
                         plotOptions: {
                             series: {
                                 dataLabels: {
                                     enabled: true,
                                 },
                                 showInLegend: true,

                             }
                         },
                         tooltip: {
                             valueDecimals: to_fixed,
                             headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                             pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                         },
                         series: [{
                             name: tab_selected + '' + $('#chart_data_type option:selected').html() ,
                             colorByPoint: true,
                             data: series
                         }],
                         drilldown: {
                             series: data2
                         }
                         //drilldown : data2,

                     });
                 }

                $('#GraphsModal').modal('show');
                hide_overlay_loader('#graphsOptionsModal .modal-content');

            }

            hide_overlay_loader('#graphsOptionsModal .modal-content');

        });

        columnCampBreakout = [
            {
                headerName: "Market",
                field: 'market',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 150,
                cellStyle: {'text-align': "left"},
                // rowGroupIndex: 1,
                pinned: 'left',
                hide: false,
                suppressMovable: true,
                cellRenderer: VendorFormatRenderer,
            },

            {
                headerName: "Ordering Status",
                field: 'ordered_status',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: false,
                pinned: 'left',
            },
            {
                headerName: " Media type",
                field: 'media_type',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },

            {
                headerName: "Comission",
                field: 'comission',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "impressions",
                field: 'imp',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "rating",
                field: 'rating',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },

        ];
        var columnCampBreakoutAdvertiser_second_part = [

            {
                headerName: "Ordering Status",
                field: 'ordered_status',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: false,
                pinned: 'left',
            },
            {
                headerName: "Media type",
                field: 'media_type',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },

            {
                headerName: "Comission",
                field: 'comission',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "impressions",
                field: 'imp',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "rating",
                field: 'rating',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },

        ];
        columnCampBreakoutAdvertiser = [
            {
                headerName: "Advertiser",
                field: 'market',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            }];
        if(show_length_breakout === 1) {
            var length_field = [
                {
                    headerName: "Vendor",
                    field: 'vendor',
                    width: 150,
                    cellStyle: {'text-align': "left"},
                    rowGroupIndex: 1,
                   // pinned: 'left',
                    hide: true,
                     suppressMovable: true,
                    // cellRenderer: VendorFormatRenderer,
                },
                {
                    headerName: "Length",
                    field: 'length',
                    width: 150,
                    cellStyle: {'text-align': "left"},
                    pinned: 'left',
                    hide: false,
                    suppressMovable: true,
                    // cellRenderer: VendorFormatRenderer,
                }
            ];

        }else{
            var length_field = [
                {
                    headerName: "Vendor",
                    field: 'vendor',
                    width: 150,
                    cellStyle: {'text-align': "left"},
                    pinned: 'left',
                    hide: false,
                    suppressMovable: true,
                    cellRenderer: VendorFormatRenderer,
                }];
        }

        columnCampBreakoutAdvertiser = columnCampBreakoutAdvertiser.concat(length_field);
        columnCampBreakoutAdvertiser =  columnCampBreakoutAdvertiser.concat(columnCampBreakoutAdvertiser_second_part);
        console.log('columnCampBreakoutAdvertiser', columnCampBreakoutAdvertiser);

        columnCampBreakoutDetails = [
            {
                headerName: "Advertiser",
                field: 'adv_name',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Campaign",
                field: 'camp_name',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Market",
                field: 'market',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Media Type",
                field: 'media_type',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 3,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 150,
                cellStyle: {'text-align': "left"},
                // rowGroupIndex: 1,
                pinned: 'left',
                hide: false,
                suppressMovable: true,
                cellRenderer: VendorFormatRenderer,
            },

            {
                headerName: "Ordering Status",
                field: 'ordered_status',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: false,
                pinned: 'left',
            },

            {
                headerName: "Comission",
                field: 'comission',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "impressions",
                field: 'imp',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "rating",
                field: 'rating',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },

        ];
        columnCampBreakoutFlowchart = [
            {
                headerName: "Campaign",
                field: 'camp_name',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Market",
                field: 'market',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Media Type",
                field: 'media_type',
                width: 130,
                cellStyle: {'text-align': "left"},
                hide: false,
                suppressMovable: true,
                pinned: 'left',
                cellRenderer: function(params){
                    console.log('cellRenderer params', params)
                    if(params.value == 'print' || params.value == 'Print')
                        return 'Print';
                    if(params.value == 'ooh' || params.value == 'OOH' || params.value == 'Ooh')
                        return 'OOH';
                    if(params.value == 'tv' || params.value == 'television' || params.value == 'Television')
                        return 'Television';
                    if(params.value == 'other' || params.value == 'Other' )
                        return 'Other';
                    if(params.value == 'radio' || params.value == 'Radio' )
                        return 'Radio';
                    if(params.value == 'ott' || params.value == 'Ott' || params.value == 'OTT JamLoop' )
                        return 'OTT JamLoop';
                    if(params.value == 'digital' || params.value == 'Digital' )
                        return 'Digital';
                    if(params.value == 'mail' || params.value == 'Mail' )
                        return 'Mail';
                    if(params.value == 'podcast' || params.value == 'Podcast')
                        return 'Podcast';
                },
            },
            {
                headerName: "Comission",
                field: 'comission',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "impressions",
                field: 'imp',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "rating",
                field: 'rating',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },

        ];
        columngriDetailedFlowchart = [
            {
                headerName: "Campaign",
                field: 'camp_name',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Media Type",
                field: 'media_type',
                rowGroupIndex: 1,
                hide: true,
                width: 130,
                cellStyle: {'text-align': "left"},
                suppressMovable: true,
                pinned: 'left',
                editable: false,
                cellRenderer: function(params){
                    if(params.value == 'print' || params.value == 'Print')
                        return 'Print';
                    if(params.value == 'ooh' || params.value == 'OOH' || params.value == 'Ooh')
                        return 'OOH';
                    if(params.value == 'tv' || params.value == 'television' || params.value == 'Television')
                        return 'Television';
                    if(params.value == 'other' || params.value == 'Other' )
                        return 'Other';
                    if(params.value == 'radio' || params.value == 'Radio' )
                        return 'Radio';
                    if(params.value == 'ott' || params.value == 'Ott' || params.value == 'OTT JamLoop' )
                        return 'OTT JamLoop';
                    if(params.value == 'digital' || params.value == 'Digital' )
                        return 'Digital';
                    if(params.value == 'cable' || params.value == 'Cable' )
                        return "Cable";
                    if(params.value == 'mail' || params.value == 'Mail' )
                        return 'Mail';
                    if(params.value == 'podcast' || params.value == 'Podcast')
                        return 'Podcast';
                },
                cellClassRules : {
                    'ag-cell-color-background-tv': function (params) {
                        console.log('params_params_params_params_ ', params);
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type == 'tv')
                            return true;
                    },
                    'ag-cell-color-background-cable': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type == 'cable')
                            return true;
                    },
                    'ag-cell-color-background-radio': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'radio')
                           return true;
                    },
                    'ag-cell-color-background-ooh': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'ooh')
                            return true;
                    },
                    'ag-cell-color-background-digital': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'digital')
                            return true;
                    },
                    'ag-cell-color-background-other': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'other')
                            return true;
                    },
                    'ag-cell-color-background-ott': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'ott')
                            return true;
                    },
                    'ag-cell-color-background-mail': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'mail')
                            return true;
                    },
                    'ag-cell-color-background-print': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'print')
                            return true;
                    },
                    'ag-cell-color-background-podcast': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type == 'podcast')
                            return true;
                    },
                }
            },
            {
                headerName: "Detail",
                field: 'detail',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: false,
                pinned: 'left',
                cellClassRules : {
                    'ag-cell-color-background-tv': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'tv')
                                return true;
                    },
                    'ag-cell-color-background-cable': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'cable')
                            return true;
                    },
                    'ag-cell-color-background-radio': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'radio')
                            return true;
                    },
                    'ag-cell-color-background-ooh': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'ooh')
                            return true;
                    },
                    'ag-cell-color-background-digital': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'digital')
                            return true;
                    },
                    'ag-cell-color-background-other': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'other')
                            return true;
                    },
                    'ag-cell-color-background-ott': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'ott')
                            return true;
                    },
                    'ag-cell-color-background-mail': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'mail')
                            return true;
                    },
                    'ag-cell-color-background-print': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type === 'print')
                            return true;
                    },
                    'ag-cell-color-background-podcast': function (params) {
                        if (params.node.level === 1 && typeof params.node.childrenAfterGroup !== 'undefined' && typeof params.node.childrenAfterGroup[0] !== 'undefined' && params.node.childrenAfterGroup[0].data.media_type == 'podcast')
                            return true;
                    },
                }
            },
            {
                headerName: "Comission",
                field: 'comission',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "impressions",
                field: 'imp',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },
            {
                headerName: "rating",
                field: 'rating',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: true,
            },

        ];

        function VendorFormatRenderer() {
        }

        VendorFormatRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            var vendor_string = params.value;
            if (typeof params.value !== 'undefined') {
                if (params.value == '') {
                    this.eGui.innerHTML = '';
                } else {
                    if (params.value.indexOf('(B)') !== -1 || params.value.indexOf('(M)') !== -1) {
                        if (params.value.indexOf('(B)') !== -1)
                            var tt = '(B)';
                        if (params.value.indexOf('(M)') !== -1)
                            var tt = '(M)';
                        vendor_string = params.value.split(tt);
                        var st = '<span style="color:#f15925">' + tt + '</span> ';
                        vendor_string =  vendor_string[1] +' '+ st;
                        this.eGui.innerHTML = vendor_string;
                    } else
                        this.eGui.innerHTML = vendor_string;
                }

            }
            else
                this.eGui.innerHTML = '';

        };

        VendorFormatRenderer.prototype.getGui = function () {
            return this.eGui;
        };
        columnMarketTotals = [
            {
                headerName: "Market",
                field: 'market',
                width: 150,
                cellStyle: {'text-align': "left"},
                hide: false,
                suppressMovable: true,
                pinned: 'left',
                cellRenderer: VendorFormatRenderer,
            },
        ];
        columnVendorTotals = [
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 150,
                cellStyle: {'text-align': "left"},
                hide: false,
                suppressMovable: true,
                pinned: 'left',
                cellRenderer: VendorFormatRenderer,
            },
        ];

        for(var ind in columns_to_add) {
            var header_name= '' ;
            header_name = columns_to_add[ind];
            var pinned= '';
            if(header_name == 'total') {
                if(time_period_type == 'quarterly')
                  header_name = 'All Quarter';
                else if(time_period_type == 'monthly')
                    header_name = 'All Months';
                else
                    header_name = 'All Weeks';
                pinned = 'right';
            }
            else{
                if(time_period_type == 'weekly')
                    header_name = 'Week '+header_name;
            }
            var col =  {
                headerName: header_name,
                headerTooltip: header_name,
                groupId:  columns_to_add[ind],
                pinned: pinned,
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Ads',
                        field: 'ads_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 70,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Ads') == -1) ? true : false,
                    },
                    {
                        headerName: 'Cost',
                        headerTooltip: 'Cost',
                        field: 'cost_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Gross Cost') == -1) ? true : false,
                    },
                    {
                        headerName: 'Net Cost',
                        headerTooltip: 'Net Cost',
                        field: 'netcost_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Net Cost') == -1) ? true : false,
                    },
                    {
                        headerName: 'Client Gross (WMJ)',
                        headerTooltip: 'Client Gross (WMJ)',
                        field: 'clientgross_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Client Gross (WMJ)') == -1) ? true : false,
                    },
                    {
                        headerName: 'Client Cost',
                        headerTooltip: 'Client Cost',
                        field: 'clientcost_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Client Cost') == -1) ? true : false,
                    },
                    {
                        headerName: 'GRP',
                        headerTooltip: 'GRP',
                        field: 'grp_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('GRP') == -1) ? true : false,
                    },
                    {
                        headerName: 'GRI',
                        headerTooltip: 'GRI',
                        field: 'gri_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('GRI') == -1) ? true : false,
                    },
                    {
                        headerName: 'CPP',
                        headerTooltip: 'CPP',
                        field: 'cpp_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('CPP') == -1) ? true : false,
                    },
                    {
                        headerName: 'Net CPP',
                        headerTooltip: 'Net CPP',
                        field: 'netcpp_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Net CPP') == -1) ? true : false,
                    },
                    {
                        headerName: 'CPM',
                        headerTooltip: 'CPM',
                        field: 'cpm_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('CPM') == -1) ? true : false,
                    }, {
                        headerName: 'Net CPM',
                        headerTooltip: 'Net CPM',
                        field: 'netcpm_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Net CPM') == -1) ? true : false,
                    },
                    {
                        headerName: 'Clicks',
                        headerTooltip: 'Clicks',
                        field: 'clicks_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 70,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Clicks') == -1) ? true : false,
                    },
                    {
                        headerName: 'Cost per click',
                        headerTooltip: 'Cost per Click',
                        field: 'costperclick_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Cost per Click') == -1) ? true : false,
                    },
                ],
                headerClass: 'group-header'
            };
            columnCampBreakout.push(col);
            columnCampBreakoutAdvertiser.push(col);
            columnMarketTotals.push(col);
            columnVendorTotals.push(col);
            columnCampBreakoutDetails.push(col);

            var col_flowchart =  {
                headerName: header_name,
                headerTooltip: header_name,
                groupId:  columns_to_add[ind],
                pinned: pinned,
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Ads',
                        field: 'ads_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 70,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Ads') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('ads_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Cost',
                        headerTooltip: 'Cost',
                        field: 'cost_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Gross Cost') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('cost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Net Cost',
                        headerTooltip: 'Net Cost',
                        field: 'netcost_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Net Cost') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('netcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Client Gross (WMJ)',
                        headerTooltip: 'Client Gross (WMJ)',
                        field: 'clientgross_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Client Gross (WMJ)') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('clientgross_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Client Cost',
                        headerTooltip: 'Client Cost',
                        field: 'clientcost_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Client Cost') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('clientcost_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'GRP',
                        headerTooltip: 'GRP',
                        field: 'grp_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('GRP') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('grp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'GRI',
                        headerTooltip: 'GRI',
                        field: 'gri_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('GRI') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('gri_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'CPP',
                        headerTooltip: 'CPP',
                        field: 'cpp_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('CPP') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('cpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Net CPP',
                        headerTooltip: 'Net CPP',
                        field: 'netcpp_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Net CPP') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('netcpp_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'CPM',
                        headerTooltip: 'CPM',
                        field: 'cpm_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('CPM') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('cpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Net CPM',
                        headerTooltip: 'Net CPM',
                        field: 'netcpm_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Net CPM') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('netcpm_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Clicks',
                        headerTooltip: 'Clicks',
                        field: 'clicks_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 70,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Ads') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['clicks_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('clicks_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: 'Cost per Click',
                        headerTooltip: 'Cost per click',
                        field: 'costperclick_' + columns_to_add[ind],
                        editable: false,
                        filter: 'number',
                        minWidth: 45,
                        width: 90,
                        required: false,
                        cellClass: "ExcelNumber",
                        pinned: pinned,
                        cellStyle: {'text-align': "left"},
                        hide: (columns_to_show.indexOf('Gross Cost') == -1) ? true : false,
                        cellClassRules :  {
                            'ag-cell-color-background-tv': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'tv') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-cable': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'cable') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;

                            },
                            'ag-cell-color-background-radio': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'radio') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-print': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'print') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-podcast': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'podcast') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-digital': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'digital') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ooh': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ooh') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-mail': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'mail') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-ott': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'ott') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                            'ag-cell-color-background-other': function(params) {
                                if (params.node.level === 2 && params.data.media_type === 'other') {
                                    var field = params.colDef.field.split('costperclick_');
                                    field = field[1];
                                    var sum = params.node.data['cost_' + field].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    return (params.node.data['ads_' + field] > 0 || sum > 0) ? true : false;
                                }
                                return false;
                            },
                        },
                    },
                ],
                headerClass: 'group-header'
            };
            columnCampBreakoutFlowchart.push(col_flowchart);
            columngriDetailedFlowchart.push(col_flowchart);
        }
        console.log('columnCampBreakoutAdvertiser ', columnCampBreakoutAdvertiser)

        $('.hide-column-client-activity-details-tab a').each( function (){
            var attr = $(this).html();
            if (attr == 'Cost')
                attr = 'Gross Cost';
            if (columns_to_show.indexOf(attr) == -1) {
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
            }
        });

        //Second Tab Initial Hide/Show columns
        $('.hide-column-client-activity-details a').each( function (){
            var attr = $(this).html();
            if(attr != 'Ordering Status') {
                if (attr == 'Cost')
                    attr = 'Gross Cost';
                if (columns_to_show.indexOf(attr) == -1) {
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                }
            }
        });

        //Third Tab Initial Hide/Show columns
        $('.hide-column-client-activity-details-advertiser a').each( function (){
            var attr = $(this).html();
            if(attr != 'Ordering Status') {
                if (attr == 'Cost')
                    attr = 'Gross Cost';
                if (columns_to_show.indexOf(attr) == -1) {
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                }
            }
        });
        //Four Tab Initial Hide/Show columns
        $('.hide-column-client-activity-details-for-tab a').each( function (){
            var attr = $(this).html();
            if(attr != 'Ordering Status') {
                if (attr == 'Cost')
                    attr = 'Gross Cost';
                console.log('attr &&&&&& ', attr);
                if (columns_to_show.indexOf(attr) == -1) {
                    $(this).addClass('hidden-column');
                    console.log('hidden');
                    $(this).css('background-color', '#CCCCCC');
                }
            }
        });

        //Five Tab Initial Hide/Show columns
        $('.hide-column-client-activity-details-for-flowchart-tab a').each( function (){
            var attr = $(this).html();
            if(attr != 'Ordering Status') {
                if (attr == 'Cost')
                    attr = 'Gross Cost';
                if (columns_to_show.indexOf(attr) == -1) {
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                }
            }
        });
        //Six Tab Initial Hide/Show columns
        $('.hide-column-client-activity-details-for-flowchart_det-tab a').each( function (){
            var attr = $(this).html();
            if(attr != 'Ordering Status') {
                if (attr == 'Cost')
                    attr = 'Gross Cost';
                if (columns_to_show.indexOf(attr) == -1) {
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                }
            }
        });

        gridCampBreakout = {
            columnDefs: columnCampBreakout,
            autoGroupColumnDef: {
                headerName: 'Market',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return ClientActivityAggFunction(nodes);
            },
            onGridReady: function (e) {
                fillTopLine(this, 1);
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                 fillTopLine(this, 1);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_det').show();
                else
                    $('#reset_filters_det').hide();
            },
        };
        gridCampBreakoutAdvertiser = {
            columnDefs: columnCampBreakoutAdvertiser,
            autoGroupColumnDef: {
                headerName: 'Advertiser',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: -1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                if(show_length_breakout === 1)
                    return ClientActivityAggFunctionFlowchartTab(nodes);
                else
                    return ClientActivityAggFunction(nodes);
            },
            onGridReady: function (e) {
                if(show_length_breakout === 0)
                     fillTopLine(this, 1);
                else
                    fillTopLine(this, 2);
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                if(show_length_breakout === 0)
                    fillTopLine(this, 1);
                else
                    fillTopLine(this, 2);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_det_advertiser').show();
                else
                    $('#reset_filters_det_advertiser').hide();
            },
        };
        gridMarketTotals = {
            columnDefs: columnMarketTotals,
            autoGroupColumnDef: {
                headerName: 'Group',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                // totalInvDetailUpd(this);
                // if (this.api.isAnyFilterPresent())
                //     $('#reset_filters').show();
                // else
                //     $('#reset_filters').hide();
            },
        };
        gridVendorTotals = {
            columnDefs: columnVendorTotals,
            autoGroupColumnDef: {
                headerName: 'Group',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                // totalInvDetailUpd(this);
                // if (this.api.isAnyFilterPresent())
                //     $('#reset_filters').show();
                // else
                //     $('#reset_filters').hide();
            },
        };
        gridCampBreakoutDetails = {
            columnDefs: columnCampBreakoutDetails,
            autoGroupColumnDef: {
                headerName: 'Details',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,
            defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 3,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return ClientActivityAggFunctionDetailsTab(nodes);
            },
            onGridReady: function (e) {
                fillTopLine(this, 4);
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                fillTopLine(this, 4);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_det_details').show();
                else
                    $('#reset_filters_det_details').hide();
            },
        };
        gridCampBreakoutFlowchart = {
            columnDefs: columnCampBreakoutFlowchart,
            autoGroupColumnDef: {
                headerName: 'Flowchart',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,
            defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 3,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return ClientActivityAggFunctionFlowchartTab(nodes);
            },
            onGridReady: function (e) {
               fillTopLine(this, 2);
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                fillTopLine(this, 2);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_flowchart_details').show();
                else
                    $('#reset_filters_flowchart_details').hide();
            },
        };
        griDetailedFlowchart = {
            columnDefs: columngriDetailedFlowchart,
            autoGroupColumnDef: {
                headerName: 'Detailed Flowchart',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                },
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,
            defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressRowGroups: false,
            groupUseEntireRow: false,
            groupDefaultExpanded: 3,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return ClientActivityAggFunctionFlowchartTab(nodes);
            },
            onGridReady: function (e) {
               fillTopLine(this, 2);
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                fillTopLine(this, 2);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_flowchart_details_det').show();
                else
                    $('#reset_filters_flowchart_details_det').hide();
            },
            getCellClass: function(params) {
                console.log('params.node.group cellClassRules', params);
            },
            getRowClass : function(params) {
                if (params.node.group && params.node.field === 'media_type' && params.node.key === 'tv')
                    return 'ag-cell-color-background-tv';
                else  if (params.node.group && params.node.field === 'media_type' && params.node.key === 'cable')
                    return 'ag-cell-color-background-cable';
                else  if (params.node.group && params.node.field === 'media_type' && params.node.key === 'radio')
                    return 'ag-cell-color-background-radio';
                else if (params.node.group && params.node.field === 'media_type' && params.node.key === 'ooh')
                    return 'ag-cell-color-background-ooh'
                else if (params.node.group && params.node.field === 'media_type' && params.node.key === 'digital')
                    return 'ag-cell-color-background-digital';
                else if (params.node.group && params.node.field === 'media_type' && params.node.key === 'other')
                    return 'ag-cell-color-background-other';
                else if (params.node.group && params.node.field === 'media_type' && params.node.key === 'ott')
                    return 'ag-cell-color-background-ott';
                else if (params.node.group && params.node.field === 'media_type' && params.node.key === 'mail')
                    return 'ag-cell-color-background-mail';
                else if (params.node.group && params.node.field === 'media_type' && params.node.key === 'print')
                    return 'ag-cell-color-background-print';
                else if (params.node.group && params.node.field === 'media_type' && params.node.key === 'podcast')
                    return 'ag-cell-color-background-podcast';
                },

        };

        var ClientActivityAggFunction = function (nodes) {
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 1) {
                    console.log('level 1', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['clicks_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        console.log('node value ', value);
                        console.log('node value data', value['data']);
                        for (var xx in columns_to_add) {
                            var month = columns_to_add[xx];
                            result['ads_' + month] += value['data']['ads_' + month];
                            result['clicks_' + month] += value['data']['clicks_' + month];

                            var sum = value['data']['cost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['cost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientgross_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientgross_' + month] += parseFloat(sum);

                            var sum = value['data']['netcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['netcost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientcost_' + month] += parseFloat(sum);

                            var sum = value['data']['gri_' + month].replace(/,/g, '');
                            result['gri_' + month] += parseFloat(sum);
                            if (value['data']['media_type'] == 'radio')
                                result['gricpm_' + month] += parseFloat(sum) / 10;
                            else
                                result['gricpm_' + month] += parseFloat(sum);
                            var sum = value['data']['grp_' + month].replace(/,/g, '');
                            result['grp_' + month] += parseFloat(sum);
                        }

                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0){
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });

                        result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        var costperclick = parseFloat(result['clicks_' + month]) > 0 ? parseFloat(result['cost_' + month]) / parseFloat(result['clicks_' + month]) : 0
                        result['costperclick_' + month] = parseFloat(costperclick).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }

                return result;
            }
            else
                return false;

        };
        var ClientActivityAggFunctionByLength = function (nodes) {
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 2) {
                    console.log('level 1', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        console.log('node value ', value);
                        console.log('node value data', value['data']);
                        for (var xx in columns_to_add) {
                            var month = columns_to_add[xx];
                            result['ads_' + month] += value['data']['ads_' + month];

                            var sum = value['data']['cost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['cost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientgross_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientgross_' + month] += parseFloat(sum);

                            var sum = value['data']['netcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['netcost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientcost_' + month] += parseFloat(sum);

                            var sum = value['data']['gri_' + month].replace(/,/g, '');
                            result['gri_' + month] += parseFloat(sum);
                            if (value['data']['media_type'] == 'radio')
                                result['gricpm_' + month] += parseFloat(sum) / 10;
                            else
                                result['gricpm_' + month] += parseFloat(sum);
                            var sum = value['data']['grp_' + month].replace(/,/g, '');
                            result['grp_' + month] += parseFloat(sum);
                        }

                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0){
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });

                        result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }
                if (nodes[0].level === 1) {
                    console.log('level ', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        console.log('node value ', value);
                        console.log('node value data', value['data']);
                        for (var xx in columns_to_add) {
                            var month = columns_to_add[xx];
                            result['ads_' + month] += value['data']['ads_' + month];

                            var sum = value['data']['cost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['cost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientgross_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientgross_' + month] += parseFloat(sum);

                            var sum = value['data']['netcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['netcost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientcost_' + month] += parseFloat(sum);

                            var sum = value['data']['gri_' + month].replace(/,/g, '');
                            result['gri_' + month] += parseFloat(sum);
                            if (value['data']['media_type'] == 'radio')
                                result['gricpm_' + month] += parseFloat(sum) / 10;
                            else
                                result['gricpm_' + month] += parseFloat(sum);
                            var sum = value['data']['grp_' + month].replace(/,/g, '');
                            result['grp_' + month] += parseFloat(sum);
                        }

                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0){
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });

                        result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }

                return result;
            }
            else
                return false;

        };
        var ClientActivityAggFunctionDetailsTab = function (nodes) {
            console.log('level_level_details', nodes);
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 4) {
                    console.log('level_4_details', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['clicks_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        console.log('node value ', value);
                        console.log('node value data', value['data']);
                        for (var xx in columns_to_add) {
                            var month = columns_to_add[xx];
                            result['ads_' + month] += value['data']['ads_' + month];
                            result['clicks_' + month] += value['data']['clicks_' + month];

                            var sum = value['data']['cost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['cost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientgross_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientgross_' + month] += parseFloat(sum);

                            var sum = value['data']['clientcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientcost_' + month] += parseFloat(sum);

                            var sum = value['data']['netcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['netcost_' + month] += parseFloat(sum);

                            var sum = value['data']['gri_' + month].replace(/,/g, '');
                            result['gri_' + month] += parseFloat(sum);
                            if (value['data']['media_type'] == 'radio')
                                result['gricpm_' + month] += parseFloat(sum) / 10;
                            else
                                result['gricpm_' + month] += parseFloat(sum);
                            var sum = value['data']['grp_' + month].replace(/,/g, '');
                            result['grp_' + month] += parseFloat(sum);
                        }

                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0) {
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        var costperclick = parseInt(result['clicks_' + month]) ? parseFloat(result['cost_' + month]) / parseInt(result['clicks_' + month]) : 0
                        result['costperclick_' + month] = parseFloat(costperclick).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }
                else if (nodes[0].level === 3) {
                    console.log('level_3_details', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['clicks_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            console.log('node value ', value);
                            console.log('node value data', value['data']);
                            for (var xx in columns_to_add) {
                                var month = columns_to_add[xx];
                                result['ads_' + month] += value['data']['ads_' + month];
                                result['clicks_' + month] += value['data']['clicks_' + month];

                                var sum = value['data']['cost_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['cost_' + month] += parseFloat(sum);

                                var sum = value['data']['clientgross_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['clientgross_' + month] += parseFloat(sum);

                                var sum = value['data']['clientcost_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['clientcost_' + month] += parseFloat(sum);

                                var sum = value['data']['netcost_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['netcost_' + month] += parseFloat(sum);

                                var sum = value['data']['gri_' + month].replace(/,/g, '');
                                result['gri_' + month] += parseFloat(sum);
                                if (value['data']['media_type'] == 'radio')
                                    result['gricpm_' + month] += parseFloat(sum) / 10;
                                else
                                    result['gricpm_' + month] += parseFloat(sum);
                                var sum = value['data']['grp_' + month].replace(/,/g, '');
                                result['grp_' + month] += parseFloat(sum);
                            }
                        });
                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0) {
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        var costperclick = parseInt(result['clicks_' + month]) ? parseFloat(result['cost_' + month]) / parseInt(result['clicks_' + month]) : 0
                        result['costperclick_' + month] = parseFloat(costperclick).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }
                else if (nodes[0].level === 2) {
                    console.log('level_2_details', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['clicks_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                console.log('node value ', value);
                                console.log('node value data', value['data']);
                                for (var xx in columns_to_add) {
                                    var month = columns_to_add[xx];
                                    result['ads_' + month] += value['data']['ads_' + month];
                                    result['clicks_' + month] += value['data']['clicks_' + month];

                                    var sum = value['data']['cost_' + month].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    result['cost_' + month] += parseFloat(sum);

                                    var sum = value['data']['clientgross_' + month].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    result['clientgross_' + month] += parseFloat(sum);

                                    var sum = value['data']['clientcost_' + month].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    result['clientcost_' + month] += parseFloat(sum);

                                    var sum = value['data']['netcost_' + month].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    result['netcost_' + month] += parseFloat(sum);

                                    var sum = value['data']['gri_' + month].replace(/,/g, '');
                                    result['gri_' + month] += parseFloat(sum);
                                    if (value['data']['media_type'] == 'radio')
                                        result['gricpm_' + month] += parseFloat(sum) / 10;
                                    else
                                        result['gricpm_' + month] += parseFloat(sum);
                                    var sum = value['data']['grp_' + month].replace(/,/g, '');
                                    result['grp_' + month] += parseFloat(sum);
                                }
                            });
                        });
                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        if (parseFloat(result['gricpm_' + month]) > 0) {
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        } else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }

                        var costperclick = parseInt(result['clicks_' + month]) ? parseFloat(result['cost_' + month]) / parseInt(result['clicks_' + month]) : 0
                        result['costperclick_' + month] = parseFloat(costperclick).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }
                else if (nodes[0].level === 1) {
                    console.log('level_1_details', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['clicks_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                $.each(value.childrenAfterGroup, function (index, value) {
                                    console.log('node value ', value);
                                    console.log('node value data', value['data']);
                                    for (var xx in columns_to_add) {
                                        var month = columns_to_add[xx];
                                        result['ads_' + month] += value['data']['ads_' + month];
                                        result['clicks_' + month] += value['data']['clicks_' + month];

                                        var sum = value['data']['cost_' + month].replace('$', '');
                                        sum = sum.replace(/,/g, '');
                                        result['cost_' + month] += parseFloat(sum);

                                        var sum = value['data']['clientgross_' + month].replace('$', '');
                                        sum = sum.replace(/,/g, '');
                                        result['clientgross_' + month] += parseFloat(sum);

                                        var sum = value['data']['clientcost_' + month].replace('$', '');
                                        sum = sum.replace(/,/g, '');
                                        result['clientcost_' + month] += parseFloat(sum);

                                        var sum = value['data']['netcost_' + month].replace('$', '');
                                        sum = sum.replace(/,/g, '');
                                        result['netcost_' + month] += parseFloat(sum);

                                        var sum = value['data']['gri_' + month].replace(/,/g, '');
                                        result['gri_' + month] += parseFloat(sum);
                                        if (value['data']['media_type'] == 'radio')
                                            result['gricpm_' + month] += parseFloat(sum) / 10;
                                        else
                                            result['gricpm_' + month] += parseFloat(sum);
                                        var sum = value['data']['grp_' + month].replace(/,/g, '');
                                        result['grp_' + month] += parseFloat(sum);
                                    }
                                });
                            });
                        });
                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0) {
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        var costperclick = parseInt(result['clicks_' + month]) ? parseFloat(result['cost_' + month]) / parseInt(result['clicks_' + month]) : 0
                        result['costperclick_' + month] = parseFloat(costperclick).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }

                return result;
            }
            else
                return false;
        };
        var ClientActivityAggFunctionFlowchartTab = function (nodes) {
            console.log('ClientActivityAggFunctionFlowchartTab', nodes);
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 2) {
                    console.log('level_2_details', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['clicks_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        console.log('node value ', value);
                        console.log('node value data', value['data']);
                        for (var xx in columns_to_add) {
                            var month = columns_to_add[xx];
                            result['ads_' + month] += value['data']['ads_' + month];
                            result['clicks_' + month] += value['data']['clicks_' + month];

                            var sum = value['data']['cost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['cost_' + month] += parseFloat(sum);

                            var sum = value['data']['clientgross_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientgross_' + month] += parseFloat(sum);

                            var sum = value['data']['clientcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['clientcost_' + month] += parseFloat(sum);

                            var sum = value['data']['netcost_' + month].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['netcost_' + month] += parseFloat(sum);

                            var sum = value['data']['gri_' + month].replace(/,/g, '');
                            result['gri_' + month] += parseFloat(sum);
                            if (value['data']['media_type'] == 'radio')
                                result['gricpm_' + month] += parseFloat(sum) / 10;
                            else
                                result['gricpm_' + month] += parseFloat(sum);
                            var sum = value['data']['grp_' + month].replace(/,/g, '');
                            result['grp_' + month] += parseFloat(sum);
                        }
                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0) {
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        } else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        var costperclick = parseInt(result['clicks_' + month]) ? parseFloat(result['cost_' + month]) / parseInt(result['clicks_' + month]) : 0
                        result['costperclick_' + month] = parseFloat(costperclick).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }
                else if (nodes[0].level === 1) {
                    console.log('level_2_details', nodes);
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        result['ads_' + month] = 0;
                        result['clicks_' + month] = 0;
                        result['cost_' + month] = 0;
                        result['clientgross_' + month] = 0;
                        result['clientcost_' + month] = 0;
                        result['netcost_' + month] = 0;
                        result['netcpm_' + month] = 0;
                        result['netcpp_' + month] = 0;
                        result['grp_' + month] = 0;
                        result['gri_' + month] = 0;
                        result['gricpm_' + month] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            for (var xx in columns_to_add) {
                                var month = columns_to_add[xx];
                                result['ads_' + month] += value['data']['ads_' + month];
                                result['clicks_' + month] += value['data']['clicks_' + month];

                                var sum = value['data']['cost_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['cost_' + month] += parseFloat(sum);

                                var sum = value['data']['clientgross_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['clientgross_' + month] += parseFloat(sum);

                                var sum = value['data']['clientcost_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['clientcost_' + month] += parseFloat(sum);

                                var sum = value['data']['netcost_' + month].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['netcost_' + month] += parseFloat(sum);

                                var sum = value['data']['gri_' + month].replace(/,/g, '');
                                result['gri_' + month] += parseFloat(sum);
                                if (value['data']['media_type'] == 'radio')
                                    result['gricpm_' + month] += parseFloat(sum) / 10;
                                else
                                    result['gricpm_' + month] += parseFloat(sum);
                                var sum = value['data']['grp_' + month].replace(/,/g, '');
                                result['grp_' + month] += parseFloat(sum);
                            }
                        });
                    });
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        if (parseFloat(result['gricpm_' + month]) > 0) {
                            result['cpm_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['gricpm_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        else {
                            result['cpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpm_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        if (parseFloat(result['grp_' + month]) > 0) {
                            result['cpp_' + month] = parseFloat(parseFloat(result['cost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(parseFloat(result['netcost_' + month]) / parseFloat(result['grp_' + month])).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        } else {
                            result['cpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            result['netcpp_' + month] = parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                        }
                        var costperclick = parseInt(result['clicks_' + month]) ? parseFloat(result['cost_' + month]) / parseInt(result['clicks_' + month]) : 0
                        result['costperclick_' + month] = parseFloat(costperclick).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['cost_' + month] = parseFloat(result['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientgross_' + month] = parseFloat(result['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['clientcost_' + month] = parseFloat(result['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['netcost_' + month] = parseFloat(result['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['gri_' + month] = parseFloat(result['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_' + month] = parseFloat(result['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                    }
                    console.log('results ', result)

                }
                return result;
            }
            else
                return false;

        };
        var camp_break_market = results_data;
        var rowData = [];
        var rowDataAdvertiser = [];
        var rowDataDetails = [];
        var totals_makets = [];
         totals_makets['market'] = [];
         totals_makets['vendor'] = [];
         var topLine = [];
         var topLineAdvertiser = [];
         var count  = 0;
         var count_one  = 0;
         var flag_count = false;
         console.log('camp_client_gross camp_client_gross', camp_client_gross)

        for(var market_name in camp_break_market){
            var m_name = (typeof flags_array[market_name] !== 'undefined') ? '(' + flag_t + ') ' + market_name : market_name;
            if(m_name != market_name)
                flag_count = true;
            var vendors_array = camp_break_market[market_name];
            if(markets_name_array.indexOf(market_name) !== -1) {
                totals_makets['market'][m_name] = [];
                totals_makets['market'][m_name]['market'] = m_name;
            }
            for(var xx in columns_to_add) {
                if(markets_name_array.indexOf(market_name) !== -1) {
                    totals_makets['market'][m_name]['ads_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['clicks_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['cost_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['netcost_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['gri_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['grp_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['gricpm_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['netcpm_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['netcpp_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['clientgross_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['clientcost_' + columns_to_add[xx]] = 0;
                    totals_makets['market'][m_name]['costperclick_' + columns_to_add[xx]] = 0;
                }

                if(count == 0){
                    topLine['ads_' + columns_to_add[xx]] = 0;
                    topLine['clicks_' + columns_to_add[xx]] = 0;
                    topLine['cost_' + columns_to_add[xx]] = 0;
                    topLine['netcost_' + columns_to_add[xx]] = 0;
                    topLine['gri_' + columns_to_add[xx]] = 0;
                    topLine['grp_' + columns_to_add[xx]] = 0;
                    topLine['gricpm_' + columns_to_add[xx]] = 0;
                    topLine['netcpm_' + columns_to_add[xx]] = 0;
                    topLine['netcpp_' + columns_to_add[xx]] = 0;
                    topLine['clientgross_' + columns_to_add[xx]] = 0;
                    topLine['clientcost_' + columns_to_add[xx]] = 0;
                    topLine['costperclick_' + columns_to_add[xx]] = 0;
                }
            }
            if(markets_name_array.indexOf(market_name) !== -1)
                 count++;
            console.log('vendors_array_vendors_array_ ', vendors_array);

            for(var vendor_name in vendors_array) {
                var lines = vendors_array[vendor_name];
                var v_name = vendor_name;
                if (typeof flags_array[market_name] !== 'undefined') {
                    if (flags_array[market_name].indexOf(vendor_name) !== -1)
                        v_name = '(' + flag_t + ') ' + vendor_name;
                }

                if(markets_name_array.indexOf(market_name) !== -1 || show_length_breakout === 0) {
                    var len = '-';
                    if (lines[0]['media_type'] === 'tv' || lines[0]['media_type'] === 'radio' || lines[0]['media_type'] === 'cable' || lines[0]['media_type'] === 'podcast_attached')
                        len = typeof lines[0]['length'] !== 'undefined' && lines[0]['length'] !== 'null' && lines[0]['length'] !== null && lines[0]['length'] !== '' ? ':' + lines[0]['length'] : ':0';
                    var row = {
                        market: market_name,
                        vendor: v_name,
                        media_type: lines[0]['media_type'],
                        length: len,
                        ordered_status: (lines[0]['wl_order_number'] === null || lines[0]['wl_order_number'] == '') ? 'Not Ordered' : lines[0]['wl_order_number'],
                    };

                    if (markets_name_array.indexOf(market_name) !== -1) {
                        if (typeof totals_makets['vendor'][v_name] === 'undefined') {
                            totals_makets['vendor'][v_name] = [];
                            totals_makets['vendor'][v_name]['vendor'] = v_name;
                            for (var xx in columns_to_add) {
                                totals_makets['vendor'][v_name]['ads_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['clicks_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['cost_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['netcost_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['gri_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['gricpm_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['grp_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['netcpm_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['netcpp_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['clientgross_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['clientcost_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['costperclick_' + columns_to_add[xx]] = 0;
                            }
                        }
                    }

                    for (var xx in columns_to_add) {
                        row['ads_' + columns_to_add[xx]] = 0;
                        row['cost_' + columns_to_add[xx]] = 0;
                        row['netcost_' + columns_to_add[xx]] = 0;
                        row['gri_' + columns_to_add[xx]] = 0;
                        row['grp_' + columns_to_add[xx]] = 0;
                        row['cpm_' + columns_to_add[xx]] = 0;
                        row['netcpm_' + columns_to_add[xx]] = 0;
                        row['cpp_' + columns_to_add[xx]] = 0;
                        row['netcpp_' + columns_to_add[xx]] = 0;
                        row['clientgross_' + columns_to_add[xx]] = 0;
                        row['clientcost_' + columns_to_add[xx]] = 0;
                        row['clicks_' + columns_to_add[xx]] = 0;
                        row['costperclick_' + columns_to_add[xx]] = 0;
                    }
                    for (var ind in lines) {
                        for (var xx in columns_to_add) {
                            if (typeof lines[ind]['months'][columns_to_add[xx]] !== 'undefined') {
                                var month = columns_to_add[xx];
                                row['ads_' + month] += parseInt(lines[ind]['months'][month]);
                                row['clicks_' + month] += typeof lines[ind]['months_clicks'] !== 'undefined' && typeof lines[ind]['months_clicks'][month] ? parseInt(lines[ind]['months_clicks'][month]) : 0;
                                if (report_obj.buy_to_include == 'both' || report_obj.buy_to_include == 'not_ordered') {
                                    if (lines[ind]['media_type'] != "Digital" && lines[ind]['media_type'] != "radio" && lines[ind]['media_type'] != "tv" && lines[ind]['media_type'] !== "Radio" && lines[ind]['media_type'] !== "TV" && lines[ind]['media_type'] !== "podcast_attached")
                                        var cost = parseFloat(parseFloat(lines[ind]['months'][month]) * parseFloat(lines[ind]['gross_cpa']));
                                    if (lines[ind]['media_type'] == "radio" || lines[ind]['media_type'] == "tv" || lines[ind]['media_type'] == "Radio" || lines[ind]['media_type'] == "TV" || lines[ind]['media_type'] === "podcast_attached")
                                        var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;

                                    if (lines[ind]['media_type'] === "Digital" || lines[ind]['media_type'] === "digital" || lines[ind]['media_type'] === "ooh" || lines[ind]['media_type'] === "OOH"
                                        || lines[ind]['media_type'] === "other" || lines[ind]['media_type'] === "Other" || lines[ind]['media_type'] === "podcast_programmatic")
                                        var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;
                                } else
                                    var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;

                                var monthly_break = false;
                                if (lines[ind]['media_type'] === "Digital" || lines[ind]['media_type'] === "digital" || lines[ind]['media_type'] === "ooh" || lines[ind]['media_type'] === "OOH"
                                    || lines[ind]['media_type'] === "other" || lines[ind]['media_type'] === "Other" || lines[ind]['media_type'] === "podcast_programmatic") {
                                    if (typeof lines[ind]['rev_id'] != 'undefined' && typeof monthly_cost_breakout[lines[ind]['rev_id']] !== 'undefined' && typeof monthly_cost_breakout[lines[ind]['rev_id']][month] !== 'undefined') {
                                        cost = monthly_cost_breakout[lines[ind]['rev_id']][month];
                                        monthly_break = true;
                                    }
                                }
                                if (monthly_break == false) {
                                    if (typeof lines[ind]['order_number'] !== 'undefined' && typeof lines[ind]['market_id'] !== 'undefined' && typeof order_revision_valids[lines[ind]['order_number']] !== 'undefined' && typeof order_revision_valids[lines[ind]['order_number']][lines[ind]['market_id']] !== 'undefined') {
                                        for (var rev_id_index in order_revision_valids[lines[ind]['order_number']][lines[ind]['market_id']]) {
                                            if (typeof monthly_cost_breakout[rev_id_index] !== 'undefined') {
                                                if (typeof monthly_cost_breakout[rev_id_index][month] !== 'undefined') {
                                                    cost = !isNaN(parseFloat(monthly_cost_breakout[rev_id_index][month])) ? monthly_cost_breakout[rev_id_index][month] : 0;
                                                    monthly_break = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                var agency_commission = parseFloat(lines[ind]['agency_commission']);
                                if (monthly_break === false) {
                                    row['netcost_' + month] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                    row['cost_' + month] += parseFloat(cost);
                                } else {
                                    row['netcost_' + month] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                    row['cost_' + month] = parseFloat(cost);
                                }

                                var spots = parseInt(lines[ind]['months'][month]);
                                row['grp_' + month] += (!isNaN(lines[ind]['rating'])) ? parseFloat(Number(Math.round((lines[ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                row['gri_' + month] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;

                                console.log('');

                                var clientgross_value = typeof camp_client_gross[lines[ind]['campaign_id']] !== 'undefined' && !isNaN(parseInt(camp_client_gross[lines[ind]['campaign_id']]['value'])) ? camp_client_gross[lines[ind]['campaign_id']]['value'] : 0;
                                var client_gross = 0;
                                cost = !isNaN(parseFloat(cost)) ? parseFloat(cost) : 0;
                                if (clientgross_value !== 0) {
                                    if (camp_client_gross[lines[ind]['campaign_id']]['type'] === 'media_gross')
                                        client_gross = cost - ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                    else if (camp_client_gross[lines[ind]['campaign_id']]['type'] === 'gross_plus_net') {
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        client_gross = n + ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                    } else if (camp_client_gross[lines[ind]['campaign_id']]['type'] === 'markup_media_net') {
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        client_gross = n * (1 + ((1 * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100));
                                    } else {
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        var div = (100 - camp_client_gross[lines[ind]['campaign_id']]['value']) / 100;
                                        client_gross = div > 0 ? n / div : n;
                                    }

                                }
                                client_gross = parseFloat(parseFloat(client_gross).toFixed(2));

                                var client_cost = !isNaN(parseFloat(lines[ind]['months_client_cost'][month])) ? parseFloat(lines[ind]['months_client_cost'][month]) : 0;
                                client_cost = parseFloat(parseFloat(client_cost).toFixed(2));

                                row['clientgross_' + month] += parseFloat(client_gross);
                                row['clientcost_' + month] += parseFloat(client_cost);

                                //fill market totals
                                if (markets_name_array.indexOf(market_name) !== -1) {
                                    totals_makets['market'][m_name]['ads_' + columns_to_add[xx]] += parseInt(lines[ind]['months'][month]);
                                    totals_makets['market'][m_name]['clicks_' + columns_to_add[xx]] += typeof lines[ind]['months_clicks'] !== 'undefined' && typeof lines[ind]['months_clicks'][month] ? parseInt(lines[ind]['months_clicks'][month]) : 0;
                                    if (monthly_break === false) {
                                        totals_makets['market'][m_name]['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                        totals_makets['market'][m_name]['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                    } else {
                                        totals_makets['market'][m_name]['cost_' + columns_to_add[xx]] = parseFloat(cost);
                                        totals_makets['market'][m_name]['netcost_' + columns_to_add[xx]] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                    }
                                    totals_makets['market'][m_name]['clientgross_' + columns_to_add[xx]] += client_gross;
                                    totals_makets['market'][m_name]['clientcost_' + columns_to_add[xx]] += parseFloat(client_cost);
                                    totals_makets['market'][m_name]['grp_' + columns_to_add[xx]] += (!isNaN(lines[ind]['rating'])) ? parseFloat(Number(Math.round((lines[ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                    totals_makets['market'][m_name]['gri_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                    if (row['media_type'] != 'radio')
                                        totals_makets['market'][m_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                    else
                                        totals_makets['market'][m_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? (parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) / 10) : 0;

                                    //fiell vendors totals
                                    totals_makets['vendor'][v_name]['ads_' + columns_to_add[xx]] += parseInt(lines[ind]['months'][month]);
                                    totals_makets['vendor'][v_name]['clicks_' + columns_to_add[xx]] += typeof lines[ind]['months_clicks'] !== 'undefined' && typeof lines[ind]['months_clicks'][month] ? parseInt(lines[ind]['months_clicks'][month]) : 0;
                                    if (monthly_break === false) {
                                        totals_makets['vendor'][v_name]['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                        totals_makets['vendor'][v_name]['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                    } else {
                                        totals_makets['vendor'][v_name]['cost_' + columns_to_add[xx]] = parseFloat(cost);
                                        totals_makets['vendor'][v_name]['netcost_' + columns_to_add[xx]] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                    }
                                    totals_makets['vendor'][v_name]['clientgross_' + columns_to_add[xx]] += client_gross;
                                    totals_makets['vendor'][v_name]['clientcost_' + columns_to_add[xx]] += parseFloat(client_cost);
                                    ;

                                    totals_makets['vendor'][v_name]['grp_' + columns_to_add[xx]] += (!isNaN(lines[ind]['rating'])) ? parseFloat(Number(Math.round((lines[ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                    totals_makets['vendor'][v_name]['gri_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                    if (row['media_type'] != 'radio')
                                        totals_makets['vendor'][v_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                    else
                                        totals_makets['vendor'][v_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? (parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) / 10) : 0;
                                }
                                //fill grid top line
                                if (markets_name_array.indexOf(market_name) !== -1) {
                                    topLine['ads_' + columns_to_add[xx]] += parseInt(lines[ind]['months'][month]);
                                    topLine['clicks_' + columns_to_add[xx]] += typeof lines[ind]['months_clicks'] !== 'undefined' && typeof lines[ind]['months_clicks'][month] ? parseInt(lines[ind]['months_clicks'][month]) : 0;

                                    if (monthly_break === false) {
                                        topLine['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                        topLine['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                    }
                                    if (ind === 0 && monthly_break === true) {
                                        topLine['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                        topLine['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                    }
                                    topLine['clientgross_' + columns_to_add[xx]] += client_gross;
                                    topLine['clientcost_' + columns_to_add[xx]] += parseFloat(client_cost);
                                    ;
                                    topLine['grp_' + columns_to_add[xx]] += (!isNaN(lines[ind]['rating'])) ? parseFloat(Number(Math.round((lines[ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                    topLine['gri_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                    if (row['media_type'] != 'radio')
                                        topLine['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                    else
                                        topLine['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? (parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) / 10) : 0;
                                }
                            }
                        }
                    }
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        row['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                        row['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;

                        if (row['media_type'] != 'radio') {
                            row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                            row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                        } else {
                            row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['cost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                            row['netcpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['netcost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                        }
                        row['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;

                        //top line
                        topLine['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                        topLine['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;

                        if (row['media_type'] != 'radio') {
                            topLine['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                            topLine['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                        } else {
                            topLine['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['cost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                            topLine['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['netcost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                        }

                        topLine['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;

                    }
                    console.log('row row ', row);
                    row['media_type'] = (row['media_type'] === 'podcast_programmatic' || row['media_type'] === 'podcast_attached') ? 'podcast' : row['media_type'];
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        row['cost_' + month] = parseFloat(row['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcost_' + month] = parseFloat(row['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['clientgross_' + month] = parseFloat(row['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['clientcost_' + month] = parseFloat(row['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['cpp_' + month] = parseFloat(row['cpp_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcpp_' + month] = parseFloat(row['netcpp_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['cpm_' + month] = parseFloat(row['cpm_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcpm_' + month] = parseFloat(row['netcpm_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['gri_' + month] = parseFloat(row['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        row['grp_' + month] = parseFloat(row['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        row['costperclick_' + month] = parseFloat(row['costperclick_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });

                    }
                    if (markets_name_array.indexOf(market_name) !== -1)
                        rowData.push(row);
                    else
                        rowDataAdvertiser.push(row);
                }
                else {
                    var len_added = [];
                    var lines_rows = collect(lines).groupBy("length").all();
                    console.log('lines_rows_lines_rows ', lines_rows)
                    if (markets_name_array.indexOf(market_name) !== -1) {
                        if (typeof totals_makets['vendor'][v_name] === 'undefined') {
                            totals_makets['vendor'][v_name] = [];
                            totals_makets['vendor'][v_name]['vendor'] = v_name;
                            for (var xx in columns_to_add) {
                                totals_makets['vendor'][v_name]['ads_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['cost_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['netcost_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['gri_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['gricpm_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['grp_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['netcpm_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['netcpp_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['clientgross_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['clientcost_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['clicks_' + columns_to_add[xx]] = 0;
                                totals_makets['vendor'][v_name]['costperclick_' + columns_to_add[xx]] = 0;
                            }
                        }
                    }

                    for (var lenth in lines_rows) {
                        var len = '-';
                        if (lines_rows[lenth][0]['media_type'] === 'tv' || lines_rows[lenth][0]['media_type'] === 'radio' || lines_rows[lenth][0]['media_type'] === 'cable' || lines_rows[lenth][0]['media_type'] === 'podcast_attached')
                            len = typeof lines_rows[lenth][0]['length'] !== 'undefined' && lines_rows[lenth][0]['length'] !== 'null' && lines_rows[lenth][0]['length'] !== null && lines_rows[lenth][0]['length'] !== '' ? ':' + lines_rows[lenth][0]['length'] : ':0';
                        var row = {
                            market: market_name,
                            vendor: v_name,
                            media_type: lines_rows[lenth][0]['media_type'],
                            length: len,
                            ordered_status: (lines_rows[lenth][0]['wl_order_number'] === null || lines_rows[lenth][0]['wl_order_number'] == '') ? 'Not Ordered' : lines_rows[lenth][0]['wl_order_number'],
                        };
                        for (var xx in columns_to_add) {
                            row['ads_' + columns_to_add[xx]] = 0;
                            row['clicks_' + columns_to_add[xx]] = 0;
                            row['cost_' + columns_to_add[xx]] = 0;
                            row['netcost_' + columns_to_add[xx]] = 0;
                            row['gri_' + columns_to_add[xx]] = 0;
                            row['grp_' + columns_to_add[xx]] = 0;
                            row['cpm_' + columns_to_add[xx]] = 0;
                            row['netcpm_' + columns_to_add[xx]] = 0;
                            row['cpp_' + columns_to_add[xx]] = 0;
                            row['netcpp_' + columns_to_add[xx]] = 0;
                            row['clientgross_' + columns_to_add[xx]] = 0;
                            row['clientcost_' + columns_to_add[xx]] = 0;
                            row['costperclick_' + columns_to_add[xx]] = 0;
                        }

                        for(var ind in lines_rows[lenth]) {
                            for (var xx in columns_to_add) {
                                if (typeof lines_rows[lenth][ind]['months'][columns_to_add[xx]] !== 'undefined') {
                                    var month = columns_to_add[xx];
                                    row['ads_' + month] += parseInt(lines_rows[lenth][ind]['months'][month]);
                                    row['clicks_' + month] += typeof lines_rows[lenth][ind]['months_clicks'] !== 'undefined' && typeof lines_rows[lenth][ind]['months_clicks'][month]!== 'undefined' ? parseInt(lines_rows[lenth][ind]['months_clicks'][month]) : 0;
                                    if (report_obj.buy_to_include == 'both' || report_obj.buy_to_include == 'not_ordered') {
                                        if (lines_rows[lenth][ind]['media_type'] != "Digital" && lines_rows[lenth][ind]['media_type'] != "radio" && lines_rows[lenth][ind]['media_type'] != "tv" && lines_rows[lenth][ind]['media_type'] !== "Radio" && lines_rows[lenth][ind]['media_type'] !== "TV" && lines_rows[lenth][ind]['media_type'] !== 'podcast_attached')
                                            var cost = parseFloat(parseFloat(lines_rows[lenth][ind]['months'][month]) * parseFloat(lines_rows[lenth][ind]['gross_cpa']));
                                        if (lines_rows[lenth][ind]['media_type'] == "radio" || lines_rows[lenth][ind]['media_type'] == "tv" || lines_rows[lenth][ind]['media_type'] == "Radio" || lines_rows[lenth][ind]['media_type'] == "TV" || lines_rows[lenth][ind]['media_type'] === 'podcast_attached')
                                            var cost = !isNaN(parseFloat(lines_rows[lenth][ind]['months_cost'][month])) ? parseFloat(lines_rows[lenth][ind]['months_cost'][month]) : 0;

                                        if (lines_rows[lenth][ind]['media_type'] === "Digital" || lines_rows[lenth][ind]['media_type'] === "digital" || lines_rows[lenth][ind]['media_type'] === "ooh" || lines_rows[lenth][ind]['media_type'] === "OOH"
                                            || lines_rows[lenth][ind]['media_type'] === "other" || lines_rows[lenth][ind]['media_type'] === "Other" || lines_rows[lenth][ind]['media_type'] === 'podcast_programmatic')
                                            var cost = !isNaN(parseFloat(lines_rows[lenth][ind]['months_cost'][month])) ? parseFloat(lines_rows[lenth][ind]['months_cost'][month]) : 0;
                                    } else
                                        var cost = !isNaN(parseFloat(lines_rows[lenth][ind]['months_cost'][month])) ? parseFloat(lines_rows[lenth][ind]['months_cost'][month]) : 0;

                                    var monthly_break = false;
                                    if (lines_rows[lenth][ind]['media_type'] === "Digital" || lines_rows[lenth][ind]['media_type'] === "digital" || lines_rows[lenth][ind]['media_type'] === "ooh" || lines_rows[lenth][ind]['media_type'] === "OOH"
                                        || lines_rows[lenth][ind]['media_type'] === "other" || lines_rows[lenth][ind]['media_type'] === "Other" || lines_rows[lenth][ind]['media_type'] === 'podcast_programmatic') {
                                        if (typeof lines_rows[lenth][ind]['rev_id'] != 'undefined' && typeof monthly_cost_breakout[lines_rows[lenth][ind]['rev_id']] !== 'undefined' && typeof monthly_cost_breakout[lines_rows[lenth][ind]['rev_id']][month] !== 'undefined') {
                                            cost = monthly_cost_breakout[lines_rows[lenth][ind]['rev_id']][month];
                                            monthly_break = true;
                                        }
                                    }
                                    if (monthly_break == false) {
                                        if (typeof lines_rows[lenth][ind]['order_number'] !== 'undefined' && typeof lines_rows[lenth][ind]['market_id'] !== 'undefined' && typeof order_revision_valids[lines_rows[lenth][ind]['order_number']] !== 'undefined' && typeof order_revision_valids[lines_rows[lenth][ind]['order_number']][lines_rows[lenth][ind]['market_id']] !== 'undefined') {
                                            for (var rev_id_index in order_revision_valids[lines_rows[lenth][ind]['order_number']][lines_rows[lenth][ind]['market_id']]) {
                                                if (typeof monthly_cost_breakout[rev_id_index] !== 'undefined') {
                                                    if (typeof monthly_cost_breakout[rev_id_index][month] !== 'undefined') {
                                                        cost = !isNaN(parseFloat(monthly_cost_breakout[rev_id_index][month])) ? monthly_cost_breakout[rev_id_index][month] : 0;
                                                        monthly_break = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    var agency_commission = parseFloat(lines_rows[lenth][ind]['agency_commission']);
                                    if (monthly_break === false) {
                                        row['netcost_' + month] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                        row['cost_' + month] += parseFloat(cost);
                                    } else {
                                        row['netcost_' + month] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        row['cost_' + month] = parseFloat(cost);
                                    }

                                    var spots = parseInt(lines_rows[lenth][ind]['months'][month]);
                                    row['grp_' + month] += (!isNaN(lines_rows[lenth][ind]['rating'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                    row['gri_' + month] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;

                                    var clientgross_value = typeof camp_client_gross[lines_rows[lenth][ind]['campaign_id']] !== 'undefined' && !isNaN(parseInt(camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['value'])) ? camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['value'] : 0;
                                    var client_gross = 0;
                                    cost = !isNaN(parseFloat(cost)) ? parseFloat(cost) : 0;
                                    if (clientgross_value !== 0) {
                                        if (camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['type'] === 'media_gross')
                                            client_gross = cost - ((cost * camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['value']) / 100);
                                        else if (camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['type'] === 'gross_plus_net') {
                                            var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                            client_gross = n + ((cost * camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['value']) / 100);
                                        } else if (camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['type'] === 'markup_media_net') {
                                            var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                            client_gross = n * (1 + ((1 * camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['value']) / 100));
                                        } else {
                                            var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                            var div = (100 - camp_client_gross[lines_rows[lenth][ind]['campaign_id']]['value']) / 100;
                                            client_gross = div > 0 ? n / div : n;
                                        }

                                    }
                                    client_gross = parseFloat(parseFloat(client_gross).toFixed(2));

                                    var client_cost = !isNaN(parseFloat(lines_rows[lenth][ind]['months_client_cost'][month])) ? parseFloat(lines_rows[lenth][ind]['months_client_cost'][month]) : 0;
                                    client_cost = parseFloat(parseFloat(client_cost).toFixed(2));

                                    row['clientgross_' + month] += parseFloat(client_gross);
                                    row['clientcost_' + month] += parseFloat(client_cost);

                                    //fill market totals
                                    if (markets_name_array.indexOf(market_name) !== -1) {
                                        totals_makets['market'][m_name]['ads_' + columns_to_add[xx]] += parseInt(lines_rows[lenth][ind]['months'][month]);
                                        totals_makets['market'][m_name]['clicks_' + columns_to_add[xx]]  += typeof lines_rows[lenth][ind]['months_clicks'] !== 'undefined' && typeof lines_rows[lenth][ind]['months_clicks'][month]!== 'undefined' ? parseInt(lines_rows[lenth][ind]['months_clicks'][month]) : 0;

                                        if (monthly_break === false) {
                                            totals_makets['market'][m_name]['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                            totals_makets['market'][m_name]['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                        } else {
                                            totals_makets['market'][m_name]['cost_' + columns_to_add[xx]] = parseFloat(cost);
                                            totals_makets['market'][m_name]['netcost_' + columns_to_add[xx]] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        }
                                        totals_makets['market'][m_name]['clientgross_' + columns_to_add[xx]] += client_gross;
                                        totals_makets['market'][m_name]['clientcost_' + columns_to_add[xx]] += parseFloat(client_cost);
                                        totals_makets['market'][m_name]['grp_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['rating'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                        totals_makets['market'][m_name]['gri_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                        if (row['media_type'] != 'radio')
                                            totals_makets['market'][m_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                        else
                                            totals_makets['market'][m_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? (parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) / 10) : 0;

                                        //fiell vendors totals
                                        totals_makets['vendor'][v_name]['ads_' + columns_to_add[xx]] += parseInt(lines_rows[lenth][ind]['months'][month]);
                                        if (monthly_break === false) {
                                            totals_makets['vendor'][v_name]['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                            totals_makets['vendor'][v_name]['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                        } else {
                                            totals_makets['vendor'][v_name]['cost_' + columns_to_add[xx]] = parseFloat(cost);
                                            totals_makets['vendor'][v_name]['netcost_' + columns_to_add[xx]] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        }
                                        totals_makets['vendor'][v_name]['clientgross_' + columns_to_add[xx]] += client_gross;
                                        totals_makets['vendor'][v_name]['clientcost_' + columns_to_add[xx]] += parseFloat(client_cost);
                                        ;

                                        totals_makets['vendor'][v_name]['grp_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['rating'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                        totals_makets['vendor'][v_name]['gri_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                        if (row['media_type'] != 'radio')
                                            totals_makets['vendor'][v_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                        else
                                            totals_makets['vendor'][v_name]['gricpm_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? (parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) / 10) : 0;
                                    }
                                    //fill grid top line
                                    if (markets_name_array.indexOf(market_name) !== -1) {
                                        topLine['ads_' + columns_to_add[xx]] += parseInt(lines_rows[lenth][ind]['months'][month]);
                                        topLine['clicks_' + columns_to_add[xx]] += typeof lines_rows[lenth][ind]['months_clicks'] !== 'undefined' && typeof lines_rows[lenth][ind]['months_clicks'][month]!== 'undefined' ? parseInt(lines_rows[lenth][ind]['months_clicks'][month]) : 0;

                                        if (monthly_break === false) {
                                            topLine['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                            topLine['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                        }
                                        if (ind === 0 && monthly_break === true) {
                                            topLine['cost_' + columns_to_add[xx]] += parseFloat(cost);
                                            topLine['netcost_' + columns_to_add[xx]] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                        }
                                        topLine['clientgross_' + columns_to_add[xx]] += client_gross;
                                        topLine['clientcost_' + columns_to_add[xx]] += parseFloat(client_cost);

                                        topLine['grp_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['rating'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                        topLine['gri_' + columns_to_add[xx]] += (!isNaN(lines_rows[lenth][ind]['impressions'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                        if (row['media_type'] != 'radio')
                                            topLine['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                        else
                                            topLine['gricpm_' + columns_to_add[xx]] += (!isNaN(lines[ind]['impressions'])) ? (parseFloat(Number(Math.round((lines_rows[lenth][ind]['impressions']) + 'e1') + 'e-1') * spots) / 10) : 0;
                                    }
                                }
                            }
                            for (var xx in columns_to_add) {
                                var month = columns_to_add[xx];
                                row['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                                row['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;

                                if (row['media_type'] != 'radio') {
                                    row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                                    row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                                } else {
                                    row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['cost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                                    row['netcpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['netcost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                                }
                                row['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;

                                //top line
                                topLine['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                                topLine['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;

                                if (row['media_type'] != 'radio') {
                                    topLine['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                                    topLine['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                                } else {
                                    topLine['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['cost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                                    topLine['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['netcost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                                }

                                 topLine['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;

                            }
                        }
                        row['media_type'] = (row['media_type'] === 'podcast_programmatic' || row['media_type'] === 'podcast_attached') ? 'podcast' : row['media_type'];
                        console.log('row row ', row);
                        for (var xx in columns_to_add) {
                            var month = columns_to_add[xx];
                            row['cost_' + month] = parseFloat(row['cost_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['netcost_' + month] = parseFloat(row['netcost_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['clientgross_' + month] = parseFloat(row['clientgross_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['clientcost_' + month] = parseFloat(row['clientcost_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['cpp_' + month] = parseFloat(row['cpp_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['netcpp_' + month] = parseFloat(row['netcpp_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['cpm_' + month] = parseFloat(row['cpm_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['netcpm_' + month] = parseFloat(row['netcpm_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });
                            row['gri_' + month] = parseFloat(row['gri_' + month]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            });
                            row['grp_' + month] = parseFloat(row['grp_' + month]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            });
                            row['costperclick_' + month] = parseFloat(row['costperclick_' + month]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });

                        }
                        rowDataAdvertiser.push(row);
                    }
                }
            }
        }
        for(var market_name in totals_makets['market']) {
            var row = totals_makets['market'][market_name];
            for (var xx in columns_to_add) {
                var month = columns_to_add[xx];
                row['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                row['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gricpm_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gricpm_' + month]) : 0;
                row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gricpm_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gricpm_' + month]) : 0;
                row['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;
                row['cost_' + month] =  parseFloat(row['cost_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcost_'+month] =  parseFloat(row['netcost_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['clientgross_'+month] =  parseFloat(row['clientgross_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['clientcost_'+month] =  parseFloat(row['clientcost_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpp_'+month] =  parseFloat(row['cpp_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcpp_'+month] =  parseFloat(row['netcpp_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpm_'+month] =  parseFloat(row['cpm_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcpm_'+month] =  parseFloat(row['netcpm_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['gri_'+month] =  parseFloat(row['gri_'+month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['grp_'+month] =  parseFloat(row['grp_'+month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['costperclick_'+month] =  parseFloat(row['costperclick_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            }
        }
        for(var market_name in totals_makets['vendor']) {
            var row = totals_makets['vendor'][market_name];
            for (var xx in columns_to_add) {
                var month = columns_to_add[xx];
                row['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                row['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gricpm_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gricpm_' + month]) : 0;
                row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gricpm_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gricpm_' + month]) : 0;
                row['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;
                row['cost_'+month] =  parseFloat(row['cost_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcost_'+month] =  parseFloat(row['netcost_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['clientgross_'+month] =  parseFloat(row['clientgross_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['clientcost_'+month] =  parseFloat(row['clientcost_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpp_'+month] =  parseFloat(row['cpp_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcpp_'+month] =  parseFloat(row['netcpp_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpm_'+month] =  parseFloat(row['cpm_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcpm_'+month] =  parseFloat(row['netcpm_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['costperclick_' + month] =  parseFloat(row['costperclick_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['gri_'+month] =  parseFloat(row['gri_'+month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['grp_'+month] =  parseFloat(row['grp_'+month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });

            }
        }

        var rowDataFlowchart = [];
        for(var cam_name in flowchart_tab){
            for(var market_name in flowchart_tab[cam_name]) {
                for(var media_type in flowchart_tab[cam_name][market_name]) {
                    var lines = flowchart_tab[cam_name][market_name][media_type];
                    console.log('rowDataFlowchart lines', lines)

                    var row = {
                        camp_name: cam_name,
                        market: market_name,
                        media_type: media_type,
                    };
                    for (var xx in columns_to_add) {
                        row['ads_' + columns_to_add[xx]] = 0;
                        row['clicks_' + columns_to_add[xx]] = 0;
                        row['cost_' + columns_to_add[xx]] = 0;
                        row['netcost_' + columns_to_add[xx]] = 0;
                        row['gri_' + columns_to_add[xx]] = 0;
                        row['grp_' + columns_to_add[xx]] = 0;
                        row['cpm_' + columns_to_add[xx]] = 0;
                        row['netcpm_' + columns_to_add[xx]] = 0;
                        row['cpp_' + columns_to_add[xx]] = 0;
                        row['netcpp_' + columns_to_add[xx]] = 0;
                        row['clientgross_' + columns_to_add[xx]] = 0;
                        row['clientcost_' + columns_to_add[xx]] = 0;
                        row['costperclick_' + columns_to_add[xx]] = 0;
                    }

                    for (var ind in lines) {
                        for (var xx in columns_to_add) {
                            if (typeof lines[ind]['months'][columns_to_add[xx]] !== 'undefined') {
                                var month = columns_to_add[xx];
                                row['ads_' + month] += parseInt(lines[ind]['months'][month]);
                                row['clicks_' + month] += typeof lines[ind]['months_clicks'] !== 'undefined' && typeof lines[ind]['months_clicks'][month] !== 'undefined' ? parseInt(lines[ind]['months_clicks'][month]) : 0;
                                if (report_obj.buy_to_include == 'both' || report_obj.buy_to_include == 'not_ordered') {
                                    if (lines[ind]['media_type'] != "Digital" && lines[ind]['media_type'] != "digital" && lines[ind]['media_type'] != "radio" && lines[ind]['media_type'] != "tv" && lines[ind]['media_type'] !== "Radio" && lines[ind]['media_type'] !== "TV" && lines[ind]['media_type'] !== "podcast_attached")
                                        var cost = parseFloat(parseFloat(lines[ind]['months'][month]) * parseFloat(lines[ind]['gross_cpa']));
                                    if (lines[ind]['media_type'] == "radio" || lines[ind]['media_type'] == "tv" || lines[ind]['media_type'] == "Radio" || lines[ind]['media_type'] == "TV" || lines[ind]['media_type'] === "podcast_attached")
                                        var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;

                                    if (lines[ind]['media_type'] === "Digital" || lines[ind]['media_type'] === "digital" || lines[ind]['media_type'] === "ooh" || lines[ind]['media_type'] === "OOH"
                                        || lines[ind]['media_type'] === "other" || lines[ind]['media_type'] === "Other" || lines[ind]['media_type'] === "podcast_programmatic")
                                        var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;
                                } else
                                    var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;

                                var monthly_break = false;
                                if (lines[ind]['media_type'] === "Digital" || lines[ind]['media_type'] === "digital" || lines[ind]['media_type'] === "ooh" || lines[ind]['media_type'] === "OOH"
                                    || lines[ind]['media_type'] === "other" || lines[ind]['media_type'] === "Other" || lines[ind]['media_type'] === "podcast_programmatic") {
                                    if (typeof lines[ind]['rev_id'] != 'undefined' && typeof monthly_cost_breakout[lines[ind]['rev_id']] !== 'undefined' && typeof monthly_cost_breakout[lines[ind]['rev_id']][month] !== 'undefined') {
                                        cost = monthly_cost_breakout[lines[ind]['rev_id']][month];
                                        monthly_break = true;
                                    }
                                }
                                if (monthly_break == false) {
                                    if (typeof lines[ind]['order_number'] !== 'undefined' && typeof lines[ind]['market_id'] !== 'undefined' && typeof order_revision_valids[lines[ind]['order_number']] !== 'undefined' && typeof order_revision_valids[lines[ind]['order_number']][lines[ind]['market_id']] !== 'undefined') {
                                        for (var rev_id_index in order_revision_valids[lines[ind]['order_number']][lines[ind]['market_id']]) {
                                            if (typeof monthly_cost_breakout[rev_id_index] !== 'undefined') {
                                                if (typeof monthly_cost_breakout[rev_id_index][month] !== 'undefined') {
                                                    cost = !isNaN(parseFloat(monthly_cost_breakout[rev_id_index][month])) ? monthly_cost_breakout[rev_id_index][month] : 0;
                                                    monthly_break = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                var agency_commission = parseFloat(lines[ind]['agency_commission']);
                                if (monthly_break === false) {
                                    row['netcost_' + month] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                    row['cost_' + month] += parseFloat(cost);
                                } else {
                                    row['netcost_' + month] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                    row['cost_' + month] = parseFloat(cost);
                                }
                                var clientgross_value = typeof camp_client_gross[lines[ind]['campaign_id']] !== 'undefined' && !isNaN(parseInt(camp_client_gross[lines[ind]['campaign_id']]['value'])) ? camp_client_gross[lines[ind]['campaign_id']]['value'] : 0;
                                var client_gross = 0;
                                var cost = !isNaN(parseFloat(row['cost_' + month])) ? parseFloat(row['cost_' + month]) : 0;
                                console.log('client_gross', cost)
                                if(clientgross_value !== 0) {
                                    if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'media_gross')
                                        client_gross = cost - ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                    else if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'gross_plus_net') {
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        client_gross = n + ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                    }
                                    else if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'markup_media_net') {
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        client_gross = n *  (1 + ((1 * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100));
                                    }
                                    else{
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        var div = (100 - camp_client_gross[lines[ind]['campaign_id']]['value']) / 100;
                                        client_gross = div > 0 ? n / div : n;
                                    }

                                }
                                row['clientgross_' + month] += parseFloat(client_gross);
                                row['clientcost_' + month] += !isNaN(parseFloat(lines[ind]['months_client_cost'][month])) ? parseFloat(lines[ind]['months_client_cost'][month]) : 0;

                                var spots = parseInt(lines[ind]['months'][month]);
                                row['grp_' + month] += (!isNaN(lines[ind]['rating'])) ? parseFloat(Number(Math.round((lines[ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                row['gri_' + month] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                            }
                        }
                    }
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        row['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                        row['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;

                        if (row['media_type'] != 'radio') {
                            row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                            row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                        } else {
                            row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['cost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                            row['netcpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['netcost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                        }
                        row['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;

                        //top line
                        topLine['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
                        topLine['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;

                        if (row['media_type'] != 'radio') {
                            topLine['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                            topLine['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                        } else {
                            topLine['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['cost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                            topLine['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['netcost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                        }

                        topLine['costperclick_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['clicks_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['clicks_' + month]) : 0;

                    }
                    row['media_type'] = row['media_type'] === 'podcast_programmatic' || row['media_type'] === 'podcast_attached' ? 'podcast' : row['media_type'];
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];

                        row['cost_' + month] = parseFloat(row['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcost_' + month] = parseFloat(row['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['clientgross_' + month] = parseFloat(row['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['clientcost_' + month] = parseFloat(row['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['cpp_' + month] = parseFloat(row['cpp_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcpp_' + month] = parseFloat(row['netcpp_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['cpm_' + month] = parseFloat(row['cpm_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcpm_' + month] = parseFloat(row['netcpm_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['gri_' + month] = parseFloat(row['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        row['grp_' + month] = parseFloat(row['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        row['costperclick_' + month] = parseFloat(row['costperclick_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });

                    }

                    rowDataFlowchart.push(row);
                }
            }
        }
        console.log('rowDataAdvertiser ', rowDataAdvertiser)

        var rowDataFlowchartDetailed = [];
        for(var cam_name in flowchart_detailed){
            for(var media_type in flowchart_detailed[cam_name]) {
                for(var field in flowchart_detailed[cam_name][media_type]) {
                    var lines = flowchart_detailed[cam_name][media_type][field];
                    console.log('rowDataFlowchart_flowchart_detailed', lines)
                    var row = {
                        camp_name: cam_name,
                        media_type: typeof lines[0]['cable'] !== 'undefined' && lines[0]['cable'] === 1 ? 'cable' :  media_type,
                        detail: field,
                    };
                    for (var xx in columns_to_add) {
                        row['ads_' + columns_to_add[xx]] = 0;
                        row['clicks_' + columns_to_add[xx]] = 0;
                        row['cost_' + columns_to_add[xx]] = 0;
                        row['netcost_' + columns_to_add[xx]] = 0;
                        row['gri_' + columns_to_add[xx]] = 0;
                        row['grp_' + columns_to_add[xx]] = 0;
                        row['cpm_' + columns_to_add[xx]] = 0;
                        row['netcpm_' + columns_to_add[xx]] = 0;
                        row['cpp_' + columns_to_add[xx]] = 0;
                        row['netcpp_' + columns_to_add[xx]] = 0;
                        row['clientgross_' + columns_to_add[xx]] = 0;
                        row['clientcost_' + columns_to_add[xx]] = 0;
                        row['costperclick_' + columns_to_add[xx]] = 0;
                    }

                    for (var ind in lines) {
                        for (var xx in columns_to_add) {
                            if (typeof lines[ind]['months'][columns_to_add[xx]] !== 'undefined') {
                                var month = columns_to_add[xx];
                                row['ads_' + month] += parseInt(lines[ind]['months'][month]);
                                row['clicks_' + month] += typeof lines[ind]['months_clicks'] !== 'undefined' && typeof parseInt(lines[ind]['months_clicks'][month]) !== 'undefined' ? parseInt(lines[ind]['months_clicks'][month]) : 0;
                                row['cost_' + month] += parseFloat(lines[ind]['months_cost'][month]);
                                row['netcost_' + month] += parseFloat(lines[ind]['months_net_cost'][month]);
                                row['gri_' + month] += parseFloat(lines[ind]['months_gri'][month]);
                                row['grp_' + month] += parseFloat(lines[ind]['months_grp'][month]);
                                //row['cpm_' + month] += parseFloat(lines[ind]['months_cpm'][month]);
                               // row['netcpm_' + month] += parseFloat(lines[ind]['months_net_cpm'][month]);
                               // row['cpp_' + month] += parseFloat(lines[ind]['months_cpp'][month]);
                               // row['netcpp_' + month] += parseFloat(lines[ind]['months_net_cpp'][month]);

                                var clientgross_value = typeof camp_client_gross[lines[ind]['campaign_id']] !== 'undefined' && !isNaN(parseInt(camp_client_gross[lines[ind]['campaign_id']]['value'])) ? camp_client_gross[lines[ind]['campaign_id']]['value'] : 0;
                                var client_gross = 0;
                                var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;
                                if(clientgross_value !== 0) {
                                    if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'media_gross')
                                        client_gross = cost - ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                    else if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'gross_plus_net') {
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        client_gross = n + ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                    }
                                    else if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'markup_media_net') {
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        client_gross = n *  (1 + ((1 * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100));
                                    }
                                    else{
                                        var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                        var div = (100 - camp_client_gross[lines[ind]['campaign_id']]['value']) / 100;
                                        client_gross = div > 0 ? n / div : n;
                                    }

                                }
                                row['clientgross_' + month] += parseFloat(client_gross);
                                row['clientcost_' + month] += !isNaN(parseFloat(lines[ind]['months_client_cost'][month])) ? parseFloat(lines[ind]['months_client_cost'][month]) : 0;


                            }
                        }
                    }
                    row['media_type'] = row['media_type'] === 'podcast_programmatic' || row['media_type'] === 'podcast_attached' ? 'podcast' : row['media_type'];
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        row['gri_'+ month] = Number(Math.round((row['gri_' + month]) + 'e1') + 'e-1');
                        row['cpp_' + month] += parseFloat(row['grp_'+ month]) > 0 ? parseFloat( row['cost_' + month]) / parseFloat(row['grp_'+ month]) : 0;
                        row['netcpp_' + month] += parseFloat(row['grp_'+ month]) > 0 ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_'+ month]) : 0;
                        row['cpm_' + month] += parseFloat(row['gri_'+ month]) > 0 ? parseFloat( row['cost_' + month]) / parseFloat(row['gri_'+ month]) : 0;
                        row['netcpm_' + month] += parseFloat(row['gri_'+ month]) > 0 ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_'+ month]) : 0;

                        row['costperclick_' + month] = parseInt(row['clicks_' + month]) > 0 ? parseFloat(row['cost_' + month] ) / parseInt(row['clicks_' + month]) : 0;
                        row['cost_' + month] = parseFloat(row['cost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcost_' + month] = parseFloat(row['netcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['clientgross_' + month] = parseFloat(row['clientgross_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['clientcost_' + month] = parseFloat(row['clientcost_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['cpp_' + month] = parseFloat(row['cpp_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcpp_' + month] = parseFloat(row['netcpp_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['cpm_' + month] = parseFloat(row['cpm_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['netcpm_' + month] = parseFloat(row['netcpm_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        row['gri_' + month] = parseFloat(row['gri_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        row['grp_' + month] = parseFloat(row['grp_' + month]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        row['costperclick_' + month] = parseFloat(row['costperclick_' + month]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });

                    }
                    rowDataFlowchartDetailed.push(row);
                }
            }
        }

        //Details Tab new code
        var details_tab_array = [];
        for(var adv_name in details_tab){
            for(var camp_name in details_tab[adv_name]){
                for(var market_name in details_tab[adv_name][camp_name]){
                    for(var media_type in details_tab[adv_name][camp_name][market_name]){
                        for(var vendor_name in details_tab[adv_name][camp_name][market_name][media_type]){
                            var media = (media_type === 'ott' || media_type === 'ooh') ? media_type.toUpperCase() : media_type.charAt(0).toUpperCase() + media_type.slice(1);
                            media = (media_type === 'tv' || media_type === 'Tv' || media_type === 'television') ? 'Television' : media;
                            var lines = details_tab[adv_name][camp_name][market_name][media_type][vendor_name];
                            var row = {
                                market: market_name,
                                vendor: vendor_name,
                                media_type: media,
                                ordered_status: (lines[0]['wl_order_number'] === null || lines[0]['wl_order_number'] == '') ? 'Not Ordered' : lines[0]['wl_order_number'],
                                adv_name: adv_name,
                                camp_name: camp_name,
                            };
                            for(var xx in columns_to_add) {
                                row['ads_' + columns_to_add[xx]] = 0;
                                row['clicks_' + columns_to_add[xx]] = 0;
                                row['cost_' + columns_to_add[xx]] = 0;
                                row['netcost_' + columns_to_add[xx]] = 0;
                                row['gri_' + columns_to_add[xx]] = 0;
                                row['grp_' + columns_to_add[xx]] = 0;
                                row['cpm_' + columns_to_add[xx]] = 0;
                                row['netcpm_' + columns_to_add[xx]] = 0;
                                row['cpp_' + columns_to_add[xx]] = 0;
                                row['netcpp_' + columns_to_add[xx]] = 0;
                                row['clientgross_' + columns_to_add[xx]] = 0;
                                row['clientcost_' + columns_to_add[xx]] = 0;
                                row['costperclick_' + columns_to_add[xx]] = 0;
                            }
                            row['media_type'] = row['media_type'] === 'podcast_programmatic' || row['media_type'] === 'podcast_attached' ? 'podcast' : row['media_type'];
                            for(var ind in details_tab[adv_name][camp_name][market_name][media_type][vendor_name]) {
                                for(var xx in columns_to_add) {
                                    if(typeof lines[ind]['months'][columns_to_add[xx]] !== 'undefined'){
                                        var month = columns_to_add[xx];
                                        row['ads_' + month] += parseInt(lines[ind]['months'][month]);
                                        row['clicks_' + month] += typeof lines[ind]['months_clicks'] !== 'undefined' && typeof lines[ind]['months_clicks'][month] !== 'undefined' ? parseInt(lines[ind]['months_clicks'][month]) : 0 ;
                                        if(report_obj.buy_to_include == 'both' || report_obj.buy_to_include == 'not_ordered') {
                                            if (lines[ind]['media_type'] != "Digital" && lines[ind]['media_type'] != "radio" && lines[ind]['media_type'] != "tv" && lines[ind]['media_type'] !== "Radio" && lines[ind]['media_type'] !== "TV" && lines[ind]['media_type'] !== "podcast_attached")
                                                var cost = parseFloat(parseFloat(lines[ind]['months'][month]) * parseFloat(lines[ind]['gross_cpa']));
                                            if (lines[ind]['media_type'] == "radio" || lines[ind]['media_type'] == "tv" || lines[ind]['media_type'] == "Radio" || lines[ind]['media_type'] == "TV" || lines[ind]['media_type'] == "podcast_attached")
                                                var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;

                                            if(lines[ind]['media_type'] === "Digital" || lines[ind]['media_type'] === "digital" || lines[ind]['media_type'] === "ooh" || lines[ind]['media_type'] === "OOH"
                                                || lines[ind]['media_type'] === "other" || lines[ind]['media_type'] === "Other" || lines[ind]['media_type'] === "podcast_programmatic")
                                                var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;
                                        }
                                        else
                                            var cost = !isNaN(parseFloat(lines[ind]['months_cost'][month])) ? parseFloat(lines[ind]['months_cost'][month]) : 0;

                                        var  monthly_break = false;
                                        if(lines[ind]['media_type'] === "Digital" || lines[ind]['media_type'] === "digital" || lines[ind]['media_type'] === "ooh" || lines[ind]['media_type'] === "OOH"
                                            || lines[ind]['media_type'] === "other" || lines[ind]['media_type'] === "Other" || lines[ind]['media_type'] === "podcast_programmatic"){
                                            if(typeof lines[ind]['rev_id']!= 'undefined' && typeof monthly_cost_breakout[lines[ind]['rev_id']] !== 'undefined' && typeof monthly_cost_breakout[lines[ind]['rev_id']][month] !== 'undefined') {
                                                cost = monthly_cost_breakout[lines[ind]['rev_id']][month];
                                                monthly_break = true;
                                            }
                                        }

                                        if(monthly_break == false){
                                            if(typeof lines[ind]['order_number'] !== 'undefined' && typeof lines[ind]['market_id'] !== 'undefined' && typeof order_revision_valids[lines[ind]['order_number']] !== 'undefined' && typeof order_revision_valids[lines[ind]['order_number']][lines[ind]['market_id']] !== 'undefined'){
                                                for(var rev_id_index in order_revision_valids[lines[ind]['order_number']][lines[ind]['market_id']]){
                                                    if(typeof monthly_cost_breakout[rev_id_index] !== 'undefined'){
                                                        if(typeof monthly_cost_breakout[rev_id_index][month] !== 'undefined') {
                                                            cost = !isNaN(parseFloat(monthly_cost_breakout[rev_id_index][month])) ? monthly_cost_breakout[rev_id_index][month] : 0;
                                                            monthly_break = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        if(isNaN(parseFloat(cost))){
                                            cost = cost.replace('$', '');
                                            cost = cost.replace(/,/g, '');
                                        }
                                        var agency_commission = parseFloat(lines[ind]['agency_commission']);
                                        if(monthly_break === false ){
                                            row['netcost_' + month] += parseFloat((cost) - ((cost * agency_commission) / 100));
                                            row['cost_' + month] += parseFloat(cost);
                                        }
                                        else{
                                            row['netcost_' + month] = parseFloat((cost) - ((cost * agency_commission) / 100));
                                            row['cost_' + month] = parseFloat(cost);
                                        }
                                        var spots = parseInt(lines[ind]['months'][month]);
                                        row['grp_' + month] += (!isNaN(lines[ind]['rating'])) ? parseFloat(Number(Math.round((lines[ind]['rating']) + 'e1') + 'e-1') * spots) : 0;
                                        row['gri_' + month] += (!isNaN(lines[ind]['impressions'])) ? parseFloat(Number(Math.round((lines[ind]['impressions']) + 'e1') + 'e-1') * spots) : 0;
                                        var clientgross_value = typeof camp_client_gross[lines[ind]['campaign_id']] !== 'undefined' && !isNaN(parseInt(camp_client_gross[lines[ind]['campaign_id']]['value'])) ? camp_client_gross[lines[ind]['campaign_id']]['value'] : 0;
                                        var client_gross = 0;
                                        var cost = !isNaN(parseFloat(row['cost_' + columns_to_add[xx]])) ? row['cost_' + columns_to_add[xx]] : 0;
                                        if(clientgross_value !== 0) {
                                            if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'media_gross')
                                                client_gross = cost - ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                            else if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'gross_plus_net') {
                                                var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                                client_gross = n + ((cost * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100);
                                            }
                                            else if(camp_client_gross[lines[ind]['campaign_id']]['type'] === 'markup_media_net') {
                                                var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                                client_gross = n *  (1 + ((1 * camp_client_gross[lines[ind]['campaign_id']]['value']) / 100));
                                            }
                                            else{
                                                var n = parseFloat((cost) - ((cost * agency_commission) / 100));
                                                var div = (100 - camp_client_gross[lines[ind]['campaign_id']]['value']) / 100;
                                                client_gross = div > 0 ? n / div : n;
                                            }

                                        }
                                        row['clientgross_' + month] += parseFloat(parseFloat(client_gross).toFixed(2));

                                        var client_cost = !isNaN(parseFloat(lines[ind]['months_client_cost'][month])) ? parseFloat(lines[ind]['months_client_cost'][month]) : 0;
                                        client_cost = parseFloat(parseFloat(client_cost).toFixed(2));
                                        row['clientcost_' + month] += client_cost;
                                    }
                                }
                                for(var xx in columns_to_add) {
                                    var month = columns_to_add[xx];
                                    row['cpp_'+month] = (!isNaN(parseFloat(row['cost_'+month])) && parseFloat(row['grp_'+month]) > 0) ? parseFloat(row['cost_'+month]) / parseFloat(row['grp_'+month]) : 0;
                                    row['netcpp_'+month] = (!isNaN(parseFloat(row['netcost_'+month])) && parseFloat(row['grp_'+month]) > 0) ? parseFloat(row['netcost_'+month]) / parseFloat(row['grp_'+month]) : 0;

                                    if(row['media_type'] != 'radio') {
                                        row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                                        row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gri_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gri_' + month]) : 0;
                                    } else {
                                        row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['cost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                                        row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && (parseFloat(row['gri_' + month]) / 10) > 0) ? parseFloat(row['netcost_' + month]) / (parseFloat(row['gri_' + month] / 10)) : 0;
                                    }
                                    row['costperclick_' + month] = (!isNaN(parseFloat(row['cost_'+month])) && parseFloat(row['clicks_'+month]) > 0) ? parseFloat(row['cost_'+month]) / parseFloat(row['clicks_'+month]) : 0;

                                }
                            }
                            details_tab_array.push(row);
                        }
                    }
                }
            }
        }
        for(var ind in details_tab_array){
            var row = details_tab_array[ind];
            for(var xx in columns_to_add) {
                var month = columns_to_add[xx];
                row['cost_' + month] = parseFloat(row['cost_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcost_' + month] = parseFloat(row['netcost_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['clientgross_' + month] = parseFloat(row['clientgross_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['clientcost_' + month] = parseFloat(row['clientcost_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpp_'+month] =  parseFloat(row['cpp_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcpp_'+month] =  parseFloat(row['netcpp_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpm_'+month] =  parseFloat(row['cpm_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['netcpm_'+month] =  parseFloat(row['netcpm_'+month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['gri_'+month] =  parseFloat(row['gri_'+month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['grp_'+month] =  parseFloat(row['grp_'+month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['costperclick_' + month] = parseFloat(row['costperclick_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            }
            row['media_type'] = row['media_type'] === 'podcast_programmatic' || row['media_type'] === 'podcast_attached' ? 'Podcast' : row['media_type'];
            row['media_type'] = row['media_type'] === 'Podcast_programmatic' || row['media_type'] === 'Podcast_attached' ? 'Podcast' : row['media_type'];
            rowDataDetails.push(row);
        }


        fill_summary_totals(totals_makets);

        function fillTopLine(grid, type){
            console.log('grid_type', type)
            var floating_top_row_new = { };
            for (var xx in columns_to_add){
                floating_top_row_new['ads_' + columns_to_add[xx]] = 0;
                floating_top_row_new['clicks_' + columns_to_add[xx]] = 0;
                floating_top_row_new['cost_' + columns_to_add[xx]] = 0;
                floating_top_row_new['netcost_' + columns_to_add[xx]] = 0;
                floating_top_row_new['clientgross_' + columns_to_add[xx]] = 0;
                floating_top_row_new['clientcost_' + columns_to_add[xx]] = 0;
                floating_top_row_new['gri_' + columns_to_add[xx]] = 0;
                floating_top_row_new['grp_' + columns_to_add[xx]] = 0;
                floating_top_row_new['gricpm_' + columns_to_add[xx]] = 0;
            }
            grid.api.forEachNodeAfterFilterAndSort(function(value) {
                console.log('node filter', value);
                if (value.level === type ) {
                    for (var xx in columns_to_add) {
                        var month = columns_to_add[xx];
                        floating_top_row_new['ads_' + month] += value['data']['ads_' + month];
                        floating_top_row_new['clicks_' + month] += value['data']['clicks_' + month];

                        var sum = value['data']['cost_' + month].replace('$', '');
                        sum = sum.replace(/,/g, '');
                        floating_top_row_new['cost_' + month] += parseFloat(sum);

                        var sum = value['data']['netcost_' + month].replace('$', '');
                        sum = sum.replace(/,/g, '');
                        floating_top_row_new['netcost_' + month] += parseFloat(sum);

                        var sum = value['data']['clientgross_' + month].replace('$', '');
                        sum = sum.replace(/,/g, '');
                        floating_top_row_new['clientgross_' + month] += parseFloat(sum);

                        var sum = value['data']['clientcost_' + month].replace('$', '');
                        sum = sum.replace(/,/g, '');
                        floating_top_row_new['clientcost_' + month] += parseFloat(sum);

                        var sum = value['data']['gri_' + month].replace(/,/g, '');
                        floating_top_row_new['gri_' + month] += parseFloat(sum);
                        if (value['data']['media_type'] == 'radio')
                            floating_top_row_new['gricpm_' + month] += parseFloat(sum) / 10;
                        else
                            floating_top_row_new['gricpm_' + month] += parseFloat(sum);
                        var sum = value['data']['grp_' + month].replace(/,/g, '');
                        floating_top_row_new['grp_' + month] += parseFloat(sum);
                    }
                }
            });
            for (var xx in columns_to_add) {
                var month = columns_to_add[xx];
                floating_top_row_new['cpp_' + month] = (!isNaN(parseFloat(floating_top_row_new['cost_' + month])) && parseFloat(floating_top_row_new['grp_' + month]) > 0) ? parseFloat(floating_top_row_new['cost_' + month]) / parseFloat(floating_top_row_new['grp_' + month]) : 0;
                floating_top_row_new['netcpp_' + month] = (!isNaN(parseFloat(floating_top_row_new['netcost_' + month])) && parseFloat(floating_top_row_new['grp_' + month]) > 0) ? parseFloat(floating_top_row_new['netcost_' + month]) / parseFloat(floating_top_row_new['grp_' + month]) : 0;
                floating_top_row_new['cpm_' + month] = (!isNaN(parseFloat(floating_top_row_new['cost_' + month])) && parseFloat(floating_top_row_new['gricpm_' + month]) > 0) ? parseFloat(floating_top_row_new['cost_' + month]) / parseFloat(floating_top_row_new['gricpm_' + month]) : 0;
                floating_top_row_new['netcpm_' + month] = (!isNaN(parseFloat(floating_top_row_new['netcost_' + month])) && parseFloat(floating_top_row_new['gricpm_' + month]) > 0) ? parseFloat(floating_top_row_new['netcost_' + month]) / parseFloat(floating_top_row_new['gricpm_' + month]) : 0;
                floating_top_row_new['costperclick_' + month] = (!isNaN(parseFloat(floating_top_row_new['cost_' + month])) && parseFloat(floating_top_row_new['clicks_' + month]) > 0) ? parseFloat(floating_top_row_new['cost_' + month]) / parseFloat(floating_top_row_new['clicks_' + month]) : 0;

                floating_top_row_new['cost_' + month] = parseFloat(floating_top_row_new['cost_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['netcost_' + month] = parseFloat(floating_top_row_new['netcost_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['clientgross_' + month] = parseFloat(floating_top_row_new['clientgross_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['clientcost_' + month] = parseFloat(floating_top_row_new['clientcost_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['cpp_' + month] = parseFloat(floating_top_row_new['cpp_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['netcpp_' + month] = parseFloat(floating_top_row_new['netcpp_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['cpm_' + month] = parseFloat(floating_top_row_new['cpm_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['netcpm_' + month] = parseFloat(floating_top_row_new['netcpm_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                floating_top_row_new['gri_' + month] = parseFloat(floating_top_row_new['gri_' + month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                floating_top_row_new['grp_' + month] = parseFloat(floating_top_row_new['grp_' + month]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                floating_top_row_new['ads_' + month] = parseFloat(floating_top_row_new['ads_' + month])
                floating_top_row_new['costperclick_' + month] = parseFloat(floating_top_row_new['costperclick_' + month]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            }
            console.log()
            grid.api.setPinnedTopRowData(
                [ floating_top_row_new ]
            );
            console.log('floating_top_row filter ', floating_top_row_new)
        };
        var orderBy = [ 'market', 'vendor'];
        var sorted = multisort(rowData, orderBy)
        gridCampBreakout.rowData = sorted;

        var orderBy = [ 'market', 'vendor'];
        var sorted = multisort(rowDataAdvertiser, orderBy)
        gridCampBreakoutAdvertiser.rowData = sorted;

        var orderBy = [ 'adv_name', 'camp_name'];
        var sorted = multisort(rowDataDetails, orderBy)
        gridCampBreakoutDetails.rowData = sorted;

        var orderBy = [ 'camp_name', 'market', 'media_type'];
        var sorted = multisort(rowDataFlowchart, orderBy)
        gridCampBreakoutFlowchart.rowData = sorted;

        var orderBy = [ 'camp_name', 'media_type', 'detail'];
        var sorted = multisort(rowDataFlowchartDetailed, orderBy)
        griDetailedFlowchart.rowData = sorted;

        $('#myGridBreakout').html('');
        var gridCampBreakoutX = document.querySelector('#myGridBreakout');
        var grid = new agGrid.Grid(gridCampBreakoutX, gridCampBreakout);

        $('#myGridBreakoutAdvertiser').html('');
        var gridCampBreakoutXX = document.querySelector('#myGridBreakoutAdvertiser');
        var grid = new agGrid.Grid(gridCampBreakoutXX, gridCampBreakoutAdvertiser);

        $('#myGridBreakoutDetails').html('');
        var gridCampBreakoutXX = document.querySelector('#myGridBreakoutDetails');
        var grid = new agGrid.Grid(gridCampBreakoutXX, gridCampBreakoutDetails);

        $('#myGridBreakoutFlowchart').html('');
        var gridCampBreakoutXXX = document.querySelector('#myGridBreakoutFlowchart');
        var grid = new agGrid.Grid(gridCampBreakoutXXX, gridCampBreakoutFlowchart);

        $('#myGridBreakoutFlowchartDetailed').html('');
        var gridCampBreakoutXXXX = document.querySelector('#myGridBreakoutFlowchartDetailed');
        var grid = new agGrid.Grid(gridCampBreakoutXXXX, griDetailedFlowchart);


        var floating_top_row = { };
        var row = topLine;
        for (var xx in columns_to_add) {
            var month = columns_to_add[xx];
            floating_top_row['cpp_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['grp_' + month]) : 0;
            floating_top_row['netcpp_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['grp_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['grp_' + month]) : 0;
            floating_top_row['cpm_' + month] = (!isNaN(parseFloat(row['cost_' + month])) && parseFloat(row['gricpm_' + month]) > 0) ? parseFloat(row['cost_' + month]) / parseFloat(row['gricpm_' + month]) : 0;
            floating_top_row['netcpm_' + month] = (!isNaN(parseFloat(row['netcost_' + month])) && parseFloat(row['gricpm_' + month]) > 0) ? parseFloat(row['netcost_' + month]) / parseFloat(row['gricpm_' + month]) : 0;

            floating_top_row['cost_' + month] = parseFloat( isNaN(parseFloat(row['cost_' + month])) ? 0 : row['cost_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['netcost_' + month] = parseFloat(isNaN(parseFloat(row['netcost_' + month])) ? 0 : row['netcost_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['clientgross_' + month] = parseFloat(isNaN(parseFloat(row['clientgross_' + month])) ? 0 : row['netcost_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['clientcost_' + month] = parseFloat(isNaN(parseFloat(row['clientcost_' + month])) ? 0 : row['clientcost_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['cpp_' + month] = parseFloat(isNaN(parseFloat(row['cpp_' + month])) ? 0 : row['cpp_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['netcpp_' + month] = parseFloat(isNaN(parseFloat(row['netcpp_' + month])) ? 0 : row['netcpp_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['cpm_' + month] = parseFloat(isNaN(parseFloat(row['cpm_' + month])) ? 0 : row['cpm_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['netcpm_' + month] = parseFloat(isNaN(parseFloat(row['netcpm_' + month])) ? 0 : row['netcpm_' + month]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            floating_top_row['gri_' + month] = parseFloat(isNaN(parseFloat(row['gri_' + month])) ? 0 : row['gri_' + month]).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            floating_top_row['grp_' + month] = parseFloat(isNaN(parseFloat(row['grp_' + month])) ? 0 : row['grp_' + month]).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            floating_top_row['ads_' + month] = parseInt(isNaN(parseInt(row['ads_' + month])) ? 0 : row['ads_' + month]);
        }

        gridCampBreakout.api.setPinnedTopRowData(
            [ floating_top_row ]
        );

        gridCampBreakoutAdvertiser.api.setPinnedTopRowData(
            [ floating_top_row ]
        );
        gridCampBreakoutDetails.api.setPinnedTopRowData(
            [ floating_top_row ]
        );

        //fill first tab grids
        function fill_summary_totals(totals_fill){
            var rowData = [];
            for(var market_name in totals_fill['market']) {
                var values = totals_fill['market'][market_name];
                rowData.push(values);
            }
            console.log('row Data markets', rowData);
            gridMarketTotals.rowData = [];
            var orderBy = [ 'market'];
            var sorted = multisort(rowData, orderBy)
            gridMarketTotals.rowData = sorted;
            $('#myGridMarketTotals').html('');
            var gridCampBreakoutX = document.querySelector('#myGridMarketTotals');
            var grid = new agGrid.Grid(gridCampBreakoutX, gridMarketTotals);

            var rowData = [];
            for(var vendor_name in totals_fill['vendor']){
                var values = totals_fill['vendor'][vendor_name];
                rowData.push(values);
            }
            console.log('row Data vendors', rowData);
            gridVendorTotals.rowData = [];
            var orderBy = [ 'vendor'];
            var sorted = multisort(rowData, orderBy)
            gridVendorTotals.rowData = sorted;

            $('#myGridVendorTotals').html('');
            var gridCampBreakoutX = document.querySelector('#myGridVendorTotals');
            var grid = new agGrid.Grid(gridCampBreakoutX, gridVendorTotals);
        };

        //Export details second/third/four/five Tab
        $('.export_camp_deta').on('click', function () {
            show_loader();
            var type = $(this).attr('data');
            var style = $(this).attr('data-style');
            var tab = $(this).attr('data-tab');
            var html_table = '<table class="table table-bordered table-striped table-condensed" >';
            var html_table_end = '</table>';
            var html = '';
            if (tab === 'market')
                var grid = gridCampBreakout;
            else if (tab === 'advertiser')
                var grid = gridCampBreakoutAdvertiser;
            else if (tab === 'flowchart')
                var grid = gridCampBreakoutFlowchart;
            else if (tab === 'flowchart_det')
                var grid = griDetailedFlowchart;
            else
                var grid = gridCampBreakoutDetails;
            var selectedItems = [];
            $('.all_more_options_totals  input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            console.log('selectedItems', selectedItems)
            var html_header = '';
            var html_body = '';
            var colspan = 2;
            var col_allowed = [];
            var group_allowed = [];
            var groups = 0;
            var colspan_group = 0;
            var columns_ads = [];
            var flowchart_color = { ooh: '#DFDFFF', ott: '#D2F0FF', tv: '#C7F5F4', radio: '#EFCEF7', mail: '#FFDDDD', print: '#DCF38F', digital: '#F3D1A2', other: '#FFFFCC' , cable: '#FAEDF5', podcast: '#D4E4E7'}
            var flowchart_media_type = { ooh: 'OOH', ott: 'OTT JamLoop', tv: 'Television', radio: 'Radio', mail: 'Mail', print: 'Print', digital: 'Digital', other: 'Other', cable: 'Cable', podcast: 'Podcast' }


            if (tab === 'market') {
                $('.hide-column-client-activity-details-group a').each(function () {
                    if ($(this).hasClass('hidden-column') == false) {
                        groups++;
                        group_allowed.push($(this).attr('data-col'))
                    }
                });
            }
            else if (tab === 'advertiser') {
                $('.hide-column-client-activity-details-group-advertiser a').each(function () {
                    if ($(this).hasClass('hidden-column') == false) {
                        groups++;
                        group_allowed.push($(this).attr('data-col'))
                    }
                });
            }
            else if (tab === 'flowchart') {
                $('.hide-column-client-activity-details-group-flowchart-tab a').each(function () {
                    if ($(this).hasClass('hidden-column') == false) {
                        groups++;
                        group_allowed.push($(this).attr('data-col'))
                    }
                });
            }else if (tab === 'flowchart_det') {
                $('.hide-column-client-activity-details-group-flowchart_det-tab a').each(function () {
                    if ($(this).hasClass('hidden-column') == false) {
                        groups++;
                        group_allowed.push($(this).attr('data-col'))
                    }
                });
            }
            else {
                $('.hide-column-client-activity-details-group-details-tab a').each(function () {
                    if ($(this).hasClass('hidden-column') == false) {
                        groups++;
                        group_allowed.push($(this).attr('data-col'))
                    }
                });
            }

            for (var xx in group_allowed) {
                var month = group_allowed[xx];
                if (tab === 'market') {
                    if (!$('.hide-column-client-activity-details .ads').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('ads_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('ADS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .cost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .clientgross').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientgross_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT GROSS (WMJ)');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .clientcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .netcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .grp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('grp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .gri').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('gri_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRI');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .clicks').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clicks_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLICKS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details .costperclick').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('costperclick_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST PER CLICK');
                        }
                    }
                }
                else if (tab === 'advertiser') {
                    if (!$('.hide-column-client-activity-details-advertiser .ads').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('ads_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('ADS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .cost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser .clientgross').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientgross_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT GROSS (WMJ)');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser .clientcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .netcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .grp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('grp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .gri').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('gri_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRI');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser  .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser .clicks').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clicks_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLICKS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-advertiser .costperclick').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('costperclick_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST PER CLICK');
                        }
                    }
                }
                else if (tab === 'details') {
                    if (!$('.hide-column-client-activity-details-for-tab .ads').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('ads_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('ADS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab  .cost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab  .clientgross').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientgross_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT GROSS (WMJ)');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab  .clientcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .netcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .grp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('grp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .gri').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('gri_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRI');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .clicks').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clicks_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLICKS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-tab .costperclick').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('costperclick_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST PER CLICK');
                        }
                    }
                }
                else if (tab === 'flowchart') {
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .ads').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('ads_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('ADS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab  .cost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .clientgross').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientgross_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT GROSS (WMJ)');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .clientcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .netcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .grp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('grp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .gri').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('gri_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRI');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .clicks').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clicks_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLICKS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart-tab .costperclick').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('costperclick_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST PER CLICK');
                        }
                    }
                }
                else if (tab === 'flowchart_det') {
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .ads').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('ads_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('ADS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab  .cost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .clientgross').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientgross_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT GROSS (WMJ)');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .clientcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clientcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLIENT COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .netcost').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcost_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET COST');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .grp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('grp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .gri').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('gri_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('GRI');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .cpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .netcpp').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpp_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPP');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .cpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('cpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .netcpm').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('netcpm_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('NET CPM');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .clicks').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('clicks_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('CLICKS');
                        }
                    }
                    if (!$('.hide-column-client-activity-details-for-flowchart_det-tab .costperclick').hasClass('hidden-column')) {
                        colspan++;
                        col_allowed.push('costperclick_' + month);
                        if (xx == 0) {
                            colspan_group++;
                            columns_ads.push('COST PER CLICK');
                        }
                    }
                }
            }

            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"><b>SMART  REPORT:  SPEND SUMMARY (' + time_period_type.toUpperCase() + ') </b></td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"><b>DATE RANGE:</b> ' + report_fd_header + ' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"><b>CALENDAR TYPE:</b> ' + flag_type + ' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"><b>AGENCY: </b> ' + agency_name + ' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"><b>CLIENT: </b> ' + advertisers_name + ' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"><b>MEDIA TYPE: </b> ' + media_type_string + ' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"></td></tr></table>';
            var bk = (tab !== 'flowchart' && tab !== 'flowchart_det') ? 'black' : '#808080';
            html_body += '<table style="width: 100%;"><tr style="background: '+ bk +';  color: white"><th></th><th></th>';

            if (tab === 'market' && !$('.hide-column-client-activity-details .ordered_status').hasClass('hidden-column'))
                html_body += '<th></th>';
            if (tab === 'advertiser' && !$('.hide-column-client-activity-details-advertiser .ordered_status').hasClass('hidden-column'))
                html_body += '<th></th>';
            if (tab === 'details' && !$('.hide-column-client-activity-details-for-tab .ordered_status').hasClass('hidden-column'))
                html_body += '<th></th>';
            for (var ind in group_allowed) {
                var bk = (tab !== 'flowchart' && tab !== 'flowchart_det') ? '#373737' : '#808080';
                if (group_allowed[ind] != 'total')
                    html_body += '<th  style="background: '+ bk  +'; color: white" colspan="' + colspan_group + '">' + group_allowed[ind] + '</th>';
                else
                    html_body += '<th  style="background: '+ bk +'; color: white" colspan="' + colspan_group + '"> TOTALS</th>';
            }

            html_body += '</tr>';
            var bk = (tab !== 'flowchart' && tab !== 'flowchart_det') ? 'black' : '#D0CECE';
            var cl = (tab !== 'flowchart' && tab !== 'flowchart_det') ? 'white' : 'black';
            var br = (tab !== 'flowchart' && tab !== 'flowchart_det') ? '' : '; border-bottom: 1px solid black';
            html_body += '<tr style="background: '+ bk +'; color: '+ cl +' '+ br +'">' ;
            if (tab !== 'flowchart' && tab !== 'flowchart_det' && show_length_breakout === 0)
                html_body +='<td>' + tab.toUpperCase() + '</td><td>VENDOR</td>';
            else if(tab === 'advertiser' && show_length_breakout === 1)
                html_body +='<td>' + tab.toUpperCase() + '</td><td>LENGTH</td>';
            else if(tab === 'flowchart_det')
                html_body +='<td>DETAILED FLOWCHART</td><td>DETAIL</td>';
            else
                html_body +='<td><b>' + tab.toUpperCase() + '</b></td><td><b>MEDIA TYPE&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b></td>';

            if (tab === 'market' && !$('.hide-column-client-activity-details .ordered_status').hasClass('hidden-column'))
                html_body += '<td>Ordering Status</td>';
            if (tab === 'advertiser' && !$('.hide-column-client-activity-details-advertiser .ordered_status').hasClass('hidden-column'))
                html_body += '<td>Ordering Status</td>';
            if (tab === 'details' && !$('.hide-column-client-activity-details-for-tab .ordered_status').hasClass('hidden-column'))
                html_body += '<td>Ordering Status</td>';

            var i = 0;
            while (i < groups) {
                for (var ind in columns_ads) {
                    if (tab !== 'flowchart' && tab !== 'flowchart_det')
                        html_body += '<td style="text-align: center">&nbsp;&nbsp;' + columns_ads[ind] + '&nbsp;&nbsp;</td>';
                    else
                        html_body += '<td style="text-align: center"><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + columns_ads[ind] + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b></td>';
                }
                i++;
            }
            html_body += '</tr>';

            var ordered_status_visible = false;
            if (tab === 'market' || (tab === 'advertiser' && show_length_breakout === 0)) {
                var values_to_export = [];
                grid.api.forEachNodeAfterFilterAndSort(function (node) {
                    if (node.level == 1) {
                        if (typeof values_to_export[node.data.market] === 'undefined' && node.data.market != "") {
                            values_to_export[node.data.market] = [];
                            values_to_export[node.data.market]['details'] = [];
                            values_to_export[node.data.market]['totals'] = [];
                        }

                        if (node.data.market != "") {
                            var row = {};
                            row['vendor'] = node.data.vendor;
                            row['ordered_status'] = node.data.ordered_status;
                            for (var ind in col_allowed)
                                row[col_allowed[ind]] = node.data[col_allowed[ind]];
                            values_to_export[node.data.market]['details'].push(row);

                        }

                    }
                    if (node.level == 0) {
                        if (typeof values_to_export[node.key] === 'undefined') {
                            values_to_export[node.key] = [];
                            values_to_export[node.key]['details'] = [];
                            values_to_export[node.key]['totals'] = [];
                        }
                        var row = {};
                        row['vendor'] = '';
                        for (var ind in col_allowed)
                            row[col_allowed[ind]] = node.aggData[col_allowed[ind]];

                        values_to_export[node.key]['totals'] = row;

                    }
                });
                var floating_top_row = grid.api.pinnedRowModel.pinnedTopRows[0].data;
                html_body += '<tr style="background-color: #c3b091; color: black !important; text-align: center;"><td></td><td></td>';
                if (tab === 'market' && !$('.hide-column-client-activity-details .ordered_status').hasClass('hidden-column')) {
                    html_body += '<td></td>';
                    ordered_status_visible = true;
                }
                else if (tab === 'advertiser' && !$('.hide-column-client-activity-details-advertiser .ordered_status').hasClass('hidden-column')) {
                    html_body += '<td></td>';
                    ordered_status_visible = true;
                }
                for (var ind in col_allowed)
                    html_body += '<td style="text-align: center;">' + floating_top_row[col_allowed[ind]] + '</td>';
                html_body += '</tr>';
                for (var market_name in values_to_export) {
                    html_body += '<tr><td>' + market_name + '</td>';
                    html_body += '<td> </td>';
                    if (tab === 'market' && !$('.hide-column-client-activity-details .ordered_status').hasClass('hidden-column'))
                        html_body += '<td></td>';
                    if (tab === 'advertiser' && !$('.hide-column-client-activity-details-advertiser .ordered_status').hasClass('hidden-column'))
                        html_body += '<td></td>';
                    for (var ind in col_allowed)
                        html_body += '<td style="text-align: center;">' + values_to_export[market_name]['totals'][col_allowed[ind]] + '</td>';
                    html_body += '</tr>';
                    for (var ind in values_to_export[market_name]['details']) {
                        var value = values_to_export[market_name]['details'][ind];
                        html_body += '<tr><td></td>';
                        html_body += '<td>' + value['vendor'] + ' </td>';
                        if (tab === 'market' && !$('.hide-column-client-activity-details .ordered_status').hasClass('hidden-column'))
                            html_body += '<td>' + value['ordered_status'] + ' </td>';
                        if (tab === 'advertiser' && !$('.hide-column-client-activity-details-advertiser .ordered_status').hasClass('hidden-column'))
                            html_body += '<td>' + value['ordered_status'] + ' </td>';
                        for (var ind in col_allowed)
                            html_body += '<td style="text-align: center;">' + value[col_allowed[ind]] + '</td>';
                        html_body += '</tr>';
                    }
                }
                if (flag_count === true) {
                    var xd = '<span style="color:#f15925; ">  (' + flag_t + ') </span> <span style="color:#f15925; font-style: italic">  ' +
                        ' Please note, this buy was placed in a ' + flag_type_no + ' so the time periods noted in the column headers might appear incorrect. </span>';

                    html_body += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"> ' + xd + '</td></tr></table>';
                }
            }
            else if (tab === 'flowchart') {
                var top_row = grid.api.pinnedRowModel.pinnedTopRows[0].data;
                floating_top_row = top_row;
                var values_to_export = [];
                grid.api.forEachNodeAfterFilterAndSort(function (node) {
                    console.log('node_node ', node);
                    if (node.level === 0) {
                        //Campaign Level
                        console.log('campaign_level_value', node)
                        var row = {};
                        row['level'] = 'campaign';
                        row['media_type'] = '';
                        row['campaign'] = node.key;
                        row['market'] = '';
                        row['colspan'] = 0;
                        for (var ind in col_allowed)
                            row[col_allowed[ind]] = node.aggData[col_allowed[ind]];
                        values_to_export.push(row);

                        $.each(node.childrenAfterGroup, function (index, value) {
                            console.log('market_level_value', value)
                            //Market Level
                            var row = {};
                            row['level'] = 'market';
                            row['media_type'] = '';
                            row['campaign'] =  ''
                            row['adv_name'] = '';
                            row['market'] = value.key;
                            row['colspan'] = 2;
                            for (var ind in col_allowed)
                                row[col_allowed[ind]] = value.aggData[col_allowed[ind]];
                            values_to_export.push(row);
                            $.each(value.childrenAfterGroup, function (index, value) {
                                // lines
                                console.log('lines value', value);
                                var row = {};
                                row['level'] = 'lines';
                                row['media_type'] = value.data['media_type'];
                                row['campaign'] = '';
                                row['lines'] = '';
                                for (var ind in col_allowed)
                                    row[col_allowed[ind]] = value.data[col_allowed[ind]];
                                values_to_export.push(row);
                            });


                        });
                    }
                });

                html_body += '<tr style="; color: black !important; text-align: center;"><td colspan=""></td><td colspan=""></td>';
                ordered_status_visible = false;
                for (var ind in col_allowed)
                    html_body += '<td style="text-align: center;">' + top_row[col_allowed[ind]] + '</td>';
                html_body += '</tr>';
                console.log('columns_ads_columns_ads', columns_ads);
                for(var ind in values_to_export) {
                    var row = values_to_export[ind];
                  //  var style_tr = ind % 2 !== 0 ? 'background-color: #F6F6F6;' : '';
                    var style_tr  = '';
                    html_body += '<tr style="' + style_tr + '">';
                    if(row['level'] === 'campaign')
                        html_body += '<td>&nbsp;&nbsp;&raquo;&nbsp;'+row[row['level']]+'</td><td></td>';
                    else if(row['level'] === 'market')
                        html_body += '<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&raquo;&nbsp;&nbsp;&nbsp;&nbsp;'+row[row['level']]+'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td></td>';
                    else if(row['level'] === 'lines')
                        html_body += '<td></td><td>' + flowchart_media_type[row.media_type] + '</td>';

                    for (var col_ind in col_allowed) {
                        console.log('row_row_row_row_ ', row);
                        var style_c = '';
                        var field = col_allowed[col_ind].split('_');
                        if(typeof field[1] !== 'undefined') {
                            console.log('field[1] ', field[1], row)
                            var sum = row['cost_' + field[1]].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            style_c = row['ads_' + field[1]] > 0 || sum > 0 ? 'background-color: ' + flowchart_color[row.media_type] + ';' : '';
                        }
                        html_body += '<td style="text-align: center; '+ style_c+'">' + row[col_allowed[col_ind]] + '</td>';
                    }
                    html_body += '</tr>';
                }
            }
            else if (tab === 'advertiser' && show_length_breakout === 1) {
                var top_row = grid.api.pinnedRowModel.pinnedTopRows[0].data;
                floating_top_row = top_row;
                var values_to_export = [];
                grid.api.forEachNodeAfterFilterAndSort(function (node) {
                    console.log('node_node ', node);
                    if (node.level === 0) {
                        //Campaign Level
                        console.log('campaign_level_value', node)
                        var row = {};
                        row['level'] = 'market';
                        row['length'] = '';
                        row['market'] = node.key;
                        row['vendor'] = '';
                        row['colspan'] = 0;
                        row['ordered_status'] = '';
                        for (var ind in col_allowed)
                            row[col_allowed[ind]] = node.aggData[col_allowed[ind]];
                        values_to_export.push(row);

                        $.each(node.childrenAfterGroup, function (index, value) {
                            console.log('market_level_value', value)
                            //Market Level
                            var row = {};
                            row['level'] = 'vendor';
                            row['length'] = '';
                            row['market'] =  ''
                            //row['adv_name'] = '';
                            row['vendor'] = value.key;
                            row['colspan'] = 2;
                            row['ordered_status'] = '';
                            for (var ind in col_allowed)
                                row[col_allowed[ind]] = value.aggData[col_allowed[ind]];
                            values_to_export.push(row);
                            $.each(value.childrenAfterGroup, function (index, value) {
                                // lines
                                console.log('lines value', value);
                                var row = {};
                                row['level'] = 'lines';
                                row['length'] = value.data['length'];
                                row['vendor'] = '';
                                row['market'] = '';
                                row['lines'] = '';
                                row['ordered_status'] = value.data['ordered_status'];;
                                for (var ind in col_allowed)
                                    row[col_allowed[ind]] = value.data[col_allowed[ind]];
                                values_to_export.push(row);
                            });


                        });
                    }
                });

                html_body += '<tr style="; color: black !important; text-align: center;"><td colspan=""></td><td colspan=""></td>';

                if (!$('.hide-column-client-activity-details-advertiser .ordered_status').hasClass('hidden-column'))
                    html_body += '<td></td>';
                for (var ind in col_allowed)
                    html_body += '<td style="text-align: center;">' + top_row[col_allowed[ind]] + '</td>';
                html_body += '</tr>';
                console.log('columns_ads_columns_ads', columns_ads);
                for(var ind in values_to_export) {
                    var row = values_to_export[ind];
                  //  var style_tr = ind % 2 !== 0 ? 'background-color: #F6F6F6;' : '';
                    var style_tr  = '';
                    html_body += '<tr style="' + style_tr + '">';
                    if(row['level'] === 'market')
                        html_body += '<td>&nbsp;&nbsp;&raquo;&nbsp;'+row[row['level']]+'</td><td></td>';
                    else if(row['level'] === 'vendor')
                        html_body += '<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&raquo;&nbsp;&nbsp;&nbsp;&nbsp;'+ row[row['level']] +'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td></td>';
                    else if(row['level'] === 'lines')
                        html_body += '<td></td><td>' + row.length + '</td>';

                    if (!$('.hide-column-client-activity-details-advertiser .ordered_status').hasClass('hidden-column'))
                        html_body += '<td>'+ row['ordered_status'] +'</td>';

                    for (var col_ind in col_allowed) {
                        console.log('row_row_row_row_ ', row);
                        var style_c = '';
                        var field = col_allowed[col_ind].split('_');
                        if(typeof field[1] !== 'undefined') {
                            console.log('field[1] ', field[1], row)
                            var sum = row['cost_' + field[1]].replace('$', '');
                            sum = sum.replace(/,/g, '');
                           // style_c = row['ads_' + field[1]] > 0 || sum > 0 ? 'background-color: ' + flowchart_color[row.media_type] + ';' : '';
                        }
                        html_body += '<td style="text-align: center;">' + row[col_allowed[col_ind]] + '</td>';
                    }
                    html_body += '</tr>';
                }
            }
            else if (tab === 'flowchart_det') {
                var top_row = grid.api.pinnedRowModel.pinnedTopRows[0].data;
                floating_top_row = top_row;
                var values_to_export = [];
                grid.api.forEachNodeAfterFilterAndSort(function (node) {
                    console.log('node_node ', node);
                    if (node.level === 0) {
                        //Campaign Level
                        console.log('campaign_level_value', node)
                        var row = {};
                        row['level'] = 'campaign';
                        row['media_type'] = '';
                        row['detail'] = '';
                        row['campaign'] = node.key;
                        row['colspan'] = 0;
                        for (var ind in col_allowed)
                            row[col_allowed[ind]] = node.aggData[col_allowed[ind]];
                        values_to_export.push(row);

                        $.each(node.childrenAfterGroup, function (index, value) {
                            //Media Type Level
                            var row = {};
                            row['level'] = 'media_type';
                            row['detail'] = '';
                            row['media_type'] =  value.key;
                            row['campaign'] =  ''
                            row['adv_name'] = '';
                            row['colspan'] = 2;
                            for (var ind in col_allowed)
                                row[col_allowed[ind]] = value.aggData[col_allowed[ind]];
                            values_to_export.push(row);
                            $.each(value.childrenAfterGroup, function (index, value) {
                                // lines
                                console.log('lines value', value);
                                var row = {};
                                row['level'] = 'lines';
                                row['detail'] = value.data['detail'];
                                row['media_type'] = value.data['media_type']
                                row['campaign'] = '';
                                row['lines'] = '';
                                for (var ind in col_allowed)
                                    row[col_allowed[ind]] = value.data[col_allowed[ind]];
                                values_to_export.push(row);
                            });
                        });
                    }
                });

                html_body += '<tr style="; color: black !important; text-align: center;"><td colspan=""></td><td colspan=""></td>';
                ordered_status_visible = false;
                for (var ind in col_allowed)
                    html_body += '<td style="text-align: center;">' + top_row[col_allowed[ind]] + '</td>';
                html_body += '</tr>';
                console.log('columns_ads_columns_ads', columns_ads);
                for(var ind in values_to_export) {
                    var row = values_to_export[ind];
                  //  var style_tr = ind % 2 !== 0 ? 'background-color: #F6F6F6;' : '';
                    var style_tr  = '';
                    html_body += '<tr style="' + style_tr + '">';
                    if(row['level'] === 'campaign')
                        html_body += '<td>&nbsp;&nbsp;&raquo;&nbsp;'+row[row['level']]+'</td><td></td>';
                    else if(row['level'] === 'media_type')
                        html_body += '<td style=" background-color: ' + flowchart_color[row.media_type] + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&raquo;&nbsp;&nbsp;&nbsp;&nbsp;'+ flowchart_media_type[row.media_type] +'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td style=" background-color: ' + flowchart_color[row.media_type] + '"></td>';
                    else if(row['level'] === 'lines')
                        html_body += '<td></td><td>' + row.detail + '</td>';

                    for (var col_ind in col_allowed) {
                        console.log('row_row_row_row_ ', row);
                        var style_c = '';
                        var field = col_allowed[col_ind].split('_');
                        if(typeof field[1] !== 'undefined') {
                            console.log('field[1] ', field[1], row)
                            var sum = row['cost_' + field[1]].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            style_c = row['level'] === 'lines' && (row['ads_' + field[1]] > 0 || sum > 0) ? 'background-color: ' + flowchart_color[row.media_type] + ';' : '';
                        }
                        html_body += '<td style="text-align: center; '+ style_c+'">' + row[col_allowed[col_ind]] + '</td>';
                    }
                    html_body += '</tr>';
                }
            }
            else {
                var top_row = grid.api.pinnedRowModel.pinnedTopRows[0].data;
                floating_top_row = top_row;
                var values_to_export = [];
                grid.api.forEachNodeAfterFilterAndSort(function (node) {
                    console.log('node_node ', node);
                    if (node.level === 0) {
                        //Adv  Level
                        console.log('advertiser node ', node)
                        var row = {};
                        row['level'] = 'adv_name';
                        row['vendor'] = '';
                        row['media_type'] = '';
                        row['campaign'] = '';
                        row['adv_name'] = node['key'];
                        row['market'] = '';
                        row['ordered_status'] = '';
                        row['colspan'] = 0;
                        for (var ind in col_allowed)
                            row[col_allowed[ind]] = node.aggData[col_allowed[ind]];
                        values_to_export.push(row);

                        $.each(node.childrenAfterGroup, function (index, value) {
                            //Campaign Level
                            var row = {};
                            row['level'] = 'campaign';
                            row['vendor'] = '';
                            row['media_type'] = '';
                            row['campaign'] = value['key'];
                            row['adv_name'] = '';
                            row['market'] = '';
                            row['ordered_status'] = '';
                            row['colspan'] = 5;
                            for (var ind in col_allowed)
                                row[col_allowed[ind]] = value.aggData[col_allowed[ind]];
                            values_to_export.push(row);

                            $.each(value.childrenAfterGroup, function (index, value) {
                                //Market Level
                                var row = {};
                                row['level'] = 'market';
                                row['vendor'] = '';
                                row['market'] = value['key'];
                                row['media_type'] = '';
                                row['campaign'] = '';
                                row['adv_name'] = '';
                                row['ordered_status'] = '';
                                row['colspan'] = 10;
                                for (var ind in col_allowed)
                                    row[col_allowed[ind]] = value.aggData[col_allowed[ind]];
                                values_to_export.push(row);

                                $.each(value.childrenAfterGroup, function (index, value) {
                                    //Media Level
                                    var row = {};
                                    row['level'] = 'media_type';
                                    row['vendor'] = '';
                                    row['market'] = '';
                                    row['media_type'] = value['key'];
                                    row['campaign'] = '';
                                    row['adv_name'] = '';
                                    row['ordered_status'] = '';
                                    row['colspan'] = 15;
                                    for (var ind in col_allowed)
                                        row[col_allowed[ind]] = value.aggData[col_allowed[ind]];
                                    values_to_export.push(row);
                                    $.each(value.childrenAfterGroup, function (index, value) {
                                        // lines
                                        console.log('lines value', value);
                                        var row = {};
                                        row['level'] = 'lines';
                                        row['vendor'] = value.data['vendor'];
                                        row['market'] = '';
                                        row['media_type'] = '';
                                        row['campaign'] = '';
                                        row['adv_name'] = '';
                                        row['ordered_status'] = value.data.ordered_status;
                                        row['lines'] = '';
                                        for (var ind in col_allowed)
                                            row[col_allowed[ind]] = value.data[col_allowed[ind]];
                                        values_to_export.push(row);
                                    });
                                });
                            });
                        });
                    }
                });

                html_body += '<tr style="background-color: #c3b091; color: black !important; text-align: center;"><td colspan=""></td><td></td>';
                if(!$('.hide-column-client-activity-details-for-tab .ordered_status').hasClass('hidden-column')) {
                    html_body += '<td></td>';
                    ordered_status_visible = true;
                }
                for (var ind in col_allowed)
                    html_body += '<td style="text-align: center;">' + top_row[col_allowed[ind]] + '</td>';
                html_body += '</tr>';
                console.log('columns_ads_columns_ads', columns_ads);
                for(var ind in values_to_export) {
                    var row = values_to_export[ind];
                    var style_tr = ind % 2 !== 0 ? 'background-color: #F6F6F6;' : '';
                    html_body += '<tr style="' + style_tr + '">';
                    if(row['level'] === 'adv_name')
                        html_body += '<td>&raquo;'+row[row['level']]+'</td>';
                    else if(row['level'] === 'campaign')
                        html_body += '<td>&nbsp;&nbsp;&raquo;&nbsp;'+row[row['level']]+'</td>';
                    else if(row['level'] === 'market')
                        html_body += '<td>&nbsp;&nbsp;&nbsp;&nbsp;&raquo;&nbsp;'+row[row['level']]+'</td>';
                    else if(row['level'] === 'media_type')
                        html_body += '<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&raquo;&nbsp;'+row[row['level']]+'</td>';
                    else if(row['level'] === 'lines')
                        html_body += '<td>'+row[row['level']]+'</td>';
                    html_body += '<td>'+ row['vendor'] +'</td>';
                    if (!$('.hide-column-client-activity-details-for-tab .ordered_status').hasClass('hidden-column'))
                        html_body += '<td>'+ row['ordered_status'] +'</td>';
                    for (var col_ind in col_allowed)
                        html_body += '<td style="text-align: center;">' + row[col_allowed[col_ind]] + '</td>';
                    html_body += '</tr>';
                }
            }

            //close table
            html_body += '</table>';
            html_body += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"></td></tr></table>';
            var html = html_header + html_body;

            var dt = new Date();
            var day = dt.getDate();
            var month = dt.getMonth() + 1;
            var year = dt.getFullYear();
            var hour = dt.getHours();
            var mins = dt.getMinutes();
            var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
            if(type === 'xls'){
                if(style === 'style') {
                    var a = document.createElement('a');
                    var data_type = 'data:application/vnd.ms-excel';
                    a.href = data_type + ', ' + encodeURIComponent(html);
                    a.download = 'exported_' + postfix + '.xls';
                    //triggering the function
                    a.click();
                }
                else {
                    var res = '<table><tr><td>'+ html +'</td></tr></table>';
                    var tbl = $(res)[0];
                    var wb = XLSX.utils.table_to_book(tbl, {sheet: "Sheet JS"});
                    wb['Sheets']['Sheet JS']['A1']['v'] = '';
                    hide_loader();
                    return XLSX.writeFile(wb, ('exported_' + postfix + '.xlsx'));
                    return false;
                }
            }
            else if(type === 'csv') {
                let data = "";
                const tableData = [];
                $('#hidden-div-to-export-csv').html('');
                $('#hidden-div-to-export-csv').html(html);
                const rows = document.querySelectorAll('#hidden-div-to-export-csv table tr');
                for (const row of rows) {
                    const rowData = [];
                    for (const [index, column] of row.querySelectorAll("th, td").entries()) {
                        var t = column.innerText.replace(/&nbsp;/g, '');
                        // To retain the commas in the "Description" column, we can enclose those fields in quotation marks.
                        if ((index + 1) % 3 === 0)
                            rowData.push('"' + t + '"');
                        else
                            rowData.push(t);

                        console.log('column.innerText', t, column.innerText);
                    }
                    tableData.push(rowData.join(","));
                }
                data += tableData.join("\n");
                var link = window.document.createElement("a");
                link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(data));
                link.setAttribute("download", 'exported_' + postfix + '.csv');
                link.click();
            }
            else{
                console.log('values_to_export', values_to_export);
                var params = {
                    tab: tab,
                    colspan: colspan,
                    group_allowed: group_allowed,
                    floating_top_row : floating_top_row,
                    lines: {},
                    col_allowed: col_allowed,
                    ordered_status_visible: ordered_status_visible,
                    time_period_type: time_period_type,
                    flag_count: flag_count,
                    flag_type_no: flag_type_no,
                    report_fd_header : report_fd_header,
                    agency_name : agency_name,
                    advertisers_name : advertisers_name,
                    media_type_string : media_type_string,
                    columns_ads: columns_ads,
                    flag_t: flag_t,
                    show_length_breakout: show_length_breakout,
                }
                console.log('text floating_top_row',floating_top_row )
                console.log('values_to_export', tab, values_to_export);
                if(tab === 'details') {
                    for (var ind in values_to_export) {
                        params.lines[ind] = {};
                        params.lines[ind] = values_to_export[ind];
                    }
                }else if(tab === 'market' || (tab === 'advertiser' && show_length_breakout === 0)){
                    var x = 0;
                    for (var ind in values_to_export) {
                        x += x > 0 ? 1 : 0;
                        params.lines[x] = {};
                        params.lines[x] = values_to_export[ind]['totals'];
                        params.lines[x][tab] = ind;
                        params.lines[x]['level'] = 'total';
                        for(var i in values_to_export[ind]['details']){
                            x++;
                            params.lines[x] = {};
                            params.lines[x] = values_to_export[ind]['details'][i];
                            params.lines[x][tab] = ind;
                            params.lines[x]['level'] = 'detail';
                        }
                    }
                }else if(tab === "flowchart" || tab === "flowchart_det" || (tab === 'advertiser' && show_length_breakout === 1)){
                    for (var ind in values_to_export) {
                        params.lines[ind] = {};
                        params.lines[ind] = values_to_export[ind];
                    }
                }
                console.log('params_params ', params)
                $.ajax({
                    type: 'POST',
                    url: '/smart/report/spend_summary/report/save/data/pdf',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (response){
                        var link = document.createElement('a');
                        link.href = '/smart/report/export/pdf/spend_summary/'+ response +'/download';
                        $(link).attr('target', '_blank');
                        link.click();
                        hide_overlay_loader($('#marketSummaryModal .modal-content'));
                    },
                    error: function (xhr) {
                        hide_overlay_loader($('#marketSummaryModal .modal-content'));
                        debug(xhr.responseText);
                    }
                });
            }
            hide_loader();
        });

        $('.export_excel_totals').on('click', function () {
            $('#format_x').val('xls');
            $('#style_x').val($(this).attr('data-style'));
            $('#totalsToExport').modal('show');
        });
        $('#export_csv_totals').on('click', function () {
            $('#format_x').val('csv');
            $('#totalsToExport').modal('show');
        });
        $('#export_pdf_totals').on('click', function () {
            $('#format_x').val('pdf');
            $('#totalsToExport').modal('show');
        });
        $('#submit_export_totals').on('click', function () {
            show_overlay_loader($("#totalsToExport .modal-content"));
            type = $('#format_x').val();
            var html_table = '<table class="table table-bordered table-striped table-condensed" >';
            var html_table_end = '</table>';
            var html = '';

            var selectedItems = [];
            $('.all_more_options_totals  input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            console.log('selectedItems', selectedItems)
            var html_header = '';
            var html_body = '';
            var colspan = 1;
            var col_allowed = [];
            var group_allowed = [];
            var groups = 0;
            var colspan_group = 0;
            var columns_ads= [];

            $('.hide-column-client-activity-details-group-tab a').each(function () {
                 if($(this).hasClass('hidden-column') ==  false){
                     groups ++;
                     group_allowed.push($(this).attr('data-col'))
                 }
            });

            for (var xx in group_allowed) {
               var month = group_allowed[xx];
                if (!$('.hide-column-client-activity-details-tab .ads').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('ads_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('ADS');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .cost').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('cost_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('COST');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .clientgross').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('clientgross_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('CLIENT GROSS (WMJ)');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .clientcost').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('clientcost_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('CLIENT COST');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .netcost').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('netcost_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('NET COST');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .grp').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('grp_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('GRP');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .gri').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('gri_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('GRI');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .cpp').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('cpp_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('CPP');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .cpp').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('netcpp_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('Net CPP');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .cpm').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('cpm_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('CPM');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .cpm').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('netcpm_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('Net CPM');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .clicks').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('clicks_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('ClICKS');
                    }
                }
                if (!$('.hide-column-client-activity-details-tab .costperclick').hasClass('hidden-column')) {
                    colspan++;
                    col_allowed.push('costperclick_' + month);
                    if (xx == 0) {
                        colspan_group++;
                        columns_ads.push('COST PER CLICK');
                    }
                }
            }

            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>SMART  REPORT:  SPEND SUMMARY ('+ time_period_type.toUpperCase() +') </b></td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>DATE RANGE: </b> '+ report_fd_header +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>CALENDAR TYPE:</b> '+ flag_type +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>AGENCY: </b> '+ agency_name +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>CLIENT: </b> '+ advertisers_name +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b>MEDIA TYPE: </b> '+ media_type_string +' </td></tr></table>';
            html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"></td></tr></table>';

            var market_lines = [];
            var vendor_lines = [];
            if (selectedItems.indexOf('market') !== -1) {
                html_body += '<table style="margin-top: 2%; margin-bottom: 2%; width: 100%;' +
                    '        height: 18px;' +
                    '        background-color: #c3b091 !important;' +
                    '        color: black !important;' +
                    '        border-bottom: none !important;' +
                    '        font-size: 12px;' +
                    '        line-height: 20px;' +
                    '        text-transform: uppercase;' +
                    '        text-align: center;"><tr><td colspan="' + colspan + '"><b>MARKET SUMMARY</b></td></tr></table>';

                html_body += '<table style="width: 100%;"><tr style="background: black;  color: white"><th></th>';
                for (var ind in group_allowed){
                    if(group_allowed[ind] != 'total')
                        html_body += '<th  style="background: #373737; color: white" colspan="' + colspan_group + '">' + group_allowed[ind] + '</th>';
                    else
                        html_body += '<th  style="background: #373737; color: white" colspan="' + colspan_group + '"> TOTALS</th>';
                }


                html_body += '</tr>';
                html_body += '<tr><td style="background: black; color: white">MARKET</td>';
                var i = 0;
                console.log('colspan_group ', colspan_group);
                while (i < groups) {
                    for (var ind in columns_ads)
                        html_body += '<td style="background: black; color: white; text-align: center">&nbsp;&nbsp;' + columns_ads[ind] + '&nbsp;&nbsp;</td>';
                    i++;
                }
                html_body += '</tr>';

                gridMarketTotals.api.forEachNode(function (node) {
                    var row = {};
                    row['market'] = node.data.market;
                    html_body += '<tr><td>' + node.data.market + '</td>';
                    for (var ind in col_allowed) {
                        html_body += '<td>' + node.data[col_allowed[ind]] + '</td>';
                        row[col_allowed[ind]] = node.data[col_allowed[ind]];
                    }
                    market_lines.push(row);
                });
                html_body += '</table>';
                html_body += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"></td></tr></table>';

            }
            if (selectedItems.indexOf('vendor') !== -1) {
                html_body += '<table style="margin-top: 2%; margin-bottom: 2%; width: 100%;' +
                    '        height: 18px;' +
                    '        background-color: #c3b091 !important;' +
                    '        color: black !important;' +
                    '        border-bottom: none !important;' +
                    '        font-size: 12px;' +
                    '        line-height: 20px;' +
                    '        text-transform: uppercase;' +
                    '        text-align: center;"><tr><td colspan="' + colspan + '"><b>VENDOR SUMMARY</b></td></tr></table>';

                html_body += '<table style="width: 100%;"><tr style="background: black;  color: white"><th></th>';
                for (var ind in group_allowed) {
                    if(group_allowed[ind] != 'total')
                        html_body += '<th  style="background: #373737; color: white" colspan="' + colspan_group + '">' + group_allowed[ind] + '</th>';
                    else
                        html_body += '<th  style="background: #373737; color: white" colspan="' + colspan_group + '"> TOTALS</th>';
                }
                html_body += '</tr>';
                html_body += '<tr><td style="background: black; color: white">VENDOR</td>';
                var i = 0;
                console.log('colspan_group ', colspan_group);
                while(i < groups ) {
                    for (var ind in columns_ads)
                        html_body += '<td style="background: black; color: white; text-align: center">&nbsp;&nbsp;' + columns_ads[ind] + '&nbsp;&nbsp;</td>';
                     i++;

                }
                html_body += '</tr>';

                gridVendorTotals.api.forEachNode(function (node) {
                    html_body += '<tr><td>' + node.data.vendor + '</td>';
                    var row = {};
                    row['vendor'] = node.data.vendor;
                    for (var ind in col_allowed) {
                        html_body += '<td>' + node.data[col_allowed[ind]] + '</td>';
                        row[col_allowed[ind]] = node.data[col_allowed[ind]];
                    }
                    vendor_lines.push(row);
                });
                html_body += '</table>';

            }
            html_body += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"></td></tr></table>';
            if(flag_count === true)
            {
                var xd = '<span style="color:#f15925; ">  ('+ flag_t +')</span> <span style="color:#f15925; font-style: italic">  ' +
                    ' Please note, this buy was placed in a ' + flag_type_no + ' so the time periods noted in the column headers might appear incorrect. </span>';

                html_body += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="' + colspan + '"> ' + xd +'</td></tr></table>';
            }
            console.log('colspan ', colspan);
            var html = html_header + html_body;

            var dt = new Date();
            var day = dt.getDate();
            var month = dt.getMonth() + 1;
            var year = dt.getFullYear();
            var hour = dt.getHours();
            var mins = dt.getMinutes();
            var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
            if(type === 'xls'){
                if($('#style_x').val() === 'style') {
                    var a = document.createElement('a');
                    var data_type = 'data:application/vnd.ms-excel';
                    a.href = data_type + ', ' + encodeURIComponent(html);
                    a.download = 'exported_' + postfix + '.xls';
                    //triggering the function
                    a.click();
                }
                else {
                    var res = '<table><tr><td>'+ html +'</td></tr></table>';
                    var tbl = $(res)[0];
                    var wb = XLSX.utils.table_to_book(tbl, {sheet: "Sheet JS"});
                    wb['Sheets']['Sheet JS']['A1']['v'] = '';
                    hide_overlay_loader($("#totalsToExport .modal-content"));
                    $('#totalsToExport').modal('hide');
                    return XLSX.writeFile(wb, ('exported_' + postfix + '.xlsx'));
                    return false;
                }
            }
            else if(type === 'csv'){
                let data = "";
                const tableData = [];
                $('#hidden-div-to-export-csv').html('');
                $('#hidden-div-to-export-csv').html(html);
                const rows = document.querySelectorAll('#hidden-div-to-export-csv table tr');
                for (const row of rows) {
                    const rowData = [];
                    for (const [index, column] of row.querySelectorAll("th, td").entries()) {
                        var t = column.innerText.replace(/&nbsp;/g, '');
                        // To retain the commas in the "Description" column, we can enclose those fields in quotation marks.
                        if ((index + 1) % 3 === 0)
                            rowData.push('"' + t + '"');
                         else
                            rowData.push(t);

                        console.log('column.innerText', t, column.innerText);
                    }
                    tableData.push(rowData.join(","));
                }
                data += tableData.join("\n");
                var link = window.document.createElement("a");
                link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(data));
                link.setAttribute("download", 'exported_' + postfix + '.csv');
                link.click();
            }
            else{
                var params = {
                        tab: 'totals',
                        selectedItems: selectedItems,
                        colspan: colspan,
                        group_allowed: group_allowed,
                        vendor_lines : {},
                        market_lines: {},
                        col_allowed: col_allowed,
                        ordered_status_visible: false,
                        time_period_type: time_period_type,
                        flag_count: flag_count,
                        flag_type_no: flag_type_no,
                        report_fd_header : report_fd_header,
                        agency_name : agency_name,
                        advertisers_name : advertisers_name,
                        media_type_string : media_type_string,
                        columns_ads: columns_ads,
                        flag_t: flag_t,
                    }
                    var i = 0;
                    if(selectedItems.indexOf('market') !== -1) {
                       // params.selectedItems[i] = 'market';
                        i++;
                        for (var ind in market_lines) {
                            params.market_lines[ind] = {};
                            params.market_lines[ind] = market_lines[ind];
                        }
                    }
                    if(selectedItems.indexOf('vendor') !== -1) {
                       // params.selectedItems[i] = 'vendor';
                        for (var ind in vendor_lines) {
                            params.vendor_lines[ind] = {};
                            params.vendor_lines[ind] = vendor_lines[ind];
                        }
                    }


                    console.log('params_params ', params)
                    $.ajax({
                        type: 'POST',
                        url: '/smart/report/spend_summary/report/save/data/pdf',
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        data: JSON.stringify(params),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function (response){
                            var link = document.createElement('a');
                            link.href = '/smart/report/export/pdf/spend_summary/'+ response +'/download';
                            $(link).attr('target', '_blank');
                            link.click();
                            hide_overlay_loader($('#marketSummaryModal .modal-content'));
                        },
                        error: function (xhr) {
                            hide_overlay_loader($('#marketSummaryModal .modal-content'));
                            debug(xhr.responseText);
                        }
                    });
                }

            hide_overlay_loader($("#totalsToExport .modal-content"));
            $('#totalsToExport').modal('hide');
        });

        //First Tab Hide/SHow buttons
        $('.hide-column-client-activity-details-tab a').bind('click', function (e) {
            var attr = $(this).attr('data-col');
            var visible_groups = [];
            $('.hide-column-client-activity-details-group-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_groups.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                var values = [];
                for (var ind in visible_groups)
                    values.push(attr + '_' + visible_groups[ind]);
                gridVendorTotals.columnApi.setColumnsVisible(values, true);
                gridMarketTotals.columnApi.setColumnsVisible(values, true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                var values = [];
                for (var ind in visible_groups)
                    values.push(attr + '_' + visible_groups[ind]);
                gridVendorTotals.columnApi.setColumnsVisible(values, false);
                gridMarketTotals.columnApi.setColumnsVisible(values, false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }

            }
            e.stopPropagation();
        });
        $('.hide-column-client-activity-details-group-tab a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');

            var visible_columns = [];
            $('.hide-column-client-activity-details-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_columns.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                var values = [];
                for(var ind in visible_columns)
                   values.push(visible_columns[ind]+'_' + attr);
                gridVendorTotals.columnApi.setColumnsVisible(values, true);
                gridMarketTotals.columnApi.setColumnsVisible(values, true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridVendorTotals.columnApi.setColumnsVisible(values, false);
                gridMarketTotals.columnApi.setColumnsVisible(values, false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        //Second Tab Hide/SHow buttons
        $('.hide-column-client-activity-details a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_groups = [];
            $('.hide-column-client-activity-details-group a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_groups.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                if(attr == 'ordered_status') {
                    gridCampBreakout.columnApi.setColumnsVisible([attr], true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakout.columnApi.setColumnsVisible(values, true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            } else {
                if(attr == 'ordered_status') {
                    gridCampBreakout.columnApi.setColumnsVisible([attr], false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakout.columnApi.setColumnsVisible(values, false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
            }
            e.stopPropagation();
        });
        $('.hide-column-client-activity-details-group a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_columns = [];
            $('.hide-column-client-activity-details a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_columns.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakout.columnApi.setColumnsVisible(values, true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakout.columnApi.setColumnsVisible(values, false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
                }
            e.stopPropagation();
        });

        //Third Tab Hide/ Show buttons
        $('.hide-column-client-activity-details-advertiser a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_groups = [];
            $('.hide-column-client-activity-details-group a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_groups.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                if(attr == 'ordered_status') {
                    gridCampBreakoutAdvertiser.columnApi.setColumnsVisible([attr], true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakoutAdvertiser.columnApi.setColumnsVisible(values, true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            } else {
                if(attr == 'ordered_status') {
                    gridCampBreakoutAdvertiser.columnApi.setColumnsVisible([attr], false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakoutAdvertiser.columnApi.setColumnsVisible(values, false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
            }
            e.stopPropagation();
        });
        $('.hide-column-client-activity-details-group-advertiser a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_columns = [];
            $('.hide-column-client-activity-details a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_columns.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakoutAdvertiser.columnApi.setColumnsVisible(values, true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakoutAdvertiser.columnApi.setColumnsVisible(values, false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        //Forth Tab Hide/ Show buttons
        $('.hide-column-client-activity-details-for-tab a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_groups = [];
            $('.hide-column-client-activity-details-group-details-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_groups.push($(this).attr('data-col'))
            });
            if ($(this).hasClass('hidden-column') ) {
                if(attr == 'ordered_status') {
                    gridCampBreakoutDetails.columnApi.setColumnsVisible([attr], true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakoutDetails.columnApi.setColumnsVisible(values, true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            } else {
                if(attr == 'ordered_status') {
                    gridCampBreakoutDetails.columnApi.setColumnsVisible([attr], false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakoutDetails.columnApi.setColumnsVisible(values, false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
            }
            e.stopPropagation();
        });
        $('.hide-column-client-activity-details-group-details-tab a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_columns = [];
            $('.hide-column-client-activity-details-for-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_columns.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakoutDetails.columnApi.setColumnsVisible(values, true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakoutDetails.columnApi.setColumnsVisible(values, false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        //Five Tab Hide/ Show buttons
        $('.hide-column-client-activity-details-for-flowchart-tab a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_groups = [];
            $('.hide-column-client-activity-details-group-flowchart-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_groups.push($(this).attr('data-col'))
            });
            if ($(this).hasClass('hidden-column') ) {
                if(attr == 'ordered_status') {
                    gridCampBreakoutFlowchart.columnApi.setColumnsVisible([attr], true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakoutFlowchart.columnApi.setColumnsVisible(values, true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            } else {
                if(attr == 'ordered_status') {
                    gridCampBreakoutFlowchart.columnApi.setColumnsVisible([attr], false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    gridCampBreakoutFlowchart.columnApi.setColumnsVisible(values, false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
            }
            e.stopPropagation();
        });
        $('.hide-column-client-activity-details-group-flowchart-tab a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_columns = [];
            $('.hide-column-client-activity-details-for-flowchart-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_columns.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakoutFlowchart.columnApi.setColumnsVisible(values, true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                gridCampBreakoutFlowchart.columnApi.setColumnsVisible(values, false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        //Six Tab Hide/ Show buttons
        $('.hide-column-client-activity-details-for-flowchart_det-tab a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_groups = [];
            $('.hide-column-client-activity-details-group-flowchart_det-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_groups.push($(this).attr('data-col'))
            });
            if ($(this).hasClass('hidden-column') ) {
                if(attr == 'ordered_status') {
                    griDetailedFlowchart.columnApi.setColumnsVisible([attr], true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    griDetailedFlowchart.columnApi.setColumnsVisible(values, true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            } else {
                if(attr == 'ordered_status') {
                    griDetailedFlowchart.columnApi.setColumnsVisible([attr], false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
                else{
                    var values = [];
                    for( var ind in visible_groups)
                        values.push(attr+'_'+visible_groups[ind]);
                    griDetailedFlowchart.columnApi.setColumnsVisible(values, false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if ($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
            }
            e.stopPropagation();
        });
        $('.hide-column-client-activity-details-group-flowchart_det-tab a').bind('click', function (e) {
            console.log("click");
            var attr = $(this).attr('data-col');
            var visible_columns = [];
            $('.hide-column-client-activity-details-for-flowchart_det-tab a').each(function () {
                if($(this).hasClass('hidden-column') ==  false)
                    visible_columns.push($(this).attr('data-col'))

            });
            if ($(this).hasClass('hidden-column') ) {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                griDetailedFlowchart.columnApi.setColumnsVisible(values, true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                var values = [];
                for(var ind in visible_columns)
                    values.push(visible_columns[ind]+'_' + attr);
                griDetailedFlowchart.columnApi.setColumnsVisible(values, false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });


        // reset filter second tab
        $('#reset_filters_det').on('click', function () {
            $.each(gridCampBreakout.api.getFilterModel(), function (index, value) {
                gridCampBreakout.api.destroyFilter(index);
            });
        });

        // reset filter third tab
        $('#reset_filters_det_advertiser').on('click', function () {
            $.each(gridCampBreakoutAdvertiser.api.getFilterModel(), function (index, value) {
                gridCampBreakoutAdvertiser.api.destroyFilter(index);
            });
        });
        // reset filter four tab
        $('#reset_filters_det_details').on('click', function () {
            $.each(gridCampBreakoutDetails.api.getFilterModel(), function (index, value) {
                gridCampBreakoutDetails.api.destroyFilter(index);
            });
        });
        // reset filter five tab
        $('#reset_filters_flowchart_details').on('click', function () {
            $.each(gridCampBreakoutFlowchart.api.getFilterModel(), function (index, value) {
                gridCampBreakoutFlowchart.api.destroyFilter(index);
            });
        });
        // reset filter five tab
        $('#reset_filters_flowchart_details_det').on('click', function () {
            $.each(griDetailedFlowchart.api.getFilterModel(), function (index, value) {
                griDetailedFlowchart.api.destroyFilter(index);
            });
        });

        //Row Data export
        $('.export_camp_deta_row_data').on('click', function() {
            var grid = '';
            var columns_to_add = {};
            var level = 0;
            if($(this).attr('data-tab') === 'flowchart') {
                grid = gridCampBreakoutFlowchart;
                columns_to_add['camp_name'] = 'Campaign';
                columns_to_add['market'] = 'Market';
                level = 2;
            } else if($(this).attr('data-tab') === 'flowchart_det'){
                grid = griDetailedFlowchart;
                columns_to_add['camp_name'] = 'Campaign';
                columns_to_add['media_type'] = 'Media Type';
                level = 2;
            } else if($(this).attr('data-tab') === 'details'){
                grid = gridCampBreakoutDetails;
                columns_to_add['adv_name'] = 'Advertiser';
                columns_to_add['camp_name'] = 'Campaign';
                columns_to_add['market'] = 'Market';
                columns_to_add['media_type'] = 'Media Type';
                level = 4;
            } else if($(this).attr('data-tab') === 'advertiser' && show_length_breakout === 0) {
                grid = gridCampBreakoutAdvertiser;
                columns_to_add['adv_name'] = 'Advertiser';
                level = 1;
            }else if($(this).attr('data-tab') === 'advertiser' && show_length_breakout === 1) {
                grid = gridCampBreakoutAdvertiser;
                columns_to_add['market'] = 'Advertiser';
                columns_to_add['vendor'] = 'Vendor';
                level = 2;
            } else if($(this).attr('data-tab') === 'market') {
                grid = gridCampBreakout;
                columns_to_add['market'] = 'Market';
                level = 1;
            }

            var all_columns = {};
            var all_columns_group = {};
            for(var ind in grid.columnDefs){
                var col = grid.columnDefs[ind];
                if(typeof col.children !== 'undefined'){
                    console.log('all_columns_all_columns col', col)
                    for(var i in col.children) {
                        all_columns[col.children[i].field] = col.children[i].headerName;
                        all_columns_group[col.children[i].field] = col.groupId;
                    }
                }else
                    all_columns[col.field] = col.headerName;
            }
            var html = '<table style="width: 100%;" class="table-bordered table-striped table-condensed"><tr style="">';

            for(var ind in columns_to_add )
                html += '<td><b>'+ columns_to_add[ind] +'</b></td>';

            for(var ind in grid.columnApi.getColumnState()){
                var value =  grid.columnApi.getColumnState()[ind];
                console.log('all_columns_all_columns value', value )
                if(typeof columns_to_add[value.colId] === 'undefined' && value.hide === false && typeof all_columns[value.colId] !== 'undefined'){
                    var h = all_columns[value.colId];
                    columns_to_add[value.colId] = h;
                    var he = h.replace('<br>', '');
                    if(typeof all_columns_group[value.colId] !== 'undefined')
                        he = h +' ('+all_columns_group[value.colId]+')';
                    html += '<td><b>'+ he +'</b></td>';

                }
            }
            console.log('all_columns_all_columns all_columns', all_columns)
            console.log('all_columns_all_columns columns_to_add', columns_to_add)
            console.log('all_columns_all_columns all_columns_group', all_columns_group)
            html += '</tr>';
            grid.api.forEachNodeAfterFilterAndSort(function (node) {
                if(node.level === level){
                    html += '<tr>';
                    for(var ind in columns_to_add){
                        console.log('node_node_', node)
                        html += '<td style="border: 1px solid #D3D3D3">'+ node.data[ind] +'</td>';
                    }
                    html += '</tr>';
                }
            });
            html += '</table>';

            var a = document.createElement('a');
            var data_type = 'data:application/vnd.ms-excel';
            a.href = data_type + ', ' + encodeURIComponent(html);
            a.download =  'smart-report.xls';
            a.click();
            if(typeof e !== 'undefined')
                e.preventDefault();
        });

        hide_loader();
    }
    else if($(".traffic_report").length > 0) {
        show_loader();
        //TAB Broadcast
        var commercial_code_array = [];
        var months_chart = [];
        var vendors_chart = [];
        $('.custom_chart_market_detail').on('click', function () {
            var tab_selected = $(this).attr('data-tab');
            $('#tab_selected_graph').val(tab_selected);
            var html_type = ' <option value=""></option>' +
                '                                            <option value="pie">Pie</option>' +
                '                                            <option value="line">Line</option>' +
                '                                            <option value="column">Column (Vertical)</option>' +
                '                                            <option value="bar">Column (Horizontal)</option>';

            $('#chart_type_details').select2({
                minimumResultsForSearch: 5,
                placeholder: 'Select one....',

            });
            $('#chart_type_details').html(html_type);

            $('#chart_breakout_details').select2({
                minimumResultsForSearch: 5
            });
            $('#chart_data_type_details').select2({
                minimumResultsForSearch: 5
            });

            console.log('commercial_code_array ', commercial_code_array);
            console.log('commercial_code_array months_chart', months_chart);
            console.log('commercial_code_array vendors_chart', vendors_chart);
            var html = '';
            for (var ind in commercial_code_array) {
                if(commercial_code_array[ind] === "")
                    html += '<option value="' + commercial_code_array[ind] + '">No Commercial Code</option>';
                else
                     html += '<option>' + commercial_code_array[ind] + '</option>';
            }
            $('#chart_markets_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_books'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_books'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_markets_details').html(html).multiSelect('refresh');

            var html = '';
            for (var ind in vendors_chart)
                html += '<option>' + vendors_chart[ind] + '</option>';
            $('#chart_stations_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_stations'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_stations'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_stations_details').html(html).multiSelect('refresh');

            var html = '';
            months_chart.sort();
            for (var ind in months_chart)
                html += '<option>' + months_chart[ind] + '</option>';
            $('#chart_month_details').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type_details option:selected').val() === 'pie') {
                        form_curr_dayparts = this.$element.val();
                        if (this.$element.val().length > 1) {
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 1 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }
                        if (form_curr_dayparts.length < 2)
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                        else
                            this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');

                    }
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type_details option:selected').val() == 'pie') {
                        form_curr_dayparts = this.$element.val();
                        this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                    }
                }
            });
            $('#chart_month_details').html(html).multiSelect('refresh');

            $('#graphsOptionsModalDetail').modal('show');

            //Select all
            $('#sel_all_chart_books').on('click', function (e) {
                $('#chart_markets_details').multiSelect('select_all');
            });
            $('#sel_all_chart_stations').on('click', function (e) {
                $('#chart_stations_details').multiSelect('select_all');
            });
            $('#sel_all_chart_dayparts').on('click', function (e) {
                $('#chart_month_details').multiSelect('select_all');
            });
            //Deselect all
            $('#desel_all_chart_books').on('click', function (e) {
                $('#chart_markets_details').multiSelect('deselect_all');
            });
            $('#desel_all_chart_stations').on('click', function (e) {
                $('#chart_stations_details').multiSelect('deselect_all');
            });
            $('#desel_all_chart_dayparts').on('click', function (e) {
                $('#chart_month_details').multiSelect('deselect_all');
            });
        });
        $('#chart_type_details').on('change', function(){
            if($(this).val() === 'pie'){
                $('.div_only_one_daypart_details').show();
                $('#chart_month_details').multiSelect('deselect_all');
            }
            else {
                $('.div_only_one_daypart_details').hide();
            }
        });
        $('#submit_charts_options_details').on('click', function(){
            if($('#chart_type_details option:selected').val() == ''){
                swal({
                        title: "Warning",
                        text: "Select Chart Type first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_stations_details').val().length == 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Vendor...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_month_details').val().length == 0) {
                if ($('#chart_type_details option:selected').val() === 'pie')
                    text = 'Select a Flight Date first...';
                else
                    text = 'Select at least one Flight Date...';
                swal({
                        title: "Warning",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_markets_details').val().length === 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Comercial Code first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else {
                show_overlay_loader('#graphsOptionsModalDetial .modal-content');
                $('#modalTTChart').html('Traffic Report Chart (Broadcast)');
                var vendor_charts = $('#chart_stations_details').val();
                var month_chart = $('#chart_month_details').val();
                var camp_charts = $('#chart_markets_details').val();
                var data_type = $('#chart_data_type_details option:selected').val();
                var data_type_text = $('#chart_data_type_details option:selected').html();
                var simbol = (data_type === 'ads' || data_type === 'gri' || data_type === 'grp') ? '' : '$';
                var to_fixed = 0;
                if(data_type === 'gri' || data_type === 'grp')
                    to_fixed = 1;
                else if(data_type === 'ads')
                    to_fixed = 0;
                else
                    to_fixed = 2;
                var results = [];

                var array_month_ordered = [];
                gridBroadcast.api.forEachNode(function (node) {
                    if (node.level === 0) {
                        console.log('node_node_node_', node);
                        $.each(node.childrenAfterGroup, function (index, value) {
                            console.log('node_node_node_ group 1', value);
                            $.each(value.childrenAfterGroup, function (index, value) {
                               // $.each(value.childrenAfterGroup, function (index, value) {
                                    console.log('inside 1', value);
                                    if (vendor_charts.indexOf(value.data.vendor) !== -1 && month_chart.indexOf(value.data.fd) !== -1 && camp_charts.indexOf(value.data.code) !== -1) {
                                        if (typeof results[value.data.code] === 'undefined')
                                            results[value.data.code] = [];
                                        if (typeof results[value.data.code][value.data.vendor] === 'undefined')
                                            results[value.data.code][value.data.vendor] = [];
                                        var time = value.data.fd;
                                        if (typeof results[value.data.code][value.data.vendor][time] === 'undefined') {
                                            results[value.data.code][value.data.vendor][time] = [];
                                            results[value.data.code][value.data.vendor][time]['value'] = 0;
                                        }
                                        var amount = 0;
                                        if (data_type === 'ads')
                                            amount = !isNaN(parseInt(value.data[data_type])) ? parseInt(value.data[data_type]) : 0;
                                        else {
                                            var amount = value.data[data_type];
                                           // amount = amount.replace('$', '');
                                         //   amount = amount.replace(/,/g, '');
                                            amount = !isNaN(parseFloat(amount)) ? parseFloat(amount).toFixed(2) : 0.00;
                                        }
                                        results[value.data.code][value.data.vendor][time]['value'] += amount;
                                        if(array_month_ordered.indexOf(time) === -1)
                                            array_month_ordered.push(time);

                                    }
                               // });
                            });
                        });
                    }
                });
                array_month_ordered.sort();
                console.log('charts_final_results results', results);
                var charts_final_results = {};
                for (var market_text in results) {
                    for (var vendor in results[market_text]) {
                        var market = (market_text === '') ? 'No Commercial Code' : market_text;
                        for(var ind in array_month_ordered) {
                            var time_period = array_month_ordered[ind];
                            if (typeof charts_final_results[market] === 'undefined')
                                charts_final_results[market] = [];
                            if (typeof charts_final_results[market][time_period] === 'undefined') {
                                charts_final_results[market][time_period] = [];
                                charts_final_results[market][time_period]['total'] = 0;
                                charts_final_results[market][time_period]['stations'] = [];
                            }
                            if (typeof charts_final_results[market][time_period]['stations'][vendor] === 'undefined')
                                charts_final_results[market][time_period]['stations'][vendor] = 0;

                            if(typeof  results[market_text][vendor][time_period] !== 'undefined') {
                                charts_final_results[market][time_period]['total'] += parseFloat(results[market_text][vendor][time_period]['value']);
                                charts_final_results[market][time_period]['stations'][vendor] += parseFloat(results[market_text][vendor][time_period]['value']);
                            }
                        }
                    }
                }

                console.log('charts_final_results ', charts_final_results);
                console.log('array_month_ordered ', array_month_ordered);
                var html = '';
                //content tabs
                html += '<div class="tab-content gr" style="width: 100%">';
                html += '<div class="row"> <div class="col-md-12">' +
                    '                                <div id="container_market_chart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                    '                            </div></div>';
                html += '</div>';
                $('.container-graphs-div').html(html);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                if ($('#chart_type_details option:selected').val() == 'column' || $('#chart_type_details option:selected').val() == 'bar') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data.push({
                                name: time_period,
                                y: market_value,
                                drilldown: time_period + '_' + cont,
                            });

                            data2.push({
                                name: market,
                                id: time_period + '_' + cont,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var orientation_type = $('#chart_type_details option:selected').val() === 'column' ? 'columns' : 'rows';
                    var defaultTitle = 'Click the '+ orientation_type +' to view ' + $('#chart_data_type_details option:selected').html() + ' by vendors.'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Commercial Code ' + data_type_text + ' Details Chart',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_data_type option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol + '{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        drilldown: {
                            series: data2
                        }

                    });
                }
                if ($('#chart_type_details option:selected').val() == 'line') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data.push({
                                name: time_period,
                                y: market_value,
                                drilldown: time_period + '_' + cont,
                            });

                            data2.push({
                                name: market,
                                id: time_period + '_' + cont,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }

                    console.log('series cleint acti', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details option:selected').html() + ' by  stations'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            // type: $('#chart_type option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Commercial Code ' + data_type_text + ' Details Chart',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_type_details option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        drilldown: {
                            series: data2
                        }
                        //drilldown : data2,

                    });
                }
                if ($('#chart_type_details option:selected').val() == 'pie') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            for (var station in charts_final_results[market][time_period]['stations']){
                                var station_metric = charts_final_results[market][time_period]['stations'][station];
                                array.push([station, station_metric]);
                            }
                            data2.push({
                                name: market,
                                id: market,
                                data: array,
                            });
                        }
                        series.push({
                            name: market,
                            y: market_value,
                            drilldown: market,
                        });
                        cont++;
                    }
                    console.log('series series', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details option:selected').html() + ' by  stations'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Commercial Code ' + data_type_text + ' Details Chart ('+ moment($('#chart_month_details').val()[0]).format('MMMM,  YYYY') + ')',
                        },
                        subtitle: {
                            text: defaultTitle,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true,
                                },
                                showInLegend: true,

                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: [{
                            name:  'Campaign ' + $('#chart_data_type_details option:selected').html() ,
                            colorByPoint: true,
                            data: series
                        }],
                        drilldown: {
                            series: data2
                        }
                        //drilldown : data2,

                    });
                }

                $('#GraphsModal').modal('show');
                hide_overlay_loader('#graphsOptionsModalDetail .modal-content');

            }

            hide_overlay_loader('#graphsOptionsModal .modal-content');

        });

        //TAB No-Broadcast
        var months_chart_1 = [];
        var vendors_chart_1 = [];
        $('.custom_chart_market_detail_1').on('click', function () {
            var html_type = ' <option value=""></option>' +
                '                                            <option value="pie">Pie</option>' +
                '                                            <option value="line">Line</option>' +
                '                                            <option value="column">Column (Vertical)</option>' +
                '                                            <option value="bar">Column (Horizontal)</option>';

            $('#chart_type_details_1').select2({
                minimumResultsForSearch: 5,
                placeholder: 'Select one....',

            });
            $('#chart_type_details_1').html(html_type);

            $('#chart_breakout_details_1').select2({
                minimumResultsForSearch: 5
            });
            $('#chart_data_type_details_1').select2({
                minimumResultsForSearch: 5
            });

            console.log('commercial_code_array months_chart', months_chart_1);
            console.log('commercial_code_array vendors_chart', vendors_chart_1);

            var html = '';
            for (var ind in vendors_chart_1)
                html += '<option>' + vendors_chart_1[ind] + '</option>';
            $('#chart_stations_details_1').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_stations_1'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_stations_1'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#chart_stations_details_1').html(html).multiSelect('refresh');

            var html = '';
            months_chart.sort();
            for (var ind in months_chart_1)
                html += '<option>' + months_chart_1[ind] + '</option>';
            $('#chart_month_details_1').multiSelect({
                selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts_1'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts_1'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type_details_1 option:selected').val() === 'pie') {
                        form_curr_dayparts = this.$element.val();
                        if (this.$element.val().length > 1) {
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 1 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }
                        if (form_curr_dayparts.length < 2)
                            this.$element.closest('.form_dayparts_container_chart_1').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                        else
                            this.$element.closest('.form_dayparts_container_chart_1').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');

                    }
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                    if ($('#chart_type_details_1 option:selected').val() == 'pie') {
                        form_curr_dayparts = this.$element.val();
                        this.$element.closest('.form_dayparts_container_chart_1').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                    }
                }
            });
            $('#chart_month_details_1').html(html).multiSelect('refresh');

            $('#graphsOptionsModalDetail_1').modal('show');

            //Select all
            $('#sel_all_chart_stations_1').on('click', function (e) {
                $('#chart_stations_details_1').multiSelect('select_all');
            });
            $('#sel_all_chart_dayparts_1').on('click', function (e) {
                $('#chart_month_details_1').multiSelect('select_all');
            });
            //Deselect all
            $('#desel_all_chart_stations_1').on('click', function (e) {
                $('#chart_stations_details_1').multiSelect('deselect_all');
            });
            $('#desel_all_chart_dayparts_1').on('click', function (e) {
                $('#chart_month_details_1').multiSelect('deselect_all');
            });
        });
        $('#chart_type_details_1').on('change', function(){
            if($(this).val() === 'pie'){
                $('.div_only_one_daypart_details_1').show();
                $('#chart_month_details_1').multiSelect('deselect_all');
            }
            else {
                $('.div_only_one_daypart_details_1').hide();
            }
        });
        $('#submit_charts_options_details_1').on('click', function(){
            if($('#chart_type_details_1 option:selected').val() == ''){
                swal({
                        title: "Warning",
                        text: "Select Chart Type first...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_stations_details_1').val().length == 0){
                swal({
                        title: "Warning",
                        text: "Select at least one Vendor...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else if($('#chart_month_details_1').val().length == 0) {
                if ($('#chart_type_details_1 option:selected').val() === 'pie')
                    text = 'Select a Flight Date first...';
                else
                    text = 'Select at least one Flight Date...';
                swal({
                        title: "Warning",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
            else {
                show_overlay_loader('#graphsOptionsModalDetial_1 .modal-content');
                $('#modalTTChart').html('Traffic Report Chart (Non-Broadcast)');
                var vendor_charts = $('#chart_stations_details_1').val();
                var month_chart = $('#chart_month_details_1').val();
                var data_type = $('#chart_data_type_details_1 option:selected').val();
                var data_type_text = $('#chart_data_type_details_1 option:selected').html();
                var simbol = (data_type === 'ads' || data_type === 'gri' || data_type === 'grp') ? '' : '$';
                var to_fixed = 0;
                if(data_type === 'gri' || data_type === 'grp')
                    to_fixed = 1;
                else if(data_type === 'ads')
                    to_fixed = 0;
                else
                    to_fixed = 2;
                var results = [];

                var array_month_ordered = [];
                console.log('vendor_charts', vendor_charts);
                console.log('vendor_charts month_chart', month_chart);
                gridNoBroadcast.api.forEachNode(function (node) {
                    if (node.level === 0) {
                        console.log('node_node_node_', node);
                        $.each(node.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                if (vendor_charts.indexOf(value.data.vendor) !== -1 && month_chart.indexOf(value.data.fd) !== -1) {
                                    if (typeof results[value.data.vendor] === 'undefined')
                                        results[value.data.vendor] = [];
                                    var time = value.data.fd;
                                    if (typeof results[value.data.vendor][time] === 'undefined') {
                                        results[value.data.vendor][time] = [];
                                        results[value.data.vendor][time]['value'] = 0;
                                    }
                                    var amount = 0;
                                    if (data_type === 'ads')
                                        amount = !isNaN(parseInt(value.data[data_type])) ? parseInt(value.data[data_type]) : 0;
                                    else {
                                        var amount = value.data[data_type];
                                        // amount = amount.replace('$', '');
                                        //   amount = amount.replace(/,/g, '');
                                        amount = !isNaN(parseFloat(amount)) ? parseFloat(amount).toFixed(2) : 0.00;
                                    }
                                    results[value.data.vendor][time]['value'] += amount;
                                    if(array_month_ordered.indexOf(time) === -1)
                                        array_month_ordered.push(time);

                                }
                            });
                        });
                    }
                });
                array_month_ordered.sort();
                console.log('charts_final_results results', results);
                var charts_final_results = {};
                for (var vendor in results) {
                       for (var ind in array_month_ordered) {
                           var time_period = array_month_ordered[ind];
                           if (typeof charts_final_results[vendor] === 'undefined')
                               charts_final_results[vendor] = [];
                           if (typeof charts_final_results[vendor][time_period] === 'undefined') {
                               charts_final_results[vendor][time_period] = [];
                               charts_final_results[vendor][time_period]['total'] = 0;
                               charts_final_results[vendor][time_period]['stations'] = [];
                           }
                           if (typeof charts_final_results[vendor][time_period]['stations'][vendor] === 'undefined')
                               charts_final_results[vendor][time_period]['stations'][vendor] = 0;

                           if (typeof results[vendor][time_period] !== 'undefined') {
                               charts_final_results[vendor][time_period]['total'] += parseFloat(results[vendor][time_period]['value']);
                               charts_final_results[vendor][time_period]['stations'][vendor] += parseFloat(results[vendor][time_period]['value']);
                           }
                       }
                   }


                console.log('charts_final_results ', charts_final_results);
                console.log('array_month_ordered ', array_month_ordered);
                var html = '';
                //content tabs
                html += '<div class="tab-content gr" style="width: 100%">';
                html += '<div class="row"> <div class="col-md-12">' +
                    '                                <div id="container_market_chart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                    '                            </div></div>';
                html += '</div>';
                $('.container-graphs-div').html(html);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                if ($('#chart_type_details_1 option:selected').val() == 'column' || $('#chart_type_details_1 option:selected').val() == 'bar') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            // for (var station in charts_final_results[market][time_period]['stations']){
                            //     var station_metric = charts_final_results[market][time_period]['stations'][station];
                            //     array.push([station, station_metric]);
                            // }
                            data.push({
                                name: time_period,
                                y: market_value,
                               // drilldown: time_period + '_' + cont,
                            });

                            // data2.push({
                            //     name: market,
                            //     id: time_period + '_' + cont,
                            //     data: array,
                            // });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }
                    console.log('series', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var orientation_type = $('#chart_type_details_1 option:selected').val() === 'column' ? 'columns' : 'rows';
                    var defaultTitle = 'Click the '+ orientation_type +' to view ' + $('#chart_data_type_details_1 option:selected').html() + ' by vendors.'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details_1 option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Non-Broadcast ' + data_type_text + ' Details Chart',
                        },
                        subtitle: {
                           // text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_data_type_1 option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol + '{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        // drilldown: {
                        //     series: data2
                        // }

                    });
                }
                if ($('#chart_type_details_1 option:selected').val() == 'line') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            // for (var station in charts_final_results[market][time_period]['stations']){
                            //     var station_metric = charts_final_results[market][time_period]['stations'][station];
                            //     array.push([station, station_metric]);
                            // }
                            data.push({
                                name: time_period,
                                y: market_value,
                               // drilldown: time_period + '_' + cont,
                            });

                            // data2.push({
                            //     name: market,
                            //     id: time_period + '_' + cont,
                            //     data: array,
                            // });
                        }
                        series.push({
                            name: market,
                            data: data,
                        });
                        cont++;
                    }

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details_1 option:selected').html() + ' by  stations'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            // type: $('#chart_type option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Non-Broadcast ' + data_type_text + ' Details Chart',
                        },
                        subtitle: {
                           // text: defaultTitle,
                        },
                        xAxis: {
                            type: 'category'
                        },
                        yAxis: {
                            title: {
                                text: $('#chart_type_details_1 option:selected').html(),
                            },
                            labels: {
                                formatter: function() {
                                    return  simbol +''+ this.value ;
                                }
                            },
                            min: 0,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: series,
                        // drilldown: {
                        //     series: data2
                        // }

                    });
                }
                if ($('#chart_type_details_1 option:selected').val() == 'pie') {
                    var data2 = [];
                    var series = [];
                    var cont = 1;
                    for(var market in charts_final_results){
                        var data = [];
                        for(var time_period in charts_final_results[market]){
                            var array = [];
                            var market_value = charts_final_results[market][time_period]['total'];
                            // for (var station in charts_final_results[market][time_period]['stations']){
                            //     var station_metric = charts_final_results[market][time_period]['stations'][station];
                            //     array.push([station, station_metric]);
                            // }
                            // data2.push({
                            //     name: market,
                            //     id: market,
                            //     data: array,
                            // });
                        }
                        series.push({
                            name: market,
                            y: market_value,
                          //  drilldown: market,
                        });
                        cont++;
                    }
                    console.log('series series', series);

                    Highcharts.theme = {
                        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                    }
                    var defaultTitle = 'Click the points to view ' + $('#chart_data_type_details_1 option:selected').html() + ' by  stations'

                    Highcharts.chart('container_market_chart', {
                        chart: {
                            type: $('#chart_type_details_1 option:selected').val(),
                            events: {
                                drilldown: function (e) {
                                    this.setSubtitle({text: e.point.name});
                                },
                                drillup: function (e) {
                                    this.setSubtitle({text: defaultTitle});
                                },
                            },
                        },
                        title: {
                            text: 'Non-Broadcast ' + data_type_text + ' Details Chart ('+ $('#chart_month_details_1').val()[0] + ')',
                        },
                        subtitle: {
                          //  text: defaultTitle,
                        },
                        credits: {
                            text: "Powered By Galeforcemedia",
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true,
                                },
                                showInLegend: true,

                            }
                        },
                        tooltip: {
                            valueDecimals: to_fixed,
                            headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>:  <b>'+ simbol +'{point.y:.' +to_fixed+ 'f}</b> <br/>'
                        },
                        series: [{
                            name:  'Non-Broadcast ' + $('#chart_data_type_details_1 option:selected').html() ,
                            colorByPoint: true,
                            data: series
                        }],
                        // drilldown: {
                        //     series: data2
                        // }
                        //drilldown : data2,

                    });
                }

                $('#GraphsModal').modal('show');
                hide_overlay_loader('#graphsOptionsModalDetail_1 .modal-content');

            }

            hide_overlay_loader('#graphsOptionsModal .modal-content');

        });

        breakoutColumnDef = [
            {
                headerName: "Flight Dates",
                field: 'fd',
                width: 130,
                cellStyle: {'text-align': "left"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 150,
                cellStyle: {'text-align': "left"},
                pinned: 'left',
                hide: true,
                suppressMovable: true,
                // cellRenderer: VendorFormatRenderer,
                rowGroupIndex: 1,
            },
            {
                headerName: "Advertiser",
                field: 'adv_name',
                width: 150,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Advertiser') !== -1) ? false : true,
            }, {
                headerName: "Campaign",
                field: 'campaign_name',
                width: 150,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Campaign') !== -1) ? false : true,
            },
            {
                headerName: "Camp Start",
                field: 'camp_start',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Campaign Start Date') !== -1) ? false : true,
            },
            {
                headerName: "Camp End",
                field: 'camp_end',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Campaign End Date') !== -1) ? false : true,
            },
            {
                headerName: "Market",
                field: 'market',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Market') !== -1) ? false : true,
            },
            {
                headerName: "Media type",
                field: 'media_type',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Media Type') !== -1) ? false : true,
            },

            {
                headerName: "Traffic Description",
                field: 'traffic_instructions',
                width: 200,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Traffic Instructions') !== -1) ? false : true,
            },
            {
                headerName: "Ads",
                field: 'ads',
                width: 80,
                cellStyle: {'text-align': "center"},
                cellRenderer: BlankCellRendered,
                hide: (columns_to_show.indexOf('Ads/Units') !== -1) ? false : true,
            },
            {
                headerName: "Cost",
                field: 'cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: BlankCellRendered,
                hide: (columns_to_show.indexOf('Cost') !== -1) ? false : true,
            },
            {
                headerName: "Traffic Period",
                field: 'traffic_period',
                width: 180,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Traffic Period') !== -1) ? false : true,
            },
            {
                headerName: "Length",
                field: 'length',
                width: 80,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Length') !== -1) ? false : true,
            },
            {
                headerName: "Commercial Code",
                field: 'code',
                width: 150,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Commercial Code') !== -1) ? false : true,
            },
            {
                headerName: "Ordered Percent",
                field: 'pct',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Percent') !== -1) ? false : true,
            },
            {
                headerName: "Invoiced Percent",
                field: 'inv_pct',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Invoiced Percent') !== -1) ? false : true,
            },

        ];
        noBreakoutColumnDef = [
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 150,
                cellStyle: {'text-align': "left"},
                pinned: 'left',
                hide: true,
                suppressMovable: true,
                //  cellRenderer: VendorFormatRenderer,
                rowGroupIndex: 0,
            },
            {
                headerName: "Fligth Dates",
                field: 'fd',
                width: 130,
                cellStyle: {'text-align': "left"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Advertiser",
                field: 'adv_name',
                width: 150,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Advertiser') !== -1) ? false : true,
            }, {
                headerName: "Campaign",
                field: 'campaign_name',
                width: 150,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Campaign') !== -1) ? false : true,
            },
            {
                headerName: "Camp Start",
                field: 'camp_start',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Campaign Start Date') !== -1) ? false : true,
            },
            {
                headerName: "Camp End",
                field: 'camp_end',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Campaign End Date') !== -1) ? false : true,
            },
            {
                headerName: "Market",
                field: 'market',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Market') !== -1) ? false : true,
            },
            {
                headerName: "Media type",
                field: 'media_type',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Media Type') !== -1) ? false : true,
            },

            {
                headerName: "Ads",
                field: 'ads',
                width: 80,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Ads/Units') !== -1) ? false : true,
            },
            {
                headerName: "Cost",
                field: 'cost',
                width: 120,
                cellStyle: {'text-align': "center"},
                cellRenderer: CurrencyStartCellRendered,
                hide: (columns_to_show.indexOf('Cost') !== -1) ? false : true,
            },
            {
                headerName: "Format",
                field: 'format',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Format') !== -1) ? false : true,
            },
            {
                headerName: "File Format",
                field: 'file_format',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('File Format') !== -1) ? false : true,
            },
            {
                headerName: "File Size",
                field: 'file_size',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('File Size') !== -1) ? false : true,
            },
            {
                headerName: "Material Closing",
                field: 'material_closing',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Material Closing Date') !== -1) ? false : true,
            },
            {
                headerName: "Space Closing",
                field: 'space_closing',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Space Closing Date') !== -1) ? false : true,
            },
            {
                headerName: "Specifications",
                field: 'specifications',
                width: 150,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Specifications') !== -1) ? false : true,
            }, {
                headerName: "Targeting",
                field: 'targeting',
                width: 120,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Targeting') !== -1) ? false : true,
            },
            {
                headerName: "Comments",
                field: 'comments',
                width: 150,
                cellStyle: {'text-align': "center"},
                hide: (columns_to_show.indexOf('Comments') !== -1) ? false : true,
            },

        ];

        function BlankCellRendered() {
        }
        BlankCellRendered.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            console.log('params ', params);
            if (params.node.level === 0 || params.node.level === 1)
                this.eGui.innerHTML = params.value;
            else
                this.eGui.innerHTML = '-';

        };
        BlankCellRendered.prototype.getGui = function () {
            return this.eGui;
        };
        function CurrencyStartCellRendered() {
        }
        CurrencyStartCellRendered.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            console.log('params ', params);
            if (typeof params.value !== 'undefined')
                this.eGui.innerHTML = parseFloat(params.value).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
            else
                this.eGui.innerHTML = '';

        };
        CurrencyStartCellRendered.prototype.getGui = function () {
            return this.eGui;
        };

        var BroadcastAggFunction = function (nodes) {
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 2) {
                    $.each(nodes, function (index, value) {
                        if(commercial_code_array.indexOf(value['data']['code']) === -1)
                            commercial_code_array.push(value['data']['code']);
                        if(months_chart.indexOf(value['data']['fd']) === -1)
                            months_chart.push(value['data']['fd']);
                        if(vendors_chart.indexOf(value['data']['vendor']) === -1)
                            vendors_chart.push(value['data']['vendor']);
                        for (var ind in value['data']) {
                            if (index === 0) {
                                if (ind === 'cost' || ind === 'ads') {
                                    if (typeof result[ind] === 'undefined')
                                        result[ind] = 0;
                                    result[ind] += value['data'][ind];
                                }
                            }
                        }
                    });
                }
                if (nodes[0].level === 1) {
                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            if(commercial_code_array.indexOf(value['data']['code']) === -1)
                                commercial_code_array.push(value['data']['code']);
                            if(months_chart.indexOf(value['data']['fd']) === -1)
                                months_chart.push(value['data']['fd']);
                            if(vendors_chart.indexOf(value['data']['vendor']) === -1)
                                vendors_chart.push(value['data']['vendor']);
                            if (index === 0) {
                                for (var ind in value['data']) {
                                    if (ind === 'cost' || ind === 'ads') {
                                        if (typeof result[ind] === 'undefined')
                                            result[ind] = 0;
                                        result[ind] += value['data'][ind];
                                    }
                                }
                            }
                        });
                    });
                }
                if (typeof result['cost'] !== 'undefined') {
                    result['cost'] = parseFloat(result['cost']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                }
                return result;
            } else
                return false;
        };
        var NoBroadcastAggFunction = function (nodes) {
            console.log('nodes ***********', nodes);
            var result = {};

            if (nodes[0] != undefined) {
                if (nodes[0].level === 2) {
                    $.each(nodes, function (index, value) {
                        if(months_chart_1.indexOf(value['data']['fd']) === -1)
                            months_chart_1.push(value['data']['fd']);
                        if(vendors_chart_1.indexOf(value['data']['vendor']) === -1)
                            vendors_chart_1.push(value['data']['vendor']);
                        for (var ind in value['data']) {
                            if (ind === 'cost' || ind === 'ads') {
                                if (typeof result[ind] === 'undefined')
                                    result[ind] = 0;
                                result[ind] += value['data'][ind];
                            }
                        }
                    });
                }
                if (nodes[0].level === 1) {
                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            if(months_chart_1.indexOf(value['data']['fd']) === -1)
                                months_chart_1.push(value['data']['fd']);
                            if(vendors_chart_1.indexOf(value['data']['vendor']) === -1)
                                vendors_chart_1.push(value['data']['vendor']);
                            for (var ind in value['data']) {
                                if (ind === 'cost' || ind === 'ads') {
                                    if (typeof result[ind] === 'undefined')
                                        result[ind] = 0;
                                    result[ind] += value['data'][ind];
                                }
                            }
                        });
                    });
                }
                // if(typeof result['cost'] !== 'undefined'){
                //     result['cost'] = parseFloat(result['cost']).toLocaleString("en-US", {
                //         style: "currency",
                //         currency: "USD",
                //         minimumFractionDigits: 2
                //     });
                // }
                return result;
            } else
                return false;
        };

        //First Tab Initial Hide/Show columns
        $('.hide-column-client-activity-details-tab a').each(function () {
            var attr = $(this).html();
            if (columns_to_show.indexOf(attr) == -1) {
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
            }
        });

        // Second Tab Initial Hide/Show columns
        $('.hide-column-client-activity-details a').each(function () {
            var attr = $(this).html();
            if (columns_to_show.indexOf(attr) == -1) {
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
            }
        });

        gridBroadcast = {
            columnDefs: breakoutColumnDef,
            autoGroupColumnDef: {
                headerName: 'Flight Dates',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true, defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return BroadcastAggFunction(nodes);
            },
            onGridReady: function (e) {
                // totalInvDetailUpd (this)
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                //fillTopLine(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_br').show();
                else
                    $('#reset_filters_br').hide();
            },
        };
        gridNoBroadcast = {
            columnDefs: noBreakoutColumnDef,
            autoGroupColumnDef: {
                headerName: 'Vendors',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true, defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return NoBroadcastAggFunction(nodes);
            },
            onGridReady: function (e) {
                // totalInvDetailUpd (this)
            },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
               // fillTopLine(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_nbr').show();
                else
                    $('#reset_filters_nbr').hide();
            },
        };

        var orderBy = ['fd', 'vendor'];
        var sorted_two = multisort(broadcast_list, orderBy)
        var rowData = sorted_two;
        gridBroadcast.rowData = [];
        gridBroadcast.rowData = rowData;

        var orderBy = ['vendor', 'fd'];
        var sorted_nbr = multisort(no_broadcast, orderBy)
        var rowDataNBr = sorted_nbr;
        gridNoBroadcast.rowData = [];
        gridNoBroadcast.rowData = rowDataNBr;

        $('#myGridBroadcast').html('');
        var gridCampBreakoutX = document.querySelector('#myGridBroadcast');
        var grid = new agGrid.Grid(gridCampBreakoutX, gridBroadcast);

        $('#myGridNoBroadcast').html('');
        var gridCampBreakoutXX = document.querySelector('#myGridNoBroadcast');
        var grid = new agGrid.Grid(gridCampBreakoutXX, gridNoBroadcast);

        $('.hide-column-client-activity-details-tab a').bind('click', function (e) {
            var attr = $(this).attr('data-col');
            if ($(this).hasClass('hidden-column')) {
                gridBroadcast.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                gridBroadcast.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });
        $('.hide-column-client-activity-details a').bind('click', function (e) {
            var attr = $(this).attr('data-col');
            if ($(this).hasClass('hidden-column')) {
                gridNoBroadcast.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');

            } else {
                gridNoBroadcast.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if ($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        $('.export_excel_br').on('click', function (){
            var format = $(this).attr('data-ac')
            var params = {
                skipHeader: false,
                columnGroups: true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "smart-report." + format,
            };
            params.processCellCallback = function (params) {
                if ((params.column.colId === 'cost' || params.column.colId === 'ads') && (params.node.level === 0 || params.node.level === 1))
                    return params.value;
                else if (params.column.colId === 'cost' || params.column.colId === 'ads')
                    return  '-';
                else
                    return params.value;
            };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Traffic Report"}}
                    ],

                ];
                params.customFooter = [
                    [],
                    []
                ];
            }

            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridBroadcast.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                var content = gridBroadcast.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'smart-export.xlsx', {bookType: 'xlsx', type: 'base64'});
            }

        });
        $('.export_excel_nbr').on('click', function (){
            var format = $(this).attr('data-ac')
            var params = {
                skipHeader: false,
                columnGroups: true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "smart-report." + format,
            };
            params.processCellCallback = function (params) {
                if (params.column.colId === 'cost')
                    return  parseFloat(params.value).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                 else
                    return params.value;
            };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Traffic Report"}}
                    ],

                ];
                params.customFooter = [
                    [],
                    []
                ];
            }

            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridNoBroadcast.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                var content = gridNoBroadcast.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'smart-export.xlsx', {bookType: 'xlsx', type: 'base64'});
            }

        });

        $('#reset_filters_br').on('click', function () {
            $.each(gridBroadcast.api.getFilterModel(), function (index, value) {
                gridBroadcast.api.destroyFilter(index);
            });
        });
        $('#reset_filters_nbr').on('click', function () {
            $.each(gridNoBroadcast.api.getFilterModel(), function (index, value) {
                gridNoBroadcast.api.destroyFilter(index);
            });
        });

        hide_loader();
    }
    else if($(".inv_isci_report_header").length > 0) {
        show_loader();
       // fill gropued grid level totals
        var CampBreakAggFunction = function (nodes) {
            console.log('nodes ***********', nodes);
            var result = {};
            var strings = ['month', 'vendor', 'campstart', 'campaign', 'code', 'comission', 'campaign_number', 'job_number', 'invoice_number'];

            if (nodes[0] != undefined) {
                if (nodes[0].level === 4) {
                    $.each(nodes, function (index, value) {
                        $.each(value['data'], function (index, value) {
                            if (!isNaN(parseFloat(value)) && strings.indexOf(index) === -1) {
                                if (typeof result[index] === 'undefined')
                                    result[index] = 0;
                                result[index] += parseFloat(value);
                            }
                        });
                    });
                    console.log('level 4 results ', result);
                } else if (nodes[0].level === 3) {
                    $.each(nodes, function (indexX, valueX) {
                        $.each(valueX.childrenAfterGroup, function (index, value) {
                            $.each(value['data'], function (index, value) {
                                if (!isNaN(parseFloat(value)) && strings.indexOf(index) === -1) {
                                    if (typeof result[index] === 'undefined')
                                        result[index] = 0;
                                    result[index] += parseFloat(value);
                                }
                            });
                        });
                    });
                    console.log('level 3 results ', result);
                } else if (nodes[0].level === 2) {
                    $.each(nodes, function (indexX, valueX) {
                        $.each(valueX.childrenAfterGroup, function (indexY, valueY) {
                            $.each(valueY.childrenAfterGroup, function (index, value) {
                                $.each(value['data'], function (index, value) {
                                    if (!isNaN(parseFloat(value)) && strings.indexOf(index) === -1) {
                                        if (typeof result[index] === 'undefined')
                                            result[index] = 0;
                                        result[index] += parseFloat(value);
                                    }
                                });
                            });
                        });
                    });
                    console.log('level 2 results ', result);
                } else if (nodes[0].level === 1) {
                    $.each(nodes, function (indexX, valueX) {
                        $.each(valueX.childrenAfterGroup, function (indexY, valueY) {
                            $.each(valueY.childrenAfterGroup, function (indexZ, valueZ) {
                                $.each(valueZ.childrenAfterGroup, function (index, value) {
                                    $.each(value['data'], function (index, value) {
                                        if (!isNaN(parseFloat(value)) && strings.indexOf(index) === -1) {
                                            if (typeof result[index] === 'undefined')
                                                result[index] = 0;
                                            result[index] += parseFloat(value);
                                        }
                                    });
                                });
                            });
                        });
                    });
                    console.log('level 1 results ', result);
                }
                return result;
            } else
                return false;
        };
        //Details Grid
        columnInvExportInfo = [
            {
                headerName: "Commercial Code",
                field: 'code',
                width: 140,
                cellStyle: {'text-align': "left"},
                hide: (custom_details.indexOf("Commercial Code") !== -1) ? false : true
            },
            {
                headerName: "Approval Rate",
                field: 'total_cost',
                width: 120,
                cellStyle: {'text-align': "right"},
                hide: (estimate_details.indexOf("Approval Rate") !== -1) ? false : true,
                cellRenderer: CurrencyFormatRendererISCI,
            },
            {
                headerName: "Net Approval Rate",
                field: 'total_net_cost',
                width: 140,
                cellStyle: {'text-align': "right"},
                hide: (estimate_details.indexOf("Net Approval Rate") !== -1) ? false : true,
                cellRenderer: CurrencyFormatRendererISCI,
            },
            {
                headerName: "Ads",
                field: 'total_runs',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_details.indexOf("Ads") !== -1) ? false : true,
            },
            {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 200,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Advertiser") !== -1) ? false : true
            },
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 220,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign") !== -1) ? false : true
            },
            {
                headerName: "Brand",
                field: 'brand',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Brand") !== -1) ? false : true
            },
            {
                headerName: "Product",
                field: 'product',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Product") !== -1) ? false : true
            },
            {
                headerName: "Est. No.",
                field: 'estimate_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Estimate No.") !== -1) ? false : true
            },
            {
                headerName: "Job No.",
                field: 'job_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Job No.") !== -1) ? false : true
            },
            {
                headerName: "Camp. No.",
                field: 'campaign_number',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Camp. No.") !== -1) ? false : true
            },
            {
                headerName: "Camp. Start",
                field: 'campstart',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign Start Date") !== -1) ? false : true
            },
            {
                headerName: "Camp. End",
                field: 'campend',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign End Date") !== -1) ? false : true
            },
            {
                headerName: "Market",
                field: 'market',
                width: 220,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Market") !== -1) ? false : true
            },
            {
                headerName: "Media",
                field: 'media_type',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Media Type") !== -1) ? false : true
            },
            {
                headerName: "Invoice Number",
                field: 'invoice_number',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Invoice Number") !== -1) ? false : true
            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Vendor") !== -1) ? false : true
            },
            {
                headerName: "Length",
                field: 'length',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Length") !== -1) ? false : true
            },
            {
                headerName: "Run Date",
                field: 'run_date',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Run Date") !== -1) ? false : true
            },
            {
                headerName: "Day of Week",
                field: 'dow',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Day of Week") !== -1) ? false : true
            },
            {
                headerName: "Run Time",
                field: 'time',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Run Time") !== -1) ? false : true
            },

        ];
        gridInvExportInfo = {
            columnDefs: columnInvExportInfo,
            defaultColDef: {
                suppressToolPanel: true
            },
            pinnedTopRowData: [{
                'impressions': 0,
                'cost': 0,
                'net_cost': 0,
                'grp': 0,
                'gri': 0,
                'cpp': 0,
                'net_cpp': 0,
                'cpm': 0,
                'net_cpm': 0,
                'ads': 0,
            }],
            rowSelection: 'single',
            suppressRowClickSelection: false,
            enableColResize: true,
            //suppressMenuColumnPanel: true,
            suppressTouch: true,
            headerHeight: 30,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 22,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            getContextMenuItems: getContextMenuInvoiceOrder,
            onGridReady: function (e) {
                 totalTVUpdateData(this);
            },
            onFilterChanged: function (e) {
                 totalTVUpdateData(this);
                 if (this.api.isAnyFilterPresent())
                     $('#reset_filters').show();
                 else
                     $('#reset_filters').hide();
            },
        };
        function totalTVUpdateData(grid){
            var totals = {
                'total_runs': 0,
                'total_cost': 0,
                'total_net_cost': 0,
            };
            gridInvExportInfo.api.forEachNodeAfterFilterAndSort(function(node){
                if(!isNaN(parseFloat(node.data.total_cost)))
                    totals['total_cost'] += parseFloat(node.data.total_cost);
                if(!isNaN(parseFloat(node.data.total_net_cost)))
                    totals['total_net_cost'] += parseFloat(node.data.total_net_cost);
                if(!isNaN(parseInt(node.data.total_runs)))
                    totals['total_runs'] += parseFloat(node.data.total_runs);
            });
            gridInvExportInfo.api.setPinnedTopRowData(
                [ totals ]
            );
        }
        $('#myGrid').html('');
        gridInvExportInfo.rowData = result;
        var gridDet = document.querySelector('#myGrid');
        var grid = new agGrid.Grid(gridDet, gridInvExportInfo);

        $('#sum-hiden-columns a').each(function(){
            var attr = $(this).attr('data-hidden');
            if(custom_details.indexOf($(this).text()) === -1 && estimate_details.indexOf($(this).text()) === -1){
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
            }
            else{
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            }
        });

        $('#sum-hiden-columns a').bind('click', function (e) {
            var attr = $(this).attr('data-hidden');
            if ($(this).hasClass('hidden-column') ) {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            } else {
                gridInvExportInfo.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        $('#reset_filters').on('click', function () {
            $.each(gridInvExportInfo.api.getFilterModel(), function (index, value) {
                gridInvExportInfo.api.destroyFilter(index);
            });
        });

      $('.export_grid_details').on('click', function(){
            var format = $(this).attr('data-ac')
            var params = {
                skipHeader: false,
                columnGroups: true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "smart-report." + format,
            };
            params.processCellCallback = function (params) {
                // if(typeof params.value !== 'undefined' && params.value.toString().split('/').length === 3 && moment(params.value).isValid())
                //     return moment(params.value).format('MMMM, YYYY');
                if (params.column.colId === 'total_cost' || params.column.colId === 'total_net_cost') {
                    param_val = params.value;
                    if (isNaN(parseFloat(params.value)))
                        param_val = 0;
                    param_val = parseFloat(param_val).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    return param_val;

                } else
                    return params.value;
            };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Smart Report"}}
                    ],

                ];
                params.customFooter = [
                    [],
                    []
                ];
            }

            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridInvExportInfo.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                var content = gridInvExportInfo.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'smart-export.xlsx', {bookType: 'xlsx', type: 'base64'});
            }
        });

        //Code breakout
        var columnDefCodeDetail = [
            {
                headerName: "Comission",
                field: 'comission',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
            },
            {
                headerName: "ISCI Code",
                field: 'code',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            }, {
                headerName: "Month",
                field: 'month',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRendererISCI,

            },
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 3,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: 'Totals Values',
                headerTooltip: 'Total Values',
                groupId: 'total_values',
                pinned: 'right',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Ads',
                        field: 'total_runs',
                        minWidth: 45,
                        width: 70,
                        cellStyle: {'text-align': "left"},
                        pinned: 'right',
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Gross Approved',
                        field: 'total_cost',
                        minWidth: 45,
                        width: 120,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                        pinned: 'right',
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Net Approved',
                        field: 'total_net_cost',
                        minWidth: 45,
                        width: 120,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                        pinned: 'right',
                    },

                ],
                headerClass: 'group-header'
            },
            {
                headerName: 'DOW: Monday',
                headerTooltip: 'DOW : Monday',
                groupId: 'monday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Monday Ads',
                        field: 'm_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Monday Gross Approved',
                        field: 'm_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Monday Net Approved',
                        field: 'm_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Tuesday',
                headerTooltip: 'DOW : Tuesday',
                groupId: 'tuesday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Tuesday Ads',
                        field: 't_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Tuesday  Gross Approved',
                        field: 't_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Tuesday Net Approved',
                        field: 't_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Wednesday',
                headerTooltip: 'DOW : Wednesday',
                groupId: 'wednesday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Wednesday Ads',
                        field: 'w_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Wednesday  Gross Approved',
                        field: 'w_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Wednesday Net Approved',
                        field: 'w_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Thursday',
                headerTooltip: 'DOW : Thursday',
                groupId: 'thursday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Ads',
                        field: 'r_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Thursday  Gross Approved',
                        field: 'r_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Thursday Net Approved',
                        field: 'r_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Friday',
                headerTooltip: 'DOW : Friday',
                groupId: 'friday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Friday Ads',
                        field: 'f_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Friday Gross Approved',
                        field: 'f_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Friday Net Approved',
                        field: 'f_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Saturday',
                headerTooltip: 'DOW : Saturday',
                groupId: 'saturday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Saturday Ads',
                        field: 's_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Saturday Gross Approved',
                        field: 's_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Saturday Net Approved',
                        field: 's_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Sunday',
                headerTooltip: 'DOW : Sunday',
                groupId: 'sunday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Sunday Ads',
                        field: 'u_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Sunday Gross Approved',
                        field: 'u_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Sunday Net Approved',
                        field: 'u_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                ],

            }

        ];
        gridCodeBreakout = {
            columnDefs: columnDefCodeDetail,
            autoGroupColumnDef: {
                headerName: 'ISCI Code',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 30,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return CampBreakAggFunction(nodes);
            },
            onGridReady: function (e) {
                this.api.expandAll();
                this.api.collapseAll();
            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        gridCodeBreakout.rowData = [];
        var orderBy = ['code', 'month', 'campaign', 'vendor'];
        var sorted_two = multisort(result, orderBy)
        gridCodeBreakout.rowData = sorted_two;
        $('#myGridBreakout').html('');
        var gridCampBreakoutX = document.querySelector('#myGridBreakout');
        var grid = new agGrid.Grid(gridCampBreakoutX, gridCodeBreakout);

        //Month breakout
        var columnDefMonthDetail = [
            {
                headerName: "Comission",
                field: 'comission',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
            },
            {
                headerName: "Month",
                field: 'month',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRendererISCI,
            },
            {
                headerName: "ISCI Code",
                field: 'code',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 3,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: 'Totals Values',
                headerTooltip: 'Total Values',
                groupId: 'total_values',
                pinned: 'right',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Ads',
                        field: 'total_runs',
                        minWidth: 45,
                        width: 70,
                        cellStyle: {'text-align': "left"},
                        pinned: 'right',
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Gross Approved',
                        field: 'total_cost',
                        minWidth: 45,
                        width: 120,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                        pinned: 'right',
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Net Approved',
                        field: 'total_net_cost',
                        minWidth: 45,
                        width: 120,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                        pinned: 'right',
                    },

                ],
                headerClass: 'group-header'
            },
            {
                headerName: 'DOW: Monday',
                headerTooltip: 'DOW : Monday',
                groupId: 'monday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Monday Ads',
                        field: 'm_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Monday Gross Approved',
                        field: 'm_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Monday Net Approved',
                        field: 'm_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Tuesday',
                headerTooltip: 'DOW : Tuesday',
                groupId: 'tuesday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Tuesday Ads',
                        field: 't_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Tuesday  Gross Approved',
                        field: 't_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Tuesday Net Approved',
                        field: 't_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Wednesday',
                headerTooltip: 'DOW : Wednesday',
                groupId: 'wednesday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Wednesday Ads',
                        field: 'w_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Wednesday  Gross Approved',
                        field: 'w_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Wednesday Net Approved',
                        field: 'w_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Thursday',
                headerTooltip: 'DOW : Thursday',
                groupId: 'thursday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Ads',
                        field: 'r_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Thursday  Gross Approved',
                        field: 'r_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Thursday Net Approved',
                        field: 'r_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Friday',
                headerTooltip: 'DOW : Friday',
                groupId: 'friday',
                headerClass: 'group-header',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Friday Ads',
                        field: 'f_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Friday Gross Approved',
                        field: 'f_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Friday Net Approved',
                        field: 'f_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Saturday',
                headerTooltip: 'DOW : Saturday',
                groupId: 'saturday',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Saturday Ads',
                        field: 's_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Saturday Gross Approved',
                        field: 's_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Saturday Net Approved',
                        field: 's_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    }],
            },
            {
                headerName: 'DOW: Sunday',
                headerTooltip: 'DOW : Sunday',
                groupId: 'sunday',
                children: [
                    {
                        headerName: 'Ads',
                        headerTooltip: 'Sunday Ads',
                        field: 'u_runs',
                        minWidth: 45,
                        width: 90,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: 'Gross Approved',
                        headerTooltip: 'Sunday Gross Approved',
                        field: 'u_total',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                    {
                        headerName: 'Net Approved',
                        headerTooltip: 'Sunday Net Approved',
                        field: 'u_total_net',
                        minWidth: 45,
                        width: 140,
                        cellStyle: {'text-align': "left"},
                        cellRenderer: CurrencyFormatRendererISCI,
                    },
                ],
                headerClass: 'group-header'
            }

        ];
        gridMonthBreakout = {
            columnDefs: columnDefMonthDetail,
            autoGroupColumnDef: {
                headerName: 'Months',
                pinned: 'left',
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 35,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 25,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return CampBreakAggFunction(nodes);
            },
            onGridReady: function (e) {
                this.api.expandAll();
                this.api.collapseAll();
            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        gridMonthBreakout.rowData = [];
        var orderBy = ['month', 'code', 'campaign', 'vendor'];
        var sorted_tree = multisort(result, orderBy);
        gridMonthBreakout.rowData = sorted_tree;
        $('#myGridBreakoutMonth').html('');
        var gridMonthBreakoutX = document.querySelector('#myGridBreakoutMonth');
        var grid = new agGrid.Grid(gridMonthBreakoutX, gridMonthBreakout);


        //Ordered Code Breakout
        var columnDefCodeDetailOrdered = [
            {
                headerName: "Comission",
                field: 'comission',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
            },
            {
                headerName: "ISCI Code",
                field: 'code',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            }, {
                headerName: "Month",
                field: 'month',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRendererISCI,
            },
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 150,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 3,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: "Ads",
                field: 'spots',
                width: 130,
                cellStyle: {'text-align': "right"},
                suppressMovable: true,

            },
            {
                headerName: "Gross Cost",
                field: 'cost',
                width: 130,
                cellStyle: {'text-align': "right"},
                suppressMovable: true,
                cellRenderer: CurrencyFormatRendererISCI,
            },
            {
                headerName: "Net Gross Cost",
                field: 'net_cost',
                width: 130,
                cellStyle: {'text-align': "right"},
                suppressMovable: true,
                cellRenderer: CurrencyFormatRendererISCI,
            },
        ];
        gridCodeBreakoutOrdered = {
            columnDefs: columnDefCodeDetailOrdered,
            autoGroupColumnDef: {
                headerName: 'ISCI Code',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 30,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return CampBreakAggFunction(nodes);
            },
            onGridReady: function (e) {
                this.api.expandAll();
                this.api.collapseAll();
            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        gridCodeBreakoutOrdered.rowData = [];
        var orderBy = ['code', 'month', 'campaign', 'vendor'];
        var sorted_two = multisort(order_traffic_results, orderBy)
        gridCodeBreakoutOrdered.rowData = sorted_two;
        $('#myGridBreakoutOrdered').html('');
        var gridCampBreakoutXX = document.querySelector('#myGridBreakoutOrdered');
        var grid = new agGrid.Grid(gridCampBreakoutXX, gridCodeBreakoutOrdered);

        //Ordered Code Breakout
        var columnDefMonthDetailOrdered = [
            {
                headerName: "Comission",
                field: 'comission',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: true,
            },
            {
                headerName: "ISCI Code",
                field: 'code',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            }, {
                headerName: "Month",
                field: 'month',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRendererISCI,
            },
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: "Vendor",
                field: 'vendor',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 3,
                hide: true,
                suppressMovable: true,

            },
            {
                headerName: "Ads",
                field: 'spots',
                width: 130,
                cellStyle: {'text-align': "right"},
                suppressMovable: true,
            },
            {
                headerName: "Gross Cost",
                field: 'cost',
                width: 130,
                cellStyle: {'text-align': "right"},
                suppressMovable: true,
                cellRenderer: CurrencyFormatRendererISCI,
            },
            {
                headerName: "Net Gross Cost",
                field: 'net_cost',
                width: 130,
                cellStyle: {'text-align': "right"},
                suppressMovable: true,
                cellRenderer: CurrencyFormatRendererISCI,
            },
        ];
        gridMonthBreakoutOrdered = {
            columnDefs: columnDefMonthDetailOrdered,
            autoGroupColumnDef: {
                headerName: 'Month',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 30,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return CampBreakAggFunction(nodes);
            },
            onGridReady: function (e) {
                this.api.expandAll();
                this.api.collapseAll();
            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        gridMonthBreakoutOrdered.rowData = [];
        var orderBy = ['month','code', 'campaign', 'vendor'];
        var sorted_two = multisort(order_traffic_results, orderBy)
        gridMonthBreakoutOrdered.rowData = sorted_two;
        $('#myGridBreakoutMonthOrdered').html('');
        var gridCampBreakoutXXX = document.querySelector('#myGridBreakoutMonthOrdered');
        var grid = new agGrid.Grid(gridCampBreakoutXXX, gridMonthBreakoutOrdered);

        fill_totals_summary();
        function fill_totals_summary() {
            console.log('^^^summary_totals ^^^', summary_totals);
            console.log('^^^summary_totals ^^^', summary_totals);
            var html = '';
            // Code
            var code_array = summary_totals['code'];
            var code_array_traffic = summary_totals_ordered['code'];
            var code_ordered = summary_totals_to_order['code'].sort();
            html += '<div class="table-wrapper" style="margin-top: 1%;"><table id="code_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr> <th> ISCI Code</th>' ;
            if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                html += '<th> Ordered Ads</th>' +
                    '<th>Ordered  Gross Cost</th>' +
                    '<th>Ordered Net Cost</th>';
            }
            if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                html += '<th>Invoiced Ads</th>' +
                    '<th>Invoiced Gross Cost</th>' +
                    '<th>Invoiced  Net Cost</th>';
            }
           html += '</tr></thead>';
            html += '<tbody>';
            for (var ind in code_ordered) {
                var camp = code_ordered[ind];

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;
                if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                    if(typeof code_array_traffic[camp] !== 'undefined') {
                        html += '<td>' + code_array_traffic[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array_traffic[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array_traffic[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }

                if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                    if(typeof code_array[camp] !== 'undefined') {
                        html += '<td>' + code_array[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody></table></div>';

            // Campaign
            var code_array = summary_totals['campaign'];
            var code_array_traffic = summary_totals_ordered['campaign'];
            var code_ordered = summary_totals_to_order['campaign'].sort();
            html += '<div class="table-wrapper" style="margin-top: 3%;"><table id="camp_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr> <th> Campaign</th>' ;
            if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                html += '<th> Ordered Ads</th>' +
                    '<th>Ordered  Gross Cost</th>' +
                    '<th>Ordered Net Cost</th>';
            }
            if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                html += '<th>Invoiced Ads</th>' +
                    '<th>Invoiced Gross Cost</th>' +
                    '<th>Invoiced  Net Cost</th>';
            }
            html += '</tr></thead>';
            html += '<tbody>';
            for (var ind in code_ordered) {
                var camp = code_ordered[ind];

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;
                if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                    if(typeof code_array_traffic[camp] !== 'undefined') {
                        html += '<td>' + code_array_traffic[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array_traffic[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array_traffic[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }

                if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                    if(typeof code_array[camp] !== 'undefined') {
                        html += '<td>' + code_array[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody></table></div>';


            // Market
            var code_array = summary_totals['market'];
            var code_array_traffic = summary_totals_ordered['market'];
            var code_ordered = summary_totals_to_order['market'].sort();
            html += '<div class="table-wrapper" style="margin-top: 3%;"><table id="market_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr> <th> Market</th>' ;
            if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                html += '<th> Ordered Ads</th>' +
                    '<th>Ordered  Gross Cost</th>' +
                    '<th>Ordered Net Cost</th>';
            }
            if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                html += '<th>Invoiced Ads</th>' +
                    '<th>Invoiced Gross Cost</th>' +
                    '<th>Invoiced  Net Cost</th>';
            }
            html += '</tr></thead>';
            html += '<tbody>';
            for (var ind in code_ordered) {
                var camp = code_ordered[ind];

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;
                if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                    if(typeof code_array_traffic[camp] !== 'undefined') {
                        html += '<td>' + code_array_traffic[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array_traffic[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array_traffic[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }

                if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                    if(typeof code_array[camp] !== 'undefined') {
                        html += '<td>' + code_array[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody></table></div>';

            // Media
            var code_array = summary_totals['media_type'];
            var code_array_traffic = summary_totals_ordered['media_type'];
            var code_ordered = summary_totals_to_order['media_type'].sort();
            html += '<div class="table-wrapper" style="margin-top: 3%;"><table id="media_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr> <th> Media</th>' ;
            if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                html += '<th> Ordered Ads</th>' +
                    '<th>Ordered  Gross Cost</th>' +
                    '<th>Ordered Net Cost</th>';
            }
            if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                html += '<th>Invoiced Ads</th>' +
                    '<th>Invoiced Gross Cost</th>' +
                    '<th>Invoiced  Net Cost</th>';
            }
            html += '</tr></thead>';
            html += '<tbody>';
            for (var ind in code_ordered) {
                var camp = code_ordered[ind];

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;
                if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                    if(typeof code_array_traffic[camp] !== 'undefined') {
                        html += '<td>' + code_array_traffic[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array_traffic[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array_traffic[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }

                if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                    if(typeof code_array[camp] !== 'undefined') {
                        html += '<td>' + code_array[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody></table></div>';

            // Vendor
            var code_array = summary_totals['vendor'];
            var code_array_traffic = summary_totals_ordered['vendor'];
            var code_ordered = summary_totals_to_order['vendor'].sort();
            html += '<div class="table-wrapper" style="margin-top: 3%;"><table id="vendor_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead><tr> <th> Vendor</th>' ;
            if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                html += '<th> Ordered Ads</th>' +
                    '<th>Ordered  Gross Cost</th>' +
                    '<th>Ordered Net Cost</th>';
            }
            if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                html += '<th>Invoiced Ads</th>' +
                    '<th>Invoiced Gross Cost</th>' +
                    '<th>Invoiced  Net Cost</th>';
            }
            html += '</tr></thead>';
            html += '<tbody>';
            for (var ind in code_ordered) {
                var camp = code_ordered[ind];

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;
                if(show_hide_grids === 'ordered' || show_hide_grids  === 'both') {
                    if(typeof code_array_traffic[camp] !== 'undefined') {
                        html += '<td>' + code_array_traffic[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array_traffic[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array_traffic[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }

                if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                    if(typeof code_array[camp] !== 'undefined') {
                        html += '<td>' + code_array[camp].ads + '</td>' +
                            '<td>' + parseFloat(code_array[camp].gross_cost).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(code_array[camp].net_cost).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    else{
                        html += '<td>0</td>' +
                            '<td>' + parseFloat(0).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }), +'</td>';
                        html += '<td>' + parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody></table></div>';

            $('#totals_summary_tab').html(html);
        };

        hide_loader();

        function CurrencyFormatRendererISCI() {
        }

        CurrencyFormatRendererISCI.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            $(this.eGui).css('text-align', 'right');
            if (typeof params.value !== 'undefined') {
                if (isNaN(parseFloat(params.value)))
                    this.eGui.innerHTML = '$0.00';
                else {
                    var val = parseFloat(params.value).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    this.eGui.innerHTML = val;
                }
            } else
                this.eGui.innerHTML = '$0.00';

        };

        CurrencyFormatRendererISCI.prototype.getGui = function () {
            return this.eGui;
        };

        function MonthFormatRendererISCI() {
        }

        MonthFormatRendererISCI.prototype.init = function (params) {
            this.eGui = document.createElement('span');
          //  console.log('params.value before undefined', params.value)
            if (typeof params.value !== 'undefined') {
                if (params.node.rowPinned !== 'bottom') {
                    console.log(' params.value bottom', params.value);
                    if (typeof params.value !== 'undefined' && params.value !== null && params.value !== '' && params.value !== -1) {
                        console.log(' params.value ', moment(params.value).format('MMMM, YYYY'));
                        this.eGui.innerHTML = moment(params.value).format('MMMM, YYYY');
                    } else {
                        this.eGui.innerHTML = '';
                    }
                } else {
                    this.eGui.innerHTML = '';
                }
            } else {
                this.eGui.innerHTML = '';
            }
        };
        MonthFormatRendererISCI.prototype.getGui = function () {
            return this.eGui;
        };

        $('#export_totals_tab').on('click', function () {
            $('#format_x').val($(this).attr('data'));
            $('#totalsToExport').modal('show');
        });

        $('#submit_export_totals').on('click', function () {
            show_overlay_loader($("#totalsToExport .modal-content"));
            type = $('#format_x').val();
            var html_table = '<table class="table table-bordered table-striped table-condensed" >';
            var html_table_end = '</table>';
            var html = '';

            var selectedItems = [];
            $('.all_more_options_totals  input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            console.log('selectedItems', selectedItems)
            if (selectedItems.indexOf('code') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>ISCI CODE SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#code_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            if (selectedItems.indexOf('campaign') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>CAMPAIGN SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#camp_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            if (selectedItems.indexOf('market') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>MARKET SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#market_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            if (selectedItems.indexOf('media') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>MEDIA SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#media_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            if (selectedItems.indexOf('vendor') !== -1) {
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>VENDOR SUMMARY</b></td></tr></table>'
                html += html_table;
                html += $('#vendor_sum_totals').html();
                html += html_table_end;
                html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
            }
            var dt = new Date();
            var day = dt.getDate();
            var month = dt.getMonth() + 1;
            var year = dt.getFullYear();
            var hour = dt.getHours();
            var mins = dt.getMinutes();
            var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
            if(type=='xls'){
                var a = document.createElement('a');
                var data_type = 'data:application/vnd.ms-excel';
                a.href = data_type + ', ' + encodeURIComponent(html);
                a.download = 'exported_' + postfix + '.xls';
                //triggering the function
                a.click();
            }
            else{
                var url='data:application/csv,charset=utf-8,' + encodeURIComponent(html);
                location.href=url;
                return false;
            }
            hide_overlay_loader($("#totalsToExport .modal-content"));
            $('#totalsToExport').modal('hide');
        });

        $('#report_detail_isci').on('click', function () {
            if(show_hide_grids === 'invoiced' || show_hide_grids  === 'both') {
                if (!$(this).hasClass('expanded')) {
                    $('#main_grid_div').css('height', '35vh');
                    $('.media-totals-wrapper').css('height', '30vh').show();
                    $(this).addClass('expanded');
                    $(this).find('i').removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
                } else {
                    $('#main_grid_div').css('height', '70vh');
                    $('.media-totals-wrapper').css('height', '0').hide();
                    $(this).removeClass('expanded');
                    $(this).find('i').removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
                }
            }
        });
        if(show_hide_grids !== 'invoiced' && show_hide_grids  !== 'both')
           $('#report_detail_isci').html('');
    }
    else if($(".mediastruction_report_header").length > 0) {
        init_progress_loader(2, 'Loading Report. Please wait ...');

        $('.export_totals_to').on('click', function () {
            $('#format_x').val($(this).attr('data'));
            $('#totalsToExport').modal('show');
        });
        $('#submit_export_totals').on('click', function () {
            var selectedItems = [];
            $('.all_more_options_totals input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });

            if($('#format_x_grid').val() == 'campaign')
                onBtExportBreakTo(gridInvExportInfo, $('#format_x').val(), selectedItems);
            else
                onBtExportBreakTo(gridInvExportInfo, $('#format_x').val(), selectedItems);
        });

       $('.exportMed').on('click', function(){
           var type = $(this).attr('data-ac');
           var html = '<table><tr>';
           html += '<th>Client</th><th>Campaign Name</th><th>Market</th><th>Media Type </th><th>Date</th><th>Impressions</th><th>Total Cost (Net)</th>'
           html += '</tr>';

           gridInvExportInfo.api.forEachNode(function (value) {
               if (value.level === 4) {
                   html += '<tr>';
                   html += '<td style="text-align: center">' + value['data']['adv_name'] + '</td>';
                   html += '<td style="text-align: center">' + value['data']['campaign_name'] + '</td>';
                   html += '<td style="text-align: center">' + value['data']['market'] + '</td>';
                   html += '<td style="text-align: center">' + value['data']['media'] + '</td>';
                   html += '<td style="text-align: center">' + value['data']['date'] + '</td>';
                   html += '<td style="text-align: center">' + value['data']['impressions'] + '</td>';
                   html += '<td style="text-align: center">' + value['data']['net_cost'] + '</td>';
                   html += '</tr>';
               }
           });
           html += '</table>';
           var dt = new Date();
           var day = dt.getDate();
           var month = dt.getMonth() + 1;
           var year = dt.getFullYear();
           var hour = dt.getHours();
           var mins = dt.getMinutes();
           var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
           if(type === 'xls'){
               html = html.replace('<button style="float:right; background-color: white; border 1px solid #f15925; color: #f15925" class="btn btn-info btn-outline" id="preview_download_2" name="preview_download_2" onclick="window.close()">NO STYLE DOWNLOAD</button><button style="float:right; background-color: white; border 1px solid #f15925; color: #f15925" class="btn btn-info btn-outline" id="preview_download" name="preview_download" onclick="window.close()">DOWNLOAD</button> <button style="float: right; background-color: white; border 1px solid #f15925; color: #f15925" class="btn btn-info btn-outline" id="preview_print" name="preview_print" onclick="">PRINT</button>', '')
               var aux = html
             //  var res = '<table><tr><td>'+ aux +'</td></tr></table>';
               var res = aux;
               var tbl = $(res)[0];
               var wb = XLSX.utils.table_to_book(tbl, {sheet:"Sheet JS"});
               wb['Sheets']['Sheet JS']['A1']['v'] = '';
               return XLSX.writeFile(wb, ( 'mediastruction_' + postfix + '.xlsx'));
               return false;
           }
           else{
               let data = "";
               const tableData = [];
               $('#hidden-div-to-export-csv').html('');
               $('#hidden-div-to-export-csv').html(html);
               const rows = document.querySelectorAll('#hidden-div-to-export-csv table tr');
               for (const row of rows) {
                   const rowData = [];
                   for (const [index, column] of row.querySelectorAll("th, td").entries()) {
                       var t = column.innerText.replace(/&nbsp;/g, '');
                       // To retain the commas in the "Description" column, we can enclose those fields in quotation marks.
                       if ((index + 1) % 3 === 0)
                           rowData.push('"' + t + '"');
                       else
                           rowData.push(t);

                       console.log('column.innerText', t, column.innerText);
                   }
                   tableData.push(rowData.join(","));
               }
               data += tableData.join("\n");
               var link = window.document.createElement("a");
               link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(data));
               link.setAttribute("download", 'mediastruction_' + postfix + '.csv');
               link.click();
           }
        });
        columnInvExportInfo = [
            {
                headerName: "Advertiser",
                field: 'adv_name',
                width: 300,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Campaign",
                field: 'campaign_name',
                width: 300,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Market",
                field: 'market',
                width: 300,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Media Type",
                field: 'media',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 3,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Date",
                field: 'date',
                width: 120,
                cellStyle: {'text-align': "right"},
               // hide: (custom_details.indexOf("Daypart") !== -1) ? false : true,
             //   cellRenderer: BlankFormatRenderer,

            },
            {
                headerName: "Impressions",
                field: 'impressions',
                width: 200,
                cellStyle: {'text-align': "right"},
                //hide: (estimate_options.indexOf("Ordered Impressions") !== -1) ? false : true,
               // cellRenderer: BlankFormatRenderer,
            },
            {
                headerName: "Total Cost (Net)",
                field: 'net_cost',
                width: 200,
                cellStyle: {'text-align': "right"},
                cellRenderer: CurrencyFormatRenderer,
            },
        ];
        gridInvExportInfo = {
            columnDefs: columnInvExportInfo,
            autoGroupColumnDef: {
                headerName: 'Details',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 250,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            toolPanelSuppressValues: true,
            defaultToolPanel: '',
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 3,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return MediastructionAggFunction(nodes);
            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                fillTopLine(this, 4);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters_det_details').show();
                else
                    $('#reset_filters_det_details').hide();
            },
        };

        var MediastructionAggFunction = function (nodes) {
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 4) {
                    result['net_cost'] = 0
                    result['impressions'] = 0
                    $.each(nodes, function (index, value) {
                        var sum = value['data']['net_cost'].replace('$', '');
                        sum = sum.replace(/,/g, '');
                        result['net_cost'] += parseFloat(sum);

                        result['impressions'] += parseFloat(value['data']['impressions'].replace(/,/g, ''));

                    });
                }
                else if (nodes[0].level === 3) {
                    result['net_cost'] = 0
                    result['impressions'] = 0
                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            var sum = value['data']['net_cost'].replace('$', '');
                            sum = sum.replace(/,/g, '');
                            result['net_cost'] += parseFloat(sum);
                            result['impressions'] += parseFloat(value['data']['impressions'].replace(/,/g, ''));
                        });
                    });
                }
                else if (nodes[0].level === 2) {
                    result['net_cost'] = 0
                    result['impressions'] = 0
                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                var sum = value['data']['net_cost'].replace('$', '');
                                sum = sum.replace(/,/g, '');
                                result['net_cost'] += parseFloat(sum);
                                result['impressions'] += parseFloat(value['data']['impressions'].replace(/,/g, ''));
                            });
                        });
                    });
                }
                else if (nodes[0].level === 1) {
                    result['net_cost'] = 0
                    result['impressions'] = 0
                    console.log('nodes__nodes__nodes 1', nodes)
                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                $.each(value.childrenAfterGroup, function (index, value) {
                                    var sum = value['data']['net_cost'].replace('$', '');
                                    sum = sum.replace(/,/g, '');
                                    result['net_cost'] += parseFloat(sum);
                                    result['impressions'] += parseFloat(value['data']['impressions'].replace(/,/g, ''));
                                });
                            });
                        });
                    });
                }

                result['net_cost'] = parseFloat(result['net_cost']).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                result['impressions'] = parseFloat(result['impressions']).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                return result;
            }
            else
                return false;

        };
        var rowdata = resultss;
        $('#myGridInvDetail').html('');
        gridInvExportInfo.rowData = rowdata;
        var gridDet = document.querySelector('#myGridMediastruction');
        var grid = new agGrid.Grid(gridDet, gridInvExportInfo);
        close_progress_loader();
        $('#reset_filters').on('click', function () {
            $.each(gridInvExportInfo.api.getFilterModel(), function (index, value) {
                gridInvExportInfo.api.destroyFilter(index);
            });
        });
    }
    else if($(".invoiced_items_report_header").length > 0) {
        show_loader();
        //Details Grid
        var columngridInvoicedItems = [
            {
                headerName: "Type",
                field: 'type',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Type") !== -1) ? false : true
            },
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 160,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Campaign") !== -1) ? false : true
            },
            {
                headerName: "Station",
                field: 'station',
                width: 120,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Station") !== -1) ? false : true
            },

            {
                headerName: "Zone",
                field: 'zone',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Zone") !== -1) ? false : true
            },
            {
                headerName: "Network",
                field: 'network',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Network") !== -1) ? false : true
            },
            {
                headerName: "Program",
                field: 'program',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Program") !== -1) ? false : true
            },
            {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 160,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Advertiser") !== -1) ? false : true
            },
            {
                headerName: "ISCI",
                field: 'code',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("ISCI") !== -1) ? false : true
            },
            {
                headerName: "Air Date",
                field: 'air_date',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Air Date") !== -1) ? false : true,
            },
            {
                headerName: "Air Time",
                field: 'air_time',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Air Time") !== -1) ? false : true,
            },
            {
                headerName: "Length",
                field: 'length',
                width: 80,
                cellStyle: {'text-align': "right"},
                hide: (custom_details.indexOf("Length") !== -1) ? false : true
            },
            {
                headerName: "Spot Price",
                field: 'spot_price',
                width: 100,
                cellStyle: {'text-align': "right"},
                hide: (estimate_details.indexOf("Spot Price") !== -1) ? false : true,
                //cellRenderer: CurrencyFormatRendererInvoiced,
            },
            {
                headerName: "Invoice Number",
                field: 'invoice_number',
                width: 80,
                cellStyle: {'text-align': "left"},
                hide: (custom_details.indexOf("Invoice Number") !== -1) ? false : true
            },
            {
                headerName: "Invoice Type",
                field: 'invoice_type',
                width: 80,
                cellStyle: {'text-align': "left"},
                hide: (custom_details.indexOf("Invoice Type") !== -1) ? false : true

            },
        ];
        var gridInvoicedItems = {
            columnDefs: columngridInvoicedItems,
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
           // pinnedTopRowData: totalInvDetailUpd(this),
            enableColResize: true,
            //suppressMenuColumnPanel: true,
            suppressTouch: true,
            headerHeight: 35,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            toolPanelSuppressValues: true,
            defaultToolPanel: '',
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            // groupRowAggNodes: function (nodes) {
            //     return AdggInvoicedItems(nodes);
            // },
            // rowSelection: 'single',
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
              //  totalInvDetailUpdOne(this);
                if (this.api.isAnyFilterPresent())
                    $('#reset_filters').show();
                else
                    $('#reset_filters').hide();
            },
            onGridReady: function (e) {
                // this.api.expandAll();
                // this.api.collapseAll();
                // this.api.expandAll();
               // totalInvDetailUpd(this);
            },
        };

        $('#myGridInvoicedItems').html('');
        gridInvoicedItems.rowData = result;
        var gridDet = document.querySelector('#myGridInvoicedItems');
        var grid = new agGrid.Grid(gridDet, gridInvoicedItems);

        $('#invoiced-item-hiden-columns a').each(function(){
            var attr = $(this).attr('data-col');
            if(custom_details.indexOf($(this).text()) === -1 && estimate_details.indexOf($(this).text()) === -1){
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
            }
            else{
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            }
        });

        $('#invoiced-item-hiden-columns a').bind('click', function (e) {
            var attr = $(this).attr('data-col');
            if ($(this).hasClass('hidden-column') ) {
                gridInvoicedItems.columnApi.setColumnsVisible([attr], true);
                $(this).removeClass('hidden-column');
                $(this).css('background-color', 'white');
            } else {
                gridInvoicedItems.columnApi.setColumnsVisible([attr], false);
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                if($(this).attr('data-ac') == 'excel') {
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                }
            }
            e.stopPropagation();
        });

        $('#reset_filters').on('click', function () {
            $.each(gridInvoicedItems.api.getFilterModel(), function (index, value) {
                gridInvoicedItems.api.destroyFilter(index);
            });
        });

        $('.export_grid_details').on('click', function(){
            var format = $(this).attr('data-ac')
            var params = {
                skipHeader: false,
                columnGroups: true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "smart-report." + format,
            };
            // params.processCellCallback = function (params) {
            //     if (params.column.colId === 'spot_price' ) {
            //         param_val = params.value;
            //         if (isNaN(parseFloat(params.value)))
            //             param_val = 0;
            //         param_val = parseFloat(param_val).toLocaleString("en-US", {
            //             style: "currency",
            //             currency: "USD",
            //             minimumFractionDigits: 2
            //         });
            //         return param_val;
            //
            //     } else
            //         return params.value;
            // };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Smart Report"}}
                    ],

                ];
                params.customFooter = [
                    [],
                    []
                ];
            }

            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridInvoicedItems.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                var content = gridInvoicedItems.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'smart-export.xlsx', {bookType: 'xlsx', type: 'base64'});
            }
        });

        hide_loader();

    }

    $('#report_summary').on('click', function () {
        if (!$(this).hasClass('expanded')) {
            $('#main_grid_div').css('height', '35vh');
            $('.media-totals-wrapper').css('height', '30vh').show();
            $(this).addClass('expanded');
            $(this).find('i').removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
        } else {
            $('#main_grid_div').css('height', '70vh');
            $('.media-totals-wrapper').css('height', '0').hide();
            $(this).removeClass('expanded');
            $(this).find('i').removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
        }
    });

    $('.export_details_groped').on('click', function(){
        var format = $(this).attr('data');
        var grid =   '';
        if(parseInt($(this).attr('data-tab')) === 2)
            grid = gridCodeBreakout;
        else if(parseInt($(this).attr('data-tab')) == 3)
            grid = gridMonthBreakout;
        else if(parseInt($(this).attr('data-tab')) == 4)
            grid = gridCodeBreakoutOrdered;
        else if(parseInt($(this).attr('data-tab')) == 5)
            grid = gridMonthBreakoutOrdered;

        var params = {
            skipHeader: false,
            columnGroups: (format == "csv") ? false : true,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "smart-report." + format,
        };
        params.processCellCallback = function (params) {
            if(typeof params.value !== 'undefined' && (params.value.toString().split('/').length === 3 || params.value.toString().split('-').length === 3 ) && moment(params.value).isValid())
                return moment(params.value).format('MMMM, YYYY');
            else if (params.column.colId === 'total_cost' || params.column.colId === 'total_net_cost' || params.column.colId === 'm_total' || params.column.colId === 't_total'
                ||params.column.colId === 'w_total' || params.column.colId === 'r_total' || params.column.colId === 'f_total' || params.column.colId === 's_total' || params.column.colId === 'u_total'
                || params.column.colId === 'm_total_net' || params.column.colId === 't_total_net' || params.column.colId === 'w_total_net' || params.column.colId === 'r_total_net'
                || params.column.colId === 'f_total_net' || params.column.colId === 's_total_net' || params.column.colId === 'u_total_net' || params.column.colId === 'cost'  || params.column.colId === 'net_cost') {
                param_val = params.value;
                if (isNaN(parseFloat(params.value)))
                    param_val = 0;

                param_val = parseFloat(param_val).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                return param_val;

            } else
                return params.value;
        };
        if (format === 'csv') {
            params.customHeader = [];
            params.customFooter = [];
        }else {
            params.customHeader = [
                [],
                [
                    {data: {type: 'String', value: 'Report'}},
                    {data: {type: 'String', value: "Smart Report"}}
                ],

            ];
            params.customFooter = [
                [],
                []
            ];
        }

        if (format === 'csv') {
            console.log("-------------csv-----------------");
            grid.api.exportDataAsCsv(params);
        } else {
            console.log("-------------excel-----------------");
            var content = grid.api.getDataAsExcel(params);
            var workbook = XLSX.read(content, {type: 'binary'});
            var xlsxContent = XLSX.writeFile(workbook, 'smart-export.xlsx', {bookType: 'xlsx', type: 'base64'});
        }
    });

    $('.export_details_tab_totals').on('click', function () {
        $('#format_x_det').val($(this).attr('data'));
        var html = '';
       if(parseInt($(this).attr('data-tab')) == 2 || parseInt($(this).attr('data-tab')) == 4 ){
           $('#tab_number').val(parseInt($(this).attr('data-tab')));
           html += '<input id="code_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="code">' +
               '                                            <label for="code_op_tab"> ISCI Code Summary</label><br>' +
               '                                            <input id="month_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="month">' +
               '                                            <label for="month_op_tab"> Month Summary</label><br>' +
               '                                            <input id="campaign_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="campaign">' +
               '                                            <label for="campaign_op_tab"> Campaign Summary</label><br>' +
               '                                            <input id="vendor_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="vendor">' +
               '                                            <label for="vendor_op_tab">Vendor Summary</label><br>';
       }
       else{
           $('#tab_number').val(parseInt($(this).attr('data-tab')));
           html += ' <input id="month_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="month">' +
               '                                            <label for="month_op_tab"> Month Summary</label><br>' +
               '                                            <input id="code_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="code">' +
               '                                            <label for="code_op_tab"> ISCI Code Summary</label><br>' +
               '                                            <input id="campaign_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="campaign">' +
               '                                            <label for="campaign_op_tab"> Campaign Summary</label><br>' +
               '                                            <input id="vendor_op_tab" name="totals_export_options_tab[]" type="checkbox" checked value="vendor">' +
               '                                            <label for="vendor_op_tab">Vendor Summary</label><br>';
       }
       $('.options_page_details_tab').html(html);
       $('#totalsToExportTabDetails').modal('show');
    });

    $('#submit_export_totals_tab_details').on('click', function(){
        if(parseInt($('#tab_number').val()) === 2)
            gridOptions = gridCodeBreakout;
        else  if(parseInt($('#tab_number').val()) === 3)
            gridOptions = gridMonthBreakout;
        else  if(parseInt($('#tab_number').val()) === 4)
            gridOptions = gridCodeBreakoutOrdered;
        else  if(parseInt($('#tab_number').val()) === 5)
            gridOptions = gridMonthBreakoutOrdered;
        var format =   $('#format_x_det').val();
        var selectedItems = [];
        $('.detail_tab_options input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });

        var params = {
            skipHeader: false,
            columnGroups: (format == "csv") ? false : true,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "smart-report." + format,

        };
        if (format === 'csv') {
            params.customHeader = [];
            params.customFooter = [];
        }else {
            params.customHeader = [
                [],
                [
                    {data: {type: 'String', value: 'Report'}},
                    {data: {type: 'String', value: "Post Buy Analysis"}}
                ],
            ];
            params.customFooter = [
                [],
                []
            ];
        }
        console.log("selectedItems before", selectedItems);
        params.shouldRowBeSkipped = function(row){
            if(typeof row.node.key === 'undefined' )
                return true
            if(selectedItems.indexOf('vendor') === -1 && row.node.field === 'vendor')
                return true;
            if(selectedItems.indexOf('month') === -1 && row.node.field === 'month')
                return true;
            if(selectedItems.indexOf('code') === -1 && row.node.field === 'code')
                return true;
            if(selectedItems.indexOf('campaign') === -1 && row.node.field === 'campaign')
                return true;
        };
        params.processCellCallback = function (params) {
            if(typeof params.value !== 'undefined' && (params.value.toString().split('/').length === 3 || params.value.toString().split('-').length === 3 )  && moment(params.value).isValid())
                return moment(params.value).format('MMMM, YYYY');
            else if (params.column.colId === 'total_cost' || params.column.colId === 'total_net_cost' || params.column.colId === 'm_total' || params.column.colId === 't_total'
                ||params.column.colId === 'w_total' || params.column.colId === 'r_total' || params.column.colId === 'f_total' || params.column.colId === 's_total' || params.column.colId === 'u_total'
                || params.column.colId === 'm_total_net' || params.column.colId === 't_total_net' || params.column.colId === 'w_total_net' || params.column.colId === 'r_total_net'
                || params.column.colId === 'f_total_net' || params.column.colId === 's_total_net' || params.column.colId === 'u_total_net' || params.column.colId === 'cost'  || params.column.colId === 'net_cost') {
                param_val = params.value;
                if (isNaN(parseFloat(params.value)))
                    param_val = 0;

                param_val = parseFloat(param_val).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                return param_val;

            } else
                return params.value;
        };
        if (format === 'csv') {
            console.log("-------------csv-----------------");
            gridOptions.api.exportDataAsCsv(params);
        } else {
            console.log("-------------excel-----------------");
            var content = gridOptions.api.getDataAsExcel(params);
            var workbook = XLSX.read(content, {type: 'binary'});
            var xlsxContent = XLSX.writeFile(workbook, 'smart-report.xlsx', {bookType: 'xlsx', type: 'base64'});
        }
    });

});
